(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Bundle = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var insertPageView = function (pageId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios_1.default.post("/api/pageview?pageId=" + pageId)];
            case 1:
                response = _a.sent();
                return [3, 3];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.default = insertPageView;
},{"axios":116}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addGoogleAnalyticsEventLog(eventName, params) {
    try {
        console.log("Sending event to Google Analytics: " + eventName, params);
        gtag('event', eventName, params);
    }
    catch (error) {
        console.error(error);
    }
}
exports.default = addGoogleAnalyticsEventLog;
},{}],3:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var calendarURLs_1 = __importDefault(require("./calendarURLs"));
function addToCalendar(button) {
    try {
        console.log('addToCalendar');
        var name_1 = button.getAttribute('data-cal-name');
        var details = button.getAttribute('data-cal-description');
        var location_1 = button.getAttribute('data-cal-location');
        var startsAt = button.getAttribute('data-cal-start');
        var endsAt = button.getAttribute('data-cal-end');
        var event_1 = {
            name: name_1,
            details: details,
            location: location_1,
            startsAt: startsAt,
            endsAt: endsAt,
        };
        var calUrls = calendarURLs_1.default(event_1);
        var calendarOptionsContainer_1 = document.querySelector('.calendar-options');
        if (!calendarOptionsContainer_1) {
            calendarOptionsContainer_1 = document.createElement('div');
            calendarOptionsContainer_1.className = 'calendar-options';
            document.body.appendChild(calendarOptionsContainer_1);
        }
        calendarOptionsContainer_1.innerHTML = '';
        var createCalendarLink = function (service, url, iconUrl) {
            var link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            var icon = document.createElement('img');
            icon.src = iconUrl;
            icon.alt = service + " icon";
            link.appendChild(icon);
            link.appendChild(document.createTextNode("" + service));
            calendarOptionsContainer_1.appendChild(link);
        };
        createCalendarLink('Apple', calUrls.ics, 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg');
        createCalendarLink('Google', calUrls.google, 'https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Calendar_icon_%282020%29.svg');
        createCalendarLink('iCal File', calUrls.ics, 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Line-style-icons-calendar-black.svg');
        createCalendarLink('Outlook.com', calUrls.outlook, 'https://upload.wikimedia.org/wikipedia/commons/9/90/Outlook.com_icon_%282012-2019%29.svg');
        createCalendarLink('Yahoo', calUrls.yahoo, 'https://upload.wikimedia.org/wikipedia/commons/8/83/Yahoo%21_icon_%282009-2013%29.svg');
        var buttonRect = button.getBoundingClientRect();
        var top_1 = window.scrollY + buttonRect.top + buttonRect.height + 10;
        var left = window.scrollX + buttonRect.left + buttonRect.width / 2 - 150;
        calendarOptionsContainer_1.style.top = top_1 + "px";
        calendarOptionsContainer_1.style.left = left + "px";
        calendarOptionsContainer_1.classList.add('show');
        var closePopup_1 = function (event) {
            if (!calendarOptionsContainer_1.contains(event.target) &&
                !button.contains(event.target) &&
                event.target !== button) {
                console.log('closing popup');
                calendarOptionsContainer_1.classList.remove('show');
                document.removeEventListener('click', closePopup_1);
            }
        };
        document.addEventListener('click', closePopup_1);
    }
    catch (err) {
        console.error('Failed to add to calendar: ', err);
    }
}
exports.default = addToCalendar;
},{"./calendarURLs":4}],4:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeDuration = function (event) {
    var minutes = Math.floor((+new Date(event.endsAt) - +new Date(event.startsAt)) / 60 / 1000);
    return Math.floor(minutes / 60) + ":" + ("0" + minutes % 60).slice(-2);
};
var makeTime = function (time) { return new Date(time).toISOString().replace(/[-:]|\.\d{3}/g, ''); };
var makeUrl = function (base, query) { return Object.keys(query).reduce(function (accum, key, index) {
    var value = query[key];
    if (value !== null) {
        return "" + accum + (index === 0 ? '?' : '&') + key + "=" + encodeURIComponent(value);
    }
    return accum;
}, base); };
var makeGoogleCalendarUrl = function (event) { return makeUrl('https://calendar.google.com/calendar/render', {
    action: 'TEMPLATE',
    dates: makeTime(event.startsAt) + "/" + makeTime(event.endsAt),
    location: event.location,
    text: event.name,
    details: event.details,
}); };
var makeOutlookCalendarUrl = function (event) { return makeUrl('https://outlook.live.com/owa', {
    rru: 'addevent',
    startdt: makeTime(event.startsAt),
    enddt: makeTime(event.endsAt),
    subject: event.name,
    location: event.location,
    body: event.details,
    allday: false,
    uid: new Date().getTime().toString(),
    path: '/calendar/view/Month',
}); };
var makeYahooCalendarUrl = function (event) { return makeUrl('https://calendar.yahoo.com', {
    v: 60,
    view: 'd',
    type: 20,
    title: event.name,
    st: makeTime(event.startsAt),
    dur: makeDuration(event),
    desc: event.details,
    in_loc: event.location,
}); };
var makeICSCalendarUrl = function (event) {
    var components = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        "URL:" + document.URL,
        "DTSTART:" + makeTime(event.startsAt),
        "DTEND:" + makeTime(event.endsAt),
        "SUMMARY:" + event.name,
        "DESCRIPTION:" + event.details,
        "LOCATION:" + event.location,
        'END:VEVENT',
        'END:VCALENDAR',
    ];
    return encodeURI("data:text/calendar;charset=utf8," + components.join('\n'));
};
var makeUrls = function (event) { return ({
    google: makeGoogleCalendarUrl(event),
    outlook: makeOutlookCalendarUrl(event),
    yahoo: makeYahooCalendarUrl(event),
    ics: makeICSCalendarUrl(event),
}); };
exports.default = makeUrls;
},{}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currentCulture = document.documentElement.getAttribute('culture');
function copyLinkToClipboard(button, link) {
    if (link === void 0) { link = window.location.href; }
    try {
        navigator.clipboard.writeText(link);
        showToast(button);
    }
    catch (err) {
        console.error('Failed to copy: ', err);
    }
}
exports.default = copyLinkToClipboard;
var showToast = function (button) {
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = currentCulture === 'ar' ? 'تم نسخ الرابط!' : 'Link copied to clipboard!';
    document.body.appendChild(toast);
    var buttonRect = button.getBoundingClientRect();
    var toastWidth = 150;
    var toastHeight = 40;
    var top = window.scrollY + buttonRect.top - toastHeight - 10;
    var left = window.scrollX + buttonRect.left + (buttonRect.width / 2) - (toastWidth / 2);
    toast.style.top = top + "px";
    toast.style.left = left + "px";
    setTimeout(function () {
        toast.classList.add('show');
    }, 100);
    setTimeout(function () {
        toast.classList.remove('show');
        setTimeout(function () {
            document.body.removeChild(toast);
        }, 500);
    }, 3000);
};
},{}],6:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
function saveOrRemoveFavourite(type, id, button) {
    try {
        axios_1.default.post("/api/favourites?pageId=" + id + "&type=" + type).then(function (response) {
            console.log(response.data);
            if (response.data) {
                if (button != null) {
                    button.classList.add('active');
                }
            }
            else {
                if (button != null) {
                    button.classList.remove('active');
                }
            }
        });
    }
    catch (error) {
        console.error(error);
    }
}
exports.default = saveOrRemoveFavourite;
},{"axios":116}],7:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatDateString = function (dateString, isUTC) {
    if (isUTC === void 0) { isUTC = true; }
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var monthsInArabic = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
    var direction = document.querySelector("html").getAttribute("dir");
    var date = new Date(dateString);
    var year = date.getUTCFullYear();
    var monthIndex = date.getUTCMonth();
    var day = isUTC ? date.getUTCDate() : date.getDate();
    var month = "";
    if (direction === "rtl") {
        month = monthsInArabic[monthIndex];
    }
    else {
        month = months[monthIndex];
    }
    return day + " " + month + " " + year;
};
exports.default = formatDateString;
},{}],8:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertTime = function (dateStr, dir) {
    var date = new Date(dateStr);
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var period;
    var displayHour;
    if (hour >= 0 && hour < 12) {
        if (dir !== 'rtl') {
            period = 'in the morning';
        }
        else {
            period = 'صباحاً';
        }
        displayHour = hour === 0 ? 12 : hour;
    }
    else if (hour >= 12 && hour < 20) {
        if (dir !== 'rtl') {
            period = 'in the afternoon';
        }
        else {
            period = 'ظهراً';
        }
        displayHour = hour === 12 ? 12 : hour - 12;
    }
    else {
        if (dir !== 'rtl') {
            period = 'in the evening';
        }
        else {
            period = 'مساءً';
        }
        displayHour = hour === 12 ? 12 : hour - 12;
    }
    var formattedMinutes = '';
    if (minutes !== 0) {
        formattedMinutes = ":" + minutes.toString().padStart(2, '0');
    }
    var formattedTime = "" + displayHour + formattedMinutes + " " + period;
    if (dir === 'rtl') {
        return "\u202B" + formattedTime + "\u202C";
    }
    return formattedTime;
};
exports.default = convertTime;
},{}],9:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsFavourited = void 0;
var IsFavourited = function (thisID, pagesIds) { return pagesIds.includes(thisID); };
exports.IsFavourited = IsFavourited;
},{}],10:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IsUserLoggedIn = function () { return Number(document.documentElement.getAttribute('login')) !== 0; };
exports.default = IsUserLoggedIn;
},{}],11:[function(require,module,exports){
var opportunityCards = document.querySelectorAll(".opportunity-card");
if (opportunityCards.length > 0) {
    var cardButtons = document.querySelectorAll(".opportunity-card__button");
    opportunityCards.forEach(function (card) {
        card.addEventListener("click", function (e) {
            var target = e.target;
            if (target.classList.contains("button") || target.classList.contains("button__image")) {
                e.preventDefault();
            }
        });
    });
    cardButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
            console.log("small button clicked");
        });
    });
}
},{}],12:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var details = document.querySelector('.article-detail');
if (details) {
    var shareButtons = document.querySelectorAll(".shareButton");
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5}],13:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var list = document.querySelector('.article-list-filters__wrapper');
if (list) {
    var grid_1 = list.querySelector('.article-list-filters__grid');
    var filters_1 = list.querySelector('.article-list-filters__filter-content');
    var resultsnumber_1 = list.querySelector('.article-list-filters__number');
    var filterButton = list.querySelector('.article-list-filters__button');
    var filterCount_1 = list.querySelector('.article-list-filters__button-count-content');
    var listSearchInput_1 = list.querySelector('.article-list__search-input');
    var articleCategoriesDiv_1 = list.querySelector('.article-list-filters__categories-list');
    var nextPageButton = list.querySelector('.pagination__page-next');
    var prevPageButton = list.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = list.querySelector('.pagination__dropdown');
    var paginationLast = list.querySelector('.pagination__page-last');
    var paginationFirst = list.querySelector('.pagination__page-first');
    var pagination_2 = list.querySelector('.pagination');
    var radios_1 = list.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var pageId_1 = Number(list.getAttribute('data-id'));
    var checkboxFiltersViews_1 = list.querySelectorAll('.article-list-filters__view-checkbox');
    var articleCards_1 = [];
    var articleCardsAll_1 = [];
    var articleCategories_1 = [];
    var keyword_1 = '';
    var categories_1 = [];
    var views_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var applyUrlState = function () {
        var url = new URL(window.location.href);
        pageNumber_1 = Number(url.searchParams.get('pageNumber') || pageNumber_1);
        pageSize_1 = Number(url.searchParams.get('pageSize') || pageSize_1);
        keyword_1 = url.searchParams.get('keyword') || '';
        categories_1 = url.searchParams.getAll('categories');
        views_1 = url.searchParams.getAll('views');
        sortBy_1 = Number(url.searchParams.get('sortBy') || sortBy_1);
        if (paginationDropdown_1) {
            paginationDropdown_1.value = pageSize_1.toString();
        }
        if (listSearchInput_1) {
            listSearchInput_1.value = keyword_1;
        }
        radios_1.forEach(function (radio) {
            radio.checked = sortBy_1 === +radio.value;
        });
        checkboxFiltersViews_1.forEach(function (checkbox) {
            checkbox.checked = views_1.includes(checkbox.value);
        });
    };
    applyUrlState();
    var fetchArticleCategories_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, 6, 7]);
                    payload = {
                        pageId: pageId_1,
                        keyword: keyword_1,
                        categories: categories_1,
                        views: views_1,
                        sortBy: sortBy_1,
                        pageNumber: pageNumber_1,
                        pageSize: pageSize_1,
                        currentCulture: currentCulture_1,
                    };
                    response = void 0;
                    if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                        window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 2];
                    return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/articles/getcategories', payload)];
                case 1:
                    response = _a.sent();
                    return [3, 4];
                case 2: return [4, axios_1.default.post('/api/articles/getcategories', payload)];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    articleCategories_1 = response.data;
                    return [3, 7];
                case 5:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 7];
                case 6:
                    updateCategories_1();
                    updateNumberCards_1();
                    return [7];
                case 7: return [2];
            }
        });
    }); };
    var updateCategories_1 = function () {
        articleCategoriesDiv_1.innerHTML = '';
        articleCategories_1.forEach(function (card) {
            var _a;
            var cardElement = document.createElement('details');
            cardElement.setAttribute('open', '');
            cardElement.className = 'article-list-filters__details';
            cardElement.innerHTML = "\n                <summary class=\"article-list-filters__summary\">\n                    <div class=\"article-list-filters__category-title flex flex--align-center\">\n                        <img src=\"/assets/img/img/icons/four-squares-filled.svg\" alt=\"" + card.title + "\"\n                            class=\"article-list-filters__category-icon\">\n                        " + card.title + "\n                    </div>\n                </summary>\n                <div class=\"article-list-filters__sub-filters flex flex--column\">\n                </div>\n            ";
            var subCats = cardElement.querySelector('.article-list-filters__sub-filters');
            (_a = card.subCategories) === null || _a === void 0 ? void 0 : _a.forEach(function (subcard) {
                var subCardElement = document.createElement('summary');
                subCardElement.innerHTML = "\n                    <div class=\"article-list-filters__sub-filters-text flex flex--align-center subcat-card\" data-id=\"" + subcard.id + "\">\n                        <input type=\"checkbox\" id=\"" + card.title + "-" + subcard.title + "\" value=\"" + subcard.id + "\"\n                            class=\"article-list-filters__sub-filters-text-checkbox article-list-filters__category-checkbox\">\n                        <label for=\"" + card.title + "-" + subcard.title + "\"\n                            class=\"article-list-filters__sub-filters-text-name flex flex--align-center\">\n                            <span>\n                            " + subcard.title + "\n                            </span>\n                            <span class=\"article-list-filters__sub-filters-text-number\">" + subcard.count + "</span>\n                        </label>\n                    </div>\n                ";
                subCats.appendChild(subCardElement);
            });
            articleCategoriesDiv_1.appendChild(cardElement);
        });
        var checkboxFiltersCategories = list.querySelectorAll('.article-list-filters__category-checkbox');
        if (checkboxFiltersCategories.length > 0) {
            checkboxFiltersCategories.forEach(function (checkbox) {
                checkbox.checked = categories_1.includes(checkbox.value);
                checkbox.addEventListener('change', function () {
                    if (categories_1.includes(checkbox.value)) {
                        categories_1 = categories_1.filter(function (cat) { return cat !== checkbox.value; });
                    }
                    else {
                        categories_1.push(checkbox.value);
                    }
                    pageNumber_1 = 1;
                    renderPage_1();
                });
            });
        }
    };
    var fetchArticles_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, fCount, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            pageId: pageId_1,
                            keyword: keyword_1,
                            categories: categories_1,
                            views: views_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        fCount = categories_1.length + views_1.length;
                        filterCount_1.innerHTML = fCount.toString();
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/articles', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/articles', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        articleCards_1 = response.data.items;
                        if (articleCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        resultsnumber_1.innerHTML = response.data.totalCount;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, articleCards_1, renderPage_1, true);
                        isLoading_1 = false;
                        updateCards_1();
                        updateNumberCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var fetchAllArticles_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            pageId: pageId_1,
                            keyword: '',
                            categories: [],
                            views: [],
                            sortBy: 1,
                            pageNumber: 1,
                            pageSize: -1,
                            currentCulture: currentCulture_1,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/articles', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/articles', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        articleCardsAll_1 = response.data.items;
                        return [3, 7];
                    case 6:
                        error_3 = _a.sent();
                        console.error(error_3);
                        return [3, 7];
                    case 7: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        grid_1.innerHTML = '';
        articleCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.className = 'fade-in';
            cardElement.innerHTML = "\n            <div class=\"article-card flex flex--column\">\n                    <div class=\"article-card__top\">\n                        <div class=\"article-card__top-content flex flex--column\">\n                            <img class=\"article-card__top-content-image\" src=\"" + card.image + "\" alt=\"" + card.title + "\" />\n                            <h3 class=\"article-card__top-content-title\">" + card.title + "</h3>\n                            <span class=\"article-card__top-content-description\">" + card.text + "</span>\n                        </div>\n                    </div>\n                    <div class=\"article-card__bottom\">\n                        <div class=\"article-card__bottom__content flex flex--row flex--align-center flex--justify-between\">\n                            <div class=\"article-card__bottom__content__author flex flex--row flex--align-center\">\n                                <img class=\"article-card__bottom__content__author-icon\" src=\"/assets/img/img/icons/user-tick-article-card.svg\"/>\n                                <p class=\"article-card__bottom__content__author-content\">" + card.author + "</p>\n                            </div>\n                            <div class=\"article-card__bottom__content__article-type flex flex--row flex--align-center\">\n                                <img class=\"article-card__bottom__content__article-type-icon\" src=\"/assets/img/img/icons/sort-article-card.svg\" />\n                                <p class=\"article-card__bottom__content__article-type-content\">" + card.category + "</p>\n                            </div>\n                            <div class=\"article-card__bottom__content__views flex flex--row flex--align-center\">\n                                <img class=\"article-card__bottom__content__views-icon\" src=\"/assets/img/img/icons/eye--article-card.svg\" />\n                                <p class=\"article-card__bottom__content__views-content\">" + card.views + "</p>\n                            </div>\n                        </div>\n                    </div>\n            </div>\n        ";
            grid_1.appendChild(cardElement);
        });
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        filters_1 === null || filters_1 === void 0 ? void 0 : filters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        filters_1.classList.remove('disabled');
    };
    if (checkboxFiltersViews_1.length > 0) {
        checkboxFiltersViews_1.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                if (views_1.includes(checkbox.value)) {
                    views_1 = views_1.filter(function (cat) { return cat !== checkbox.value; });
                }
                else {
                    views_1.push(checkbox.value);
                }
                pageNumber_1 = 1;
                renderPage_1();
            });
        });
    }
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        renderPage_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        renderPage_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        renderPage_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        renderPage_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        renderPage_1();
    });
    var timeout_1 = null;
    listSearchInput_1 === null || listSearchInput_1 === void 0 ? void 0 : listSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = listSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchArticles_1();
        }, 1000);
    });
    radios_1.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = list.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            pageNumber_1 = 1;
            renderPage_1();
        });
    });
    filterButton === null || filterButton === void 0 ? void 0 : filterButton.addEventListener('click', function () {
        var filterColumn = list.querySelector('.article-list-filters__accordions');
        if (filterColumn === null || filterColumn === void 0 ? void 0 : filterColumn.classList.contains('hidden')) {
            filterColumn === null || filterColumn === void 0 ? void 0 : filterColumn.classList.remove('hidden');
        }
        else {
            filterColumn === null || filterColumn === void 0 ? void 0 : filterColumn.classList.add('hidden');
        }
    });
    var renderPage_1 = function (page) {
        if (page === void 0) { page = null; }
        if (page) {
            pageNumber_1 = page;
        }
        var url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber_1.toString());
        url.searchParams.set('pageSize', pageSize_1.toString());
        if (keyword_1) {
            url.searchParams.set('keyword', keyword_1);
        }
        categories_1.forEach(function (category) { return url.searchParams.append('categories', category); });
        views_1.forEach(function (view) { return url.searchParams.append('views', view); });
        url.searchParams.set('sortBy', sortBy_1.toString());
        if (page == null) {
            window.location.href = url.toString();
        }
        return url.toString();
    };
    var initializeList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchAllArticles_1()];
                case 1:
                    _a.sent();
                    return [4, fetchArticleCategories_1()];
                case 2:
                    _a.sent();
                    return [4, fetchArticles_1()];
                case 3:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeList();
    var updateNumberCards_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var filterDivs;
        return __generator(this, function (_a) {
            filterDivs = document.querySelectorAll('.views-card');
            filterDivs.forEach(function (filterDiv) {
                var minViews = parseInt(filterDiv.getAttribute('data-min'), 10);
                var maxViews = parseInt(filterDiv.getAttribute('data-max'), 10);
                var count = articleCardsAll_1.filter(function (article) { return article.views >= minViews && article.views <= maxViews; }).length;
                var countSpan = filterDiv.querySelector('.article-list-filters__sub-filters-text-number');
                countSpan.textContent = count.toString();
            });
            return [2];
        });
    }); };
    updateNumberCards_1();
}
},{"../pagination/pagination":71,"axios":116}],14:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],15:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var awardsAccreditations = document.querySelector('.awards-list');
if (awardsAccreditations) {
    var eventTabs_1 = awardsAccreditations.querySelectorAll('.awards-list__tab');
    var awardsGrid_1 = awardsAccreditations.querySelector('.awards-list__grid');
    var awardsFilters_1 = awardsAccreditations.querySelector('.awards-list__search');
    var awardsListSearchInput_1 = awardsAccreditations.querySelector('.awards-list__search-input');
    var nextPageButton = awardsAccreditations.querySelector('.pagination__page-next');
    var prevPageButton = awardsAccreditations.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = awardsAccreditations.querySelector('.pagination__dropdown');
    var paginationLast = awardsAccreditations.querySelector('.pagination__page-last');
    var paginationFirst = awardsAccreditations.querySelector('.pagination__page-first');
    var pagination_2 = awardsAccreditations.querySelector('.pagination');
    var awardsTabsComponent_1 = awardsAccreditations.querySelector('.awards-list__tabs');
    var radios_1 = awardsAccreditations.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var activeTab_1 = 0;
    var awardsCards_1 = [];
    var keyword_1 = '';
    var awardsType_1 = 2;
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var keywordChanged_1 = false;
    var awardsCardSettings_1 = {
        Text: '',
    };
    var resetTabs_1 = function () {
        eventTabs_1.forEach(function (tab) { return tab.classList.remove('awards-list__tab--active'); });
    };
    var fetchAwardsCardSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/awardsaccreditations/cardsettings?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    awardsCardSettings_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchAwards_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var url, payload, response, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        url = new URL(window.location.href);
                        pageNumber_1 = keywordChanged_1 ? 1 : Number(url.searchParams.get('pageNumber') || 1);
                        pageSize_1 = Number(url.searchParams.get('pageSize') || pageSize_1);
                        keyword_1 = keywordChanged_1 ? keyword_1 : url.searchParams.get('keyword') || '';
                        awardsType_1 = Number(url.searchParams.get('awardsType') || awardsType_1);
                        sortBy_1 = Number(url.searchParams.get('sortBy') || sortBy_1);
                        paginationDropdown_1.value = pageSize_1.toString();
                        awardsListSearchInput_1.value = keyword_1;
                        radios_1.forEach(function (radio) {
                            radio.checked = sortBy_1 === +radio.value;
                        });
                        activeTab_1 = awardsType_1 === 2 ? 0 : 1;
                        resetTabs_1();
                        (_a = eventTabs_1[activeTab_1]) === null || _a === void 0 ? void 0 : _a.classList.add('awards-list__tab--active');
                        payload = {
                            keyword: keyword_1,
                            awardsType: awardsType_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/awardsaccreditations', payload)];
                    case 2:
                        response = _b.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/awardsaccreditations', payload)];
                    case 4:
                        response = _b.sent();
                        _b.label = 5;
                    case 5:
                        awardsCards_1 = response.data.items;
                        if (awardsCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_2 = _b.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, awardsCards_1, renderPage_1, true);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        awardsGrid_1.innerHTML = '';
        awardsCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.className = 'awards-list__card flex flex--column';
            cardElement.innerHTML = "        \n\t\t\t\t\t<div class=\"awards-list__card-image-container\">\n\t\t\t\t\t\t<img src=\"" + card.image + "\" alt=\"" + card.title + "\" class=\"awards-list__card-image\">\n\t\t\t\t\t</div>\n                    " + (card.date.slice(0, 10) === '0001-01-01'
                ? ''
                : "<div class='awards-list__card-date flex flex--align-center'>\n                                    <img src='/assets/img/img/calendar-icon-yellow.svg' alt='calendar icon' class='awards-list__card-icon' />\n                                    <span class='awards-list__card-date-text'>\n                                    " + formatDate_1.default(card.date) + "\n                                    </span>\n                                </div>") + "\n                    <h4 class=\"awards-list__card-title\">" + card.title + "</h4>\n                    <p class=\"awards-list__card-text\">" + card.description + "</p>\n      ";
            awardsGrid_1.appendChild(cardElement);
        });
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        awardsTabsComponent_1.classList.add('disabled');
        awardsFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        awardsTabsComponent_1.classList.remove('disabled');
        awardsFilters_1.classList.remove('disabled');
    };
    eventTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            resetTabs_1();
            eventTabs_1[activeTab_1].classList.add('awards-list__tab--active');
            pageNumber_1 = 1;
            if (index === 0) {
                awardsType_1 = 2;
            }
            else {
                awardsType_1 = 1;
            }
            renderPage_1();
        });
    });
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        renderPage_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        renderPage_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        renderPage_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        renderPage_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        renderPage_1();
    });
    var timeout_1 = null;
    awardsListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = awardsListSearchInput_1.value.trim();
            keywordChanged_1 = true;
            pageNumber_1 = 1;
            fetchAwards_1();
        }, 1000);
    });
    radios_1.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = awardsAccreditations.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            pageNumber_1 = 1;
            renderPage_1();
        });
    });
    var renderPage_1 = function (page) {
        if (page === void 0) { page = null; }
        if (page) {
            pageNumber_1 = page;
        }
        var url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber_1.toString());
        url.searchParams.set('pageSize', pageSize_1.toString());
        if (keyword_1) {
            url.searchParams.set('keyword', keyword_1);
        }
        url.searchParams.set('awardsType', awardsType_1.toString());
        url.searchParams.set('sortBy', sortBy_1.toString());
        if (page == null) {
            window.location.href = url.toString();
        }
        return url.toString();
    };
    fetchAwardsCardSettings();
    fetchAwards_1();
}
},{"../../../helpers/formatDate":7,"../pagination/pagination":71,"axios":116}],16:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],17:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var pagination_1 = require("../pagination/pagination");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var axios_1 = __importDefault(require("axios"));
var borchuresPublicationsList = document.querySelector('.brochures-list');
if (borchuresPublicationsList) {
    var brochuresGrid_1 = borchuresPublicationsList.querySelector('.brochures-list__grid');
    var identityFilters_1 = borchuresPublicationsList.querySelector('.brochures-list__search');
    var borchuresPublicationsListSearchInput_1 = borchuresPublicationsList.querySelector('.brochures-list__search-input');
    var nextPageButton = borchuresPublicationsList.querySelector('.pagination__page-next');
    var prevPageButton = borchuresPublicationsList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = borchuresPublicationsList.querySelector('.pagination__dropdown');
    var paginationLast = borchuresPublicationsList.querySelector('.pagination__page-last');
    var paginationFirst = borchuresPublicationsList.querySelector('.pagination__page-first');
    var pagination_2 = borchuresPublicationsList.querySelector('.pagination');
    var radios = borchuresPublicationsList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var brochureCards_1 = [];
    var keyword_1 = '';
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchBrochuresPublications_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/brochurespublications', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/brochurespublications', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        brochureCards_1 = response.data.items;
                        if (brochureCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, brochureCards_1, fetchBrochuresPublications_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        brochuresGrid_1.innerHTML = '';
        brochureCards_1.forEach(function (card) {
            var cardElement = document.createElement('div');
            cardElement.className = 'science-card flex flex--column flex--align-start flex--justify-between';
            cardElement.innerHTML = "\n                    <div class=\"science-card__top flex flex--wrap\">\n                        <div class=\"science-card__image-container flex flex--align-center flex--justify-center\">\n                            <img src=" + card.image + " alt=\"image\" class=\"science-card__image\">\n                        </div>\n                        <div class=\"science-card__content flex flex--column flex--justify-start\">\n                            <div class='science-card__date flex flex--align-center'>\n                                <div class=\"science-card__date-inner flex flex--align-center\">\n                                    <img src='/assets/img/img/calendar-icon-yellow.svg' alt='calendar icon' class='science-card__date-icon' />\n                                    <span class='science-card__date-text'>\n                                    " + formatDate_1.default(card.date) + "\n                                    </span>\n                                </div>\n                                <img src=\"/assets/img/fractal/filetype--" + card.fileType + ".svg\"\n                                 alt=\"pdf icon\" class=\"science-card__pdf\">\n                            </div>\n                            <span class=\"science-card__title\">" + card.title + "</span>\n                            <span class=\"science-card__text\">" + card.description + "</span>\n                        </div>\n                    </div>\n                    <div class=\"science-card__bottom flex flex--wrap flex--align-center\">\n                        <a href=\"" + card.link + "\"\n                         draggable=\"false\" class=\"link link--secondary science-card__link science-card__link--full flex flex--justify-center flex--align-center\" target=\"_blank\">\n                            <span class=\"link__label\">" + card.linkTitle + "</span>\n                            <img class=\"link__image\" src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"/assets/img/img/arrow-top-left-dark.svg\">\n                        </a>\n                        <div class=\"science-card__buttons flex flex--align-center\">\n                            <button class=\"button button--round-tiny shareButton brochures-list__item__button brochures-list__item__button-share flex flex--justify-center flex--align-center\">\n                                <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                            </button>\n                            <a href=\"" + card.link + "\"\n                                 draggable=\"false\" class=\"link link--round-tiny science-card__button science-card__button-download flex flex--justify-center flex--align-center\" download=\"" + card.link + "\" target=\"_blank\">\n                                <img class=\"link__image\" src=\"/assets/img/img/download-icon-dark.svg\" alt=\"/assets/img/img/download-icon-dark.svg\">\n                            </a>\n                        </div>\n                    </div>\n            ";
            brochuresGrid_1.appendChild(cardElement);
        });
        addCardListeners_1();
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        identityFilters_1 === null || identityFilters_1 === void 0 ? void 0 : identityFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        identityFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchBrochuresPublications_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchBrochuresPublications_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchBrochuresPublications_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchBrochuresPublications_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchBrochuresPublications_1();
    });
    var timeout_1 = null;
    borchuresPublicationsListSearchInput_1 === null || borchuresPublicationsListSearchInput_1 === void 0 ? void 0 : borchuresPublicationsListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = borchuresPublicationsListSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchBrochuresPublications_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = borchuresPublicationsList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchBrochuresPublications_1();
        });
    });
    fetchBrochuresPublications_1();
    var addCardListeners_1 = function () {
        var brochuresListCards = brochuresGrid_1.querySelectorAll('.brochures-list__item');
        if (brochuresListCards.length > 0) {
            var cardButtons = document.querySelectorAll('.brochures-list__item__button');
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/formatDate":7,"../pagination/pagination":71,"axios":116}],18:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],19:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var isUserLoggedIn_1 = __importDefault(require("../../../helpers/isUserLoggedIn"));
var competitionsList = document.querySelector('.competitions-list');
if (competitionsList) {
    var grid_1 = competitionsList.querySelector('.competitions-list__images');
    var nextPageButton = competitionsList.querySelector('.pagination__page-next');
    var prevPageButton = competitionsList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = competitionsList.querySelector('.pagination__dropdown');
    var paginationLast = competitionsList.querySelector('.pagination__page-last');
    var paginationFirst = competitionsList.querySelector('.pagination__page-first');
    var pagination_2 = competitionsList.querySelector('.pagination');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var favouritedIds_1 = JSON.parse(grid_1.getAttribute('data-ids'));
    var compCards_1 = [];
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchCompetitions_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/competitions', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post("/api/competitions", payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        compCards_1 = response.data.items;
                        if (compCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalCount_1 = response.data.totalCount;
                        totalPages_1 = response.data.totalPages;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, compCards_1, fetchCompetitions_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        grid_1.innerHTML = '';
        compCards_1.forEach(function (card) {
            var cardElement = document.createElement('div');
            cardElement.className = 'competitions-list__item sticky flex flex--column';
            cardElement.style.backgroundImage = "url(" + card.backgroundImage + ")";
            var _class = '';
            if (isFavourite_1.IsFavourited(card.id, favouritedIds_1)) {
                _class = 'active';
            }
            cardElement.innerHTML = "            \n            <div class=\"competitions-list__item-content flex flex--column\">\n                <p class=\"competitions-list__title\">" + card.title + "</p>\n                <p class=\"competitions-list__text\">" + card.text + "</p>\n                <div class=\"competitions-list__buttons flex flex--align-center\">\n                    <button\n                        class=\"button button--round-tiny shareButton competitions-list__button competitions-list__button competitions-list__button-share flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/share-filled-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                    " + (isUserLoggedIn_1.default()
                ? "<button class=\"button button--favourite-small button--favourite-white competitions-list__button favouriteButton events-card__button flex flex--justify-center flex--align-center " + _class + "\" data-type=\"competition\" data-id=\"" + card.id + "\">\n                                </button>"
                : '') + "\n                    \n                </div>\n            </div>\n            <a href=\"" + card.link + "\" draggable=\"false\" " + (card.target !== null ? "target=" + card.target : '') + "\n                class=\"link link--lg link--transparent competitions-list__item-link flex flex--justify-center flex--align-center\">\n                <span class=\"link__label\">" + card.linkText + "</span>\n                <img class=\"link__image\" src=\"/assets/img/img/arrow-top-left.svg\" alt=\"more\">\n            </a>\n            ";
            grid_1.appendChild(cardElement);
        });
        var cardElement = document.createElement('div');
        cardElement.className = 'programs-list__item sticky';
        cardElement.style.opacity = '0';
        cardElement.style.zIndex = '-1';
        grid_1.appendChild(cardElement);
        addCardListeners_1();
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchCompetitions_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchCompetitions_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchCompetitions_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchCompetitions_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchCompetitions_1();
    });
    fetchCompetitions_1();
    var addCardListeners_1 = function () {
        var listCards = competitionsList.querySelectorAll('.competitions-list__item');
        if (listCards.length > 0) {
            var cardButtons = document.querySelectorAll('.competitions-list__button');
            listCards.forEach(function (card) {
                card.addEventListener('click', function (e) {
                    var target = e.target;
                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('favouriteButton')) {
                        var t = button.getAttribute('data-type');
                        var id = Number(button.getAttribute('data-id'));
                        favourites_1.default(t, id, button);
                    }
                    else if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
            var top_1 = 180;
            var headerHeight_1 = 65;
            if (window.innerWidth < 1200) {
                top_1 = 20;
            }
            var cardsCount = listCards.length;
            if (cardsCount) {
                listCards.forEach(function (card, i) {
                    var incValue = i * headerHeight_1;
                    if (i === 0) {
                        card.style.top = top_1 + "px";
                    }
                    else {
                        card.style.top = top_1 + incValue + "px";
                    }
                });
            }
        }
    };
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9,"../../../helpers/isUserLoggedIn":10,"../pagination/pagination":71,"axios":116}],20:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],21:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var contactus = document.querySelector('.contact-us');
if (contactus) {
    var shareButtons = document.querySelectorAll(".shareButton");
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5}],22:[function(require,module,exports){
var countryDropdowns = document.querySelectorAll('.country-dropdown__wrapper');
countryDropdowns.forEach(function (countryDropdown) {
    if (countryDropdown) {
        var countries = [
            { name: "Afghanistan", code: "AF", phone: 93 },
            { name: "Aland Islands", code: "AX", phone: 358 },
            { name: "Albania", code: "AL", phone: 355 },
            { name: "Algeria", code: "DZ", phone: 213 },
            { name: "American Samoa", code: "AS", phone: 1684 },
            { name: "Andorra", code: "AD", phone: 376 },
            { name: "Angola", code: "AO", phone: 244 },
            { name: "Anguilla", code: "AI", phone: 1264 },
            { name: "Antarctica", code: "AQ", phone: 672 },
            { name: "Antigua and Barbuda", code: "AG", phone: 1268 },
            { name: "Argentina", code: "AR", phone: 54 },
            { name: "Armenia", code: "AM", phone: 374 },
            { name: "Aruba", code: "AW", phone: 297 },
            { name: "Australia", code: "AU", phone: 61 },
            { name: "Austria", code: "AT", phone: 43 },
            { name: "Azerbaijan", code: "AZ", phone: 994 },
            { name: "Bahamas", code: "BS", phone: 1242 },
            { name: "Bahrain", code: "BH", phone: 973 },
            { name: "Bangladesh", code: "BD", phone: 880 },
            { name: "Barbados", code: "BB", phone: 1246 },
            { name: "Belarus", code: "BY", phone: 375 },
            { name: "Belgium", code: "BE", phone: 32 },
            { name: "Belize", code: "BZ", phone: 501 },
            { name: "Benin", code: "BJ", phone: 229 },
            { name: "Bermuda", code: "BM", phone: 1441 },
            { name: "Bhutan", code: "BT", phone: 975 },
            { name: "Bolivia", code: "BO", phone: 591 },
            { name: "Bonaire, Sint Eustatius and Saba", code: "BQ", phone: 599 },
            { name: "Bosnia and Herzegovina", code: "BA", phone: 387 },
            { name: "Botswana", code: "BW", phone: 267 },
            { name: "Bouvet Island", code: "BV", phone: 55 },
            { name: "Brazil", code: "BR", phone: 55 },
            { name: "British Indian Ocean Territory", code: "IO", phone: 246 },
            { name: "Brunei Darussalam", code: "BN", phone: 673 },
            { name: "Bulgaria", code: "BG", phone: 359 },
            { name: "Burkina Faso", code: "BF", phone: 226 },
            { name: "Burundi", code: "BI", phone: 257 },
            { name: "Cambodia", code: "KH", phone: 855 },
            { name: "Cameroon", code: "CM", phone: 237 },
            { name: "Canada", code: "CA", phone: 1 },
            { name: "Cape Verde", code: "CV", phone: 238 },
            { name: "Cayman Islands", code: "KY", phone: 1345 },
            { name: "Central African Republic", code: "CF", phone: 236 },
            { name: "Chad", code: "TD", phone: 235 },
            { name: "Chile", code: "CL", phone: 56 },
            { name: "China", code: "CN", phone: 86 },
            { name: "Christmas Island", code: "CX", phone: 61 },
            { name: "Cocos (Keeling) Islands", code: "CC", phone: 672 },
            { name: "Colombia", code: "CO", phone: 57 },
            { name: "Comoros", code: "KM", phone: 269 },
            { name: "Congo", code: "CG", phone: 242 },
            { name: "Democratic Republic of the Congo", code: "CD", phone: 242 },
            { name: "Cook Islands", code: "CK", phone: 682 },
            { name: "Costa Rica", code: "CR", phone: 506 },
            { name: "Cote D'Ivoire", code: "CI", phone: 225 },
            { name: "Croatia", code: "HR", phone: 385 },
            { name: "Cuba", code: "CU", phone: 53 },
            { name: "Curacao", code: "CW", phone: 599 },
            { name: "Cyprus", code: "CY", phone: 357 },
            { name: "Czech Republic", code: "CZ", phone: 420 },
            { name: "Denmark", code: "DK", phone: 45 },
            { name: "Djibouti", code: "DJ", phone: 253 },
            { name: "Dominica", code: "DM", phone: 1767 },
            { name: "Dominican Republic", code: "DO", phone: 1809 },
            { name: "Ecuador", code: "EC", phone: 593 },
            { name: "Egypt", code: "EG", phone: 20 },
            { name: "El Salvador", code: "SV", phone: 503 },
            { name: "Equatorial Guinea", code: "GQ", phone: 240 },
            { name: "Eritrea", code: "ER", phone: 291 },
            { name: "Estonia", code: "EE", phone: 372 },
            { name: "Ethiopia", code: "ET", phone: 251 },
            { name: "Falkland Islands", code: "FK", phone: 500 },
            { name: "Faroe Islands", code: "FO", phone: 298 },
            { name: "Fiji", code: "FJ", phone: 679 },
            { name: "Finland", code: "FI", phone: 358 },
            { name: "France", code: "FR", phone: 33 },
            { name: "French Guiana", code: "GF", phone: 594 },
            { name: "French Polynesia", code: "PF", phone: 689 },
            { name: "French Southern Territories", code: "TF", phone: 262 },
            { name: "Gabon", code: "GA", phone: 241 },
            { name: "Gambia", code: "GM", phone: 220 },
            { name: "Georgia", code: "GE", phone: 995 },
            { name: "Germany", code: "DE", phone: 49 },
            { name: "Ghana", code: "GH", phone: 233 },
            { name: "Gibraltar", code: "GI", phone: 350 },
            { name: "Greece", code: "GR", phone: 30 },
            { name: "Greenland", code: "GL", phone: 299 },
            { name: "Grenada", code: "GD", phone: 1473 },
            { name: "Guadeloupe", code: "GP", phone: 590 },
            { name: "Guam", code: "GU", phone: 1671 },
            { name: "Guatemala", code: "GT", phone: 502 },
            { name: "Guernsey", code: "GG", phone: 44 },
            { name: "Guinea", code: "GN", phone: 224 },
            { name: "Guinea-Bissau", code: "GW", phone: 245 },
            { name: "Guyana", code: "GY", phone: 592 },
            { name: "Haiti", code: "HT", phone: 509 },
            { name: "Heard Island and McDonald Islands", code: "HM", phone: 0 },
            { name: "Vatican", code: "VA", phone: 39 },
            { name: "Honduras", code: "HN", phone: 504 },
            { name: "Hong Kong", code: "HK", phone: 852 },
            { name: "Hungary", code: "HU", phone: 36 },
            { name: "Iceland", code: "IS", phone: 354 },
            { name: "India", code: "IN", phone: 91 },
            { name: "Indonesia", code: "ID", phone: 62 },
            { name: "Iran", code: "IR", phone: 98 },
            { name: "Iraq", code: "IQ", phone: 964 },
            { name: "Ireland", code: "IE", phone: 353 },
            { name: "Isle of Man", code: "IM", phone: 44 },
            { name: "Israel", code: "IL", phone: 972 },
            { name: "Italy", code: "IT", phone: 39 },
            { name: "Jamaica", code: "JM", phone: 1876 },
            { name: "Japan", code: "JP", phone: 81 },
            { name: "Jersey", code: "JE", phone: 44 },
            { name: "Jordan", code: "JO", phone: 962 },
            { name: "Kazakhstan", code: "KZ", phone: 7 },
            { name: "Kenya", code: "KE", phone: 254 },
            { name: "Kiribati", code: "KI", phone: 686 },
            { name: "Korea, Democratic People's Republic of", code: "KP", phone: 850 },
            { name: "Korea, Republic of", code: "KR", phone: 82 },
            { name: "Kosovo", code: "XK", phone: 383 },
            { name: "Kuwait", code: "KW", phone: 965 },
            { name: "Kyrgyzstan", code: "KG", phone: 996 },
            { name: "Lao People's Democratic Republic", code: "LA", phone: 856 },
            { name: "Latvia", code: "LV", phone: 371 },
            { name: "Lebanon", code: "LB", phone: 961 },
            { name: "Lesotho", code: "LS", phone: 266 },
            { name: "Liberia", code: "LR", phone: 231 },
            { name: "Libyan Arab Jamahiriya", code: "LY", phone: 218 },
            { name: "Liechtenstein", code: "LI", phone: 423 },
            { name: "Lithuania", code: "LT", phone: 370 },
            { name: "Luxembourg", code: "LU", phone: 352 },
            { name: "Macao", code: "MO", phone: 853 },
            { name: "Macedonia", code: "MK", phone: 389 },
            { name: "Madagascar", code: "MG", phone: 261 },
            { name: "Malawi", code: "MW", phone: 265 },
            { name: "Malaysia", code: "MY", phone: 60 },
            { name: "Maldives", code: "MV", phone: 960 },
            { name: "Mali", code: "ML", phone: 223 },
            { name: "Malta", code: "MT", phone: 356 },
            { name: "Marshall Islands", code: "MH", phone: 692 },
            { name: "Martinique", code: "MQ", phone: 596 },
            { name: "Mauritania", code: "MR", phone: 222 },
            { name: "Mauritius", code: "MU", phone: 230 },
            { name: "Mayotte", code: "YT", phone: 262 },
            { name: "Mexico", code: "MX", phone: 52 },
            { name: "Micronesia", code: "FM", phone: 691 },
            { name: "Moldova, Republic of", code: "MD", phone: 373 },
            { name: "Monaco", code: "MC", phone: 377 },
            { name: "Mongolia", code: "MN", phone: 976 },
            { name: "Montenegro", code: "ME", phone: 382 },
            { name: "Montserrat", code: "MS", phone: 1664 },
            { name: "Morocco", code: "MA", phone: 212 },
            { name: "Mozambique", code: "MZ", phone: 258 },
            { name: "Myanmar", code: "MM", phone: 95 },
            { name: "Namibia", code: "NA", phone: 264 },
            { name: "Nauru", code: "NR", phone: 674 },
            { name: "Nepal", code: "NP", phone: 977 },
            { name: "Netherlands", code: "NL", phone: 31 },
            { name: "Netherlands Antilles", code: "AN", phone: 599 },
            { name: "New Caledonia", code: "NC", phone: 687 },
            { name: "New Zealand", code: "NZ", phone: 64 },
            { name: "Nicaragua", code: "NI", phone: 505 },
            { name: "Niger", code: "NE", phone: 227 },
            { name: "Nigeria", code: "NG", phone: 234 },
            { name: "Niue", code: "NU", phone: 683 },
            { name: "Norfolk Island", code: "NF", phone: 672 },
            { name: "Northern Mariana Islands", code: "MP", phone: 1670 },
            { name: "Norway", code: "NO", phone: 47 },
            { name: "Oman", code: "OM", phone: 968 },
            { name: "Pakistan", code: "PK", phone: 92 },
            { name: "Palau", code: "PW", phone: 680 },
            { name: "Palestinian Territory", code: "PS", phone: 970 },
            { name: "Panama", code: "PA", phone: 507 },
            { name: "Papua New Guinea", code: "PG", phone: 675 },
            { name: "Paraguay", code: "PY", phone: 595 },
            { name: "Peru", code: "PE", phone: 51 },
            { name: "Philippines", code: "PH", phone: 63 },
            { name: "Pitcairn", code: "PN", phone: 64 },
            { name: "Poland", code: "PL", phone: 48 },
            { name: "Portugal", code: "PT", phone: 351 },
            { name: "Puerto Rico", code: "PR", phone: 1787 },
            { name: "Qatar", code: "QA", phone: 974 },
            { name: "Reunion", code: "RE", phone: 262 },
            { name: "Romania", code: "RO", phone: 40 },
            { name: "Russian Federation", code: "RU", phone: 7 },
            { name: "Rwanda", code: "RW", phone: 250 },
            { name: "Saint Barthelemy", code: "BL", phone: 590 },
            { name: "Saint Helena", code: "SH", phone: 290 },
            { name: "Saint Kitts and Nevis", code: "KN", phone: 1869 },
            { name: "Saint Lucia", code: "LC", phone: 1758 },
            { name: "Saint Martin", code: "MF", phone: 590 },
            { name: "Saint Pierre and Miquelon", code: "PM", phone: 508 },
            { name: "Saint Vincent and the Grenadines", code: "VC", phone: 1784 },
            { name: "Samoa", code: "WS", phone: 684 },
            { name: "San Marino", code: "SM", phone: 378 },
            { name: "Sao Tome and Principe", code: "ST", phone: 239 },
            { name: "Saudi Arabia", code: "SA", phone: 966 },
            { name: "Senegal", code: "SN", phone: 221 },
            { name: "Serbia", code: "RS", phone: 381 },
            { name: "Seychelles", code: "SC", phone: 248 },
            { name: "Sierra Leone", code: "SL", phone: 232 },
            { name: "Singapore", code: "SG", phone: 65 },
            { name: "St Martin", code: "SX", phone: 721 },
            { name: "Slovakia", code: "SK", phone: 421 },
            { name: "Slovenia", code: "SI", phone: 386 },
            { name: "Solomon Islands", code: "SB", phone: 677 },
            { name: "Somalia", code: "SO", phone: 252 },
            { name: "South Africa", code: "ZA", phone: 27 },
            { name: "South Georgia and the South Sandwich Islands", code: "GS", phone: 500 },
            { name: "South Sudan", code: "SS", phone: 211 },
            { name: "Spain", code: "ES", phone: 34 },
            { name: "Sri Lanka", code: "LK", phone: 94 },
            { name: "Sudan", code: "SD", phone: 249 },
            { name: "Suriname", code: "SR", phone: 597 },
            { name: "Svalbard and Jan Mayen", code: "SJ", phone: 47 },
            { name: "Swaziland", code: "SZ", phone: 268 },
            { name: "Sweden", code: "SE", phone: 46 },
            { name: "Switzerland", code: "CH", phone: 41 },
            { name: "Syrian Arab Republic", code: "SY", phone: 963 },
            { name: "Taiwan, Province of China", code: "TW", phone: 886 },
            { name: "Tajikistan", code: "TJ", phone: 992 },
            { name: "Tanzania, United Republic of", code: "TZ", phone: 255 },
            { name: "Thailand", code: "TH", phone: 66 },
            { name: "Timor-Leste", code: "TL", phone: 670 },
            { name: "Togo", code: "TG", phone: 228 },
            { name: "Tokelau", code: "TK", phone: 690 },
            { name: "Tonga", code: "TO", phone: 676 },
            { name: "Trinidad and Tobago", code: "TT", phone: 1868 },
            { name: "Tunisia", code: "TN", phone: 216 },
            { name: "Turkey", code: "TR", phone: 90 },
            { name: "Turkmenistan", code: "TM", phone: 7370 },
            { name: "Turks and Caicos Islands", code: "TC", phone: 1649 },
            { name: "Tuvalu", code: "TV", phone: 688 },
            { name: "Uganda", code: "UG", phone: 256 },
            { name: "Ukraine", code: "UA", phone: 380 },
            { name: "United Arab Emirates", code: "AE", phone: 971 },
            { name: "United Kingdom", code: "GB", phone: 44 },
            { name: "United States", code: "US", phone: 1 },
            { name: "Uruguay", code: "UY", phone: 598 },
            { name: "Uzbekistan", code: "UZ", phone: 998 },
            { name: "Vanuatu", code: "VU", phone: 678 },
            { name: "Venezuela", code: "VE", phone: 58 },
            { name: "Viet Nam", code: "VN", phone: 84 },
            { name: "Virgin Islands, British", code: "VG", phone: 1284 },
            { name: "Virgin Islands, U.s.", code: "VI", phone: 1340 },
            { name: "Wallis and Futuna", code: "WF", phone: 681 },
            { name: "Western Sahara", code: "EH", phone: 212 },
            { name: "Yemen", code: "YE", phone: 967 },
            { name: "Zambia", code: "ZM", phone: 260 },
            { name: "Zimbabwe", code: "ZW", phone: 263 }
        ], optionsContainer_1 = countryDropdown.querySelector('.country-dropdown__options'), searchInput_1 = countryDropdown.querySelector('.country-dropdown__search'), numberInput_1 = countryDropdown.querySelector('.country-dropdown__number'), dropdown_1 = countryDropdown.querySelector('.country-dropdown__inner');
        var options_1 = null;
        countries.forEach(function (country) {
            var option = "\n        <li class=\"country-dropdown__country-item option flex flex--justify-between\" tabindex=\"0\">\n          <div class=\"country-dropdown__country\">\n            <span class=\"country-dropdown__flag iconify\" data-icon=\"flag:" + country.code.toLowerCase() + "-4x3\"></span>\n            <span class=\"country-dropdown__title country-name\">" + country.name + "</span>\n          </div>\n          <span class=\"country-dropdown__country-code\">+" + country.phone + "</span>\n        </li> ";
            optionsContainer_1.querySelector('.country-dropdown__list').insertAdjacentHTML('beforeend', option);
            options_1 = countryDropdown.querySelectorAll('.country-dropdown__country-item');
        });
        var selectOption_1 = function (item) {
            var icon = item.querySelector('.country-dropdown__flag').cloneNode(true), phone_code = item.querySelector('.country-dropdown__country-code').cloneNode(true);
            phone_code.style.pointerEvents = 'none';
            icon.style.pointerEvents = 'none';
            dropdown_1.innerHTML = '';
            dropdown_1.append(icon, phone_code);
            numberInput_1.focus();
            optionsContainer_1.classList.remove('active');
            dropdown_1.classList.remove('active');
            optionsContainer_1.querySelectorAll('.hide').forEach(function (el) { return el.classList.remove('hide'); });
        };
        var searchCountry = function () {
            var searchQuery = searchInput_1.value.toLowerCase();
            options_1.forEach(function (option) {
                var countryNameElement = option.querySelector('.country-dropdown__title');
                var isMatched = countryNameElement.innerText.toLowerCase().includes(searchQuery);
                option.classList.toggle('hide', !isMatched);
            });
        };
        dropdown_1.addEventListener('click', function () {
            optionsContainer_1.classList.toggle('active');
            dropdown_1.classList.toggle('active');
            searchInput_1.focus();
        });
        dropdown_1.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                optionsContainer_1.classList.add('active');
                dropdown_1.classList.add('active');
                searchInput_1.focus();
            }
        });
        options_1.forEach(function (option) { return option.addEventListener('click', function () {
            selectOption_1(option);
        }); });
        options_1.forEach(function (option) { return option.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                selectOption_1(option);
            }
        }); });
        searchInput_1.addEventListener('input', searchCountry);
        window.addEventListener('click', function (e) {
            var target = e.target;
            if (target.classList.contains('country-dropdown__inner') || target.classList.contains('country-dropdown__search')) {
                return;
            }
            else {
                optionsContainer_1.classList.remove('active');
                dropdown_1.classList.remove('active');
            }
        });
    }
});
},{}],23:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var curriculums = document.querySelector('.curriculums');
if (curriculums) {
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5}],24:[function(require,module,exports){
var dateRange = document.querySelector('.date-range');
if (dateRange) {
    var dateRangeFilterTrigger = dateRange.querySelector('.date-range__icon-container');
    var dateRangeInner_1 = dateRange.querySelector('.date-range__inner');
    var dateRangeIcon_1 = dateRange.querySelector('.date-range__icon-container');
    var dateRangeInputs = dateRange.querySelectorAll('.date-range__input');
    var handleDateClick_1 = function (input) {
        try {
            input.showPicker();
        }
        catch (error) {
            console.error(error.message);
        }
    };
    if (dateRangeInner_1 && dateRangeIcon_1) {
        var handleTrigger_1 = function () {
            dateRangeInner_1.classList.toggle('date-range__inner--active');
            dateRangeIcon_1.classList.toggle('date-range__icon-container--active');
        };
        var closeDateRange_1 = function () {
            dateRangeInner_1.classList.remove('date-range__inner--active');
            dateRangeIcon_1.classList.remove('date-range__icon-container--active');
        };
        dateRangeInputs.forEach(function (input) {
            input.addEventListener('click', function () {
                handleDateClick_1(input);
            });
            input.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    handleDateClick_1(input);
                }
            });
            input.addEventListener('input', function () {
                input.classList.add('date-range__input--active');
                input.nextElementSibling.classList.add('date-range__input-overlay--hidden');
            });
        });
        dateRangeFilterTrigger.addEventListener('click', function () {
            handleTrigger_1();
        });
        dateRangeFilterTrigger.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                handleTrigger_1();
            }
        });
        document.addEventListener('click', function (event) {
            if (event.target instanceof Element) {
                if (dateRange && !dateRange.contains(event.target)) {
                    closeDateRange_1();
                }
            }
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeDateRange_1();
            }
        });
    }
}
},{}],25:[function(require,module,exports){
var digitalLibrary = document.querySelector('.digital-library-list__wrapper');
if (digitalLibrary) {
    var digitalCards = digitalLibrary.querySelectorAll('.digital-library-list__item');
    if (digitalCards.length > 0) {
        var top_1 = 180;
        var headerHeight_1 = 65;
        if (window.innerWidth < 1200) {
            top_1 = 20;
        }
        digitalCards.forEach(function (card, i) {
            var incValue = i * headerHeight_1;
            if (i === 0) {
                card.style.top = top_1 + "px";
            }
            else {
                card.style.top = top_1 + incValue + "px";
            }
        });
    }
}
},{}],26:[function(require,module,exports){
var filters = document.querySelectorAll(".dropdown-filter");
var direction = document.querySelector("html").getAttribute("dir");
filters.forEach(function (item) {
    var selects = item.querySelectorAll(".multi-select");
    selects.forEach(function (select) {
        init(select);
    });
    document.addEventListener('click', function (e) {
        var selects = document.querySelectorAll(".multi-select");
        var buttonContainer = document.querySelectorAll(".dropdown-filter__button-container");
        var triggers = document.querySelectorAll(".dropdown-filter__trigger");
        for (var i = 0; i < selects.length; i++) {
            if (e) {
                var isClickInside = selects[i].parentElement.parentElement.contains(e.target);
                if (!isClickInside) {
                    var wrapper = selects[i].parentElement.parentElement;
                    var dropdown = wrapper.querySelector(".dropdown-filter__dropdown-icon");
                    var autocomplete_list = wrapper.querySelector(".dropdown-filter__autocomplete-list");
                    dropdown.classList.remove("active");
                    var multiSelects = document.querySelectorAll(".dropdown-filter__multi-select-container");
                    multiSelects[i].classList.remove("dropdown-filter__multi-select-container--active");
                    buttonContainer[i].classList.remove("dropdown-filter__button-container--active");
                    triggers[i].classList.remove("dropdown-filter__trigger--active");
                    autocomplete_list.innerHTML = "";
                    addPlaceholder(wrapper);
                }
            }
        }
    });
    var trigger = item.querySelector(".dropdown-filter__trigger");
    if (trigger) {
        trigger.addEventListener("click", handleTrigger);
        trigger.addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
                handleTrigger(e);
            }
        });
    }
    function handleTrigger(e) {
        var wrapper = item.querySelector(".dropdown-filter__multi-select-container");
        var buttonContainer = item.querySelector(".dropdown-filter__button-container");
        if (wrapper.classList.contains("dropdown-filter__multi-select-container--active")) {
            wrapper.classList.remove("dropdown-filter__multi-select-container--active");
            buttonContainer.classList.remove("dropdown-filter__button-container--active");
            trigger.classList.remove("dropdown-filter__trigger--active");
        }
        else {
            wrapper.classList.add("dropdown-filter__multi-select-container--active");
            buttonContainer.classList.add("dropdown-filter__button-container--active");
            trigger.classList.add("dropdown-filter__trigger--active");
        }
        var dropdown = wrapper.querySelector(".dropdown-filter__dropdown-icon");
        var event = new Event('click');
        dropdown.dispatchEvent(event);
    }
    function init(element) {
        var filter = item;
        var wrapper = document.createElement("div");
        wrapper.addEventListener("click", clickOnWrapper);
        wrapper.classList.add("dropdown-filter__multi-select-container");
        var search_div = document.createElement("div");
        search_div.classList.add("dropdown-filter__search-container");
        var buttonContainer = document.createElement("div");
        buttonContainer.classList.add("dropdown-filter__button-container");
        var input = document.createElement("input");
        input.classList.add("selected-input");
        input.setAttribute("autocomplete", "off");
        input.setAttribute("tabindex", "0");
        input.addEventListener("keyup", inputChange);
        input.addEventListener("keydown", deletePressed);
        input.addEventListener("click", openOptions);
        var dropdown_icon = document.createElement("a");
        dropdown_icon.classList.add("dropdown-filter__dropdown-icon");
        dropdown_icon.addEventListener("click", clickDropdown);
        var autocomplete_list = document.createElement("ul");
        autocomplete_list.classList.add("dropdown-filter__autocomplete-list");
        search_div.appendChild(input);
        search_div.appendChild(autocomplete_list);
        search_div.appendChild(dropdown_icon);
        filter.appendChild(buttonContainer);
        element.parentNode.replaceChild(wrapper, element);
        wrapper.appendChild(element);
        wrapper.appendChild(search_div);
        createInitialTokens(element);
        addPlaceholder(wrapper);
    }
    function removePlaceholder(wrapper) {
        var input_search = wrapper.querySelector(".selected-input");
        input_search.removeAttribute("placeholder");
    }
    function addPlaceholder(wrapper) {
        var input_search = wrapper.querySelector(".selected-input");
        var tokens = wrapper.querySelectorAll(".dropdown-filter__selected-wrapper");
        if (!tokens.length && !(document.activeElement === input_search))
            input_search.setAttribute("placeholder", "---------");
    }
    function createInitialTokens(select) {
        var options_selected = getOptions(select).options_selected;
        var wrapper = select.parentNode;
        for (var i = 0; i < options_selected.length; i++) {
            createToken(wrapper, options_selected[i]);
        }
    }
    function inputChange(e) {
        var wrapper = e.target.parentNode.parentNode;
        var select = wrapper.querySelector("select");
        var dropdown = wrapper.querySelector(".dropdown-filter__dropdown-icon");
        var input_val = e.target.value;
        if (input_val) {
            dropdown.classList.add("active");
            populateAutocompleteList(select, input_val.trim());
        }
        else {
            dropdown.classList.remove("active");
            var event_1 = new Event('click');
            dropdown.dispatchEvent(event_1);
        }
    }
    function clickOnWrapper(e) {
        var wrapper = e.target;
        if (wrapper.tagName == "DIV") {
            var input_search = wrapper.querySelector(".selected-input");
            var dropdown = wrapper.querySelector(".dropdown-filter__dropdown-icon");
            if (!dropdown.classList.contains("active")) {
                var event_2 = new Event('click');
                dropdown.dispatchEvent(event_2);
            }
            input_search.focus();
            removePlaceholder(wrapper);
        }
    }
    function openOptions(e) {
        var input_search = e.target;
        var wrapper = input_search.parentElement.parentElement;
        var dropdown = wrapper.querySelector(".dropdown-filter__dropdown-icon");
        if (!dropdown.classList.contains("active")) {
            var event_3 = new Event('click');
            dropdown.dispatchEvent(event_3);
        }
        e.stopPropagation();
    }
    function createToken(wrapper, value) {
        var buttonContainer = item.querySelector(".dropdown-filter__button-container");
        var tokenContainer = document.createElement("div");
        tokenContainer.classList.add("wrapper");
        var token = document.createElement("div");
        token.classList.add("dropdown-filter__selected-wrapper");
        var token_span = document.createElement("span");
        token_span.classList.add("selected-label");
        token_span.innerText = value;
        var close = document.createElement("a");
        close.classList.add("selected-close");
        close.setAttribute("tabindex", "-1");
        close.setAttribute("data-option", value);
        close.setAttribute("data-hits", "0");
        close.addEventListener("click", removeToken);
        token.appendChild(token_span);
        token.appendChild(close);
        buttonContainer.appendChild(token);
    }
    function clickDropdown(e) {
        var dropdown = e.target;
        var wrapper = dropdown.parentNode.parentNode;
        var input_search = wrapper.querySelector(".selected-input");
        var select = wrapper.querySelector("select");
        dropdown.classList.toggle("active");
        if (dropdown.classList.contains("active")) {
            removePlaceholder(wrapper);
            input_search.focus();
            if (!input_search.value) {
                populateAutocompleteList(select, "", true);
            }
            else {
                populateAutocompleteList(select, input_search.value);
            }
        }
        else {
            clearAutocompleteList(select);
            addPlaceholder(wrapper);
        }
    }
    function clearAutocompleteList(select) {
        var wrapper = select.parentNode;
        var autocomplete_list = wrapper.querySelector(".dropdown-filter__autocomplete-list");
        autocomplete_list.innerHTML = "";
    }
    function populateAutocompleteList(select, query, dropdown) {
        if (dropdown === void 0) { dropdown = false; }
        var _a = getOptions(select), autocomplete_options = _a.autocomplete_options, all_options = _a.all_options, options_selected = _a.options_selected;
        var options_to_show;
        if (dropdown)
            options_to_show = autocomplete_options;
        else
            options_to_show = autocomplete(query, autocomplete_options);
        var wrapper = select.parentNode;
        var autocomplete_list = wrapper.querySelector(".dropdown-filter__autocomplete-list");
        autocomplete_list.innerHTML = "";
        var result_size = options_to_show.length;
        if (result_size == 1) {
            var li = document.createElement("li");
            li.innerText = options_to_show[0];
            li.setAttribute('data-value', options_to_show[0]);
            li.addEventListener("click", selectOption);
            autocomplete_list.appendChild(li);
            if (query.length == options_to_show[0].length) {
                var event_4 = new Event('click');
                li.dispatchEvent(event_4);
            }
        }
        else if (result_size > 1) {
            for (var i = 0; i < result_size; i++) {
                var li = document.createElement("li");
                li.innerText = options_to_show[i];
                li.setAttribute('data-value', options_to_show[i]);
                li.addEventListener("click", selectOption);
                autocomplete_list.appendChild(li);
            }
        }
        else {
            var li = document.createElement("li");
            li.classList.add("not-cursor");
            if (direction === "rtl") {
                li.innerText = "لم يتم العثور على خيارات";
            }
            else {
                li.innerText = "No options found";
            }
            autocomplete_list.appendChild(li);
        }
        handleListItems(options_selected);
    }
    function selectOption(e) {
        var filterComponent = item;
        var select = filterComponent.querySelector(".multi-select");
        var options_selected = Array.from(select.querySelectorAll("option:checked")).map(function (el) { return el.value; });
        if (options_selected.includes(e.target.dataset.value)) {
            removeTokenList(e.target.dataset.value);
            return;
        }
        var wrapper = e.target.parentNode.parentNode.parentNode;
        var input_search = wrapper.querySelector(".selected-input");
        var option = wrapper.querySelector("select option[value=\"" + e.target.dataset.value + "\"]");
        option.setAttribute("selected", "");
        createToken(wrapper, e.target.dataset.value);
        if (input_search.value) {
            input_search.value = "";
        }
        input_search.focus();
        var autocomplete_list = wrapper.querySelector(".dropdown-filter__autocomplete-list");
        if (!autocomplete_list.children.length) {
            var li = document.createElement("li");
            li.classList.add("not-cursor");
            li.innerText = "No options found";
            autocomplete_list.appendChild(li);
        }
        var event = new Event('keyup');
        input_search.dispatchEvent(event);
        e.stopPropagation();
    }
    function autocomplete(query, options) {
        if (!query) {
            return options;
        }
        var options_return = [];
        for (var i = 0; i < options.length; i++) {
            if (options[i].toLowerCase().includes(query.toLowerCase())) {
                options_return.push(options[i]);
            }
        }
        return options_return;
    }
    function getOptions(select) {
        var all_options = Array.from(select.querySelectorAll("option")).map(function (el) { return el.value; });
        var options_selected = Array.from(select.querySelectorAll("option:checked")).map(function (el) { return el.value; });
        var autocomplete_options = [];
        all_options.forEach(function (option) {
            if (!options_selected.includes(option)) {
                autocomplete_options.push(option);
            }
        });
        autocomplete_options.sort();
        autocomplete_options = all_options;
        return {
            options_selected: options_selected,
            autocomplete_options: autocomplete_options,
            all_options: all_options
        };
    }
    function removeToken(e) {
        var value_to_remove = e.target.dataset.option;
        var wrapper = item.querySelector(".multi-select");
        var input_search = item.querySelector(".selected-input");
        var dropdown = item.querySelector(".dropdown-filter__dropdown-icon");
        var option_to_unselect = wrapper.querySelector("select option[value=\"" + value_to_remove + "\"]");
        option_to_unselect.removeAttribute("selected");
        e.target.parentNode.remove();
        input_search.focus();
        dropdown.classList.remove("active");
        var event = new Event('click');
        dropdown.dispatchEvent(event);
        e.stopPropagation();
    }
    function removeTokenList(value) {
        var value_to_remove = value;
        var wrapper = item.querySelector(".multi-select");
        var input_search = item.querySelector(".selected-input");
        var option_to_unselect = wrapper.querySelector("select option[value=\"" + value_to_remove + "\"]");
        option_to_unselect.removeAttribute("selected");
        var options_selected = [];
        var selectedElements = item.querySelectorAll(".selected-label");
        selectedElements.forEach(function (el) {
            if (el.textContent === value) {
                el.parentElement.remove();
            }
        });
        var updatedSelectedElements = item.querySelectorAll(".selected-label");
        updatedSelectedElements.forEach(function (item) {
            options_selected.push(item.textContent);
        });
        input_search.focus();
        handleListItems(options_selected);
    }
    function deletePressed(e) {
        var wrapper = e.target.parentNode.parentNode;
        var input_search = e.target;
        var key = e.keyCode || e.charCode;
        var tokens = wrapper.querySelectorAll(".dropdown-filter__selected-wrapper");
        if (tokens.length) {
            var last_token_x = tokens[tokens.length - 1].querySelector("a");
            var hits = +last_token_x.dataset.hits;
            if (key == 8 || key == 46) {
                if (!input_search.value) {
                    if (hits > 1) {
                        var event_5 = new Event('click');
                        last_token_x.dispatchEvent(event_5);
                    }
                    else {
                        last_token_x.dataset.hits = 2;
                    }
                }
            }
            else {
                last_token_x.dataset.hits = 0;
            }
        }
        return true;
    }
    function addOption(target, val, text) {
        var select = item.querySelector(target);
        var opt = document.createElement('option');
        opt.value = val;
        opt.innerHTML = text;
        select.appendChild(opt);
    }
    var handleListItems = function (arr) {
        var list = item.querySelectorAll(".dropdown-filter__autocomplete-list li");
        list.forEach(function (item) {
            if (arr.includes(item.textContent)) {
                item.classList.add("item--active");
            }
            else {
                item.classList.remove("item--active");
            }
        });
    };
});
},{}],27:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var eservicesComponent = document.querySelector('.e-services');
if (eservicesComponent) {
    var eserviceCarousels = eservicesComponent.querySelectorAll('.e-services__carousel-inner');
    var direction_1 = document.querySelector('html').getAttribute('dir');
    var eserviceTabs_1 = eservicesComponent.querySelectorAll('.e-services__tab');
    var eserviceCarouselsContainer_1 = eservicesComponent.querySelectorAll('.e-services__carousel');
    var activeTab_1 = 0;
    if (eserviceCarousels.length > 0) {
        var eserviceCarouselsArray = Array.from(eserviceCarousels) || [];
        eserviceCarouselsArray.forEach(function (item) {
            var glideSettings = {
                type: 'slider',
                perView: 4,
                gap: 24,
                rewind: true,
                bound: true,
                direction: direction_1 || 'ltr',
                breakpoints: {
                    1400: {
                        perView: 3,
                    },
                    1100: {
                        perView: 2,
                        gap: 16,
                    },
                },
            };
            var glide = new glide_1.default(item, glideSettings);
            glide.mount();
        });
    }
    var resetAll_1 = function () {
        eserviceCarouselsContainer_1.forEach(function (carousel) { return carousel.classList.remove('e-services__carousel--active'); });
        eserviceTabs_1.forEach(function (tab) { return tab.classList.remove('e-services__tab--active'); });
    };
    var showActiveItems_1 = function (activeTab) {
        resetAll_1();
        eserviceTabs_1[activeTab].classList.add('e-services__tab--active');
        eserviceCarouselsContainer_1[activeTab].classList.add('e-services__carousel--active');
        if (window.innerWidth <= 767.98) {
            var activeCarousel = eserviceCarouselsContainer_1[activeTab];
            var carouselItems = activeCarousel.querySelectorAll('.e-services__card');
            carouselItems.forEach(function (item, index) {
                if (index < 4) {
                    item.classList.add('e-services__card--active');
                }
                else {
                    item.classList.remove('e-services__card--active');
                }
            });
        }
    };
    eserviceTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            showActiveItems_1(activeTab_1);
        });
    });
    showActiveItems_1(activeTab_1);
    var shareButtons = eservicesComponent.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var favButtons = eservicesComponent.querySelectorAll('.favouriteButton');
    if (favButtons && favButtons.length > 0) {
        favButtons.forEach(function (button) {
            var dataIdAttr = button.getAttribute('data-id');
            var type = button.getAttribute('data-type');
            var favouritedIds = JSON.parse(button.getAttribute('data-ids'));
            if (dataIdAttr !== null && favouritedIds != null) {
                var dataId_1 = parseInt(dataIdAttr);
                if (isFavourite_1.IsFavourited(dataId_1, favouritedIds)) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
                button.addEventListener('click', function (e) {
                    console.log('small button clicked - events details');
                    favourites_1.default(type, dataId_1, button);
                });
            }
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9,"@glidejs/glide":115}],28:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var eacomponent = document.querySelectorAll(".employee-access-component");
if (eacomponent) {
    var buttons = document.querySelectorAll(".employee-access-component__button");
    buttons.forEach(function (button) {
        button.addEventListener("click", function (e) {
            var target = e.target;
            if (target.classList.contains("button") || target.classList.contains("button__image")) {
                e.preventDefault();
            }
            if (target.classList.contains("shareButton")) {
                copyToClipboard_1.default(button);
            }
        });
    });
}
},{"../../../helpers/copyToClipboard":5}],29:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var addToCalendar_1 = __importDefault(require("../../../helpers/addToCalendar"));
var enrichKnowledge = document.querySelector('.enrich-knowledge');
if (enrichKnowledge) {
    var enrichTabs_1 = enrichKnowledge.querySelectorAll('.enrich-knowledge__tab');
    var sections_1 = enrichKnowledge.querySelectorAll('.enrich-knowledge__section');
    var activeTab_1 = 0;
    var resetTabs_1 = function () {
        enrichTabs_1.forEach(function (tab) { return tab.classList.remove('enrich-knowledge__tab--active'); });
        sections_1.forEach(function (tab) { return tab.classList.remove('enrich-knowledge__section--active'); });
    };
    enrichTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            resetTabs_1();
            enrichTabs_1[activeTab_1].classList.add('enrich-knowledge__tab--active');
            sections_1[activeTab_1].classList.add('enrich-knowledge__section--active');
        });
    });
    sections_1.forEach(function (section) {
        var accordion = section.firstElementChild;
        if (accordion != null) {
            if (accordion.classList.contains('enrich-knowledge__accordion')) {
                accordion.setAttribute('open', 'true');
            }
        }
        var accordions = section.querySelectorAll('.enrich-knowledge__accordion');
        accordions.forEach(function (childAccordion) {
            childAccordion.addEventListener('toggle', function () {
                if (childAccordion.open) {
                    accordions.forEach(function (otherAccordion) {
                        if (otherAccordion !== childAccordion) {
                            otherAccordion.removeAttribute('open');
                        }
                    });
                }
            });
        });
    });
    var favButtons = document.querySelectorAll('.favouriteButton');
    if (favButtons && favButtons.length > 0) {
        favButtons.forEach(function (button) {
            var dataIdAttr = button.getAttribute('data-id');
            var type = button.getAttribute('data-type');
            var favouritedIds = JSON.parse(button.getAttribute('data-ids'));
            if (dataIdAttr !== null && favouritedIds != null) {
                var dataId_1 = parseInt(dataIdAttr);
                if (isFavourite_1.IsFavourited(dataId_1, favouritedIds)) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
                button.addEventListener('click', function (e) {
                    console.log('small button clicked - program details');
                    favourites_1.default(type, dataId_1, button);
                });
            }
        });
    }
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var calButtons = document.querySelectorAll('.calButton');
    if (calButtons && calButtons.length > 0) {
        calButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                addToCalendar_1.default(button);
            });
        });
    }
}
},{"../../../helpers/addToCalendar":3,"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9}],30:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var addToCalendar_1 = __importDefault(require("../../../helpers/addToCalendar"));
var eventsDetails = document.querySelector('.event-details');
if (eventsDetails) {
    var favButtons = document.querySelectorAll('.favouriteButton');
    if (favButtons && favButtons.length > 0) {
        favButtons.forEach(function (button) {
            var dataIdAttr = button.getAttribute('data-id');
            var type = button.getAttribute('data-type');
            var favouritedIds = JSON.parse(button.getAttribute('data-ids'));
            if (dataIdAttr !== null && favouritedIds != null) {
                var dataId_1 = parseInt(dataIdAttr);
                if (isFavourite_1.IsFavourited(dataId_1, favouritedIds)) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
                button.addEventListener('click', function (e) {
                    console.log('small button clicked - events details');
                    favourites_1.default(type, dataId_1, button);
                });
            }
        });
    }
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var calButtons = document.querySelectorAll('.calButton');
    if (calButtons && calButtons.length > 0) {
        calButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                addToCalendar_1.default(button);
            });
        });
    }
}
},{"../../../helpers/addToCalendar":3,"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9}],31:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var axios_1 = __importDefault(require("axios"));
var eventsCalendar = document.querySelector('.events-calendar');
if (eventsCalendar) {
    var eventsCalendarCarousel = eventsCalendar.querySelector('.events-calendar__carousel-inner');
    var carouselItemsContainer_1 = eventsCalendar.querySelector('.events-calendar__carousel-slides');
    var tabs_1 = eventsCalendar.querySelectorAll('.events-calendar__tab');
    var columns_1 = eventsCalendar.querySelectorAll('.events-calendar__column');
    var eventsListSearchInput_1 = eventsCalendar.querySelector('.events-calendar__search-input');
    var eventsCalendarDateFrom = eventsCalendar.querySelector('.date-range__input-from');
    var eventsCalendarDateTo = eventsCalendar.querySelector('.date-range__input-to');
    var direction_1 = document.querySelector('html').getAttribute('dir');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var activeTab_1 = 0;
    var activeItem_1 = 0;
    var eventCalendarCards_1 = [];
    var keyword_1 = '';
    var dateFrom_1 = '';
    var dateTo_1 = '';
    var eventType_1 = 0;
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = 100;
    var createWeekButtons = function () {
        var oneDay = 24 * 60 * 60 * 1000;
        var today = new Date();
        var getStartOfCurrentWeek = function (date) {
            var day = date.getDay();
            var diff = date.getDate() - day + (day >= 5 ? 6 : -1);
            return new Date(date.setDate(diff));
        };
        var currentDate = today.getDay() === 5 ? today : getStartOfCurrentWeek(today);
        for (var i = 0; i < 52; i++) {
            var startOfWeek = new Date(currentDate);
            var endOfWeek = new Date(startOfWeek.getTime() + 6 * oneDay);
            if (i === 0) {
                dateFrom_1 = startOfWeek.toISOString().split('T')[0];
                dateTo_1 = endOfWeek.toISOString().split('T')[0];
            }
            var button = document.createElement('button');
            button.className =
                'events-calendar__carousel-item events-calendar__carousel-item--active flex flex--align-center flex--justify-center';
            var startMonth = '';
            var endMonth = '';
            if (direction_1 === 'rtl') {
                startMonth = startOfWeek.toLocaleDateString('ar', { month: 'long' });
                endMonth = endOfWeek.toLocaleDateString('ar', { month: 'long' });
            }
            else {
                startMonth = startOfWeek.toLocaleDateString('en-US', { month: 'long' });
                endMonth = endOfWeek.toLocaleDateString('en-US', { month: 'long' });
            }
            var buttonText = startOfWeek.getDate() + "-" + endOfWeek.getDate();
            if (startMonth !== endMonth) {
                buttonText += " " + startMonth + "/" + endMonth;
            }
            else {
                buttonText += " " + startMonth;
            }
            button.textContent = buttonText;
            button.setAttribute('data-date-from', startOfWeek.toISOString().split('T')[0]);
            button.setAttribute('data-date-to', endOfWeek.toISOString().split('T')[0]);
            carouselItemsContainer_1.appendChild(button);
            currentDate = new Date(currentDate.getTime() + 7 * oneDay);
        }
    };
    var resetTabs_1 = function () {
        tabs_1.forEach(function (tab) { return tab.classList.remove('events-calendar__tab--active'); });
    };
    var fetchEvents_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        keyword: keyword_1,
                        dateFrom: dateFrom_1,
                        dateTo: dateTo_1,
                        eventType: eventType_1,
                        sortBy: sortBy_1,
                        pageNumber: pageNumber_1,
                        pageSize: pageSize_1,
                        currentCulture: currentCulture_1,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    response = void 0;
                    if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                        window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                    return [4, axios_1.default.post('/api/events', payload)];
                case 2:
                    response = _a.sent();
                    return [3, 5];
                case 3: return [4, axios_1.default.post('/api/events', payload)];
                case 4:
                    response = _a.sent();
                    _a.label = 5;
                case 5:
                    eventCalendarCards_1 = response.data.items;
                    return [3, 8];
                case 6:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 8];
                case 7:
                    updateCards_1(eventCalendarCards_1);
                    return [7];
                case 8: return [2];
            }
        });
    }); };
    var glideSettings = {
        type: 'slider',
        perView: 9,
        gap: 0,
        rewind: false,
        bound: false,
        direction: direction_1 || 'ltr',
        breakpoints: {
            992: {
                perView: 6,
            },
            768: {
                perView: 5,
            },
            480: {
                perView: 3,
            },
        },
    };
    createWeekButtons();
    var glide_2 = new glide_1.default(eventsCalendarCarousel, glideSettings);
    glide_2.mount();
    var carouselItems = eventsCalendar.querySelectorAll('.events-calendar__carousel-item');
    carouselItems.forEach(function (item, index) {
        item.addEventListener('click', function () {
            activeItem_1 = index;
            glide_2.go("=" + index);
            if (index > 0) {
                resetTabs_1();
                tabs_1[1].classList.add('events-calendar__tab--active');
            }
        });
    });
    var timeout_1 = null;
    glide_2.on('move.after', function () {
        activeItem_1 === glide_2.index;
        if (glide_2.index > 0) {
            resetTabs_1();
            tabs_1[1].classList.add('events-calendar__tab--active');
            activeItem_1 = glide_2.index;
        }
        else if (glide_2.index === 0) {
            resetTabs_1();
            tabs_1[0].classList.add('events-calendar__tab--active');
            activeItem_1 = 0;
        }
        eventsListSearchInput_1.value = '';
        var carouselTabs = eventsCalendar.querySelectorAll('.events-calendar__carousel-item');
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            dateFrom_1 = carouselTabs[activeItem_1].getAttribute('data-date-from');
            dateTo_1 = carouselTabs[activeItem_1].getAttribute('data-date-to');
            fetchEvents_1();
        }, 100);
    });
    tabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            resetTabs_1();
            tabs_1[activeTab_1].classList.add('events-calendar__tab--active');
            if (index === 0) {
                glide_2.go("=0");
            }
            if (index === 1 && activeItem_1 === 0) {
                activeItem_1 = 1;
                glide_2.go("=1");
            }
        });
    });
    if (window.innerWidth < 992) {
        var eventsCalendarColumns_1 = eventsCalendar.querySelectorAll('.events-calendar__column');
        eventsCalendarColumns_1.forEach(function (column) {
            column.removeAttribute('open');
            eventsCalendarColumns_1[0].open = true;
        });
    }
    eventsListSearchInput_1.addEventListener('input', function (e) {
        var target = e.target;
        var searchInputValue = target.value.toLowerCase();
        var cards = eventsCalendar.querySelectorAll('.events-calendar__card');
        cards.forEach(function (card) {
            var _a;
            var cardText = ((_a = card.querySelector('.events-calendar__card-text').textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
            if (cardText.includes(searchInputValue)) {
                card.classList.remove('hidden');
            }
            else {
                card.classList.add('hidden');
            }
        });
    });
    var updateCards_1 = function (items) {
        columns_1.forEach(function (column) {
            var cards = column.querySelectorAll('.events-calendar__card');
            cards.forEach(function (card) { return card.remove(); });
        });
        items.forEach(function (item) {
            createCard_1(item);
        });
        setColumnNumbers_1();
    };
    var createCard_1 = function (item) {
        var card = document.createElement('a');
        card.className = 'events-calendar__card flex flex--column fade-in';
        card.setAttribute('href', item.link);
        card.setAttribute('data-from', item.start_Date);
        card.setAttribute('data-to', item.end_Date);
        card.innerHTML = "\n        " + (item.image !== null ? "<img src=\"" + item.image + "\" alt=\"this is alt\" class=\"events-calendar__card-image\">" : '') + "\n        <p class=\"events-calendar__card-text\">" + item.title + "</p>\n        ";
        var dayToColumnIndex = {
            6: 0,
            0: 1,
            1: 2,
            2: 3,
            3: 4,
            4: 5,
            5: -1,
        };
        var dayOfWeek = new Date(item.start_Date).getDay();
        var columnIndex = dayToColumnIndex[dayOfWeek];
        if (columnIndex !== -1) {
            var cardsContainer = columns_1[columnIndex].querySelector('.events-calendar__cards');
            cardsContainer.appendChild(card);
        }
    };
    var setColumnNumbers_1 = function () {
        columns_1.forEach(function (column) {
            var numberContainer = column.querySelector('.events-calendar__column-number');
            var cardsContainer = column.querySelector('.events-calendar__cards');
            var numberOfCards = cardsContainer.children.length;
            var formattedNumber;
            if (numberOfCards === 0) {
                formattedNumber = '0';
            }
            else if (numberOfCards < 10) {
                formattedNumber = '0' + numberOfCards;
            }
            else {
                formattedNumber = numberOfCards.toString();
            }
            numberContainer.textContent = formattedNumber;
        });
    };
    fetchEvents_1();
}
},{"@glidejs/glide":115,"axios":116}],32:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],33:[function(require,module,exports){
var cards = document.querySelectorAll(".events-card");
if (cards && cards.length > 0) {
    var cardButtons = document.querySelectorAll(".events-card__button");
    cards.forEach(function (card) {
        card.addEventListener("click", function (e) {
            var target = e.target;
            if (target.classList.contains("button") || target.classList.contains("button__image")) {
                e.preventDefault();
            }
        });
    });
    cardButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
        });
    });
}
},{}],34:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var addToCalendar_1 = __importDefault(require("../../../helpers/addToCalendar"));
var isUserLoggedIn_1 = __importDefault(require("../../../helpers/isUserLoggedIn"));
var eventsList = document.querySelector('.events-list');
if (eventsList) {
    var eventsGrid_1 = eventsList.querySelector('.events-list__grid');
    var eventsFilters_1 = eventsList.querySelector('.events-list__search');
    var eventsListSearchInput_1 = eventsList.querySelector('.events-list__search-input');
    var eventDateFrom = eventsList.querySelector('.date-range__input-from');
    var eventDateTo = eventsList.querySelector('.date-range__input-to');
    var eventTabs_1 = eventsList.querySelectorAll('.events-list__tab');
    var eventTabsComponent_1 = eventsList.querySelector('.events-list__tabs');
    var nextPageButton = eventsList.querySelector('.pagination__page-next');
    var prevPageButton = eventsList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = eventsList.querySelector('.pagination__dropdown');
    var paginationLast = eventsList.querySelector('.pagination__page-last');
    var paginationFirst = eventsList.querySelector('.pagination__page-first');
    var pagination_2 = eventsList.querySelector('.pagination');
    var radios_1 = eventsList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var favouritedIds_1 = JSON.parse(eventsGrid_1.getAttribute('data-ids'));
    var activeTab_1 = 0;
    var eventCards_1 = [];
    var keyword_1 = '';
    var dateFrom_1 = '';
    var dateTo_1 = '';
    var eventType_1 = 1;
    var sortBy_1 = 2;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var keywordChanged_1 = false;
    var eventCardSettings_1 = {
        dateFromText: '',
        dateToText: '',
        locationText: '',
    };
    var resetTabs_1 = function () {
        eventTabs_1.forEach(function (tab) { return tab.classList.remove('events-list__tab--active'); });
    };
    var fetchEventCardSettings_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/events/cardsettings?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    eventCardSettings_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchEvents_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var url, eventTypeParam, eventTypeTabIndex, payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        url = new URL(window.location.href);
                        pageNumber_1 = keywordChanged_1 ? 1 : Number(url.searchParams.get('pageNumber') || 1);
                        pageSize_1 = Number(url.searchParams.get('pageSize') || pageSize_1);
                        keyword_1 = keywordChanged_1 ? keyword_1 : url.searchParams.get('keyword') || '';
                        eventTypeParam = url.searchParams.get('eventType');
                        eventType_1 = Number(eventTypeParam || eventType_1);
                        sortBy_1 = Number(url.searchParams.get('sortBy') || sortBy_1);
                        paginationDropdown_1.value = pageSize_1.toString();
                        eventsListSearchInput_1.value = keyword_1;
                        radios_1.forEach(function (radio) {
                            radio.checked = sortBy_1 === +radio.value;
                        });
                        eventTypeTabIndex = eventType_1 === 3 ? 0 : eventType_1 === 1 ? 1 : 2;
                        if (eventTypeParam && eventTabs_1[eventTypeTabIndex]) {
                            activeTab_1 = eventTypeTabIndex;
                            resetTabs_1();
                            eventTabs_1[activeTab_1].classList.add('events-list__tab--active');
                        }
                        payload = {
                            keyword: keyword_1,
                            dateFrom: dateFrom_1,
                            dateTo: dateTo_1,
                            eventType: eventType_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/events', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/events', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        eventCards_1 = response.data.items;
                        if (eventCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, eventCards_1, renderPage_1, true);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        eventsGrid_1.innerHTML = '';
        eventCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.className = 'events-card flex fade-in';
            var _class = '';
            if (isFavourite_1.IsFavourited(card.id, favouritedIds_1)) {
                _class = 'active';
            }
            cardElement.innerHTML = "\n        " + (card.image !== null
                ? "<div class=\"events-card__image-container\">\n                        <img src=\"" + card.image + "\" alt=\"\" class=\"events-card__image\">\n                    </div>"
                : '') + "\n        <div class=\"events-card__content flex flex--column\">\n          <div class=\"events-card__buttons flex flex--align-center flex--justify-end\">\n          " + (isUserLoggedIn_1.default()
                ? "<button class=\"button button--favourite-small favouriteButton events-card__button flex flex--justify-center flex--align-center " + _class + "\" data-type=\"event\" data-id=\"" + card.id + "\">\n                    </button>"
                : '') + "\n          \n          <button class=\"button  button--round-small shareButton events-card__button events-card__button-share  flex flex--justify-center flex--align-center\">\n            <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n          </button>\n\n          <button class=\"button  button--round-small calButton events-card__button events-card__button-calendar  flex flex--justify-center flex--align-center\"\n            data-cal-name=\"" + card.title + "\"\n            data-cal-description=\"\"\n            data-cal-location=\"" + card.location + "\"\n            data-cal-start=\"" + card.start_Date_iso + "\"\n            data-cal-end=\"" + card.end_Date_iso + "\">\n            <img src=\"/assets/img/img/calendar-add.svg\" alt=\"calendar icon\" class=\"button__image\">\n          </button>\n\n          </div>\n            <h3 class=\"events-card__title\">" + card.title + "</h3>\n            <div class=\"events-card__bottom flex flex--wrap flex--justify-between flex--align-center\">\n    \n            <div class=\"events-card__column flex flex--column\">\n            <p class=\"events-card__column-title\">" + eventCardSettings_1.dateFromText + "</p>\n            <p class=\"events-card__column-text\">" + formatDate_1.default(card.start_Date) + "</p>\n          </div>\n\n          <div class=\"events-card__column flex flex--column\">\n            <p class=\"events-card__column-title\">" + eventCardSettings_1.dateToText + "</p>\n            <p class=\"events-card__column-text\">" + formatDate_1.default(card.end_Date) + "</p>\n          </div>\n          " + (card.location !== ''
                ? "<div class=\"events-card__column flex flex--column\">\n                      <p class=\"events-card__column-title\">" + eventCardSettings_1.locationText + "</p>\n                      <p class=\"events-card__column-text\">" + card.location + "</p>\n                    </div>"
                : '') + "\n          </div>\n        </div>\n        ";
            eventsGrid_1.appendChild(cardElement);
        });
        addCardListeners_1();
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        eventTabsComponent_1.classList.add('disabled');
        eventsFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        eventTabsComponent_1.classList.remove('disabled');
        eventsFilters_1.classList.remove('disabled');
    };
    eventTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            resetTabs_1();
            eventTabs_1[activeTab_1].classList.add('events-list__tab--active');
            pageNumber_1 = 1;
            if (index === 0) {
                eventType_1 = 3;
            }
            else if (index === 1) {
                eventType_1 = 1;
            }
            else if (index === 2) {
                eventType_1 = 2;
            }
            renderPage_1();
        });
    });
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        renderPage_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        renderPage_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        renderPage_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        renderPage_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        renderPage_1();
    });
    var timeout_1 = null;
    eventsListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = eventsListSearchInput_1.value.trim();
            keywordChanged_1 = true;
            pageNumber_1 = 1;
            fetchEvents_1();
        }, 1000);
    });
    radios_1.forEach(function (radio) {
        if (radio.value === sortBy_1.toString()) {
            radio.checked = true;
        }
        else {
            radio.checked = false;
        }
        radio.addEventListener('change', function () {
            var checkedRadio = eventsList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            renderPage_1();
        });
    });
    var initializeEventsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchEventCardSettings_1()];
                case 1:
                    _a.sent();
                    return [4, fetchEvents_1()];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeEventsList();
    var addCardListeners_1 = function () {
        var serviceListCards = eventsList.querySelectorAll('.events-card');
        if (serviceListCards.length > 0) {
            var cardButtons = document.querySelectorAll('.events-card__button');
            serviceListCards.forEach(function (card) {
                card.addEventListener('click', function (e) {
                    var target = e.target;
                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    console.log('small button clicked - events list');
                    if (button.classList.contains('favouriteButton')) {
                        var t = button.getAttribute('data-type');
                        var id = Number(button.getAttribute('data-id'));
                        favourites_1.default(t, id, button);
                    }
                    else if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                    else if (button.classList.contains('calButton')) {
                        addToCalendar_1.default(button);
                    }
                });
            });
        }
    };
    var renderPage_1 = function (page) {
        if (page === void 0) { page = null; }
        if (page) {
            pageNumber_1 = page;
        }
        var url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber_1.toString());
        url.searchParams.set('pageSize', pageSize_1.toString());
        if (keyword_1)
            url.searchParams.set('keyword', keyword_1);
        url.searchParams.set('eventType', eventType_1.toString());
        url.searchParams.set('sortBy', sortBy_1.toString());
        if (page == null) {
            window.location.href = url.toString();
        }
        return url.toString();
    };
}
var shareButtons = document.querySelectorAll('.shareButton');
if (shareButtons && shareButtons.length > 0) {
    shareButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            copyToClipboard_1.default(button);
        });
    });
}
},{"../../../helpers/addToCalendar":3,"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/formatDate":7,"../../../helpers/isFavourite":9,"../../../helpers/isUserLoggedIn":10,"../pagination/pagination":71,"axios":116}],35:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],36:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var eventsComponents = document.querySelectorAll('.events');
eventsComponents.forEach(function (eventsComponent) {
    if (eventsComponent) {
        var daysContainer_1 = eventsComponent.querySelectorAll('.events__days-current');
        var bulletsContainer_1 = eventsComponent.querySelectorAll('.glide__bullets');
        var days_1 = eventsComponent.querySelectorAll('.events__day');
        var dayNumbers = eventsComponent.querySelectorAll('.events__day-number');
        var dates = eventsComponent.querySelectorAll('.events__card-text');
        var eventsCarousels = eventsComponent.querySelectorAll('.events__carousel-inner');
        var direction_1 = document.querySelector('html').getAttribute('dir');
        var eventTabs_1 = eventsComponent.querySelectorAll('.events__tab');
        var eventCarouselsContainer_1 = eventsComponent.querySelectorAll('.events__carousel');
        var activeTab_1 = 0;
        var activeDay_1 = 0;
        if (eventsCarousels.length > 0) {
            var eventsCarouselsArray = Array.from(eventsCarousels) || [];
            var generateBullets_1 = function (carousel, num) {
                var bulletCount = carousel.querySelectorAll('.events__card').length - num;
                var bulletWrapper = carousel.querySelector('.glide__bullets');
                for (var index = 0; index < bulletCount; index++) {
                    var button = document.createElement('button');
                    button.className = 'glide__bullet';
                    button.setAttribute('data-glide-dir', '=' + index);
                    bulletWrapper.appendChild(button);
                }
            };
            eventsCarouselsArray.forEach(function (item) {
                var glideSettings = {
                    type: 'slider',
                    perView: 3,
                    gap: 24,
                    rewind: false,
                    bound: true,
                    direction: direction_1 || 'ltr',
                    breakpoints: {
                        768: {
                            perView: 2.3,
                            gap: 16,
                        },
                        480: {
                            perView: 2.27,
                        },
                    },
                };
                var glide = new glide_1.default(item, glideSettings);
                glide.mount();
                var width = window.innerWidth;
                var diff = 0;
                width > 768 ? (diff = 2) : (diff = 1);
                generateBullets_1(item, diff);
                glide.on('move.after', function () {
                    var bullets = item.querySelectorAll('.glide__bullet');
                    var currentIndex = glide.index;
                    if (bullets.length > 0) {
                        bullets.forEach(function (bullet, index) {
                            bullet.classList.remove('glide__bullet--active');
                            bullet.addEventListener('click', function (e) {
                                glide.go("=" + index);
                            });
                        });
                        bullets[currentIndex].classList.add('glide__bullet--active');
                    }
                });
            });
        }
        var resetAll_1 = function () {
            eventCarouselsContainer_1.forEach(function (carousel) { return carousel.classList.remove('events__carousel--active'); });
            daysContainer_1.forEach(function (item) { return item.classList.add('hidden'); });
            eventTabs_1.forEach(function (tab) { return tab.classList.remove('events__tab--active'); });
            days_1.forEach(function (day) { return day.classList.remove('events__day--active'); });
            bulletsContainer_1.forEach(function (item) { return item.classList.remove('glide__bullets--active'); });
        };
        var showActiveItems_1 = function (activeTab, activeDay) {
            resetAll_1();
            eventTabs_1[activeTab].classList.add('events__tab--active');
            if (activeTab === 1) {
                eventCarouselsContainer_1[activeDay].classList.add('events__carousel--active');
                bulletsContainer_1[activeDay].classList.add('glide__bullets--active');
            }
            else {
                daysContainer_1[activeTab].classList.remove('hidden');
                days_1[activeDay].classList.add('events__day--active');
                eventCarouselsContainer_1[activeDay].classList.add('events__carousel--active');
                bulletsContainer_1[activeDay].classList.add('glide__bullets--active');
            }
        };
        var getDayFromDate_1 = function (dateString) {
            var dateParts = dateString.split('-');
            var day = parseInt(dateParts[2], 10);
            return day.toString();
        };
        eventTabs_1.forEach(function (tab, index) {
            tab.addEventListener('click', function () {
                activeTab_1 = index;
                index === 0 ? (activeDay_1 = 0) : (activeDay_1 = 5);
                showActiveItems_1(activeTab_1, activeDay_1);
            });
        });
        days_1.forEach(function (day, index) {
            day.addEventListener('click', function () {
                activeDay_1 = index;
                showActiveItems_1(activeTab_1, activeDay_1);
            });
        });
        dayNumbers.forEach(function (day) {
            var fullDate = day.textContent;
            day.textContent = getDayFromDate_1(fullDate);
        });
        showActiveItems_1(activeTab_1, activeDay_1);
    }
});
},{"@glidejs/glide":115}],37:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var faq = document.querySelector('.faq');
if (faq) {
    var faqsList_1 = faq.querySelector('.accordion__items');
    var faqFilters_1 = faq.querySelector('.faq__filters');
    var faqSearchInput_1 = faq.querySelector('.input--search');
    var nextPageButton = faq.querySelector('.pagination__page-next');
    var prevPageButton = faq.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = faq.querySelector('.pagination__dropdown');
    var paginationLast = faq.querySelector('.pagination__page-last');
    var paginationFirst = faq.querySelector('.pagination__page-first');
    var pagination_2 = faq.querySelector('.pagination');
    var radios = faq.querySelectorAll('.sort-filter__input');
    var dropdownFilters = faq.querySelectorAll('.dropdown-filter');
    var singleDropdown_1 = faq.querySelector('.single-select');
    var singleDropdownFilterTrigger = faq.querySelector('.single-dropdown-filter__trigger');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var faqGroups_1 = [];
    var keyword_1 = '';
    var faqsGroup_1 = '';
    var beneficiaries_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchFaqs_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            faqsGroup: faqsGroup_1,
                            beneficiaries: beneficiaries_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/faqs', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/faqs', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        faqGroups_1 = response.data.items;
                        if (faqGroups_1.length > pageSize_1) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, faqGroups_1, fetchFaqs_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        faqsList_1.innerHTML = '';
        faqGroups_1.forEach(function (group) {
            var groupElement = document.createElement('div');
            groupElement.className = 'accordion__subtitle';
            groupElement.innerHTML = group.subCategory;
            faqsList_1.appendChild(groupElement);
            group.items.forEach(function (item) {
                var cardElement = document.createElement('details');
                cardElement.className = 'accordion__item fade-in';
                cardElement.innerHTML = "\n                <summary\n                    class=\"accordion__item-title-container flex flex--align-center flex--justify-between\">\n                    <span class=\"accordion__item-title\">" + item.question + "</span>\n                </summary>\n                <div class=\"accordion__item-inner rte\">\n                    " + item.answer + "\n                </div>";
                faqsList_1.appendChild(cardElement);
            });
        });
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        faqFilters_1 === null || faqFilters_1 === void 0 ? void 0 : faqFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        faqFilters_1.classList.remove('disabled');
    };
    singleDropdown_1.addEventListener('change', function () {
        var selected = singleDropdown_1.querySelector('option:checked');
        faqsGroup_1 = selected.value;
        pageNumber_1 = 1;
        fetchFaqs_1();
    });
    singleDropdownFilterTrigger.addEventListener('keydown', function (e) {
        e.preventDefault();
    });
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchFaqs_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchFaqs_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchFaqs_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchFaqs_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchFaqs_1();
    });
    var timeout_1 = null;
    faqSearchInput_1 === null || faqSearchInput_1 === void 0 ? void 0 : faqSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = faqSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchFaqs_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = faq.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchFaqs_1();
        });
    });
    dropdownFilters.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var beneficiariesOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    beneficiariesOptions_1.push(element.textContent);
                                });
                                beneficiaries_1 = beneficiariesOptions_1;
                                break;
                            default:
                                break;
                        }
                        pageNumber_1 = 1;
                        fetchFaqs_1();
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
    fetchFaqs_1();
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"axios":116}],38:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],39:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var addToCalendar_1 = __importDefault(require("../../../helpers/addToCalendar"));
var initializeFavouritesComponent = function (favouritesComponent) { return __awaiter(void 0, void 0, void 0, function () {
    var favouritesTabs, services, programs, compeitions, events, activeTab, nextPageButton, prevPageButton, paginationDropdown, paginationLast, paginationFirst, pagination, radios, currentCulture, eventCards, servicesCards, programsCards, competitionCards, ids, sortBy, pageNumber, pageSize, totalPages, totalCount, hasNextPage, hasPreviousPage, buttonsToShow, isLoading, currentType, eventCardSettings, fetchEventCardSettings, serviceCardSettings, fetchServiceCardSettings, TabTranslations, languageKey, tabTitles, showSelectedItems, handleTabClick, getEventCards, getServiceCards, getProgramCards, getCompetitionCards, updateEventCards, updateServiceCards, updateProgramCards, updateCompetitionCards, addServiceCardListeners, addProgramCardListeners, addCompetitionCardListeners, addEventCardListeners, disableInputs, enableInputs, fetchCards;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                favouritesTabs = favouritesComponent.querySelectorAll('.favourites__tab');
                services = favouritesComponent.querySelector('.favourites__grid--services');
                programs = favouritesComponent.querySelector('.favourites__grid--programs');
                compeitions = favouritesComponent.querySelector('.favourites__grid--contests');
                events = favouritesComponent.querySelector('.favourites__grid--events');
                activeTab = 0;
                nextPageButton = favouritesComponent.querySelector('.pagination__page-next');
                prevPageButton = favouritesComponent.querySelector('.pagination__page-prev');
                paginationDropdown = favouritesComponent.querySelector('.pagination__dropdown');
                paginationLast = favouritesComponent.querySelector('.pagination__page-last');
                paginationFirst = favouritesComponent.querySelector('.pagination__page-first');
                pagination = favouritesComponent.querySelector('.pagination');
                radios = favouritesComponent.querySelectorAll('.sort-filter__input');
                currentCulture = document.documentElement.getAttribute('culture');
                eventCards = [];
                servicesCards = [];
                programsCards = [];
                competitionCards = [];
                ids = [];
                sortBy = 1;
                pageNumber = 1;
                pageSize = +paginationDropdown.value;
                totalPages = 0;
                totalCount = 0;
                hasNextPage = false;
                hasPreviousPage = false;
                buttonsToShow = 3;
                isLoading = false;
                currentType = 'services';
                eventCardSettings = {
                    dateFromText: '',
                    dateToText: '',
                    locationText: '',
                };
                fetchEventCardSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var response, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4, axios_1.default.get("/api/events/cardsettings?currentCulture=" + currentCulture)];
                            case 1:
                                response = _a.sent();
                                eventCardSettings = response.data;
                                return [3, 3];
                            case 2:
                                error_1 = _a.sent();
                                console.error(error_1);
                                return [3, 3];
                            case 3: return [2];
                        }
                    });
                }); };
                serviceCardSettings = {
                    cardButtonText: '',
                    availableText: '',
                    endText: '',
                };
                fetchServiceCardSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var response, error_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4, axios_1.default.get("/api/services/cardsettings?currentCulture=" + currentCulture)];
                            case 1:
                                response = _a.sent();
                                serviceCardSettings = response.data;
                                return [3, 3];
                            case 2:
                                error_2 = _a.sent();
                                console.error(error_2);
                                return [3, 3];
                            case 3: return [2];
                        }
                    });
                }); };
                TabTranslations = {
                    services: { ar: 'الخدمات الإلكترونية', engb: 'Electric services' },
                    programs: { ar: 'البرامج', engb: 'Programs' },
                    contests: { ar: 'المسابقات', engb: 'Contests' },
                    events: { ar: 'الفعاليات', engb: 'Events' },
                };
                languageKey = ((_a = document.querySelector('html')) === null || _a === void 0 ? void 0 : _a.getAttribute('dir')) === 'rtl' ? 'ar' : 'engb';
                tabTitles = favouritesComponent.querySelectorAll('.favourites__tab-title');
                tabTitles.forEach(function (title) {
                    var _a;
                    var alias = (_a = title.textContent) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
                    if (TabTranslations[alias]) {
                        title.textContent = TabTranslations[alias][languageKey];
                    }
                });
                showSelectedItems = function (activeTab) { return __awaiter(void 0, void 0, void 0, function () {
                    var selectedTab, grids;
                    return __generator(this, function (_a) {
                        favouritesTabs.forEach(function (tab) { return tab.classList.remove('favourites__tab--active'); });
                        selectedTab = favouritesTabs[activeTab];
                        selectedTab.classList.add('favourites__tab--active');
                        currentType = selectedTab.getAttribute('data-type');
                        ids = JSON.parse(selectedTab.getAttribute('data-ids'));
                        pageNumber = 1;
                        if (currentType == 'event') {
                            getEventCards();
                        }
                        else if (currentType == 'service') {
                            getServiceCards();
                        }
                        else if (currentType == 'competition') {
                            getCompetitionCards();
                        }
                        else if (currentType == 'program') {
                            getProgramCards();
                        }
                        grids = [services, programs, compeitions, events];
                        grids.forEach(function (grid, index) {
                            grid.style.display = activeTab === index ? 'grid' : 'none';
                        });
                        return [2];
                    });
                }); };
                handleTabClick = function (index) {
                    activeTab = index;
                    showSelectedItems(activeTab);
                };
                favouritesTabs.forEach(function (tab, index) {
                    tab.addEventListener('click', function () { return handleTabClick(index); });
                });
                getEventCards = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var payload, response, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(ids.length > 0)) return [3, 9];
                                payload = {
                                    sortBy: sortBy,
                                    pageNumber: pageNumber,
                                    pageSize: pageSize,
                                    currentCulture: currentCulture,
                                    ids: ids,
                                };
                                isLoading = true;
                                disableInputs();
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, 7, 8]);
                                response = void 0;
                                if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                                    window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                                return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/events/byids', payload)];
                            case 2:
                                response = _a.sent();
                                return [3, 5];
                            case 3: return [4, axios_1.default.post('/api/events/byids', payload)];
                            case 4:
                                response = _a.sent();
                                _a.label = 5;
                            case 5:
                                eventCards = response.data.items;
                                if (eventCards.length > 0) {
                                    pagination.classList.remove('hidden');
                                }
                                totalPages = response.data.totalPages;
                                totalCount = response.data.totalCount;
                                hasNextPage = response.data.hasNextPage;
                                hasPreviousPage = response.data.hasPreviousPage;
                                return [3, 8];
                            case 6:
                                error_3 = _a.sent();
                                console.error(error_3);
                                enableInputs();
                                return [3, 8];
                            case 7:
                                pagination_1.updatePaginationButtons(totalPages, hasPreviousPage, hasNextPage, pageNumber, pageSize, totalCount, buttonsToShow, eventCards, getEventCards);
                                isLoading = false;
                                updateEventCards();
                                enableInputs();
                                return [7];
                            case 8: return [3, 10];
                            case 9:
                                pagination.classList.add('hidden');
                                events.innerHTML = '';
                                _a.label = 10;
                            case 10: return [2];
                        }
                    });
                }); };
                getServiceCards = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var payload, response, error_4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(ids.length > 0)) return [3, 9];
                                payload = {
                                    sortBy: sortBy,
                                    pageNumber: pageNumber,
                                    pageSize: pageSize,
                                    currentCulture: currentCulture,
                                    ids: ids,
                                };
                                isLoading = true;
                                disableInputs();
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, 7, 8]);
                                response = void 0;
                                if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                                    window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                                return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/services/byids', payload)];
                            case 2:
                                response = _a.sent();
                                return [3, 5];
                            case 3: return [4, axios_1.default.post('/api/services/byids', payload)];
                            case 4:
                                response = _a.sent();
                                _a.label = 5;
                            case 5:
                                servicesCards = response.data.items;
                                if (servicesCards.length > 0) {
                                    pagination.classList.remove('hidden');
                                }
                                totalCount = response.data.totalCount;
                                totalPages = response.data.totalPages;
                                hasNextPage = response.data.hasNextPage;
                                hasPreviousPage = response.data.hasPreviousPage;
                                return [3, 8];
                            case 6:
                                error_4 = _a.sent();
                                console.error(error_4);
                                enableInputs();
                                return [3, 8];
                            case 7:
                                pagination_1.updatePaginationButtons(totalPages, hasPreviousPage, hasNextPage, pageNumber, pageSize, totalCount, buttonsToShow, servicesCards, getServiceCards);
                                isLoading = false;
                                updateServiceCards();
                                enableInputs();
                                return [7];
                            case 8: return [3, 10];
                            case 9:
                                pagination.classList.add('hidden');
                                services.innerHTML = '';
                                _a.label = 10;
                            case 10: return [2];
                        }
                    });
                }); };
                getProgramCards = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var payload, response, error_5;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(ids.length > 0)) return [3, 9];
                                payload = {
                                    pageNumber: pageNumber,
                                    pageSize: pageSize,
                                    currentCulture: currentCulture,
                                    ids: ids,
                                };
                                isLoading = true;
                                disableInputs();
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, 7, 8]);
                                response = void 0;
                                if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                                    window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                                return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/programs/byids', payload)];
                            case 2:
                                response = _a.sent();
                                return [3, 5];
                            case 3: return [4, axios_1.default.post("/api/programs/byids", payload)];
                            case 4:
                                response = _a.sent();
                                _a.label = 5;
                            case 5:
                                programsCards = response.data.items;
                                if (programsCards.length > 0) {
                                    pagination.classList.remove('hidden');
                                }
                                totalCount = response.data.totalCount;
                                totalPages = response.data.totalPages;
                                hasNextPage = response.data.hasNextPage;
                                hasPreviousPage = response.data.hasPreviousPage;
                                return [3, 8];
                            case 6:
                                error_5 = _a.sent();
                                console.error(error_5);
                                enableInputs();
                                return [3, 8];
                            case 7:
                                pagination_1.updatePaginationButtons(totalPages, hasPreviousPage, hasNextPage, pageNumber, pageSize, totalCount, buttonsToShow, programsCards, getProgramCards);
                                isLoading = false;
                                updateProgramCards();
                                enableInputs();
                                return [7];
                            case 8: return [3, 10];
                            case 9:
                                pagination.classList.add('hidden');
                                programs.innerHTML = '';
                                _a.label = 10;
                            case 10: return [2];
                        }
                    });
                }); };
                getCompetitionCards = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var payload, response, error_6;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(ids.length > 0)) return [3, 9];
                                payload = {
                                    pageNumber: pageNumber,
                                    pageSize: pageSize,
                                    currentCulture: currentCulture,
                                    ids: ids,
                                };
                                isLoading = true;
                                disableInputs();
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, 7, 8]);
                                response = void 0;
                                if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                                    window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                                return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/competitions/byids', payload)];
                            case 2:
                                response = _a.sent();
                                return [3, 5];
                            case 3: return [4, axios_1.default.post("/api/competitions/byids", payload)];
                            case 4:
                                response = _a.sent();
                                _a.label = 5;
                            case 5:
                                competitionCards = response.data.items;
                                if (competitionCards.length > 0) {
                                    pagination.classList.remove('hidden');
                                }
                                totalCount = response.data.totalCount;
                                totalPages = response.data.totalPages;
                                hasNextPage = response.data.hasNextPage;
                                hasPreviousPage = response.data.hasPreviousPage;
                                return [3, 8];
                            case 6:
                                error_6 = _a.sent();
                                console.error(error_6);
                                enableInputs();
                                return [3, 8];
                            case 7:
                                pagination_1.updatePaginationButtons(totalPages, hasPreviousPage, hasNextPage, pageNumber, pageSize, totalCount, buttonsToShow, competitionCards, getCompetitionCards);
                                isLoading = false;
                                updateCompetitionCards();
                                enableInputs();
                                return [7];
                            case 8: return [3, 10];
                            case 9:
                                pagination.classList.add('hidden');
                                compeitions.innerHTML = '';
                                _a.label = 10;
                            case 10: return [2];
                        }
                    });
                }); };
                updateEventCards = function () {
                    events.innerHTML = '';
                    eventCards.forEach(function (card) {
                        var cardElement = document.createElement('a');
                        cardElement.setAttribute('href', card.link);
                        cardElement.className = 'events-card flex fade-in';
                        var _class = '';
                        if (isFavourite_1.IsFavourited(card.id, ids)) {
                            _class = 'active';
                        }
                        cardElement.innerHTML = "\n                " + (card.image !== null
                            ? "<div class=\"events-card__image-container\">\n                                <img src=\"" + card.image + "\" alt=\"\" class=\"events-card__image\">\n                            </div>"
                            : '') + "\n                <div class=\"events-card__content flex flex--column\">\n                <div class=\"events-card__buttons flex flex--align-center flex--justify-end\">\n\n                    <button class=\"button button--favourite-small favouriteButton events-card__button flex flex--justify-center flex--align-center " + _class + "\" data-type=\"event\" data-id=\"" + card.id + "\">\n                    </button>\n                    <button class=\"button  button--round-small  events-card__button events-card__button-share  flex flex--justify-center flex--align-center shareButton\">\n                        <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n\n                    <button class=\"button  button--round-small calButton events-card__button events-card__button-calendar  flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/calendar-add.svg\" alt=\"calendar icon\" class=\"button__image\">\n                    </button>\n\n                </div>\n                    <h3 class=\"events-card__title\">" + card.title + "</h3>\n                    <div class=\"events-card__bottom flex flex--wrap flex--justify-between flex--align-center\">\n            \n                    <div class=\"events-card__column flex flex--column\">\n                    <p class=\"events-card__column-title\">" + eventCardSettings.dateFromText + "</p>\n                    <p class=\"events-card__column-text\">" + formatDate_1.default(card.start_Date) + "</p>\n                </div>\n\n                <div class=\"events-card__column flex flex--column\">\n                    <p class=\"events-card__column-title\">" + eventCardSettings.dateToText + "</p>\n                    <p class=\"events-card__column-text\">" + formatDate_1.default(card.end_Date) + "</p>\n                </div>\n                " + (card.location !== ''
                            ? "<div class=\"events-card__column flex flex--column\">\n                            <p class=\"events-card__column-title\">" + eventCardSettings.locationText + "</p>\n                            <p class=\"events-card__column-text\">" + card.location + "</p>\n                            </div>"
                            : '') + "\n                </div>\n                </div>\n                ";
                        events.appendChild(cardElement);
                    });
                    addEventCardListeners();
                };
                updateServiceCards = function () {
                    services.innerHTML = '';
                    servicesCards.forEach(function (card) {
                        var cardElement = document.createElement('a');
                        cardElement.className = 'service-list__card fade-in';
                        cardElement.setAttribute('href', card.link);
                        var _class = '';
                        if (isFavourite_1.IsFavourited(card.id, ids)) {
                            _class = 'active';
                        }
                        cardElement.innerHTML = "\n                " + (card.isAvailable ? "<p class='service-list__card-tag'>" + serviceCardSettings.availableText + "</p>" : "<p class='service-list__card-tag e-services__card-closed'>" + serviceCardSettings.endText + "</p>") + "\n\t\t\t\t<h3 class='service-list__card-title'>" + card.title + "</h3>\n\t\t\t\t<p class='service-list__card-text'>\n\t\t\t\t\t\t" + card.description + "\n\t\t\t\t</p>\n\t\t\t\t<div class='service-list__card-bottom flex flex--justify-between flex--align-center'>\n                        <div class=\"service-list__link flex flex--align-center flex--justify-center\">\n                            " + serviceCardSettings.cardButtonText + "\n                            <img src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"arrow icon\"\n                                class=\"service-list__link-icon\">\n                        </div>\n\t\t\t\t\t<div class='service-list__card-buttons flex flex--align-center'>\n                        <button class=\"button button--favourite-small favouriteButton service-list__button flex flex--justify-center flex--align-center " + _class + "\" data-type=\"service\" data-id=\"" + card.id + "\">\n                        </button>\n\t\t\t\t\t\t<button class=\"button  button--round-small  service-list__button-share service-list__button  flex flex--justify-center flex--align-center shareButton\">\n\t\t\t\t\t\t\t\t<img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t";
                        services.appendChild(cardElement);
                    });
                    addServiceCardListeners();
                };
                updateProgramCards = function () {
                    programs.innerHTML = '';
                    programsCards.forEach(function (card) {
                        var cardElement = document.createElement('div');
                        cardElement.className = 'programs-list__item flex flex--column';
                        cardElement.style.backgroundImage = "url(" + card.backgroundImage + ")";
                        var _class = '';
                        if (isFavourite_1.IsFavourited(card.id, ids)) {
                            _class = 'active';
                        }
                        cardElement.innerHTML = "            \n            <div class=\"programs-list__item-content flex flex--column\">\n                <p class=\"programs-list__title\">" + card.title + "</p>\n                <p class=\"programs-list__text\">" + card.text + "</p>\n                <div class=\"programs-list__buttons flex flex--align-center\">\n                    <button\n                        class=\"button button--round-tiny programs-list__button programs-list__button programs-list__button-share flex flex--justify-center flex--align-center shareButton\">\n                        <img src=\"/assets/img/img/share-filled-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                    <button class=\"button button--favourite-white button--favourite-small favouriteButton programs-list__button flex flex--justify-center flex--align-center\" data-type=\"program\" data-id=\"" + card.id + "\">\n                    </button>\n                </div>\n            </div>\n            <a href=\"" + card.link + "\" draggable=\"false\"\n                class=\"link link--lg link--transparent programs-list__item-link flex flex--justify-center flex--align-center\">\n                <span class=\"link__label\">" + card.linkText + "</span>\n                <img class=\"link__image\" src=\"/assets/img/img/arrow-top-left.svg\" alt=\"more\">\n            </a>\n            ";
                        programs.appendChild(cardElement);
                    });
                    addProgramCardListeners();
                };
                updateCompetitionCards = function () {
                    compeitions.innerHTML = '';
                    competitionCards.forEach(function (card) {
                        var cardElement = document.createElement('div');
                        cardElement.className = 'programs-list__item flex flex--column';
                        cardElement.style.backgroundImage = "url(" + card.backgroundImage + ")";
                        var _class = '';
                        if (isFavourite_1.IsFavourited(card.id, ids)) {
                            _class = 'active';
                        }
                        cardElement.innerHTML = "            \n            <div class=\"programs-list__item-content flex flex--column\">\n                <p class=\"programs-list__title\">" + card.title + "</p>\n                <p class=\"programs-list__text\">" + card.text + "</p>\n                <div class=\"programs-list__buttons flex flex--align-center\">\n                    <button\n                        class=\"button button--round-tiny programs-list__button programs-list__button programs-list__button-share flex flex--justify-center flex--align-center shareButton\">\n                        <img src=\"/assets/img/img/share-filled-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                    <button class=\"button button--favourite-white button--favourite-small favouriteButton programs-list__button flex flex--justify-center flex--align-center\" data-type=\"competition\" data-id=\"" + card.id + "\">\n                    </button>\n                </div>\n            </div>\n            <a href=\"" + card.link + "\" draggable=\"false\"\n                class=\"link link--lg link--transparent programs-list__item-link flex flex--justify-center flex--align-center\">\n                <span class=\"link__label\">" + card.linkText + "</span>\n                <img class=\"link__image\" src=\"/assets/img/img/arrow-top-left.svg\" alt=\"more\">\n            </a>\n            ";
                        compeitions.appendChild(cardElement);
                    });
                    addCompetitionCardListeners();
                };
                addServiceCardListeners = function () {
                    var serviceListCards = services.querySelectorAll('.service-list__card');
                    if (serviceListCards.length > 0) {
                        var cardButtons = document.querySelectorAll('.service-list__button');
                        serviceListCards.forEach(function (card) {
                            card.addEventListener('click', function (e) {
                                var target = e.target;
                                if (target.classList.contains('button') || target.classList.contains('button__image')) {
                                    e.preventDefault();
                                }
                            });
                        });
                        cardButtons.forEach(function (button) {
                            button.addEventListener('click', function (e) {
                                if (button.classList.contains('favouriteButton')) {
                                    var t = button.getAttribute('data-type');
                                    var id = Number(button.getAttribute('data-id'));
                                    favourites_1.default(t, id, button);
                                    ids = ids.filter(function (itemId) { return itemId !== id; });
                                    fetchCards();
                                }
                                else if (button.classList.contains('shareButton')) {
                                    copyToClipboard_1.default(button);
                                }
                                else if (button.classList.contains('calButton')) {
                                    addToCalendar_1.default(button);
                                }
                            });
                        });
                    }
                };
                addProgramCardListeners = function () {
                    var listCards = programs.querySelectorAll('.programs-list__item');
                    if (listCards.length > 0) {
                        var cardButtons = document.querySelectorAll('.programs-list__button');
                        listCards.forEach(function (card) {
                            card.addEventListener('click', function (e) {
                                var target = e.target;
                                if (target.classList.contains('button') || target.classList.contains('button__image')) {
                                    e.preventDefault();
                                }
                            });
                        });
                        cardButtons.forEach(function (button) {
                            button.addEventListener('click', function (e) {
                                if (button.classList.contains('favouriteButton')) {
                                    var t = button.getAttribute('data-type');
                                    var id = Number(button.getAttribute('data-id'));
                                    favourites_1.default(t, id, button);
                                    ids = ids.filter(function (itemId) { return itemId !== id; });
                                    fetchCards();
                                }
                                else if (button.classList.contains('shareButton')) {
                                    copyToClipboard_1.default(button);
                                }
                                else if (button.classList.contains('calButton')) {
                                    addToCalendar_1.default(button);
                                }
                            });
                        });
                    }
                };
                addCompetitionCardListeners = function () {
                    var listCards = compeitions.querySelectorAll('.programs-list__item');
                    if (listCards.length > 0) {
                        var cardButtons = document.querySelectorAll('.programs-list__button');
                        listCards.forEach(function (card) {
                            card.addEventListener('click', function (e) {
                                var target = e.target;
                                if (target.classList.contains('button') || target.classList.contains('button__image')) {
                                    e.preventDefault();
                                }
                            });
                        });
                        cardButtons.forEach(function (button) {
                            button.addEventListener('click', function (e) {
                                if (button.classList.contains('favouriteButton')) {
                                    var t = button.getAttribute('data-type');
                                    var id = Number(button.getAttribute('data-id'));
                                    favourites_1.default(t, id, button);
                                    ids = ids.filter(function (itemId) { return itemId !== id; });
                                    fetchCards();
                                }
                                else if (button.classList.contains('shareButton')) {
                                    copyToClipboard_1.default(button);
                                }
                                else if (button.classList.contains('calButton')) {
                                    addToCalendar_1.default(button);
                                }
                            });
                        });
                    }
                };
                addEventCardListeners = function () {
                    var serviceListCards = events.querySelectorAll('.events-card');
                    if (serviceListCards.length > 0) {
                        var cardButtons = document.querySelectorAll('.events-card__button');
                        serviceListCards.forEach(function (card) {
                            card.addEventListener('click', function (e) {
                                var target = e.target;
                                if (target.classList.contains('button') || target.classList.contains('button__image')) {
                                    e.preventDefault();
                                }
                            });
                        });
                        cardButtons.forEach(function (button) {
                            button.addEventListener('click', function (e) {
                                if (button.classList.contains('favouriteButton')) {
                                    var t = button.getAttribute('data-type');
                                    var id = Number(button.getAttribute('data-id'));
                                    favourites_1.default(t, id, button);
                                    ids = ids.filter(function (itemId) { return itemId !== id; });
                                    fetchCards();
                                }
                                else if (button.classList.contains('shareButton')) {
                                    copyToClipboard_1.default(button);
                                }
                                else if (button.classList.contains('calButton')) {
                                    addToCalendar_1.default(button);
                                }
                            });
                        });
                    }
                };
                disableInputs = function () {
                    pagination.classList.add('disabled');
                };
                enableInputs = function () {
                    pagination.classList.remove('disabled');
                };
                paginationDropdown.addEventListener('change', function () {
                    pageSize = +paginationDropdown.value;
                    pageNumber = 1;
                    fetchCards();
                });
                nextPageButton.addEventListener('click', function () {
                    pageNumber++;
                    fetchCards();
                });
                prevPageButton.addEventListener('click', function () {
                    pageNumber--;
                    fetchCards();
                });
                paginationFirst.addEventListener('click', function () {
                    pageNumber = 1;
                    fetchCards();
                });
                paginationLast.addEventListener('click', function () {
                    pageNumber = totalPages;
                    fetchCards();
                });
                fetchCards = function () {
                    if (currentType == 'event') {
                        getEventCards();
                    }
                    else if (currentType == 'service') {
                        getServiceCards();
                    }
                    else if (currentType == 'competition') {
                        getCompetitionCards();
                    }
                    else if (currentType == 'program') {
                        getProgramCards();
                    }
                };
                return [4, fetchServiceCardSettings()];
            case 1:
                _b.sent();
                fetchEventCardSettings();
                return [4, showSelectedItems(activeTab)];
            case 2:
                _b.sent();
                return [2];
        }
    });
}); };
document.querySelectorAll('.favourites').forEach(function (favouritesComponent) {
    initializeFavouritesComponent(favouritesComponent);
});
},{"../../../helpers/addToCalendar":3,"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/formatDate":7,"../../../helpers/isFavourite":9,"../pagination/pagination":71,"axios":116}],40:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],41:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var glide_1 = __importDefault(require("@glidejs/glide"));
var giftedCompetingList = document.querySelector('.gifted-list');
if (giftedCompetingList) {
    var giftedCompetingCarousels = document.querySelectorAll('.gifted-list__carousel-inner');
    var direction_1 = document.querySelector('html').getAttribute('dir');
    if (giftedCompetingCarousels.length > 0) {
        giftedCompetingCarousels.forEach(function (item) {
            var glideSettings = {
                type: 'slider',
                perView: 1,
                gap: 0,
                rewind: true,
                bound: true,
                direction: direction_1 || 'ltr',
            };
            var glide = new glide_1.default(item, glideSettings);
            glide.mount();
            glide.on('move.after', function () {
                var bullets = item.querySelectorAll('.glide__bullet');
                var currentIndex = glide.index;
                bullets.forEach(function (bullet, index) {
                    bullet.classList.remove('glide__bullet--active');
                    bullet.addEventListener('click', function (e) {
                        glide.go("=" + index);
                    });
                });
                bullets[currentIndex].classList.add('glide__bullet--active');
            });
        });
    }
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"@glidejs/glide":115}],42:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],43:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var giftedSubListing = document.querySelector('.gifted-sublist') || null;
if (giftedSubListing) {
    var parentNodeId_1 = giftedSubListing.getAttribute('data-id');
    var tableBody_1 = giftedSubListing.querySelector('.gifted-sublist__table-body');
    var mobileTableBody_1 = giftedSubListing.querySelector('.gifted-sublist__table-mobile-body');
    var nextPageButton = giftedSubListing.querySelector('.pagination__page-next');
    var prevPageButton = giftedSubListing.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = giftedSubListing.querySelector('.pagination__dropdown');
    var paginationLast = giftedSubListing.querySelector('.pagination__page-last');
    var paginationFirst = giftedSubListing.querySelector('.pagination__page-first');
    var pagination_2 = giftedSubListing.querySelector('.pagination');
    var radios = giftedSubListing.querySelectorAll('.sort-filter__input');
    var giftedSubListFilters_1 = giftedSubListing.querySelector('.gifted-sublist__filters');
    var giftedSubListingSearchInput_1 = giftedSubListing.querySelector('.gifted-sublist__search-input');
    var dropdownFilters = giftedSubListing.querySelectorAll('.dropdown-filter');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var singleDropdown_1 = giftedSubListing.querySelector('.single-select');
    var singleDropdownPlaceholder = Number(singleDropdown_1.getAttribute('data-placeholder'));
    var singleDropdownFilterTrigger = giftedSubListing.querySelector('.single-dropdown-filter__trigger');
    var giftedSubListItems_1 = [];
    var keyword_1 = '';
    var educationDepartments_1 = [];
    var positions_1 = [];
    var projectFields_1 = [];
    var olympiadTypes_1 = [];
    var year_1 = singleDropdownPlaceholder;
    singleDropdownFilterTrigger.innerHTML = singleDropdownPlaceholder.toString();
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var giftedSubListColumnsNames_1 = [];
    var fetchGiftedSubListColumnsNames_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/giftedCompeting/columnsNames/" + parentNodeId_1 + "?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    giftedSubListColumnsNames_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchGiftedSubList_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            parentNodeId: parentNodeId_1,
                            keyword: keyword_1,
                            educationDepartments: educationDepartments_1,
                            positions: positions_1,
                            projectFields: projectFields_1,
                            olympiadTypes: olympiadTypes_1,
                            year: year_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/giftedCompeting/sublist', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/giftedCompeting/sublist', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        giftedSubListItems_1 = response.data.items;
                        if (giftedSubListItems_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, giftedSubListItems_1, fetchGiftedSubList_1);
                        isLoading_1 = false;
                        updateItems_1();
                        enableInputs_1();
                        createModals_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        giftedSubListFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        giftedSubListFilters_1.classList.remove('disabled');
    };
    var updateItems_1 = function () {
        tableBody_1.innerHTML = '';
        mobileTableBody_1.innerHTML = '';
        giftedSubListItems_1.forEach(function (item) {
            var rowElement = document.createElement('tr');
            rowElement.className = 'gifted-sublist__table-row';
            rowElement.innerHTML = "\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'student name'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center " + (item.studentImage !== null ? 'gifted-sublist__table-content-image' : '') + "\">\n                                    " + (item.studentImage !== null
                    ? "<img src=\"" + item.studentImage + "\" alt=\"student image\" class=\"gifted-sublist__table-image\" />"
                    : '') + "\n                                    <span class=\"gifted-sublist__table-content-title\">" + item.studentName + "</span>\n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'speciality'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + (item.speciality !== null ? item.speciality : '-') + "</span>\n                                </div>\n                            </td>"
                : '') + "\n                \n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'project field'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + item.projectField + "</span>\n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'project title'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + item.projectTitle + "</span>\n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'education department'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + item.educationDepartment + "</span>\n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'olympiad'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + item.olympiad + "</span>\n                                </div>\n                            </td>"
                : '') + "\n                \n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'grand prize'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center gifted-sublist__table-content-icon\">\n                                    " + (item.position !== null
                    ? "<img src=\"/assets/img/img/icons/medal-star.svg\" alt=\"icon\" class=\"gifted-sublist__table-icon\">\n                                                <span class=\"gifted-sublist__table-content-title\">" + item.position + "</span>"
                    : '<span class="gifted-sublist__table-content-title"></span>') + "\n                                    \n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'school'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + (item.school !== null ? item.school : '-') + "</span>\n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'search entity'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + (item.searchEntity !== null ? item.searchEntity : '-') + "</span>\n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'special prize'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div\n                                    class=\"gifted-sublist__table-content flex flex--align-center " + (item.specialPrize !== null ? '' : 'flex--justify-center') + "\">\n                                    <span class=\"gifted-sublist__table-content-title\">" + (item.specialPrize !== null ? item.specialPrize : '-') + "</span>\n                                </div>\n                            </td>"
                : '') + "\n\n                " + (giftedSubListColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'success story'; })
                ? "<td class=\"gifted-sublist__table-data\">\n                                <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                                    " + (item.successStoryVideoLink !== ''
                    ? "<div\n                                                class='modal modal--table'>\n                                                    <button tabindex=\"0\" class=\"modal__open\">\n                                                        <img tabindex=\"0\" src='/assets/img/img/play-cricle.svg' alt='play button'\n                                                            class='modal__icon modal__icon--table' />\n                                                    </button>\n                                                    <dialog class='modal__dialog'>\n                                                        <div class='modal__inner'>\n                                                            <div class='modal__top flex flex--justify-between flex--align-center'>\n                                                                <div class='flex flex--justify-between flex--align-center'>\n                                                                    <button class=\"button button--round-small modal__close flex flex--justify-center flex--align-center\">\n                                                                        <img src=\"/assets/img/img/icons/close.svg\" alt=\"close icon\" class=\"button__image\">\n                                                                    </button>\n                                                                    <div class='modal__title' id='modal-title'>" + item.studentName + "</div>\n                                                                </div>\n                                                                <div class='modal__right flex flex--justify-between flex--align-center'>\n                                                                <button class=\"button button--round-small modal__share flex flex--justify-center flex--align-center\">\n                                                                    <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                                                                </button>\n                                                                </div>\n                                                            </div>\n                                                            <iframe class='modal__video' src='" + item.successStoryVideoLink + "' frameborder='0'\n                                                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'\n                                                            allowFullScreen sandbox=\"allow-scripts allow-modals allow-same-origin allow-presentation\"></iframe>\n                                                        </div>\n                                                    </dialog>\n                                                </div>"
                    : '') + "\n                                </div>\n                            </td>"
                : '');
            addMobileRow_1(item);
            tableBody_1.appendChild(rowElement);
        });
    };
    var addMobileRow_1 = function (item) {
        var studentName = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'student name'; });
        var speciality = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'speciality'; });
        var projectField = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'project field'; });
        var projectTitle = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'project title'; });
        var educationDepartment = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'education department'; });
        var olympiad = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'olympiad'; });
        var school = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'school'; });
        var searchEntity = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'search entity'; });
        var grandPrize = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'grand prize'; });
        var specialPrize = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'special prize'; });
        var successStory = giftedSubListColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'success story'; });
        mobileTableBody_1.insertAdjacentHTML('beforeend', "\n        " + (studentName !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + studentName.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center " + (item.studentImage !== null ? 'gifted-sublist__table-content-image' : '') + "\">\n                            " + (item.studentImage !== null
                ? "<img src=\"" + item.studentImage + "\" alt=\"student image\" class=\"gifted-sublist__table-image\" />"
                : '') + "\n                                <span class=\"gifted-sublist__table-content-title\">" + item.studentName + "</span>\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n\n        " + (speciality !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + speciality.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                                <span class=\"gifted-sublist__table-content-title\">" + (item.speciality !== null ? item.speciality : '-') + "</span>\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n        " + (projectField !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + projectField.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                                <span class=\"gifted-sublist__table-content-title\">" + item.projectField + "</span>\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n\n        " + (projectTitle !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + projectTitle.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                                <span class=\"gifted-sublist__table-content-title\">" + item.projectTitle + "</span>\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n\n        " + (educationDepartment !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + educationDepartment.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                                <span class=\"gifted-sublist__table-content-title\">" + item.educationDepartment + "</span>\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n\n        " + (olympiad !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                    <th class=\"gifted-sublist__table-header\">" + olympiad.value + "</th>\n                    <td class=\"gifted-sublist__table-data\">\n                        <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                            <span class=\"gifted-sublist__table-content-title\">" + item.olympiad + "</span>\n                        </div>\n                    </td>\n                </tr>"
            : '') + "\n\n        " + (grandPrize !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + grandPrize.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center gifted-sublist__table-content-icon\">\n                                <img src=\"/assets/img/img/icons/medal-star.svg\" alt=\"alt\" class=\"gifted-sublist__table-icon\" />\n                                <span class=\"gifted-sublist__table-content-title\">" + (item.position !== null ? item.position : '-') + "</span>\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n\n        " + (school !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                    <th class=\"gifted-sublist__table-header\">" + school.value + "</th>\n                    <td class=\"gifted-sublist__table-data\">\n                        <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                            <span class=\"gifted-sublist__table-content-title\">" + (item.school !== null ? item.school : '-') + "</span>\n                        </div>\n                    </td>\n                </tr>"
            : '') + "\n\n        " + (searchEntity !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                    <th class=\"gifted-sublist__table-header\">" + searchEntity.value + "</th>\n                    <td class=\"gifted-sublist__table-data\">\n                        <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                            <span class=\"gifted-sublist__table-content-title\">" + (item.searchEntity !== null ? item.searchEntity : '-') + "</span>\n                        </div>\n                    </td>\n                </tr>"
            : '') + "\n\n        " + (specialPrize !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + specialPrize.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                                <span class=\"gifted-sublist__table-content-title\">" + (item.speciality !== null ? item.speciality : '-') + "</span>\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n\n        " + (successStory !== undefined
            ? "<tr class=\"gifted-sublist__table-row\">\n                        <th class=\"gifted-sublist__table-header\">" + successStory.value + "</th>\n                        <td class=\"gifted-sublist__table-data\">\n                            <div class=\"gifted-sublist__table-content flex flex--align-center\">\n                            " + (item.successStoryVideoLink !== ''
                ? "<div\n                                        class='modal modal--table'>\n                                            <button tabindex=\"0\" class=\"modal__open\">\n                                                <img tabindex=\"0\" src='/assets/img/img/play-cricle.svg' alt='play button'\n                                                    class='modal__icon modal__icon--table' />\n                                            </button>\n                                            <dialog class='modal__dialog'>\n                                                <div class='modal__inner'>\n                                                    <div class='modal__top flex flex--justify-between flex--align-center'>\n                                                        <div class='flex flex--justify-between flex--align-center'>\n                                                            <button class=\"button button--round-small modal__close flex flex--justify-center flex--align-center\">\n                                                                <img src=\"/assets/img/img/icons/close.svg\" alt=\"close icon\" class=\"button__image\">\n                                                            </button>\n                                                            <div class='modal__title' id='modal-title'>" + item.studentName + "</div>\n                                                        </div>\n                                                        <div class='modal__right flex flex--justify-between flex--align-center'>\n                                                        <button class=\"button button--round-small modal__share flex flex--justify-center flex--align-center\">\n                                                            <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                                                        </button>\n                                                        </div>\n                                                    </div>\n                                                    <iframe class='modal__video' src='" + item.successStoryVideoLink + "' frameborder='0'\n                                                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'\n                                                    allowFullScreen sandbox=\"allow-scripts, allow-modals, allow-same-origin allow-presentation\"></iframe>\n                                                </div>\n                                            </dialog>\n                                        </div>"
                : '') + "\n                            </div>\n                        </td>\n                    </tr>"
            : '') + "\n        ");
    };
    var createModals_1 = function () {
        var modals = giftedSubListing.querySelectorAll('.modal');
        if (modals.length > 0) {
            modals === null || modals === void 0 ? void 0 : modals.forEach(function (modalContainer, index) {
                var _a;
                var modalDialog = modalContainer.querySelector('dialog');
                if (!modalDialog)
                    return;
                var modalId = "modal-" + index;
                var openButtonId = "open-button-" + index;
                modalDialog.id = modalId;
                var openButton = modalContainer.querySelector('.modal__open');
                if (openButton) {
                    openButton.id = openButtonId;
                }
                var closeButton = modalDialog.querySelector('.modal__close');
                (_a = document.getElementById(openButtonId)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (event) {
                    modalDialog.showModal();
                });
                closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', function (event) {
                    modalDialog.close();
                });
                modalDialog.addEventListener('click', function (event) {
                    if (event.target === modalDialog) {
                        modalDialog.close();
                    }
                });
            });
        }
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchGiftedSubList_1();
    });
    singleDropdown_1.addEventListener('change', function () {
        var selected = singleDropdown_1.querySelector('option:checked');
        year_1 = Number(selected.value);
        pageNumber_1 = 1;
        fetchGiftedSubList_1();
    });
    singleDropdownFilterTrigger.addEventListener('keydown', function (e) {
        e.preventDefault();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchGiftedSubList_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchGiftedSubList_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchGiftedSubList_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchGiftedSubList_1();
    });
    var timeout_1 = null;
    giftedSubListingSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = giftedSubListingSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchGiftedSubList_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = giftedSubListing.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchGiftedSubList_1();
        });
    });
    dropdownFilters.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var educationDepartmentsOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    educationDepartmentsOptions_1.push(element.textContent);
                                });
                                educationDepartments_1 = educationDepartmentsOptions_1;
                                break;
                            case 1:
                                var positionsOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    positionsOptions_1.push(element.textContent);
                                });
                                positions_1 = positionsOptions_1;
                                break;
                            case 2:
                                var projectFieldsOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    projectFieldsOptions_1.push(element.textContent);
                                });
                                projectFields_1 = projectFieldsOptions_1;
                                break;
                            case 3:
                                var olympiadTypesOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    olympiadTypesOptions_1.push(element.textContent);
                                });
                                olympiadTypes_1 = olympiadTypesOptions_1;
                                break;
                            default:
                                break;
                        }
                        pageNumber_1 = 1;
                        fetchGiftedSubList_1();
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
    var initializeList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchGiftedSubListColumnsNames_1()];
                case 1:
                    _a.sent();
                    return [4, fetchGiftedSubList_1()];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeList();
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"axios":116}],44:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],45:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var shareButtons = document.querySelectorAll(".shareButton");
if (shareButtons && shareButtons.length > 0) {
    shareButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            copyToClipboard_1.default(button);
        });
    });
}
},{"../../../helpers/copyToClipboard":5}],46:[function(require,module,exports){
var hero = document.querySelector(".hero");
if (hero) {
    var slides_1 = hero.querySelectorAll(".hero__slide");
    var contents_1 = hero.querySelectorAll(".hero__content");
    var activeSlide_1 = hero.querySelector(".hero__slide--active");
    var heroLeft = hero.querySelector(".hero__left");
    var heroDots_1 = hero.querySelectorAll(".hero__dot");
    var isTransitioning_1 = false;
    var animationDuration_1 = 1000;
    var activeIndex_1 = 0;
    var animationTimer_1 = +heroLeft.getAttribute("data-timer") || 5000;
    var minSwipeDistance_1 = 30;
    var touchStartX_1 = 0;
    var touchEndX_1 = 0;
    var isMouseDown_1 = false;
    var mountSlider = function () {
        var slides = Array.from(document.querySelectorAll(".hero__slide"));
        var orders = Array(slides.length)
            .fill(null)
            .map(function (_, index) { return "hero__slide-" + (index + 1); });
        var slideCount = slides.length;
        slides.forEach(function (slide, index) { return slide.classList.add(orders[index]); });
        var activeIndex = 0;
        handleDots_1();
        var updateOrder = function (activeIndex) {
            slides.forEach(function (slide, index) {
                var newOrderIndex = (index - activeIndex + slideCount) % slideCount;
                slide.className = orders[newOrderIndex] + " hero__slide";
                if (activeIndex === index) {
                    slide.classList.add("hero__slide--active");
                }
            });
        };
        var next = function () {
            activeIndex++;
            if (activeIndex === slideCount)
                activeIndex = 0;
            updateOrder(activeIndex);
            return activeIndex;
        };
        var prev = function () {
            activeIndex--;
            if (activeIndex === -1)
                activeIndex = slideCount - 1;
            updateOrder(activeIndex);
            return activeIndex;
        };
        return { next: next, prev: prev, updateOrder: updateOrder };
    };
    var handleDots_1 = function () {
        heroDots_1.forEach(function (dot, i) {
            dot.classList.remove("hero__dot--active");
            if (i === activeIndex_1) {
                dot.classList.add("hero__dot--active");
            }
        });
    };
    var handleTouchStart = function (event) {
        touchStartX_1 = event.changedTouches[0].screenX;
    };
    var handleTouchMove = function (event) {
        touchEndX_1 = event.changedTouches[0].screenX;
    };
    var handleTouchEnd_1 = function () {
        handleSwipeGesture_1();
    };
    var handleSwipeGesture_1 = function () {
        var distance = touchEndX_1 - touchStartX_1;
        if (isTransitioning_1) {
            return;
        }
        if (Math.abs(distance) >= minSwipeDistance_1) {
            if (distance > 0) {
                activeIndex_1 = next_1();
                handleDots_1();
                handleSlides_1();
            }
            else {
                activeIndex_1 = prev_1();
                handleDots_1();
                handleSlides_1();
            }
        }
        setTimeout(function () {
            isTransitioning_1 = false;
        }, animationDuration_1);
    };
    var handleMouseDown_1 = function (event) {
        touchStartX_1 = event.screenX;
        isMouseDown_1 = true;
    };
    var handleMouseMove_1 = function (event) {
        if (isMouseDown_1) {
            touchEndX_1 = event.screenX;
        }
    };
    var handleMouseUp_1 = function () {
        if (isMouseDown_1) {
            handleSwipeGesture_1();
            isMouseDown_1 = false;
        }
    };
    var handleSlides_1 = function () {
        if (isTransitioning_1) {
            return;
        }
        else {
            isTransitioning_1 = true;
            updateOrder_1(activeIndex_1);
            activeSlide_1.textContent = (activeIndex_1 + 1).toString();
            contents_1.forEach(function (item) { return item.classList.add("hidden"); });
            contents_1[activeIndex_1].classList.remove("hidden");
            handleDots_1();
            setTimeout(function () {
                isTransitioning_1 = false;
            }, animationDuration_1);
        }
    };
    var interval_1;
    var startInterval_1 = function () {
        interval_1 = setInterval(function () {
            activeIndex_1 = next_1();
            handleSlides_1();
        }, animationTimer_1);
    };
    var resetInterval_1 = function () {
        clearInterval(interval_1);
        startInterval_1();
    };
    var handleContentHeight = function () {
        var allContents = hero.querySelectorAll(".hero__content");
        var tallestHeight = 0;
        allContents.forEach(function (content) {
            content.classList.remove("hidden");
            var contentHeight = content.offsetHeight;
            if (contentHeight > tallestHeight) {
                tallestHeight = contentHeight;
            }
        });
        allContents.forEach(function (content) {
            content.style.height = tallestHeight + "px";
            content.classList.add("hidden");
        });
        allContents[activeIndex_1].classList.remove("hidden");
    };
    if (window.innerWidth < 768) {
        handleContentHeight();
    }
    var _a = mountSlider(), next_1 = _a.next, prev_1 = _a.prev, updateOrder_1 = _a.updateOrder;
    heroDots_1.forEach(function (dot, index) {
        var handleEvent = function () {
            activeIndex_1 = index;
            handleSlides_1();
            updateOrder_1(activeIndex_1);
            handleDots_1();
        };
        dot.addEventListener("click", function () {
            resetInterval_1();
            handleEvent();
        });
        dot.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                resetInterval_1();
                handleEvent();
            }
        });
    });
    heroLeft.addEventListener('touchstart', handleTouchStart, false);
    heroLeft.addEventListener('touchmove', handleTouchMove, false);
    heroLeft.addEventListener('touchend', function () {
        handleTouchEnd_1();
        resetInterval_1();
    }, false);
    heroLeft.addEventListener('mousedown', function (e) {
        handleMouseDown_1(e);
        resetInterval_1();
    });
    heroLeft.addEventListener('mousemove', function (e) {
        handleMouseMove_1(e);
        resetInterval_1();
    });
    heroLeft.addEventListener('mouseup', function () {
        handleMouseUp_1();
        resetInterval_1();
    });
    setTimeout(function () {
        slides_1.forEach(function (slide) {
            slide.classList.remove("no-transition");
        });
    }, 100);
    startInterval_1();
    contents_1[activeIndex_1].classList.remove("hidden");
}
},{}],47:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var axios_1 = __importDefault(require("axios"));
var identityList = document.querySelector('.identity-list');
if (identityList) {
    var identityGrid_1 = identityList.querySelector('.identity-list__grid');
    var identityFilters_1 = identityList.querySelector('.identity-list__search');
    var identityListSearchInput_1 = identityList.querySelector('.identity-list__search-input');
    var dropdownFilters = identityList.querySelectorAll('.dropdown-filter');
    var nextPageButton = identityList.querySelector('.pagination__page-next');
    var prevPageButton = identityList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = identityList.querySelector('.pagination__dropdown');
    var paginationLast = identityList.querySelector('.pagination__page-last');
    var paginationFirst = identityList.querySelector('.pagination__page-first');
    var pagination_2 = identityList.querySelector('.pagination');
    var radios = identityList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var modalButton = identityList.querySelector('.modal__open');
    var videoModal_1 = identityList.querySelector('.modal__video');
    var identityCards_1 = [];
    var keyword_1 = '';
    var programs_1 = [];
    var fileTypes_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchIdentity_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            programs: programs_1,
                            fileTypes: fileTypes_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/identity', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/identity', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        identityCards_1 = response.data.items;
                        if (identityCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, identityCards_1, fetchIdentity_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        identityGrid_1.innerHTML = '';
        identityCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.setAttribute('download', '');
            cardElement.className = 'fade-in';
            cardElement.innerHTML = "\n            <div class='identity-list__card'>\n                <div class='identity-list__card-top flex flex--align-center'>\n                    <img src='/assets/img/fractal/filetype--" + card.fileType + ".svg' alt='icon' class='identity-list__card-image' />\n                    <div class='identity-list__card-title'>" + card.documentName + "</div>\n                </div>\n                <div class='flex flex--justify-between flex--align-center'>\n                    <div class='identity-list__card-size' dir='ltr'>" + card.size + "</div>\n                    <div>\n                        <div class='identity-list__card-buttons flex flex--align-center'>\n                            <button class=\"button button--round-small identity-list__button identity-list__button-download flex flex--justify-center flex--align-center\">\n                                <img src=\"/assets/img/img/download-icon.svg\" alt=\"'download icon\" class=\"button__image\">\n                            </button>\n                            <button class=\"button button--round-small shareButton identity-list__button identity-list__button-share flex flex--justify-center flex--align-center\">\n                                <img src=\"/assets/img/img/heart-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            ";
            identityGrid_1.appendChild(cardElement);
        });
        addCardListeners_1();
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        identityFilters_1 === null || identityFilters_1 === void 0 ? void 0 : identityFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        identityFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchIdentity_1();
    });
    modalButton === null || modalButton === void 0 ? void 0 : modalButton.addEventListener('click', function () {
        if (videoModal_1 && !videoModal_1.src.includes('&rel=0&autoplay=1')) {
            videoModal_1.src += '&rel=0&autoplay=1';
        }
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchIdentity_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchIdentity_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchIdentity_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchIdentity_1();
    });
    var timeout_1 = null;
    identityListSearchInput_1 === null || identityListSearchInput_1 === void 0 ? void 0 : identityListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = identityListSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchIdentity_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = identityList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchIdentity_1();
        });
    });
    dropdownFilters.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var fileTypesOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    fileTypesOptions_1.push(element.textContent);
                                });
                                fileTypes_1 = fileTypesOptions_1;
                                break;
                            case 1:
                                var programsOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    programsOptions_1.push(element.textContent);
                                });
                                programs_1 = programsOptions_1;
                                break;
                            default:
                                break;
                        }
                        pageNumber_1 = 1;
                        fetchIdentity_1();
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
    fetchIdentity_1();
    var addCardListeners_1 = function () {
        var serviceListCards = identityGrid_1.querySelectorAll('.identity-list__card');
        if (serviceListCards.length > 0) {
            var cardButtons = document.querySelectorAll('.identity-list__button');
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"axios":116}],48:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],49:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var InsertPageView_1 = __importDefault(require("../../../helpers/InsertPageView"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var isUserLoggedIn_1 = __importDefault(require("../../../helpers/isUserLoggedIn"));
var imagesGallery = document.querySelector('.image-gallery');
if (imagesGallery) {
    var imagesGrid_1 = imagesGallery.querySelector('.image-gallery__grid');
    var imagesFilters_1 = imagesGallery.querySelector('.image-gallery__filters');
    var imagesGallerySearchInput_1 = imagesGallery.querySelector('.image-gallery__search-input');
    var nextPageButton = imagesGallery.querySelector('.pagination__page-next');
    var prevPageButton = imagesGallery.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = imagesGallery.querySelector('.pagination__dropdown');
    var paginationLast = imagesGallery.querySelector('.pagination__page-last');
    var paginationFirst = imagesGallery.querySelector('.pagination__page-first');
    var pagination_2 = imagesGallery.querySelector('.pagination');
    var radios = imagesGallery.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var favouritedIds_1 = JSON.parse(imagesGrid_1.getAttribute('data-ids'));
    var imagesCards_1 = [];
    var keyword_1 = '';
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchImagesGallery_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/imagesGallery', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/imagesGallery', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        imagesCards_1 = response.data.items;
                        if (imagesCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, imagesCards_1, fetchImagesGallery_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        imagesGrid_1.innerHTML = '';
        imagesCards_1.forEach(function (card) {
            var cardElement = document.createElement('div');
            cardElement.className = 'image-card flex flex--column';
            var _class = '';
            if (isFavourite_1.IsFavourited(card.id, favouritedIds_1)) {
                _class = 'active';
            }
            cardElement.innerHTML = "\n            <div class='image-card__tooltip'>" + card.title + "</div> \n                <img src='" + card.imageURL + "' alt='image' class='image-card__image' />\n                <div class='image-card__border flex flex--justify-between'>\n                    <a href=\"" + card.imageURL + "\" draggable=\"false\" download class=\"button button--round-small image-card__download flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/icons/download--blue-bg.svg\" alt=\"download icon\" class=\"button__image\">\n                    </a>\n                    <div class='image-card__icons flex flex--align-center flex--justify-center'>\n                        <div class=\"flex\">\n                            <span class='image-card__count'>" + card.views + "</span>\n                            <img src='/assets/img/img/icons/eye.svg' alt='views icon' class='image-card__eye' />\n                        </div>\n                        " + (isUserLoggedIn_1.default()
                ? "<button\n                                    class=\"button button--round-small favouriteButton image-card__button image-card__icon flex flex--justify-center flex--align-center " + _class + "\" data-type=\"image\" data-id=\"" + card.id + "\">\n                                    <img src=\"/assets/img/img/heart-icon.svg\" alt=\"heart icon\" class=\"button__image\">\n                                    </button>"
                : '') + "\n                        \n                        <button\n                            class=\"button button--round-small shareButton image-card__button image-card__icon flex flex--justify-center flex--align-center\">\n                            <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                        </button>\n                        <div class='modal modal--empty' data-page-id='" + card.id + "'>\n                            <button tabindex=\"0\" class=\"modal__open\">\n                                <img tabindex=\"0\" class='modal__icon modal__icon--empty' />\n                            </button>\n                            <dialog class='modal__dialog modal__dialog-image-gallery'>\n                                <div class='modal__image-gallery-inner'>\n                                    <img src='" + card.imageURL + "' alt='image' class='image-card__image' />\n                                    <div class='image-card__border flex flex--justify-between'>\n                                        <a href=\"" + card.imageURL + "\" draggable=\"false\" download class=\"button button--round-small image-card__download flex flex--justify-center flex--align-center\">\n                                            <img src=\"/assets/img/img/icons/download--blue-bg.svg\" alt=\"download icon\" class=\"button__image\">\n                                        </a>\n                                        <div class='image-card__icons flex flex--align-center flex--justify-center'>\n                                            <div class=\"flex\">\n                                                <span class='image-card__count'>" + card.views + "</span>\n                                                <img src='/assets/img/img/icons/eye.svg' alt='views icon' class='image-card__eye' />\n                                            </div>\n                                            " + (isUserLoggedIn_1.default()
                ? "<button class=\"button button--round-small favouriteButton image-card__button image-card__icon flex flex--justify-center flex--align-center " + _class + "\" data-type=\"image\" data-id=\"" + card.id + "\">\n                                                            <img src=\"/assets/img/img/heart-icon.svg\" alt=\"heart icon\" class=\"button__image\">\n                                                        </button>"
                : '') + "\n                                            \n                                            <button\n                                                class=\"button button--round-small shareButton image-card__button image-card__icon flex flex--justify-center flex--align-center\">\n                                                <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </dialog>\n                        </div>\n                    </div>\n                </div>\n                ";
            imagesGrid_1.appendChild(cardElement);
        });
        addCardListeners_1();
        enableModals_1();
    };
    var enableModals_1 = function () {
        var modals = document.querySelectorAll('.modal');
        var html = document.querySelector('html');
        if (modals.length > 0) {
            modals === null || modals === void 0 ? void 0 : modals.forEach(function (modalContainer, index) {
                var _a;
                var modalDialog = modalContainer.querySelector('dialog');
                if (!modalDialog)
                    return;
                var modalId = "modal-" + index;
                var openButtonId = "open-button-" + index;
                modalDialog.id = modalId;
                var openButton = modalContainer.querySelector('.modal__open');
                if (openButton) {
                    openButton.id = openButtonId;
                }
                var closeButton = modalDialog.querySelector('.modal__close');
                var pageId = parseInt(modalContainer.getAttribute('data-page-id'));
                (_a = document.getElementById(openButtonId)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (event) {
                    modalDialog.showModal();
                    html.style.overflow = 'hidden';
                    if (pageId > 0) {
                        InsertPageView_1.default(pageId);
                    }
                });
                closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', function (event) {
                    modalDialog.close();
                    html.style.overflow = '';
                });
                modalDialog.addEventListener('click', function (event) {
                    if (event.target === modalDialog) {
                        modalDialog.close();
                        html.style.overflow = '';
                    }
                });
                window.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter') {
                        html.style.overflow = '';
                    }
                });
            });
        }
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        imagesFilters_1 === null || imagesFilters_1 === void 0 ? void 0 : imagesFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        imagesFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchImagesGallery_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchImagesGallery_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchImagesGallery_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchImagesGallery_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchImagesGallery_1();
    });
    var timeout_1 = null;
    imagesGallerySearchInput_1 === null || imagesGallerySearchInput_1 === void 0 ? void 0 : imagesGallerySearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = imagesGallerySearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchImagesGallery_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = imagesGallery.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchImagesGallery_1();
        });
    });
    fetchImagesGallery_1();
    var addCardListeners_1 = function () {
        var serviceListCards = imagesGrid_1.querySelectorAll('.image-card');
        if (serviceListCards.length > 0) {
            var cardButtons = document.querySelectorAll('.image-card__button');
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('favouriteButton')) {
                        var t = button.getAttribute('data-type');
                        var id = Number(button.getAttribute('data-id'));
                        favourites_1.default(t, id, button);
                    }
                    else if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
}
},{"../../../helpers/InsertPageView":1,"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9,"../../../helpers/isUserLoggedIn":10,"../pagination/pagination":71,"axios":116}],50:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],51:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var InsertPageView_1 = __importDefault(require("../../../helpers/InsertPageView"));
var infoGallery = document.querySelector('.info-gallery');
if (infoGallery) {
    var infoGrid_1 = infoGallery.querySelector('.info-gallery__grid');
    var infoFilters_1 = infoGallery.querySelector('.info-gallery__filters');
    var infoGallerySearchInput_1 = infoGallery.querySelector('.info-gallery__search-input');
    var nextPageButton = infoGallery.querySelector('.pagination__page-next');
    var prevPageButton = infoGallery.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = infoGallery.querySelector('.pagination__dropdown');
    var paginationLast = infoGallery.querySelector('.pagination__page-last');
    var paginationFirst = infoGallery.querySelector('.pagination__page-first');
    var pagination_2 = infoGallery.querySelector('.pagination');
    var radios = infoGallery.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var infoCards_1 = [];
    var keyword_1 = '';
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchInfoGallery_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/infoGallery', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/infoGallery', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        infoCards_1 = response.data.items;
                        if (infoCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, infoCards_1, fetchInfoGallery_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        infoGrid_1.innerHTML = '';
        infoCards_1.forEach(function (card) {
            var _a;
            var cardElement = document.createElement('div');
            cardElement.className = 'image-card flex flex--column';
            cardElement.innerHTML = "\n                <div class='image-card__tooltip'>" + card.title + "</div>\n                <div class=\"image-card__image-container flex flex--align-start\">\n                    <img src='" + card.imageURL + "' alt='this is an alt' class='image-card__image' />\n                    <div class='modal modal--youtube' data-page-id='" + card.id + "'>\n                        <button tabindex=\"0\" class=\"modal__open\">\n                            <img tabindex=\"0\" src='/assets/img/img/icons/youtube-play-button.png' alt='play button' class='modal__icon modal__icon--youtube' />\n                            <img tabindex=\"0\" src='/assets/img/img/icons/play-button.svg' alt='play button' class='modal__icon modal__icon--purple' />\n                            <img tabindex=\"0\" src='/assets/img/img/play-button-blue.png' alt='play button' class='modal__icon modal__icon--blue' />\n                            <img tabindex=\"0\" src='/assets/img/img/play-cricle.svg' alt='play button' class='modal__icon modal__icon--table' />\n                        </button>\n                        <dialog class='modal__dialog modal__dialog-infograph'>\n                            <div class='modal__inner'>\n                                <div class='modal__top flex flex--justify-between flex--align-center'>\n                                    <div class='flex flex--justify-between flex--align-center'>\n                                        <button class=\"button  button--round-small  modal__close  flex flex--justify-center flex--align-center\">\n                                            <img src=\"/assets/img/img/icons/close.svg\" alt=\"share icon\" class=\"button__image\">\n                                        </button>\n                                        <div class='modal__title' id='modal-title'>" + card.title + "</div>\n                                    </div>\n                                    <div class='modal__right flex flex--wrap  flex--align-center'>\n                                        <img src='/assets/img/img/icons/eye--yellow.svg' alt='decorative' class='modal__eye' />\n                                        <div class='modal__count'>" + card.views + "</div>\n                                        <div>" + (card.viewsText !== null ? card.viewsText : '') + "</div>\n                                        <div class=\"modal__buttons flex flex--align-center\">\n                                            <a class=\"button  button--round-large flex flex--justify-center flex--align-center\" href=\"" + card.imageURL + "\" download>\n                                                <img src=\"/assets/img/img/download-icon.svg\" alt=\"download icon\" class=\"button__image\">\n                                            </a>\n                                            <button class=\"button image-card__button shareButton button--round-large shareButton modal__share  flex flex--justify-center flex--align-center\">\n                                                <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"modal__bottom flex flex--column\">\n                                    <div class=\"modal__image-container\">\n                                        <img src='" + card.imageURL + "' alt=\"" + card.title + "\" class=\"modal__image\">\n                                    </div>\n                                    <div class=\"modal__images flex flex--column flex--align-start\">\n                                        <span class=\"modal__images-text\">More photos</span>\n                                        <div class=\"modal__images flex flex--align-center otherimages\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </dialog>\n                    </div>\n                </div>\n                <div class='image-card__border flex flex--justify-between'>\n                    <a class=\"button button--round-small image-card__download flex flex--justify-center flex--align-center\" href=\"" + card.imageURL + "\" download>\n                        <img src=\"/assets/img/img/icons/download--blue-bg.svg\" alt=\"download icon\" class=\"button__image\">\n                    </a>\n                    <div class='image-card__icons flex flex--align-center flex--justify-center'>\n                        <div class=\"flex\">\n                            <span class='image-card__count'>" + card.views + "</span>\n                            <img src='/assets/img/img/icons/eye.svg' alt='views icon' class='image-card__eye' />\n                        </div>\n                        <button class=\"button  button--round-small image-card__button shareButton image-card__icon  flex flex--justify-center flex--align-center\">\n                            <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                        </button>\n                    </div>\n                </div>\n            ";
            var otherimages = cardElement.querySelector('.otherimages');
            (_a = card.otherImageURL) === null || _a === void 0 ? void 0 : _a.forEach(function (otherImageLink) {
                var childImageElement = document.createElement('div');
                childImageElement.className = 'modal__image-small-container';
                childImageElement.innerHTML = "<img src=\"" + otherImageLink + " alt=\"this is alt\" class=\"modal__image-small\">";
                otherimages.appendChild(childImageElement);
            });
            infoGrid_1.appendChild(cardElement);
        });
        addCardListeners_1();
        enableModals_1();
    };
    var enableModals_1 = function () {
        var modals = document.querySelectorAll('.modal');
        var html = document.querySelector('html');
        if (modals.length > 0) {
            modals === null || modals === void 0 ? void 0 : modals.forEach(function (modalContainer, index) {
                var _a;
                var modalDialog = modalContainer.querySelector('dialog');
                if (!modalDialog)
                    return;
                var modalId = "modal-" + index;
                var openButtonId = "open-button-" + index;
                modalDialog.id = modalId;
                var openButton = modalContainer.querySelector('.modal__open');
                if (openButton) {
                    openButton.id = openButtonId;
                }
                var closeButton = modalDialog.querySelector('.modal__close');
                var pageId = parseInt(modalContainer.getAttribute('data-page-id'));
                (_a = document.getElementById(openButtonId)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (event) {
                    modalDialog.showModal();
                    html.style.overflow = 'hidden';
                    if (pageId > 0) {
                        InsertPageView_1.default(pageId);
                    }
                });
                closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', function (event) {
                    modalDialog.close();
                    html.style.overflow = '';
                });
                modalDialog.addEventListener('click', function (event) {
                    if (event.target === modalDialog) {
                        modalDialog.close();
                        html.style.overflow = '';
                    }
                });
                window.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter') {
                        html.style.overflow = '';
                    }
                });
            });
        }
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        infoFilters_1 === null || infoFilters_1 === void 0 ? void 0 : infoFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        infoFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchInfoGallery_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchInfoGallery_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchInfoGallery_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchInfoGallery_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchInfoGallery_1();
    });
    var timeout_1 = null;
    infoGallerySearchInput_1 === null || infoGallerySearchInput_1 === void 0 ? void 0 : infoGallerySearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = infoGallerySearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchInfoGallery_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = infoGallery.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchInfoGallery_1();
        });
    });
    fetchInfoGallery_1();
    var addCardListeners_1 = function () {
        var serviceListCards = infoGrid_1.querySelectorAll('.image-card');
        if (serviceListCards.length > 0) {
            var cardButtons = document.querySelectorAll('.image-card__button');
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
}
},{"../../../helpers/InsertPageView":1,"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"axios":116}],52:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],53:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var isef = document.querySelector('.isef');
if (isef) {
    var eventTabs_1 = isef.querySelectorAll('.isef__tab');
    var sections_1 = isef.querySelectorAll('.isef__section');
    var winnersSection = isef.querySelector('.isef__mega-table-wrapper');
    var activeTab_1 = 0;
    var resetTabs_1 = function () {
        eventTabs_1.forEach(function (tab) { return tab.classList.remove('isef__tab--active'); });
        sections_1.forEach(function (tab) { return tab.classList.remove('isef__section--active'); });
    };
    eventTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            resetTabs_1();
            eventTabs_1[activeTab_1].classList.add('isef__tab--active');
            sections_1[activeTab_1].classList.add('isef__section--active');
        });
    });
    sections_1.forEach(function (section) {
        var accordion = section.firstElementChild;
        if (accordion != null) {
            if (accordion.classList.contains('isef__accordion')) {
                accordion.setAttribute('open', 'true');
            }
            var accordions_1 = section.querySelectorAll('.isef__accordion');
            accordions_1.forEach(function (childAccordion) {
                childAccordion.addEventListener('toggle', function () {
                    if (childAccordion.open) {
                        accordions_1.forEach(function (otherAccordion) {
                            if (otherAccordion !== childAccordion) {
                                otherAccordion.removeAttribute('open');
                            }
                        });
                    }
                });
            });
        }
    });
    var favButtons = document.querySelectorAll('.favouriteButton');
    if (favButtons && favButtons.length > 0) {
        favButtons.forEach(function (button) {
            var dataIdAttr = button.getAttribute('data-id');
            var type = button.getAttribute('data-type');
            var favouritedIds = JSON.parse(button.getAttribute('data-ids'));
            if (dataIdAttr !== null && favouritedIds != null) {
                var dataId_1 = parseInt(dataIdAttr);
                if (isFavourite_1.IsFavourited(dataId_1, favouritedIds)) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
                button.addEventListener('click', function (e) {
                    console.log('small button clicked - program details');
                    favourites_1.default(type, dataId_1, button);
                });
            }
        });
    }
    if (winnersSection) {
        var studentsTableBody_1 = isef.querySelector('.isef__mega-table-body');
        var studentsMobileTableBody_1 = isef.querySelector('.isef__mega-table-mobile-body');
        var nextPageButton = isef.querySelector('.pagination__page-next');
        var prevPageButton = isef.querySelector('.pagination__page-prev');
        var paginationDropdown_1 = isef.querySelector('.pagination__dropdown');
        var paginationLast = isef.querySelector('.pagination__page-last');
        var paginationFirst = isef.querySelector('.pagination__page-first');
        var pagination_2 = isef.querySelector('.pagination');
        var radios = isef.querySelectorAll('.sort-filter__input');
        var isefFilters_1 = isef.querySelector('.isef__filters');
        var isefSearchInput_1 = isef.querySelector('.isef__search-input');
        var dropdownFilters = isef.querySelectorAll('.dropdown-filter');
        var currentCulture_1 = document.documentElement.getAttribute('culture');
        var parentNodeId_1 = winnersSection.getAttribute('data-id');
        var isefWinnersItems_1 = [];
        var keyword_1 = '';
        var educationDepartments_1 = [];
        var positions_1 = [];
        var years_1 = [];
        var sortBy_1 = 1;
        var pageNumber_1 = 1;
        var pageSize_1 = +paginationDropdown_1.value;
        var totalPages_1 = 0;
        var totalCount_1 = 0;
        var hasNextPage_1 = false;
        var hasPreviousPage_1 = false;
        var buttonsToShow_1 = 3;
        var isLoading_1 = false;
        var clickedNumber_1 = null;
        var isefWinnersTableColumnsNames_1 = [];
        var fetchIsefWinnersTableColumnsNames = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.get("/api/services/results/columnsNames/" + parentNodeId_1 + "?currentCulture=" + currentCulture_1)];
                    case 1:
                        response = _a.sent();
                        isefWinnersTableColumnsNames_1 = response.data;
                        console.log(isefWinnersTableColumnsNames_1);
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var fetchIsefWinnersResultsList_1 = function (page) {
            if (page === void 0) { page = null; }
            return __awaiter(void 0, void 0, void 0, function () {
                var payload, response, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            clickedNumber_1 = page;
                            pagination_2.classList.add('hidden');
                            if (clickedNumber_1) {
                                pageNumber_1 = page;
                            }
                            payload = {
                                parentNodeId: parentNodeId_1,
                                keyword: keyword_1,
                                educationDepartments: educationDepartments_1,
                                positions: positions_1,
                                years: years_1,
                                sortBy: sortBy_1,
                                pageNumber: pageNumber_1,
                                pageSize: pageSize_1,
                                currentCulture: currentCulture_1,
                            };
                            isLoading_1 = true;
                            disableInputs_1();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            response = void 0;
                            if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                                window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                            return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/services/results', payload)];
                        case 2:
                            response = _a.sent();
                            return [3, 5];
                        case 3: return [4, axios_1.default.post('/api/services/results', payload)];
                        case 4:
                            response = _a.sent();
                            _a.label = 5;
                        case 5:
                            isefWinnersItems_1 = response.data.items;
                            if (isefWinnersItems_1.length > 0) {
                                pagination_2.classList.remove('hidden');
                            }
                            totalPages_1 = response.data.totalPages;
                            totalCount_1 = response.data.totalCount;
                            hasNextPage_1 = response.data.hasNextPage;
                            hasPreviousPage_1 = response.data.hasPreviousPage;
                            return [3, 8];
                        case 6:
                            error_2 = _a.sent();
                            console.error(error_2);
                            enableInputs_1();
                            return [3, 8];
                        case 7:
                            pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, isefWinnersItems_1, fetchIsefWinnersResultsList_1);
                            isLoading_1 = false;
                            updateItems_1();
                            enableInputs_1();
                            return [7];
                        case 8: return [2];
                    }
                });
            });
        };
        var disableInputs_1 = function () {
            pagination_2.classList.add('disabled');
            isefFilters_1.classList.add('disabled');
        };
        var enableInputs_1 = function () {
            pagination_2.classList.remove('disabled');
            isefFilters_1.classList.remove('disabled');
        };
        var updateItems_1 = function () {
            studentsTableBody_1.innerHTML = '';
            studentsMobileTableBody_1.innerHTML = '';
            isefWinnersItems_1.forEach(function (item) {
                var rowElement = document.createElement('tr');
                rowElement.className = 'isef__mega-table-row';
                rowElement.innerHTML = "\n                " + (isefWinnersTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'student/team name'; })
                    ? "<td class=\"isef__mega-table-data\">\n                                <div class=\"isef__mega-table-content flex flex--align-center\">\n                                    <div class=\"isef__mega-table-images\"> </div>\n                                    <span class=\"isef__mega-table-content-title\">" + item.students[0].name + "</span>\n                                </div>\n                            </td>"
                    : '') + "\n\n                " + (isefWinnersTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'project title'; })
                    ? "<td class=\"isef__mega-table-data\">\n                                <div\n                                    class=\"isef__mega-table-content flex flex--align-center\">\n                                    <span class=\"isef__mega-table-content-title\">" + item.projectTitle + "</span>\n                                </div>\n                            </td>"
                    : '') + "\n\n                " + (isefWinnersTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'education department'; })
                    ? "<td class=\"isef__mega-table-data\">\n                                <div\n                                    class=\"isef__mega-table-content flex flex--align-center\">\n                                    <span class=\"isef__mega-table-content-title\">" + item.educationDepartment + "</span>\n                                </div>\n                            </td>"
                    : '') + "\n\n                " + (isefWinnersTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'school'; })
                    ? "<td class=\"isef__mega-table-data\">\n                                <div\n                                    class=\"isef__mega-table-content flex flex--align-center\">\n                                    <span class=\"isef__mega-table-content-title\">" + item.school + "</span>\n                                </div>\n                            </td>"
                    : '') + "\n                " + (isefWinnersTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'search entity'; })
                    ? "<td class=\"isef__mega-table-data\">\n                                <div\n                                    class=\"isef__mega-table-content flex flex--align-center\">\n                                    <span class=\"isef__mega-table-content-title\">" + (item.searchEntity !== null ? item.searchEntity : '-') + "</span>\n                                </div>\n                            </td>"
                    : '') + "\n                \n                " + (isefWinnersTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'prize'; })
                    ? "<td class=\"isef__mega-table-data\">\n                                <div\n                                    class=\"isef__mega-table-content flex flex--align-center isef__mega-table-content-icon\">\n                                    <img src=\"/assets/img/img/icons/medal-star.svg\" alt=\"icon\" class=\"isef__mega-table-icon\">\n                                    <span class=\"isef__mega-table-content-title\">" + item.position + "</span>\n                                </div>\n                            </td>"
                    : '');
                var images = rowElement.querySelector('.isef__mega-table-images');
                if (images) {
                    item.students
                        .filter(function (std) { return std.image !== null && std.image !== undefined && std.image !== ''; })
                        .forEach(function (student) {
                        var imageItem = document.createElement('img');
                        imageItem.alt = 'student image';
                        imageItem.src = student.image;
                        imageItem.classList.add('isef__mega-table-image');
                        images.appendChild(imageItem);
                    });
                }
                addMobileRow_1(item);
                studentsTableBody_1.appendChild(rowElement);
            });
        };
        var addMobileRow_1 = function (item) {
            var studentName = isefWinnersTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'student/team name'; });
            var projectTitle = isefWinnersTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'project title'; });
            var educationDepartment = isefWinnersTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'education department'; });
            var school = isefWinnersTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'school'; });
            var searchEntity = isefWinnersTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'search entity'; });
            var prize = isefWinnersTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'prize'; });
            studentsMobileTableBody_1.insertAdjacentHTML('beforeend', "\n        " + (studentName !== undefined
                ? "<tr class=\"isef__mega-table-row\">\n                        <th class=\"isef__mega-table-header\">" + studentName.value + "</th>\n                        <td class=\"isef__mega-table-data\">\n                            <div class=\"isef__mega-table-content flex flex--align-center\">\n                                <div class=\"isef__mega-table-images\"> </div>\n                                <span class=\"isef__mega-table-content-title\">" + item.students[0].name + "</span>\n                            </div>\n                        </td>\n                    </tr>"
                : '') + "\n\n        " + (projectTitle !== undefined
                ? "<tr class=\"isef__mega-table-row\">\n                        <th class=\"isef__mega-table-header\">" + projectTitle.value + "</th>\n                        <td class=\"isef__mega-table-data\">\n                            <div class=\"isef__mega-table-content flex flex--align-center\">\n                                <span class=\"isef__mega-table-content-title\">" + item.projectTitle + "</span>\n                            </div>\n                        </td>\n                    </tr>"
                : '') + "\n\n        " + (educationDepartment !== undefined
                ? "<tr class=\"isef__mega-table-row\">\n                        <th class=\"isef__mega-table-header\">" + educationDepartment.value + "</th>\n                        <td class=\"isef__mega-table-data\">\n                            <div class=\"isef__mega-table-content flex flex--align-center\">\n                                <span class=\"isef__mega-table-content-title\">" + item.educationDepartment + "</span>\n                            </div>\n                        </td>\n                    </tr>"
                : '') + "\n\n        " + (prize !== undefined
                ? "<tr class=\"isef__mega-table-row\">\n                        <th class=\"isef__mega-table-header\">" + prize.value + "</th>\n                        <td class=\"isef__mega-table-data\">\n                            <div class=\"isef__mega-table-content flex flex--align-center isef__mega-table-content-icon\">\n                                <img src=\"/assets/img/img/icons/medal-star.svg\" alt=\"alt\" class=\"isef__mega-table-icon\" />\n                                <span class=\"isef__mega-table-content-title\">" + item.position + "</span>\n                            </div>\n                        </td>\n                    </tr>"
                : '') + "\n\n        " + (school !== undefined
                ? "<tr class=\"isef__mega-table-row\">\n                        <th class=\"isef__mega-table-header\">" + school.value + "</th>\n                        <td class=\"isef__mega-table-data\">\n                            <div class=\"isef__mega-table-content flex flex--align-center\">\n                                <span class=\"isef__mega-table-content-title\">" + item.school + "</span>\n                            </div>\n                        </td>\n                    </tr>"
                : '') + "\n\n        " + (searchEntity !== undefined
                ? "<tr class=\"isef__mega-table-row\">\n                        <th class=\"isef__mega-table-header\">" + searchEntity.value + "</th>\n                        <td class=\"isef__mega-table-data\">\n                            <div class=\"isef__mega-table-content flex flex--align-center\">\n                                <span class=\"isef__mega-table-content-title\">" + (item.searchEntity !== null ? item.searchEntity : '-') + "</span>\n                            </div>\n                        </td>\n                    </tr>"
                : ''));
        };
        paginationDropdown_1.addEventListener('change', function () {
            pageSize_1 = +paginationDropdown_1.value;
            pageNumber_1 = 1;
            fetchIsefWinnersResultsList_1();
        });
        nextPageButton.addEventListener('click', function () {
            pageNumber_1++;
            fetchIsefWinnersResultsList_1();
        });
        prevPageButton.addEventListener('click', function () {
            pageNumber_1--;
            fetchIsefWinnersResultsList_1();
        });
        paginationFirst.addEventListener('click', function () {
            pageNumber_1 = 1;
            fetchIsefWinnersResultsList_1();
        });
        paginationLast.addEventListener('click', function () {
            pageNumber_1 = totalPages_1;
            fetchIsefWinnersResultsList_1();
        });
        var timeout_1 = null;
        isefSearchInput_1.addEventListener('input', function (e) {
            clearTimeout(timeout_1);
            timeout_1 = setTimeout(function () {
                keyword_1 = isefSearchInput_1.value.trim();
                pageNumber_1 = 1;
                fetchIsefWinnersResultsList_1();
            }, 1000);
        });
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                var checkedRadio = isef.querySelector('input[name="sort-filter"]:checked');
                var checkedRadioValue = checkedRadio.value;
                sortBy_1 = +checkedRadioValue;
                fetchIsefWinnersResultsList_1();
            });
        });
        dropdownFilters.forEach(function (dropdown, index) {
            var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container') || null;
            if (optionsContainer) {
                var config = { childList: true };
                var callback = function (mutationsList, observer) {
                    var _loop_1 = function (mutation) {
                        if (mutation.type === 'childList') {
                            switch (index) {
                                case 0:
                                    var educationDepartmentsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        educationDepartmentsOptions_1.push(element.textContent);
                                    });
                                    educationDepartments_1 = educationDepartmentsOptions_1;
                                    break;
                                case 1:
                                    var positionsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        positionsOptions_1.push(element.textContent);
                                    });
                                    positions_1 = positionsOptions_1;
                                    break;
                                case 2:
                                    var yearsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        yearsOptions_1.push(element.textContent);
                                    });
                                    years_1 = yearsOptions_1;
                                    break;
                                default:
                                    break;
                            }
                            pageNumber_1 = 1;
                            fetchIsefWinnersResultsList_1();
                        }
                    };
                    for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                        var mutation = mutationsList_1[_i];
                        _loop_1(mutation);
                    }
                };
                var observer = new MutationObserver(callback);
                observer.observe(optionsContainer, config);
            }
        });
        fetchIsefWinnersTableColumnsNames();
        fetchIsefWinnersResultsList_1();
    }
}
},{"../../../helpers/favourites":6,"../../../helpers/isFavourite":9,"../pagination/pagination":71,"axios":116}],54:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],55:[function(require,module,exports){
var jobCards = document.querySelectorAll(".job-card");
if (jobCards.length > 0) {
    var cardButtons = document.querySelectorAll(".job-card__button");
    jobCards.forEach(function (card) {
        card.addEventListener("click", function (e) {
            var target = e.target;
            if (target.classList.contains("button") || target.classList.contains("button__image")) {
                e.preventDefault();
            }
        });
    });
    cardButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
            console.log("small button clicked");
        });
    });
}
},{}],56:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var jobDetails = document.querySelector('.job-details');
if (jobDetails) {
    var tabs_1 = jobDetails.querySelectorAll('.job-details__tab');
    var tabContents_1 = jobDetails.querySelectorAll('.job-details__tab-content');
    var starsFill = jobDetails.querySelector('.job-details__stars-fill');
    var direction_1 = document.querySelector('html').getAttribute('dir');
    var activeTabIndex_1 = 0;
    tabContents_1[activeTabIndex_1].classList.remove('hidden');
    tabs_1[activeTabIndex_1].classList.add('job-details__tab--active');
    var resetTabs_1 = function () {
        tabs_1.forEach(function (tab) { return tab.classList.remove('job-details__tab--active'); });
        tabContents_1.forEach(function (item) { return item.classList.add('hidden'); });
    };
    tabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            resetTabs_1();
            tab.classList.add('job-details__tab--active');
            activeTabIndex_1 = index;
            tabContents_1[activeTabIndex_1].classList.remove('hidden');
        });
    });
}
var shareButtons = document.querySelectorAll(".shareButton");
if (shareButtons && shareButtons.length > 0) {
    shareButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            copyToClipboard_1.default(button);
        });
    });
}
},{"../../../helpers/copyToClipboard":5}],57:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var pagination_1 = require("../pagination/pagination");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var axios_1 = __importDefault(require("axios"));
var jobsList = document.querySelector('.jobs-list');
if (jobsList) {
    var jobsGrid_1 = jobsList.querySelector('.jobs-list__grid');
    var jobsFilters_1 = jobsList.querySelector('.jobs-list__filters');
    var jobsListSearchInput_1 = jobsList.querySelector('.jobs-list__search-input');
    var dropdownFilters = jobsList.querySelectorAll('.dropdown-filter');
    var nextPageButton = jobsList.querySelector('.pagination__page-next');
    var prevPageButton = jobsList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = jobsList.querySelector('.pagination__dropdown');
    var paginationLast = jobsList.querySelector('.pagination__page-last');
    var paginationFirst = jobsList.querySelector('.pagination__page-first');
    var pagination_2 = jobsList.querySelector('.pagination');
    var radios_1 = jobsList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var jobCards_1 = [];
    var keyword_1 = '';
    var departments_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var keywordChanged_1 = false;
    var restoreDropdownSelections = function (dropdown, selectedValues) {
        var select = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.multi-select');
        var buttonContainer = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.dropdown-filter__button-container');
        if (!select)
            return;
        selectedValues.forEach(function (value) {
            var option = Array.from(select.options).find(function (item) { return item.value === value; });
            if (!option)
                return;
            option.selected = true;
            option.setAttribute('selected', '');
            if (!buttonContainer)
                return;
            var alreadyRendered = Array.from(buttonContainer.querySelectorAll('.selected-label')).some(function (label) { return label.textContent === value; });
            if (alreadyRendered)
                return;
            var token = document.createElement('div');
            token.classList.add('dropdown-filter__selected-wrapper');
            var label = document.createElement('span');
            label.classList.add('selected-label');
            label.textContent = value;
            var close = document.createElement('a');
            close.classList.add('selected-close');
            close.setAttribute('tabindex', '-1');
            close.setAttribute('data-option', value);
            close.setAttribute('data-hits', '0');
            close.addEventListener('click', function (event) {
                option.selected = false;
                option.removeAttribute('selected');
                token.remove();
                event.stopPropagation();
            });
            token.appendChild(label);
            token.appendChild(close);
            buttonContainer.appendChild(token);
        });
    };
    var initialUrl = new URL(window.location.href);
    restoreDropdownSelections(dropdownFilters[0], initialUrl.searchParams.getAll('departments'));
    var jobCardSettings_1 = {
        cardButtonText: '',
        availableText: '',
        endText: '',
        noJobsText: '',
    };
    var fetchJobCardSettings_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/jobs/cardsettings?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    jobCardSettings_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchJobs_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var url, payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        url = new URL(window.location.href);
                        pageNumber_1 = keywordChanged_1 ? 1 : Number(url.searchParams.get('pageNumber') || 1);
                        pageSize_1 = Number(url.searchParams.get('pageSize') || pageSize_1);
                        keyword_1 = keywordChanged_1 ? keyword_1 : url.searchParams.get('keyword') || '';
                        departments_1 = departments_1.length === 0 ? url.searchParams.getAll('departments') : departments_1;
                        sortBy_1 = Number(url.searchParams.get('sortBy') || sortBy_1);
                        paginationDropdown_1.value = pageSize_1.toString();
                        jobsListSearchInput_1.value = keyword_1;
                        radios_1.forEach(function (radio) {
                            radio.checked = sortBy_1 === +radio.value;
                        });
                        payload = {
                            keyword: keyword_1,
                            departments: departments_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/jobs', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/jobs', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        jobCards_1 = response.data.items;
                        if (jobCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, jobCards_1, renderPage_1, true);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        jobsGrid_1.innerHTML = '';
        if (jobCards_1.length === 0) {
            jobsGrid_1.innerHTML = "<div class=\"flex\" style=\"align-self: center;\">" + jobCardSettings_1.noJobsText + "</div>";
        }
        else {
            jobCards_1.forEach(function (card) {
                var cardElement = document.createElement('a');
                cardElement.setAttribute('href', card.link);
                cardElement.className = 'job-card flex flex--column';
                cardElement.innerHTML = "\n                <span class=\"job-card__tag " + (card.isAvailable ? '' : 'job-card__tag--red') + "\">" + (card.isAvailable ? jobCardSettings_1.availableText : jobCardSettings_1.endText) + "</span>\n                <div class=\"job-card__content flex flex--column\">\n                    <p class='job-card__title'>" + card.title + "</p>\n                    <p class='job-card__text'>" + card.description + "</p>\n                </div>\n                <div class=\"job-card__items flex flex--wrap flex--align-center\">\n                    <p class='job-card__info flex flex--align-center'>\n                        <img src='/assets/img/img/user-octagon-icon.svg' alt='calendar icon' class='job-card__icon' />\n                        <span class='job-card__info-text'>\n                            " + card.department + "\n                        </span>\n                    </p>\n                    <p class='job-card__info flex flex--align-center'>\n                        <img src='/assets/img/img/calendar-icon-yellow.svg' alt='calendar icon' class='job-card__icon' />\n                        <span class='job-card__info-text'>\n                                " + formatDate_1.default(card.publishDate) + "\n                        </span>\n                    </p>\n                </div>\n                <div class=\"job-card__buttons flex flex--wrap flex--align-center flex--justify-between\">\n                    <div class=\"job-card__link flex flex--align-center flex--justify-center\">\n                        " + jobCardSettings_1.cardButtonText + "\n                        <img src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"arrow icon\" class=\"job-card__link-icon\">\n                    </div>\n                    <button class=\"button shareButton button--round-tiny job-card__button job-card__button-share flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                </div>\n            ";
                jobsGrid_1.appendChild(cardElement);
            });
            addCardListeners_1();
        }
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        jobsFilters_1 === null || jobsFilters_1 === void 0 ? void 0 : jobsFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        jobsFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        renderPage_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        renderPage_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        renderPage_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        renderPage_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        renderPage_1();
    });
    var timeout_1 = null;
    jobsListSearchInput_1 === null || jobsListSearchInput_1 === void 0 ? void 0 : jobsListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = jobsListSearchInput_1.value.trim();
            keywordChanged_1 = true;
            pageNumber_1 = 1;
            fetchJobs_1();
        }, 1000);
    });
    radios_1.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = jobsList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            renderPage_1();
        });
    });
    dropdownFilters.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var departmentsOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    departmentsOptions_1.push(element.textContent);
                                });
                                departments_1 = departmentsOptions_1;
                                break;
                            default:
                                break;
                        }
                        pageNumber_1 = 1;
                        renderPage_1();
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
    var initializeEventsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchJobCardSettings_1()];
                case 1:
                    _a.sent();
                    return [4, fetchJobs_1()];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeEventsList();
    var addCardListeners_1 = function () {
        var listCards = jobsList.querySelectorAll('.job-card');
        if (listCards.length > 0) {
            var cardButtons = document.querySelectorAll('.job-card__button');
            listCards.forEach(function (card) {
                card.addEventListener('click', function (e) {
                    var target = e.target;
                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
    var renderPage_1 = function (page) {
        if (page === void 0) { page = null; }
        if (page) {
            pageNumber_1 = page;
        }
        var url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber_1.toString());
        url.searchParams.set('pageSize', pageSize_1.toString());
        if (keyword_1)
            url.searchParams.set('keyword', keyword_1);
        departments_1.forEach(function (department) { return url.searchParams.append('departments', department); });
        url.searchParams.set('sortBy', sortBy_1.toString());
        if (page == null) {
            window.location.href = url.toString();
        }
        return url.toString();
    };
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/formatDate":7,"../pagination/pagination":71,"axios":116}],58:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],59:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var latestNewsComponent = document.querySelector(".latest-news");
if (latestNewsComponent) {
    var latestNewsCarousels = document.querySelectorAll(".latest-news__carousel-inner");
    var direction_1 = document.querySelector("html").getAttribute("dir");
    if (latestNewsCarousels.length > 0) {
        var latestNewsCarouselsArray = Array.from(latestNewsCarousels) || [];
        latestNewsCarouselsArray.forEach(function (item) {
            var glideSettings = {
                type: 'slider',
                perView: 3,
                gap: 24,
                rewind: true,
                bound: true,
                direction: direction_1 || "ltr",
                breakpoints: {
                    1000: {
                        perView: 2,
                        gap: 16
                    }
                }
            };
            var glide = new glide_1.default(item, glideSettings);
            glide.mount();
        });
    }
}
},{"@glidejs/glide":115}],60:[function(require,module,exports){
var mobileMenu = document.querySelector(".menu-mobile__container");
if (mobileMenu) {
    var mobileMenuIcon_1 = mobileMenu.querySelector(".menu-mobile__icon");
    var mobileMenuIconContainer = mobileMenu.querySelector(".menu-mobile__icon-container");
    var mobileMenuButton = mobileMenu.querySelector(".menu-mobile__icon-container");
    var mobileMenuOverlay_1 = mobileMenu.querySelector(".menu-mobile__overlay");
    var mobileMenuClose = mobileMenu.querySelector(".menu-mobile__close");
    var accordions_1 = mobileMenu.querySelectorAll(".menu-mobile__accordion");
    var chevrons = mobileMenu.querySelectorAll(".menu-mobile__chevron");
    var html_1 = document.querySelector("html");
    var dir = document.querySelector("html").getAttribute("dir");
    var title = mobileMenu.querySelector(".menu-mobile__title");
    var openMenu_1 = function () {
        mobileMenuIcon_1.classList.add("menu-mobile__icon--open");
        mobileMenuOverlay_1.classList.add("menu-mobile__overlay--active");
        html_1.style.overflow = "hidden";
    };
    var closeMenu_1 = function () {
        mobileMenuIcon_1.classList.remove("menu-mobile__icon--open");
        mobileMenuOverlay_1.classList.remove("menu-mobile__overlay--active");
        setTimeout(function () {
            closeAllAccordions_1();
        }, 500);
        html_1.style.overflow = "auto";
    };
    var closeAllAccordions_1 = function () {
        accordions_1.forEach(function (acc) {
            var pan = acc.nextElementSibling;
            pan.style.maxHeight = "";
            pan.classList.remove("menu-mobile__accordion-panel--active");
            acc.classList.remove("menu-mobile__accordion--active");
        });
    };
    var handleAccordionClick_1 = function (element) {
        var panel = element.nextElementSibling;
        var isActive = element.classList.contains("menu-mobile__accordion--active");
        closeAllAccordions_1();
        if (!isActive) {
            panel.classList.add("menu-mobile__accordion-panel--active");
            panel.style.maxHeight = panel.scrollHeight + "px";
            element.classList.add("menu-mobile__accordion--active");
        }
    };
    mobileMenuIconContainer.addEventListener("click", function (e) {
        if (mobileMenuIcon_1.classList.contains("menu-mobile__icon--open")) {
            closeMenu_1();
        }
        else {
            openMenu_1();
        }
    });
    mobileMenuButton.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            if (mobileMenuIcon_1.classList.contains("menu-mobile__icon--open")) {
                closeMenu_1();
            }
            else {
                openMenu_1();
            }
        }
    });
    mobileMenuOverlay_1.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closeMenu_1();
        }
    });
    mobileMenuOverlay_1.addEventListener("click", function (e) {
        var targetElement = e.target;
        if (targetElement.className === "menu-mobile__overlay menu-mobile__overlay--active") {
            closeMenu_1();
        }
    });
    chevrons.forEach(function (chevron) {
        chevron.addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
                handleAccordionClick_1(chevron.parentElement);
            }
        });
    });
    mobileMenuClose.addEventListener("click", function (e) {
        closeMenu_1();
    });
    mobileMenuClose.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            closeMenu_1();
        }
    });
    accordions_1.forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            if (this.nextElementSibling.classList.contains("menu-mobile__accordion-panel")) {
                handleAccordionClick_1(this);
            }
        });
    });
}
},{}],61:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var methodology = document.querySelector('.methodology');
if (methodology) {
    var shareButtons = document.querySelectorAll(".shareButton");
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5}],62:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var InsertPageView_1 = __importDefault(require("../../../helpers/InsertPageView"));
var modals = document.querySelectorAll('.modal');
var html = document.querySelector('html');
if (modals.length > 0) {
    document.addEventListener('DOMContentLoaded', function () {
        modals === null || modals === void 0 ? void 0 : modals.forEach(function (modalContainer, index) {
            var _a;
            var iframe = modalContainer.querySelector('.modal__video');
            var modalDialog = modalContainer.querySelector('dialog');
            if (!modalDialog)
                return;
            var modalId = "modal-" + index;
            var openButtonId = "open-button-" + index;
            modalDialog.id = modalId;
            var openButton = modalContainer.querySelector('.modal__open');
            if (openButton) {
                openButton.id = openButtonId;
            }
            var closeButton = modalDialog.querySelector('.modal__close');
            var pageId = parseInt(modalContainer.getAttribute('data-page-id'));
            (_a = document.getElementById(openButtonId)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (event) {
                modalDialog.showModal();
                if (pageId > 0) {
                    InsertPageView_1.default(pageId);
                }
                html.style.overflow = 'hidden';
            });
            closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', function (event) {
                event.stopPropagation();
                closeModal_1(modalDialog, iframe);
            });
            modalDialog.addEventListener('click', function (event) {
                event.stopPropagation();
                if (event.target === modalDialog) {
                    closeModal_1(modalDialog, iframe);
                }
            });
            window.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    html.style.overflow = '';
                }
            });
        });
    });
    var closeModal_1 = function (modal, iframe) {
        modal.close();
        html.style.overflow = '';
        if (iframe && iframe.contentWindow && iframe.contentDocument) {
            var video = iframe.contentDocument.querySelector('video');
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        }
    };
}
},{"../../../helpers/InsertPageView":1}],63:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var initializeFavouritesNavComponent = function (favouritesTabComponent) {
    var _a;
    var favouritesTabs = favouritesTabComponent.querySelectorAll('.nav-favourites__tab');
    var services = favouritesTabComponent.querySelector('.nav-favourites__content_services');
    var others = favouritesTabComponent.querySelector('.nav-favourites__content_other');
    var favouritesContents = favouritesTabComponent.querySelectorAll('.nav-favourites__content');
    var activeTab = 0;
    var currentType = 'service';
    var isLoading = false;
    var currentCulture = document.documentElement.getAttribute('culture');
    var servicesCards = [];
    var ids = [];
    if (favouritesTabComponent) {
        var favouritesButton_1 = favouritesTabComponent.querySelector('.nav-favourites__button');
        var hasFavourites = (_a = favouritesTabComponent.getAttribute('data-has-favourites')) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
        if (hasFavourites === 'true') {
            favouritesButton_1.classList.add('active');
        }
        var openFavouriteDropdown_1 = function () {
            favouritesButton_1.nextElementSibling.classList.add('nav-favourites__inner--active');
            showSelectedTab_1(activeTab);
        };
        var closeFavouriteDropdown_1 = function () {
            favouritesButton_1.nextElementSibling.classList.remove('nav-favourites__inner--active');
        };
        window.addEventListener('click', function (event) {
            var targetElement = favouritesTabComponent.querySelector('.nav-favourites__inner');
            var clickedElement = event.target;
            if (clickedElement.classList.contains('nav-favourites__button')) {
                if (clickedElement.nextElementSibling.classList.contains('nav-favourites__inner--active')) {
                    closeFavouriteDropdown_1();
                }
                else {
                    openFavouriteDropdown_1();
                }
                return;
            }
            if (!targetElement)
                return;
            while (clickedElement) {
                if (clickedElement === targetElement) {
                    favouritesButton_1.nextElementSibling.classList.add('nav-favourites__inner--active');
                    return;
                }
                clickedElement = clickedElement.parentElement;
            }
            favouritesButton_1.nextElementSibling.classList.remove('nav-favourites__inner--active');
        });
        window.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                closeFavouriteDropdown_1();
            }
        });
        var showSelectedTab_1 = function (activeTab) {
            favouritesTabs.forEach(function (tab, index) {
                tab.classList.remove('nav-favourites__tab--active');
                favouritesContents[index].style.display = 'none';
            });
            var selectedTab = favouritesTabs[activeTab];
            selectedTab.classList.add('nav-favourites__tab--active');
            favouritesContents[activeTab].style.display = 'block';
            currentType = selectedTab.getAttribute('data-type');
            ids = JSON.parse(selectedTab.getAttribute('data-ids'));
            if (currentType == 'other') {
                getOtherCards_1();
            }
            else if (currentType == 'service') {
                getServiceCards_1();
            }
        };
        var handleTabClick_1 = function (index) {
            activeTab = index;
            showSelectedTab_1(activeTab);
        };
        favouritesTabs.forEach(function (tab, index) {
            tab.addEventListener('click', function () { return handleTabClick_1(index); });
        });
        var getServiceCards_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(ids.length > 0)) return [3, 9];
                        payload = {
                            sortBy: 1,
                            pageNumber: 1,
                            pageSize: 3,
                            currentCulture: currentCulture,
                            ids: ids,
                        };
                        isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/services/byids', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/services/byids', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        servicesCards = response.data.items;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3, 8];
                    case 7:
                        isLoading = false;
                        updateServiceCards_1();
                        return [7];
                    case 8: return [3, 9];
                    case 9: return [2];
                }
            });
        }); };
        var getOtherCards_1 = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2];
        }); }); };
        var updateServiceCards_1 = function () {
            services.innerHTML = '';
            servicesCards.forEach(function (card) {
                var cardElement = document.createElement('a');
                cardElement.className = 'nav-favourites__item flex flex--align-center flex--justify-between';
                cardElement.setAttribute('href', card.link);
                cardElement.innerHTML = "\n                <div class='nav-favourites__item-left flex flex--align-center'>\n                        <div class='nav-favourites__item-title'>" + card.title + "</div>\n                </div>\n                <img src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"arrow icon\" class=\"nav-favourites__item-arrow\">\n                ";
                services.appendChild(cardElement);
            });
        };
        showSelectedTab_1(activeTab);
    }
};
document.querySelectorAll('.nav-favourites__wrapper').forEach(function (favouritesTabComponent) {
    initializeFavouritesNavComponent(favouritesTabComponent);
});
},{"axios":116}],64:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],65:[function(require,module,exports){
var navbar = document.querySelector('.navbar');
if (navbar) {
    var navbarUser = navbar.querySelector('.navbar__user');
    var navbarUserDropdown_1 = navbar.querySelector('.navbar__user-dropdown');
    var searchButton_1 = navbar.querySelector('.navbar__button-search');
    var linkItems = navbar.querySelectorAll('.navbar__links-drop');
    var searchInput_1 = navbar.querySelector('.navbar__button-search-input');
    var searchPageUrl_1 = searchInput_1.parentElement.getAttribute('data-search-page');
    var searchSubmitButton_1 = navbar.querySelector('.navbar__button-search-submit');
    var checkScrollPosition = function () {
        if (window.scrollY === 0) {
            navbar.classList.remove('navbar--sticky');
        }
        else {
            navbar.classList.add('navbar--sticky');
        }
    };
    var openSearchDropdown_1 = function () {
        searchButton_1.nextElementSibling.classList.add('navbar__button-search-inner--active');
    };
    var closeSearchDropdown_1 = function () {
        searchButton_1.nextElementSibling.classList.remove('navbar__button-search-inner--active');
    };
    searchInput_1.addEventListener('input', function () {
        if (searchInput_1.value.length > 0) {
            searchSubmitButton_1.removeAttribute('disabled');
        }
        else {
            searchSubmitButton_1.setAttribute('disabled', 'true');
        }
    });
    searchInput_1.addEventListener('submit', function (e) {
        e.preventDefault();
        if (searchInput_1.value.length > 0) {
            window.location.href = searchPageUrl_1 + '?q=' + searchInput_1.value;
        }
    });
    searchSubmitButton_1.addEventListener('click', function (e) {
        e.preventDefault();
        if (searchInput_1.value.length > 0) {
            window.location.href = searchPageUrl_1 + '?q=' + searchInput_1.value;
        }
    });
    if (navbarUser) {
        navbarUser.addEventListener('click', function (event) {
            event.stopPropagation();
            navbarUserDropdown_1.classList.toggle('navbar__user-dropdown--active');
        });
        navbarUser.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.stopPropagation();
                navbarUserDropdown_1.classList.toggle('navbar__user-dropdown--active');
            }
        });
    }
    linkItems.forEach(function (link) {
        var href = link.getAttribute('data-url');
        link.addEventListener('click', function () {
            if (href) {
                window.location.href = href;
            }
        });
        link.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && href) {
                window.location.href = href;
            }
        });
    });
    window.addEventListener('click', function (event) {
        var targetElement = navbar.querySelector('.navbar__button-search-inner');
        var clickedElement = event.target;
        if (!clickedElement.classList.contains('navbar__user') || !clickedElement.parentElement.classList.contains('navbar__user')) {
            if (navbarUserDropdown_1 != null) {
                navbarUserDropdown_1.classList.remove('navbar__user-dropdown--active');
            }
        }
        if (clickedElement.classList.contains('navbar__button-search')) {
            if (clickedElement.nextElementSibling.classList.contains('navbar__button-search-inner--active')) {
                closeSearchDropdown_1();
            }
            else {
                openSearchDropdown_1();
            }
            return;
        }
        if (!targetElement)
            return;
        while (clickedElement) {
            if (clickedElement === targetElement) {
                searchButton_1.nextElementSibling.classList.add('navbar__button-search-inner--active');
                return;
            }
            clickedElement = clickedElement.parentElement;
        }
        searchButton_1.nextElementSibling.classList.remove('navbar__button-search-inner--active');
    });
    window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeSearchDropdown_1();
            navbarUserDropdown_1.classList.remove('navbar__user-dropdown--active');
        }
    });
    window.addEventListener('scroll', checkScrollPosition);
    checkScrollPosition();
}
},{}],66:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var newsDetails = document.querySelector('.news-details__wrapper');
if (newsDetails) {
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5}],67:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var newsList = document.querySelector('.news-list');
if (newsList) {
    var Grid_1 = newsList.querySelector('.news-list__grid');
    var Filters_1 = newsList.querySelector('.news-list__search');
    var ListSearchInput_1 = newsList.querySelector('.news-list__search-input');
    var DateFrom_1 = newsList.querySelector('.date-range__input-from');
    var DateTo_1 = newsList.querySelector('.date-range__input-to');
    var nextPageButton = newsList.querySelector('.pagination__page-next');
    var prevPageButton = newsList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = newsList.querySelector('.pagination__dropdown');
    var paginationLast = newsList.querySelector('.pagination__page-last');
    var paginationFirst = newsList.querySelector('.pagination__page-first');
    var pagination_2 = newsList.querySelector('.pagination');
    var radios_1 = newsList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var dropdownFilters = newsList.querySelectorAll('.dropdown-filter');
    var newsCards_1 = [];
    var keyword_1 = '';
    var dateFrom_1 = '';
    var dateTo_1 = '';
    var userTypes_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var keyWordChanged_1 = false;
    var dateFromChanged_1 = false;
    var dateToChanged_1 = false;
    var restoreDropdownSelections = function (dropdown, selectedValues) {
        var select = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.multi-select');
        var buttonContainer = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.dropdown-filter__button-container');
        if (!select)
            return;
        selectedValues.forEach(function (value) {
            var option = Array.from(select.options).find(function (item) { return item.value === value; });
            if (!option)
                return;
            option.selected = true;
            option.setAttribute('selected', '');
            if (!buttonContainer)
                return;
            var alreadyRendered = Array.from(buttonContainer.querySelectorAll('.selected-label')).some(function (label) { return label.textContent === value; });
            if (alreadyRendered)
                return;
            var token = document.createElement('div');
            token.classList.add('dropdown-filter__selected-wrapper');
            var label = document.createElement('span');
            label.classList.add('selected-label');
            label.textContent = value;
            var close = document.createElement('a');
            close.classList.add('selected-close');
            close.setAttribute('tabindex', '-1');
            close.setAttribute('data-option', value);
            close.setAttribute('data-hits', '0');
            close.addEventListener('click', function (event) {
                option.selected = false;
                option.removeAttribute('selected');
                token.remove();
                event.stopPropagation();
            });
            token.appendChild(label);
            token.appendChild(close);
            buttonContainer.appendChild(token);
        });
    };
    var initialUrl = new URL(window.location.href);
    restoreDropdownSelections(dropdownFilters[0], initialUrl.searchParams.getAll('userTypes'));
    var newsCardSettings_1 = {
        Text: '',
    };
    var fetchNewsCardSettings_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/news/cardsettings?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    newsCardSettings_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchNews_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var url, payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        url = new URL(window.location.href);
                        pageNumber_1 = keyWordChanged_1 ? 1 : Number(url.searchParams.get('pageNumber') || 1);
                        pageSize_1 = Number(url.searchParams.get('pageSize') || pageSize_1);
                        keyword_1 = keyWordChanged_1 ? keyword_1 : (url.searchParams.get('keyword') || '');
                        dateFrom_1 = dateFromChanged_1 ? dateFrom_1 : (url.searchParams.get('dateFrom') || '');
                        dateTo_1 = dateToChanged_1 ? dateTo_1 : (url.searchParams.get('dateTo') || '');
                        userTypes_1 = userTypes_1.length == 0 ? (url.searchParams.getAll('userTypes') || []) : userTypes_1;
                        sortBy_1 = Number(url.searchParams.get('sortBy') || 1);
                        paginationDropdown_1.value = pageSize_1.toString();
                        DateFrom_1.value = dateFrom_1;
                        DateTo_1.value = dateTo_1;
                        if (dateFrom_1 != '') {
                            DateFrom_1.dispatchEvent(new Event('input'));
                        }
                        if (dateTo_1 != '') {
                            DateTo_1.dispatchEvent(new Event('input'));
                        }
                        ListSearchInput_1.value = keyword_1;
                        radios_1.forEach(function (radio) {
                            radio.checked = sortBy_1 === +radio.value;
                        });
                        payload = {
                            keyword: keyword_1,
                            dateFrom: dateFrom_1,
                            dateTo: dateTo_1,
                            userTypes: userTypes_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/news', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/news', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        newsCards_1 = response.data.items;
                        if (newsCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, newsCards_1, renderPage_1, true);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        Grid_1.innerHTML = '';
        newsCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.className = 'news__card flex flex--column';
            cardElement.innerHTML = "\n            " + (card.image !== null ? "<img src='" + card.image + "' alt='" + card.title + "' class='news__card-image' />" : '') + "\n            <p class='news__card-title'>" + card.title + "</p>\n            <p class='news__card-date flex flex--align-center'>\n                <img src='/assets/img/img/calendar-icon-yellow.svg' alt='calendar icon' class='news__card-icon' />\n                <span class='news__card-text'>\n                    " + formatDate_1.default(card.date) + "\n                </span>\n            </p>\n            ";
            Grid_1.appendChild(cardElement);
        });
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        Filters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        Filters_1.classList.remove('disabled');
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        renderPage_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        renderPage_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        renderPage_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        renderPage_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        renderPage_1();
    });
    var timeout_1 = null;
    ListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = ListSearchInput_1.value.trim();
            keyWordChanged_1 = true;
            pageNumber_1 = 1;
            fetchNews_1();
        }, 1000);
    });
    DateFrom_1.addEventListener('change', function () {
        dateFrom_1 = DateFrom_1.value;
        dateFromChanged_1 = true;
        pageNumber_1 = 1;
        fetchNews_1();
    });
    DateTo_1.addEventListener('change', function () {
        dateTo_1 = DateTo_1.value;
        dateToChanged_1 = true;
        pageNumber_1 = 1;
        fetchNews_1();
    });
    radios_1.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = newsList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            renderPage_1();
        });
    });
    dropdownFilters.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var userTypesOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    userTypesOptions_1.push(element.textContent);
                                });
                                userTypes_1 = userTypesOptions_1;
                                break;
                            default:
                                break;
                        }
                        pageNumber_1 = 1;
                        renderPage_1();
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
    var initializeEventsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchNewsCardSettings_1()];
                case 1:
                    _a.sent();
                    return [4, fetchNews_1()];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeEventsList();
    var shareButtons = document.querySelectorAll(".shareButton");
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var renderPage_1 = function (page) {
        if (page === void 0) { page = null; }
        if (page) {
            pageNumber_1 = page;
        }
        var url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber_1.toString());
        url.searchParams.set('pageSize', pageSize_1.toString());
        if (keyword_1) {
            url.searchParams.set('keyword', keyword_1);
        }
        if (dateFrom_1) {
            url.searchParams.set('dateFrom', dateFrom_1);
        }
        if (dateTo_1) {
            url.searchParams.set('dateTo', dateTo_1);
        }
        userTypes_1.forEach(function (userType) {
            url.searchParams.append('userTypes', userType);
        });
        if (sortBy_1) {
            url.searchParams.set('sortBy', sortBy_1.toString());
        }
        if (page == null) {
            window.location.href = url.toString();
        }
        return url.toString();
    };
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/formatDate":7,"../pagination/pagination":71,"axios":116}],68:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],69:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var pagination_1 = require("../pagination/pagination");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var axios_1 = __importDefault(require("axios"));
var opportunitiesList = document.querySelector('.opportunities-list');
if (opportunitiesList) {
    var opportunitiesGrid_1 = opportunitiesList.querySelector('.opportunities-list__grid');
    var opportunitiesFilters_1 = opportunitiesList.querySelector('.opportunities-list__filters');
    var opportunitiesListSearchInput_1 = opportunitiesList.querySelector('.opportunities-list__search-input');
    var nextPageButton = opportunitiesList.querySelector('.pagination__page-next');
    var prevPageButton = opportunitiesList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = opportunitiesList.querySelector('.pagination__dropdown');
    var paginationLast = opportunitiesList.querySelector('.pagination__page-last');
    var paginationFirst = opportunitiesList.querySelector('.pagination__page-first');
    var pagination_2 = opportunitiesList.querySelector('.pagination');
    var radios_1 = opportunitiesList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var opportunityCards_1 = [];
    var keyword_1 = '';
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var keywordChanged_1 = false;
    var opportunityCardSettings_1 = {
        cardButtonText: '',
        availableText: '',
        endText: '',
        noOpportunitiesText: '',
    };
    var fetchOpportunityCardSettings_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/opportunities/cardsettings?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    opportunityCardSettings_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchOpportunities_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var url, payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        url = new URL(window.location.href);
                        pageNumber_1 = keywordChanged_1 ? 1 : Number(url.searchParams.get('pageNumber') || 1);
                        pageSize_1 = Number(url.searchParams.get('pageSize') || pageSize_1);
                        keyword_1 = keywordChanged_1 ? keyword_1 : url.searchParams.get('keyword') || '';
                        sortBy_1 = Number(url.searchParams.get('sortBy') || sortBy_1);
                        paginationDropdown_1.value = pageSize_1.toString();
                        opportunitiesListSearchInput_1.value = keyword_1;
                        radios_1.forEach(function (radio) {
                            radio.checked = sortBy_1 === +radio.value;
                        });
                        payload = {
                            keyword: keyword_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/opportunities', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/opportunities', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        opportunityCards_1 = response.data.items;
                        if (opportunityCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, opportunityCards_1, renderPage_1, true);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        opportunitiesGrid_1.innerHTML = '';
        if (opportunityCards_1.length === 0) {
            opportunitiesGrid_1.innerHTML = "<div class=\"flex\" style=\"align-self: center;\">" + opportunityCardSettings_1.noOpportunitiesText + "</div>";
        }
        else {
            opportunityCards_1.forEach(function (card) {
                var cardElement = document.createElement('a');
                cardElement.setAttribute('href', card.link);
                cardElement.className = 'opportunity-card flex flex--column';
                cardElement.innerHTML = "\n                <div class=\"opportunity-card__content flex flex--column\">\n                    <p class='opportunity-card__title'>" + card.title + "</p>\n                    <p class='opportunity-card__text'>" + card.typeName + "</p>\n                </div>\n                <div class=\"opportunity-card__items\">\n                    <p class='opportunity-card__info flex flex--align-center mb-2'>\n                        <img src='/assets/img/img/user-octagon-icon.svg' alt='calendar icon' class='opportunity-card__icon' />\n                        <span class='opportunity-card__info-text'>\n                            " + card.methodName + "\n                        </span>\n                    </p>\n                    <p class='opportunity-card__info flex flex--align-center'>\n                        <img src='/assets/img/img/calendar-icon-yellow.svg' alt='calendar icon' class='opportunity-card__icon' />\n                        <span class='opportunity-card__info-text'>\n                                " + formatDate_1.default(card.startDate, false) + "\n                        </span>\n                    </p>\n                </div>\n                <div class=\"opportunity-card__buttons flex flex--wrap flex--align-center flex--justify-between\">\n                    <div class=\"opportunity-card__link flex flex--align-center flex--justify-center\">\n                        " + opportunityCardSettings_1.cardButtonText + "\n                        <img src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"arrow icon\" class=\"opportunity-card__link-icon\">\n                    </div>\n                    <button class=\"button shareButton button--round-tiny opportunity-card__button opportunity-card__button-share flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                </div>\n            ";
                opportunitiesGrid_1.appendChild(cardElement);
            });
            addCardListeners_1();
        }
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        opportunitiesFilters_1 === null || opportunitiesFilters_1 === void 0 ? void 0 : opportunitiesFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        opportunitiesFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        renderPage_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        renderPage_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        renderPage_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        renderPage_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        renderPage_1();
    });
    var timeout_1 = null;
    opportunitiesListSearchInput_1 === null || opportunitiesListSearchInput_1 === void 0 ? void 0 : opportunitiesListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = opportunitiesListSearchInput_1.value.trim();
            keywordChanged_1 = true;
            pageNumber_1 = 1;
            fetchOpportunities_1();
        }, 1000);
    });
    radios_1.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = opportunitiesList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            renderPage_1();
        });
    });
    var initializeEventsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchOpportunityCardSettings_1()];
                case 1:
                    _a.sent();
                    return [4, fetchOpportunities_1()];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeEventsList();
    var addCardListeners_1 = function () {
        var listCards = opportunitiesList.querySelectorAll('.opportunity-card');
        if (listCards.length > 0) {
            var cardButtons = document.querySelectorAll('.opportunity-card__button');
            listCards.forEach(function (card) {
                card.addEventListener('click', function (e) {
                    var target = e.target;
                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
    var renderPage_1 = function (page) {
        if (page === void 0) { page = null; }
        if (page) {
            pageNumber_1 = page;
        }
        var url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber_1.toString());
        url.searchParams.set('pageSize', pageSize_1.toString());
        if (keyword_1)
            url.searchParams.set('keyword', keyword_1);
        url.searchParams.set('sortBy', sortBy_1.toString());
        if (page == null) {
            window.location.href = url.toString();
        }
        return url.toString();
    };
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/formatDate":7,"../pagination/pagination":71,"axios":116}],70:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],71:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaginationButtons = exports.updatePaginationButtons = exports.setPage = exports.removeOldButtons = exports.getPages = void 0;
var direction = document.querySelector('html').getAttribute('dir');
var nextPageButton = document.querySelector('.pagination__page-next');
var prevPageButton = document.querySelector('.pagination__page-prev');
var paginationMultiEnd = document.querySelector('.pagination__page-multi-end');
var paginationMultiStart = document.querySelector('.pagination__page-multi-start');
var paginationLast = document.querySelector('.pagination__page-last');
var paginationFirst = document.querySelector('.pagination__page-first');
var paginationCurrent = document.querySelector('.pagination__current');
var paginationTotal = document.querySelector('.pagination__total');
var hasPreviousPage;
var hasNextPage;
var totalPages;
var pageNumber;
var totalCount;
var buttonsToShow = 3;
var pageCards = [];
var buttons = [];
var fetchEvents = null;
var serverSidePagination = false;
var getPages = function () {
    var startPage = pageNumber === 1 ? 1 : pageNumber - 1;
    return Array.from({ length: buttonsToShow }, function (_, i) { return startPage + i; }).filter(function (page) { return page <= totalPages; });
};
exports.getPages = getPages;
var removeOldButtons = function () {
    var oldButtons = document.querySelectorAll('.pagination__page-number');
    oldButtons.forEach(function (button) { return button.remove(); });
};
exports.removeOldButtons = removeOldButtons;
var setPage = function (page) {
    if (page < 1 || page > totalPages)
        return;
    removeOldButtons();
    pageNumber = page;
    createPaginationButtons();
    fetchEvents(pageNumber);
};
exports.setPage = setPage;
var updatePaginationButtons = function (tot, hasPrevPage, hasNext, pageNum, pageSize, total, totButtons, cards, fetchResults, isServerSidePagination) {
    if (isServerSidePagination === void 0) { isServerSidePagination = false; }
    hasPreviousPage = hasPrevPage;
    hasNextPage = hasNext;
    totalPages = tot;
    pageNumber = pageNum;
    totalCount = total;
    buttonsToShow = totButtons;
    pageCards = cards;
    fetchEvents = fetchResults;
    serverSidePagination = isServerSidePagination;
    removeOldButtons();
    if (hasPreviousPage) {
        prevPageButton.removeAttribute('disabled');
    }
    else {
        prevPageButton.setAttribute('disabled', 'true');
    }
    if (hasNextPage) {
        nextPageButton.removeAttribute('disabled');
    }
    else {
        nextPageButton.setAttribute('disabled', 'true');
    }
    paginationLast.textContent = totalPages.toString();
    var offset = (pageNumber - 1) * pageSize + 1;
    var end = Math.min((pageNumber - 1) * pageSize + pageSize, totalCount);
    if (direction == 'rtl') {
        paginationCurrent.textContent = end.toString() + '-' + offset.toString();
    }
    else {
        paginationCurrent.textContent = offset.toString() + '-' + end.toString();
    }
    paginationTotal.textContent = totalCount.toString();
    createPaginationButtons();
};
exports.updatePaginationButtons = updatePaginationButtons;
var createPaginationButtons = function () {
    var pages = getPages();
    buttons = [];
    pages.forEach(function (page, i) {
        var button = null;
        if (serverSidePagination) {
            button = document.createElement('a');
            button.setAttribute('href', fetchEvents(page));
        }
        else {
            button = document.createElement('button');
            button.addEventListener('click', function () { return setPage(page); });
        }
        button.className = 'pagination__page pagination__page-number flex flex--align-center flex--justify-center';
        if (pageNumber === page) {
            button.classList.add('pagination__page--active');
        }
        button.textContent = page.toString();
        if (page === pageNumber) {
            button.classList.add('active');
        }
        buttons.push(button);
    });
    buttons.reverse().forEach(function (button) {
        paginationMultiStart.insertAdjacentElement('afterend', button);
    });
    if (pageNumber === totalPages) {
        paginationMultiEnd.classList.add('hidden');
        paginationLast.classList.add('hidden');
    }
    else {
        paginationMultiEnd.classList.remove('hidden');
        paginationLast.classList.remove('hidden');
    }
    if (pageNumber > 2) {
        paginationFirst.classList.remove('hidden');
        paginationMultiStart.classList.remove('hidden');
    }
    else {
        paginationFirst.classList.add('hidden');
        paginationMultiStart.classList.add('hidden');
    }
    if (pageNumber === 1 && totalCount === 0) {
        paginationMultiEnd.classList.add('hidden');
        paginationLast.classList.add('disabled');
        paginationLast.classList.add('pagination__page--active');
        paginationLast.textContent = '1';
    }
    buttons.forEach(function (button) {
        if (paginationLast.textContent === button.textContent) {
            paginationLast.classList.add('hidden');
            paginationMultiEnd.classList.add('hidden');
        }
    });
};
exports.createPaginationButtons = createPaginationButtons;
},{}],72:[function(require,module,exports){
var partnersList = document.querySelector('.partners-list');
if (partnersList) {
    var partnerTabs_1 = partnersList.querySelectorAll('.partners-list__tab');
    var partnersListBlocks_1 = partnersList.querySelectorAll('.partners-list__block');
    partnerTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            resetTabs();
            if (index === 0) {
                partnersListBlocks_1.forEach(function (carousel) { return carousel.classList.add('partners-list__block--active'); });
            }
            else {
                partnersListBlocks_1[index - 1].classList.add('partners-list__block--active');
            }
            tab.classList.add('partners-list__tab--active');
        });
    });
    function resetTabs() {
        partnerTabs_1.forEach(function (tab) {
            partnersListBlocks_1.forEach(function (carousel) { return carousel.classList.remove('partners-list__block--active'); });
            tab.classList.remove('partners-list__tab--active');
        });
    }
}
},{}],73:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var partnersComponent = document.querySelector('.partners');
if (partnersComponent) {
    var partnersCarousels = partnersComponent.querySelectorAll('.partners__carousel-inner');
    var direction_1 = document.querySelector('html').getAttribute('dir');
    var partnersTabs_1 = partnersComponent.querySelectorAll('.partners__tab');
    var partnersCarouselsContainer_1 = partnersComponent.querySelectorAll('.partners__carousel');
    var activeTab_1 = 0;
    if (partnersCarousels.length > 0) {
        var partnersCarouselsArray = Array.from(partnersCarousels) || [];
        partnersCarouselsArray.forEach(function (item) {
            var numOfSlides = +item.getAttribute("data-count");
            var glideSettings = {
                type: 'slider',
                perView: 4,
                gap: 24,
                rewind: true,
                bound: true,
                hoverpause: true,
                direction: direction_1 || 'ltr',
                breakpoints: {
                    1400: {
                        perView: 4,
                    },
                    1100: {
                        perView: 3,
                        gap: 16,
                    },
                    600: {
                        type: 'carousel',
                        perView: 1,
                        gap: 16,
                        focusAt: "center",
                        peek: {
                            before: 50,
                            after: 50
                        }
                    },
                    389: {
                        type: 'carousel',
                        perView: 1,
                        gap: 16,
                        focusAt: "center",
                        peek: {
                            before: 30,
                            after: 30
                        }
                    },
                },
            };
            var glide = new glide_1.default(item, glideSettings);
            glide.mount();
            glide.on("resize", function () {
                generateBullets(bulletsContainer, bulletsToRender(numOfSlides, glide.settings.perView), glide);
            });
            var bulletsContainer = item.querySelector(".partners__bullets");
            generateBullets(bulletsContainer, bulletsToRender(numOfSlides, glide.settings.perView), glide);
        });
    }
    var resetAll_1 = function () {
        partnersCarouselsContainer_1.forEach(function (carousel) { return carousel.classList.remove('partners__carousel--active'); });
        partnersTabs_1.forEach(function (tab) { return tab.classList.remove('partners__tab--active'); });
    };
    var showActiveItems_1 = function (activeTabNum) {
        resetAll_1();
        partnersTabs_1[activeTabNum].classList.add('partners__tab--active');
        partnersCarouselsContainer_1[activeTabNum].classList.add('partners__carousel--active');
    };
    partnersTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            showActiveItems_1(activeTab_1);
        });
    });
    showActiveItems_1(activeTab_1);
}
function bulletsToRender(num, perView) {
    var totalSlides = num;
    var amount = 0;
    if (totalSlides <= perView) {
        amount = 0;
    }
    else {
        var steps = Math.ceil(totalSlides - perView);
        amount = +steps;
    }
    return amount;
}
function generateBullets(buttonsElement, amount, glide) {
    buttonsElement.innerHTML = "";
    if (amount < 1) {
        return;
    }
    var _loop_1 = function (i) {
        var button = document.createElement("button");
        button.className = "glide__bullet partners__bullet";
        button.setAttribute("data-glide-dir", "=" + i);
        buttonsElement.appendChild(button);
        button.addEventListener("click", function () {
            glide.go("=" + i);
        });
    };
    for (var i = 0; i <= amount; i++) {
        _loop_1(i);
    }
}
},{"@glidejs/glide":115}],74:[function(require,module,exports){
var peopleComponent = document.querySelector(".people__wrapper");
if (peopleComponent) {
    var peopleCards = peopleComponent.querySelectorAll(".people__image-container");
    peopleCards.forEach(function (card) {
        card.addEventListener("click", function () {
            card.classList.toggle("people__image-container--active");
        });
    });
}
},{}],75:[function(require,module,exports){
var policies = document.querySelector('.policies');
if (policies) {
    var policiesTabs_1 = policies.querySelectorAll('.policies__tab');
    var policiesSections_1 = policies.querySelectorAll('.policies__section');
    var activeTab_1 = 0;
    var resetTabs_1 = function () {
        policiesTabs_1.forEach(function (tab) { return tab.classList.remove('policies__tab--active'); });
        policiesSections_1.forEach(function (item) { return item.classList.add('hidden'); });
    };
    policiesTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            resetTabs_1();
            policiesTabs_1[activeTab_1].classList.add('policies__tab--active');
            policiesSections_1[activeTab_1].classList.remove('hidden');
        });
    });
}
},{}],76:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var addToCalendar_1 = __importDefault(require("../../../helpers/addToCalendar"));
var programDetails = document.querySelector('.program-details');
if (programDetails) {
    var eventTabs_1 = programDetails.querySelectorAll('.program-details__tab');
    var sections_1 = programDetails.querySelectorAll('.program-details__section');
    var programDetailsCarousels = programDetails.querySelectorAll('.program-details__carousel-inner');
    var direction_1 = document.querySelector('html').getAttribute('dir');
    var activeTab_1 = 0;
    var resetTabs_1 = function () {
        eventTabs_1.forEach(function (tab) { return tab.classList.remove('program-details__tab--active'); });
        sections_1.forEach(function (tab) { return tab.classList.remove('program-details__section--active'); });
    };
    eventTabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activeTab_1 = index;
            resetTabs_1();
            eventTabs_1[activeTab_1].classList.add('program-details__tab--active');
            sections_1[activeTab_1].classList.add('program-details__section--active');
            var tabName = tab.getAttribute('id');
            history.replaceState(null, null, "?tab=" + tabName);
        });
    });
    sections_1.forEach(function (section) {
        var accordion = section.firstElementChild;
        if (accordion != null) {
            if (accordion.classList.contains('program-details__accordion')) {
                accordion.setAttribute('open', 'true');
            }
        }
        var accordions = section.querySelectorAll('.program-details__accordion');
        accordions.forEach(function (childAccordion) {
            childAccordion.addEventListener('toggle', function () {
                if (childAccordion.open) {
                    accordions.forEach(function (otherAccordion) {
                        if (otherAccordion !== childAccordion) {
                            otherAccordion.removeAttribute('open');
                        }
                    });
                }
            });
        });
    });
    if (programDetailsCarousels.length > 0) {
        programDetailsCarousels.forEach(function (item) {
            var carouselType = item.getAttribute('data-carousel');
            var glideSettings;
            if (carouselType === 'events-carousel') {
                glideSettings = {
                    type: 'slider',
                    perView: 2,
                    gap: 24,
                    rewind: true,
                    bound: true,
                    direction: direction_1 || 'ltr',
                    breakpoints: {
                        480: {
                            perView: 1,
                        },
                    },
                };
            }
            else if (carouselType === 'programs-carousel') {
                glideSettings = {
                    type: 'slider',
                    perView: 4,
                    gap: 24,
                    rewind: true,
                    bound: true,
                    direction: direction_1 || 'ltr',
                    breakpoints: {
                        1200: {
                            perView: 3,
                        },
                        992: {
                            perView: 2,
                        },
                        480: {
                            perView: 1,
                        },
                    },
                };
            }
            var glide = new glide_1.default(item, glideSettings);
            glide.mount();
        });
    }
    var favButtons = document.querySelectorAll('.favouriteButton');
    if (favButtons && favButtons.length > 0) {
        favButtons.forEach(function (button) {
            var dataIdAttr = button.getAttribute('data-id');
            var type = button.getAttribute('data-type');
            var favouritedIds = JSON.parse(button.getAttribute('data-ids'));
            if (dataIdAttr !== null && favouritedIds != null) {
                var dataId_1 = parseInt(dataIdAttr);
                if (isFavourite_1.IsFavourited(dataId_1, favouritedIds)) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
                button.addEventListener('click', function (e) {
                    console.log('small button clicked - program details');
                    favourites_1.default(type, dataId_1, button);
                });
            }
        });
    }
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var calButtons = document.querySelectorAll('.calButton');
    if (calButtons && calButtons.length > 0) {
        calButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                addToCalendar_1.default(button);
            });
        });
    }
}
function activateTab(tabName) {
    var btn = document.getElementById(tabName);
    console.log(btn);
    if (btn) {
        console.log("cliick");
        btn.click();
    }
}
document.addEventListener("DOMContentLoaded", function () {
    var urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams);
    var tabName = urlParams.get('tab');
    console.log(tabName);
    if (tabName) {
        activateTab(tabName);
    }
});
},{"../../../helpers/addToCalendar":3,"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9,"@glidejs/glide":115}],77:[function(require,module,exports){
var initializeProgramStatsComponent = function (webStatsComponent) {
    var programStatsTabs = webStatsComponent.querySelectorAll('.program-stats__tab');
    var programStatsContents = webStatsComponent.querySelectorAll('.program-stats__content');
    var activeTab = 0;
    var showSelectedItems = function (activeTab) {
        programStatsTabs.forEach(function (tab, index) {
            tab.classList.remove('program-stats__tab--active');
            programStatsContents[index].style.display = 'none';
        });
        programStatsTabs[activeTab].classList.add('program-stats__tab--active');
        programStatsContents[activeTab].style.display = 'block';
    };
    var handleTabClick = function (index) {
        activeTab = index;
        showSelectedItems(activeTab);
    };
    programStatsTabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { return handleTabClick(index); });
    });
    showSelectedItems(activeTab);
};
document.querySelectorAll('.program-stats').forEach(function (webStatsComponent) {
    initializeProgramStatsComponent(webStatsComponent);
});
},{}],78:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var programsList = document.querySelector('.programs-list');
if (programsList) {
    var Grid_1 = programsList.querySelector('.programs-list__images');
    var nextPageButton = programsList.querySelector('.pagination__page-next');
    var prevPageButton = programsList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = programsList.querySelector('.pagination__dropdown');
    var paginationLast = programsList.querySelector('.pagination__page-last');
    var paginationFirst = programsList.querySelector('.pagination__page-first');
    var pagination_2 = programsList.querySelector('.pagination');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var programsCards_1 = [];
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchPrograms_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://mawhiba-development.azurewebsites.net/api/programs', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post("/api/programs", payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        programsCards_1 = response.data.items;
                        if (programsCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalCount_1 = response.data.totalCount;
                        totalPages_1 = response.data.totalPages;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, programsCards_1, fetchPrograms_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        Grid_1.innerHTML = '';
        programsCards_1.forEach(function (card) {
            var cardElement = document.createElement('div');
            cardElement.className = 'programs-list__item sticky flex flex--justify-between';
            cardElement.style.backgroundImage = "url(" + card.backgroundImage + ")";
            cardElement.innerHTML = "            \n            <div class=\"programs-list__item-content flex flex--column\">\n                <p class=\"programs-list__title\">" + card.title + "</p>\n                <p class=\"programs-list__text\">" + card.text + "</p>\n            </div>\n                \n            <div class=\"programs-list__item-right flex flex--column flex--align-end flex--justify-between\">\n                <div class=\"programs-list__buttons flex flex--align-center\">\n                    <button\n                        class=\"button button--round-tiny shareButton programs-list__button programs-list__button-share flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/share-filled-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                </div>\n            </div>\n            ";
            if (card.links.length > 0) {
                var list_1 = document.createElement('ul');
                list_1.className = 'programs-list__list fade-in flex flex--column flex--align-start';
                card.links.forEach(function (link) {
                    var listItem = document.createElement('li');
                    listItem.className = 'programs-list__list-item';
                    listItem.innerHTML = "\n                        <a href=\"" + link.linkURL + "\" class=\"programs-list__list-link flex flex--align-center flex--justify-between\">\n                            <span class=\"programs-list__list-link-text\">\n                                " + link.title + "\n                            </span>\n                            <img src=\"/assets/img/img/arrow-left.svg\" alt=\"arrow icon\" class=\"programs-list__list-link-icon\">\n                        </a>\n                    ";
                    list_1.appendChild(listItem);
                });
                var rightContent = cardElement.querySelector('.programs-list__item-right');
                rightContent.appendChild(list_1);
                var moreButton = document.createElement('button');
                moreButton.className =
                    'button button--transparent programs-list__item-button flex flex--justify-center flex--align-center';
                moreButton.innerHTML = "\n                    <span class=\"button__label\">" + card.linkText + "</span>\n                    <img src=\"/assets/img/img/arrow-top-left.svg\" alt=\"arrow icon\" class=\"button__image\">\n                ";
                rightContent.appendChild(moreButton);
            }
            Grid_1.appendChild(cardElement);
        });
        var cardElement = document.createElement('div');
        cardElement.className = 'programs-list__item sticky';
        cardElement.style.opacity = '0';
        cardElement.style.zIndex = '-1';
        Grid_1.appendChild(cardElement);
        addCardListeners_1();
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchPrograms_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchPrograms_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchPrograms_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchPrograms_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchPrograms_1();
    });
    fetchPrograms_1();
    var addCardListeners_1 = function () {
        var listCards = programsList.querySelectorAll('.programs-list__item');
        if (listCards.length > 0) {
            var cardButtons = programsList.querySelectorAll('.programs-list__button');
            var moreButtons_1 = programsList.querySelectorAll('.programs-list__item-button');
            var list_2 = programsList.querySelectorAll('.programs-list__list');
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('favouriteButton')) {
                        var t = button.getAttribute('data-type');
                        var id = Number(button.getAttribute('data-id'));
                        favourites_1.default(t, id, button);
                    }
                    else if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
            listCards.forEach(function (card, index) {
                card.addEventListener('click', function (e) {
                    var target = e.target;
                    if (target.classList.contains('programs-list__item-button') ||
                        target.parentElement.classList.contains('programs-list__item-button') ||
                        target.parentElement.classList.contains('programs-list__item-button')) {
                        list_2[index].classList.toggle('programs-list__list--active');
                        moreButtons_1[index].classList.add('hidden');
                    }
                    else {
                        closeAllLists_1();
                    }
                });
            });
            var top_1 = 180;
            var headerHeight_1 = 65;
            if (window.innerWidth < 1200) {
                top_1 = 20;
            }
            var cardsCount = listCards.length;
            if (cardsCount) {
                listCards.forEach(function (card, i) {
                    var incValue = i * headerHeight_1;
                    if (i === 0) {
                        card.style.top = top_1 + "px";
                    }
                    else {
                        card.style.top = top_1 + incValue + "px";
                    }
                });
            }
            var closeAllLists_1 = function () {
                var list = programsList.querySelectorAll('.programs-list__list');
                var moreButtons = programsList.querySelectorAll('.programs-list__item-button');
                list.forEach(function (item, i) {
                    item.classList.remove('programs-list__list--active');
                    moreButtons[i].classList.remove('hidden');
                });
            };
            window.addEventListener('scroll', function () {
                closeAllLists_1();
            });
        }
    };
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../pagination/pagination":71,"axios":116}],79:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],80:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var quickJoin = document.querySelector('.quick-join');
if (quickJoin) {
    var trigger = quickJoin.querySelector('.quick-join__trigger');
    var triggerText_1 = quickJoin.querySelector('.quick-join__trigger-text');
    var triggerIcon_1 = quickJoin.querySelector('.quick-join__trigger-close');
    var form = quickJoin.querySelector('.quick-join__form');
    var nextButtons = quickJoin.querySelectorAll('.quick-join__next');
    var closeButton = quickJoin.querySelector('.quick-join__close');
    var submitButton_1 = quickJoin.querySelector('.quick-join__submit');
    var firstSection_1 = quickJoin.querySelector('.quick-join__section-1');
    var secondSection_1 = quickJoin.querySelector('.quick-join__section-2');
    var thirdSection_1 = quickJoin.querySelector('.quick-join__section-3');
    var userEmail_1 = quickJoin.querySelector('.quick-join__user');
    var idInput_1 = quickJoin.querySelector('.quick-join__id-input');
    var mobileNumberInput_1 = quickJoin.querySelector('.country-dropdown__number');
    var emailInput_1 = quickJoin.querySelector('.quick-join__email-input');
    var countryCode_1 = quickJoin.querySelector('.country-dropdown__title');
    var formidInput_1 = quickJoin.querySelector('.quick-join-formid');
    var classValidation_1 = quickJoin.querySelector('.quick-join__classes-validation');
    var programsValidation_1 = quickJoin.querySelector('.quick-join__programs-validation');
    var idValidation_1 = quickJoin.querySelector('.quick-join__id-validation');
    var mobileValidation_1 = quickJoin.querySelector('.quick-join__mobile-validation');
    var emailValidation_1 = quickJoin.querySelector('.quick-join__email-validation');
    var dropdownFilters_1 = firstSection_1.querySelectorAll('.dropdown-filter');
    var dropdownFilterTriggers = firstSection_1.querySelectorAll('.dropdown-filter__trigger');
    var programsDropdown_1 = firstSection_1.querySelector('.multi-select');
    var singleDropdownFilter = firstSection_1.querySelector('.single-dropdown-filter');
    var singleDropdownFilterTrigger_1 = firstSection_1.querySelector('.single-dropdown-filter__trigger');
    var singleDropdown_1 = singleDropdownFilter.querySelector('.single-select');
    var singleDropdownPlaceholder_1 = singleDropdown_1.getAttribute('data-placeholder');
    var autocompleLists_1 = quickJoin.querySelectorAll('.multi-select');
    var singleAutocompleLists_1 = quickJoin.querySelectorAll('.single-select');
    var buttonContainers_1 = quickJoin.querySelectorAll('.dropdown-filter__button-container');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var _class_1 = '';
    var programs_1 = [];
    var resetForm_1 = function () {
        firstSection_1.classList.remove('hidden');
        secondSection_1.classList.add('hidden');
        thirdSection_1.classList.add('hidden');
        idInput_1.value = '';
        mobileNumberInput_1.value = '';
        emailInput_1.value = '';
        buttonContainers_1.forEach(function (container) {
            container.innerHTML = '';
        });
        programs_1 = [];
        _class_1 = '';
        autocompleLists_1.forEach(function (list) {
            list.querySelectorAll('option').forEach(function (item) {
                item.removeAttribute('selected');
            });
        });
        dropdownFilters_1.forEach(function (filter) {
            filter.classList.add('disabled');
        });
        singleDropdownFilterTrigger_1.innerHTML = singleDropdownPlaceholder_1;
        singleAutocompleLists_1.forEach(function (list) {
            list.querySelectorAll('option').forEach(function (item) {
                item.removeAttribute('selected');
            });
        });
        userEmail_1.textContent = '';
    };
    var resetValidations_1 = function () {
        classValidation_1.classList.add('hidden');
        programsValidation_1.classList.add('hidden');
        idValidation_1.classList.add('hidden');
        mobileValidation_1.classList.add('hidden');
        emailValidation_1.classList.add('hidden');
    };
    var isFormValid_1 = function () {
        var tenDigitsPattern = /^\d{10}$/;
        var isIdValid = tenDigitsPattern.test(idInput_1.value);
        if (idInput_1.value === '' || !isIdValid) {
            idValidation_1.classList.remove('hidden');
        }
        else {
            idValidation_1.classList.add('hidden');
        }
        var mobilePattern = /^\+(?:[0-9] ?){6,14}[0-9]$/;
        var ismobileValid = mobilePattern.test(countryCode_1.textContent + mobileNumberInput_1.value);
        if (mobileNumberInput_1.value === '' || !ismobileValid) {
            mobileValidation_1.classList.remove('hidden');
        }
        else {
            mobileValidation_1.classList.add('hidden');
        }
        var emailPattern = /^[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+$/;
        var isEmailValid = emailPattern.test(emailInput_1.value);
        if (emailInput_1.value === '' || !isEmailValid) {
            emailValidation_1.classList.remove('hidden');
        }
        else {
            emailValidation_1.classList.add('hidden');
        }
        if (idInput_1.value !== '' &&
            isIdValid &&
            mobileNumberInput_1.value !== '' &&
            emailInput_1.value !== '' &&
            _class_1 !== '' &&
            programs_1.length > 0 &&
            firstSection_1.classList.contains('hidden')) {
            return true;
        }
        return false;
    };
    var toggleSlider_1 = function () {
        resetForm_1();
        resetValidations_1();
        quickJoin.classList.toggle('quick-join--open');
        triggerIcon_1.classList.toggle('hidden');
    };
    var closeSlider_1 = function () {
        quickJoin.classList.remove('quick-join--open');
        triggerIcon_1.classList.add('hidden');
        resetForm_1();
        resetValidations_1();
    };
    var resetProgramsDropdown_1 = function () {
        buttonContainers_1.forEach(function (container) {
            container.innerHTML = '';
        });
        programs_1 = [];
        autocompleLists_1.forEach(function (list) {
            list.querySelectorAll('option').forEach(function (item) {
                item.removeAttribute('selected');
            });
        });
    };
    var getServices_1 = function (className) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/quickjoin/services?class=" + className + "&currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    programsDropdown_1.length = 0;
                    response.data.forEach(function (service) {
                        var opt = document.createElement('option');
                        opt.value = service;
                        opt.innerHTML = service;
                        programsDropdown_1.appendChild(opt);
                    });
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    closeButton.addEventListener('click', function () {
        closeSlider_1();
    });
    window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeSlider_1();
        }
    });
    if (triggerText_1) {
        window.addEventListener('scroll', function () {
            if (window.scrollY === 0) {
                triggerText_1.classList.remove('quick-join__trigger-text--hidden');
            }
            else {
                triggerText_1.classList.add('quick-join__trigger-text--hidden');
            }
        });
    }
    dropdownFilterTriggers.forEach(function (trigger) {
        trigger.addEventListener('keydown', function (e) {
            e.preventDefault();
        });
    });
    singleDropdownFilterTrigger_1.addEventListener('keydown', function (e) {
        e.preventDefault();
    });
    singleDropdown_1.addEventListener('change', function () {
        var selected = singleDropdown_1.querySelector('option:checked');
        _class_1 = selected.value;
        classValidation_1.classList.add('hidden');
        getServices_1(selected.value);
        resetProgramsDropdown_1();
        dropdownFilters_1.forEach(function (filter) {
            filter.classList.remove('disabled');
        });
    });
    trigger.addEventListener('click', function () {
        toggleSlider_1();
    });
    trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            toggleSlider_1();
        }
    });
    nextButtons.forEach(function (button, index) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            if (index === 0) {
                if (_class_1 === '') {
                    classValidation_1.classList.remove('hidden');
                }
                if (_class_1 !== '' && programs_1.length < 1) {
                    programsValidation_1.classList.remove('hidden');
                }
                if (_class_1 !== '' && programs_1.length > 0) {
                    firstSection_1.classList.add('hidden');
                    secondSection_1.classList.remove('hidden');
                    resetValidations_1();
                }
            }
        });
    });
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitButton_1.setAttribute('disabled', 'true');
        if (isFormValid_1()) {
            userEmail_1.textContent = emailInput_1.value;
            secondSection_1.classList.add('hidden');
            thirdSection_1.classList.remove('hidden');
            var dataObject = {
                class: _class_1,
                programs: programs_1,
                idNumber: idInput_1.value,
                countryCode: countryCode_1.textContent,
                mobile: mobileNumberInput_1.value,
                email: emailInput_1.value,
                formid: formidInput_1.value,
            };
            console.log(dataObject);
            SendData_1(dataObject);
        }
        submitButton_1.removeAttribute('disabled');
    });
    var SendData_1 = function (dataObject) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post("/api/quickjoin", dataObject)];
                case 1:
                    response = _a.sent();
                    console.log(response.data);
                    return [3, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    dropdownFilters_1.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var arr2_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    arr2_1.push(element.textContent);
                                });
                                programsValidation_1.classList.add('hidden');
                                programs_1 = arr2_1;
                                break;
                            default:
                                break;
                        }
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
}
},{"axios":116}],81:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],82:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var starRatings_1 = require("../starRatings/starRatings");
var list = document.querySelector('.science-pubs__wrapper');
if (list) {
    var grid_1 = list.querySelector('.science-pubs__grid');
    var filters_1 = list.querySelector('.science-pubs__filter-content');
    var resultsnumber_1 = list.querySelector('.science-pubs__number');
    var filterButton = list.querySelector('.science-pubs__button');
    var filterCount_1 = list.querySelector('.science-pubs__button-count-content');
    var listSearchInput_1 = list.querySelector('.science-pubs__search-input');
    var publicationsAuthorsDiv_1 = list.querySelector('.science-pubs__sub-filters');
    var publicationsFileTypesDiv_1 = list.querySelector('.science-pubs__summary-filetypes');
    var nextPageButton = list.querySelector('.pagination__page-next');
    var prevPageButton = list.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = list.querySelector('.pagination__dropdown');
    var paginationLast = list.querySelector('.pagination__page-last');
    var paginationFirst = list.querySelector('.pagination__page-first');
    var pagination_2 = list.querySelector('.pagination');
    var radios = list.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var pageId_1 = Number(list.getAttribute('data-id'));
    var checkboxFiltersViews = list.querySelectorAll('.science-pubs__view-checkbox');
    var scienceCards_1 = [];
    var scienceCardsAll_1 = [];
    var publicationsAuthors_1 = [];
    var publicationsFileTypes_1 = [];
    var keyword_1 = '';
    var authors_1 = [];
    var views_1 = [];
    var ratings_1 = [];
    var fileTypes_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var addPageView_1 = function (pageViewedId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post("/api/pageview?pageId=" + pageViewedId)];
                case 1:
                    _a.sent();
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchPublicationsFilters_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, 6, 7]);
                    payload = {
                        pageId: pageId_1,
                        keyword: keyword_1,
                        authors: authors_1,
                        views: views_1,
                        ratings: ratings_1,
                        fileTypes: fileTypes_1,
                        sortBy: sortBy_1,
                        pageNumber: pageNumber_1,
                        pageSize: pageSize_1,
                        currentCulture: currentCulture_1,
                    };
                    response = void 0;
                    if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                        window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 2];
                    return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/scientificpublications/filters', payload)];
                case 1:
                    response = _a.sent();
                    return [3, 4];
                case 2: return [4, axios_1.default.post('/api/scientificpublications/filters', payload)];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    publicationsAuthors_1 = response.data.authors;
                    publicationsFileTypes_1 = response.data.fileTypes;
                    return [3, 7];
                case 5:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3, 7];
                case 6:
                    updateFilters_1();
                    updateNumberCards_1();
                    return [7];
                case 7: return [2];
            }
        });
    }); };
    var updateFilters_1 = function () {
        publicationsAuthorsDiv_1.innerHTML = '';
        publicationsAuthors_1.forEach(function (card) {
            var cardElement = document.createElement('summary');
            cardElement.innerHTML = "\n                    <div class=\"science-pubs__sub-filters-text flex flex--align-center\">\n                        <input type=\"checkbox\" id=\"author-" + card.id + "\" value=\"" + card.name + "\"\n                            class=\"science-pubs__sub-filters-text-checkbox science-pubs__category-checkbox\">\n                        <label for=\"author-" + card.id + "\"\n                            class=\"science-pubs__sub-filters-text-name flex flex--align-center\">\n                            <span class=\"science-pubs__sub-filters-span\">\n                                " + card.name + "\n                            </span>\n                            <span\n                                class=\"science-pubs__sub-filters-text-number\">" + card.count + "</span>\n                        </label>\n                    </div>\n            ";
            publicationsAuthorsDiv_1.appendChild(cardElement);
        });
        var checkboxFiltersAuthors = list.querySelectorAll('.science-pubs__category-checkbox');
        if (checkboxFiltersAuthors.length > 0) {
            checkboxFiltersAuthors.forEach(function (checkbox) {
                checkbox.addEventListener('change', function () {
                    if (authors_1.includes(checkbox.value)) {
                        authors_1 = authors_1.filter(function (cat) { return cat !== checkbox.value; });
                    }
                    else {
                        authors_1.push(checkbox.value);
                    }
                    fetchPublications_1();
                    fetchAllPublications_1();
                });
            });
        }
        publicationsFileTypesDiv_1.innerHTML = '';
        publicationsFileTypes_1.forEach(function (card) {
            var cardElement = document.createElement('div');
            cardElement.className = 'science-pubs__sub-filters-text flex flex--align-center';
            cardElement.innerHTML = "\n                    <input type=\"checkbox\" id=\"filetype-" + card.name + "\" value=\"" + card.name + "\"\n                        class=\"science-pubs__sub-filters-text-checkbox science-pubs__filetype-checkbox\">\n                        <label for=\"filetype-" + card.name + "\"\n                            class=\"science-pubs__sub-filters-text-name flex flex--align-center\">\n                        <span>\n                            " + card.name + "\n                        </span>\n                        <span class=\"science-pubs__sub-filters-text-number\">" + card.count + "</span>\n                    </label>\n            ";
            publicationsFileTypesDiv_1.appendChild(cardElement);
        });
        var checkboxFiltersFileTypes = list.querySelectorAll('.science-pubs__filetype-checkbox');
        if (checkboxFiltersFileTypes.length > 0) {
            checkboxFiltersFileTypes.forEach(function (checkbox) {
                checkbox.addEventListener('change', function () {
                    if (fileTypes_1.includes(checkbox.value)) {
                        fileTypes_1 = fileTypes_1.filter(function (cat) { return cat !== checkbox.value; });
                    }
                    else {
                        fileTypes_1.push(checkbox.value);
                    }
                    fetchPublications_1();
                    fetchAllPublications_1();
                });
            });
        }
    };
    var fetchPublications_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, fCount, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            pageId: pageId_1,
                            keyword: keyword_1,
                            authors: authors_1,
                            views: views_1,
                            ratings: ratings_1,
                            fileTypes: fileTypes_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        fCount = authors_1.length + views_1.length;
                        filterCount_1.innerHTML = fCount.toString();
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/scientificpublications', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/scientificpublications', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        scienceCards_1 = response.data.items;
                        if (scienceCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        resultsnumber_1.innerHTML = response.data.totalCount;
                        return [3, 8];
                    case 6:
                        error_3 = _a.sent();
                        console.error(error_3);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, scienceCards_1, fetchPublications_1);
                        isLoading_1 = false;
                        updateCards_1();
                        updateNumberCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var fetchAllPublications_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            pageId: pageId_1,
                            keyword: '',
                            authors: [],
                            views: [],
                            fileTypes: [],
                            ratings: [],
                            sortBy: 1,
                            pageNumber: 1,
                            pageSize: -1,
                            currentCulture: currentCulture_1,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/scientificpublications', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/scientificpublications', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        scienceCardsAll_1 = response.data.items;
                        return [3, 7];
                    case 6:
                        error_4 = _a.sent();
                        console.error(error_4);
                        return [3, 7];
                    case 7: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        grid_1.innerHTML = '';
        scienceCards_1.forEach(function (card) {
            var cardElement = document.createElement('div');
            cardElement.className = 'science-card flex flex--column flex--align-start flex--justify-between fade-in';
            cardElement.innerHTML = "\n                    <div class=\"science-card__top flex flex--wrap\">\n                        " + (card.image !== null && card.image !== ''
                ? "<div class=\"science-card__image-container flex flex--align-center flex--justify-center\">\n                                        <img src=" + card.image + " alt=\"publciation image\" class=\"science-card__image\">\n                                    </div>"
                : '') + "\n                        <div class=\"science-card__content flex flex--column flex--justify-between\">\n                            " + (card.fileType !== null && card.fileType !== ''
                ? "<div class='science-card__date flex flex--align-center'>\n                                        <img src=\"/assets/img/fractal/filetype--" + card.fileType + ".svg\" alt=\"pdf icon\" class=\"science-card__pdf\">\n                                    </div>"
                : '') + "\n                            <span class=\"science-card__title\">" + card.title + "</span>\n                            <span class=\"science-card__text\">" + card.description + "</span>\n                            <div class=\"science-card__row flex flex--wrap flex--justify-between flex--align-center\">\n                                <div class=\"science-card__row-item flex flex--align-center\">\n                                    <img src=\"/assets/img/img/icons/user-tick-article-card.svg\" alt=\"user icon\"\n                                        class=\"science-card__row-item-icon\">\n                                    <span class=\"science-card__row-item-text\">" + card.author + "</span>\n                                </div>\n                                " + (card.summaryLink !== null && card.summaryLink !== ''
                ? "<div class=\"science-card__row-item flex flex--align-center\">\n                                                                <img src=\"/assets/img/img/icons/book-square2.svg\" alt=\"summary icon\"\n                                                                    class=\"science-card__row-item-icon\">\n                                                                <a class=\"science-card__row-item-text\" target=\"_blank\" href=\"" + card.summaryLink + "\">" + card.summaryLinkTitle + "</a>\n                                                        </div>" : '') + "\n                                \n                                <div class=\"science-card__row-item science-card__row-item-review flex flex--align-center\" tabindex=\"0\">\n                                    <div class=\"star-rating-trigger flex flex--justify-center flex--align-center\">\n\n                                    " + (card.isRated
                ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="#7a5df5" xmlns="http://www.w3.org/2000/svg"><path d="M13.2703 3.79429L14.9713 7.19642C15.2033 7.67001 15.8218 8.12427 16.3438 8.21126L19.4269 8.72351C21.3986 9.05212 21.8626 10.4826 20.4418 11.8937L18.0448 14.2906C17.6389 14.6966 17.4166 15.4794 17.5422 16.04L18.2285 19.0072C18.7697 21.3558 17.5229 22.2644 15.4449 21.0369L12.555 19.3262C12.0331 19.0169 11.1729 19.0169 10.6413 19.3262L7.75146 21.0369C5.68312 22.2644 4.42665 21.3462 4.9679 19.0072L5.65413 16.04C5.77977 15.4794 5.55747 14.6966 5.15154 14.2906L2.75459 11.8937C1.34348 10.4826 1.79774 9.05212 3.76943 8.72351L6.8526 8.21126C7.36485 8.12427 7.98342 7.67001 8.21539 7.19642L9.91645 3.79429C10.8443 1.94825 12.3521 1.94825 13.2703 3.79429Z" fill="#7a5df5" /></svg>'
                : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.7733 15.1132C11.42 15.1132 10.9667 14.9999 10.4 14.6665L8.40666 13.4865C8.2 13.3665 7.8 13.3665 7.6 13.4865L5.6 14.6665C4.42 15.3666 3.72666 15.0866 3.41333 14.8599C3.10666 14.6332 2.62666 14.0532 2.94 12.7199L3.41333 10.6732C3.46666 10.4599 3.36 10.0932 3.2 9.93322L1.54666 8.27988C0.719997 7.45322 0.786664 6.74655 0.899997 6.39988C1.01333 6.05322 1.37333 5.43988 2.52 5.24655L4.64666 4.89322C4.84666 4.85988 5.13333 4.64655 5.22 4.46655L6.4 2.11322C6.93333 1.03988 7.63333 0.879883 8 0.879883C8.36666 0.879883 9.06666 1.03988 9.6 2.11322L10.7733 4.45988C10.8667 4.63988 11.1533 4.85322 11.3533 4.88655L13.48 5.23988C14.6333 5.43322 14.9933 6.04655 15.1 6.39322C15.2067 6.73988 15.2733 7.44655 14.4533 8.27322L12.8 9.93322C12.64 10.0932 12.54 10.4532 12.5867 10.6732L13.06 12.7199C13.3667 14.0532 12.8933 14.6332 12.5867 14.8599C12.42 14.9799 12.1533 15.1132 11.7733 15.1132ZM8 12.3932C8.32666 12.3932 8.65333 12.4732 8.91333 12.6266L10.9067 13.8065C11.4867 14.1532 11.8533 14.1532 11.9933 14.0532C12.1333 13.9532 12.2333 13.5999 12.0867 12.9466L11.6133 10.8999C11.4867 10.3465 11.6933 9.63322 12.0933 9.22655L13.7467 7.57322C14.0733 7.24655 14.22 6.92655 14.1533 6.70655C14.08 6.48655 13.7733 6.30655 13.32 6.23322L11.1933 5.87988C10.68 5.79322 10.12 5.37988 9.88666 4.91322L8.71333 2.56655C8.5 2.13988 8.23333 1.88655 8 1.88655C7.76666 1.88655 7.5 2.13988 7.29333 2.56655L6.11333 4.91322C5.88 5.37988 5.32 5.79322 4.80666 5.87988L2.68666 6.23322C2.23333 6.30655 1.92666 6.48655 1.85333 6.70655C1.78 6.92655 1.93333 7.25322 2.26 7.57322L3.91333 9.22655C4.31333 9.62655 4.52 10.3465 4.39333 10.8999L3.92 12.9466C3.76666 13.6066 3.87333 13.9532 4.01333 14.0532C4.15333 14.1532 4.51333 14.1465 5.1 13.8065L7.09333 12.6266C7.34666 12.4732 7.67333 12.3932 8 12.3932Z" fill="#2B254B"/></svg>') + "\n\n                                        <span class=\"star-rating-text\">" + card.rating + "</span>\n                                    </div>\n                                    <div class=\"science-card__rating flex flex--align-center reviews\">\n                                        <div class=\"star-rating\" data-pageid=\"" + card.id + "\"\n                                            data-user-rated=\"" + (card.isRated ? 1 : 0) + "\"\n                                            data-avg-rating=\"" + card.rating + "\">\n                                        <span class=\"star\" data-value=\"1\">\n                                            <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                                <path d=\"M13.2703 3.79429L14.9713 7.19642C15.2033 7.67001 15.8218 8.12427 16.3438 8.21126L19.4269 8.72351C21.3986 9.05212 21.8626 10.4826 20.4418 11.8937L18.0448 14.2906C17.6389 14.6966 17.4166 15.4794 17.5422 16.04L18.2285 19.0072C18.7697 21.3558 17.5229 22.2644 15.4449 21.0369L12.555 19.3262C12.0331 19.0169 11.1729 19.0169 10.6413 19.3262L7.75146 21.0369C5.68312 22.2644 4.42665 21.3462 4.9679 19.0072L5.65413 16.04C5.77977 15.4794 5.55747 14.6966 5.15154 14.2906L2.75459 11.8937C1.34348 10.4826 1.79774 9.05212 3.76943 8.72351L6.8526 8.21126C7.36485 8.12427 7.98342 7.67001 8.21539 7.19642L9.91645 3.79429C10.8443 1.94825 12.3521 1.94825 13.2703 3.79429Z\" fill=\"#D1D5DB\" />\n                                            </svg>\n                                        </span>\n                                        <span class=\"star\" data-value=\"2\">\n                                            <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                                <path d=\"M13.2703 3.79429L14.9713 7.19642C15.2033 7.67001 15.8218 8.12427 16.3438 8.21126L19.4269 8.72351C21.3986 9.05212 21.8626 10.4826 20.4418 11.8937L18.0448 14.2906C17.6389 14.6966 17.4166 15.4794 17.5422 16.04L18.2285 19.0072C18.7697 21.3558 17.5229 22.2644 15.4449 21.0369L12.555 19.3262C12.0331 19.0169 11.1729 19.0169 10.6413 19.3262L7.75146 21.0369C5.68312 22.2644 4.42665 21.3462 4.9679 19.0072L5.65413 16.04C5.77977 15.4794 5.55747 14.6966 5.15154 14.2906L2.75459 11.8937C1.34348 10.4826 1.79774 9.05212 3.76943 8.72351L6.8526 8.21126C7.36485 8.12427 7.98342 7.67001 8.21539 7.19642L9.91645 3.79429C10.8443 1.94825 12.3521 1.94825 13.2703 3.79429Z\" fill=\"#D1D5DB\" />\n                                            </svg>\n                                        </span>\n                                        <span class=\"star\" data-value=\"3\">\n                                            <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                                <path d=\"M13.2703 3.79429L14.9713 7.19642C15.2033 7.67001 15.8218 8.12427 16.3438 8.21126L19.4269 8.72351C21.3986 9.05212 21.8626 10.4826 20.4418 11.8937L18.0448 14.2906C17.6389 14.6966 17.4166 15.4794 17.5422 16.04L18.2285 19.0072C18.7697 21.3558 17.5229 22.2644 15.4449 21.0369L12.555 19.3262C12.0331 19.0169 11.1729 19.0169 10.6413 19.3262L7.75146 21.0369C5.68312 22.2644 4.42665 21.3462 4.9679 19.0072L5.65413 16.04C5.77977 15.4794 5.55747 14.6966 5.15154 14.2906L2.75459 11.8937C1.34348 10.4826 1.79774 9.05212 3.76943 8.72351L6.8526 8.21126C7.36485 8.12427 7.98342 7.67001 8.21539 7.19642L9.91645 3.79429C10.8443 1.94825 12.3521 1.94825 13.2703 3.79429Z\" fill=\"#D1D5DB\" />\n                                            </svg>\n                                        </span>\n                                        <span class=\"star\" data-value=\"4\">\n                                            <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                                <path d=\"M13.2703 3.79429L14.9713 7.19642C15.2033 7.67001 15.8218 8.12427 16.3438 8.21126L19.4269 8.72351C21.3986 9.05212 21.8626 10.4826 20.4418 11.8937L18.0448 14.2906C17.6389 14.6966 17.4166 15.4794 17.5422 16.04L18.2285 19.0072C18.7697 21.3558 17.5229 22.2644 15.4449 21.0369L12.555 19.3262C12.0331 19.0169 11.1729 19.0169 10.6413 19.3262L7.75146 21.0369C5.68312 22.2644 4.42665 21.3462 4.9679 19.0072L5.65413 16.04C5.77977 15.4794 5.55747 14.6966 5.15154 14.2906L2.75459 11.8937C1.34348 10.4826 1.79774 9.05212 3.76943 8.72351L6.8526 8.21126C7.36485 8.12427 7.98342 7.67001 8.21539 7.19642L9.91645 3.79429C10.8443 1.94825 12.3521 1.94825 13.2703 3.79429Z\" fill=\"#D1D5DB\" />\n                                            </svg>\n                                        </span>\n                                        <span class=\"star\" data-value=\"5\">\n                                            <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                                <path d=\"M13.2703 3.79429L14.9713 7.19642C15.2033 7.67001 15.8218 8.12427 16.3438 8.21126L19.4269 8.72351C21.3986 9.05212 21.8626 10.4826 20.4418 11.8937L18.0448 14.2906C17.6389 14.6966 17.4166 15.4794 17.5422 16.04L18.2285 19.0072C18.7697 21.3558 17.5229 22.2644 15.4449 21.0369L12.555 19.3262C12.0331 19.0169 11.1729 19.0169 10.6413 19.3262L7.75146 21.0369C5.68312 22.2644 4.42665 21.3462 4.9679 19.0072L5.65413 16.04C5.77977 15.4794 5.55747 14.6966 5.15154 14.2906L2.75459 11.8937C1.34348 10.4826 1.79774 9.05212 3.76943 8.72351L6.8526 8.21126C7.36485 8.12427 7.98342 7.67001 8.21539 7.19642L9.91645 3.79429C10.8443 1.94825 12.3521 1.94825 13.2703 3.79429Z\" fill=\"#D1D5DB\" />\n                                            </svg>\n                                        </span>\n                                        </div>\n                                        <div class=\"science-card__rating-value rating-value\">\n                                            " + card.rating + "\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"science-card__row-item flex flex--align-center\">\n                                    <img src=\"/assets/img/img/icons/eye.svg\" alt=\"eye icon\" class=\"science-card__row-item-icon\">\n                                    <span class=\"science-card__row-item-text\">" + card.views + "</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"science-card__bottom flex flex--wrap flex--align-center\">\n                        <a href=\"" + card.link + "\" data-id=\"" + card.id + "\" target=\"_blank\" draggable=\"false\" class=\"link link--secondary science-card__link science-card__link--full flex flex--justify-center flex--align-center\">\n                            <span class=\"link__label\">" + card.linkTitle + "</span>\n                            <img class=\"link__image\" src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"/assets/img/img/arrow-top-left-dark.svg\">\n                        </a>\n                        <div class=\"science-card__buttons flex flex--align-center\">\n                            <button class=\"button button--round-tiny shareButton science-card__button science-card__button-share flex flex--justify-center flex--align-center\">\n                                <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                            </button>\n                            <a href=\"" + card.link + "\" draggable=\"false\" class=\"link link--round-tiny science-card__button science-card__button-download flex flex--justify-center flex--align-center\" download>\n                                <img class=\"link__image\" src=\"/assets/img/img/download-icon-dark.svg\" alt=\"/assets/img/img/download-icon-dark.svg\">\n                            </a>\n                        </div>\n                    </div>\n            ";
            grid_1.appendChild(cardElement);
        });
        addCardListeners_1();
        starRatings_1.initStarRatings();
        var fileButtons = grid_1.querySelectorAll('.science-card__link--full');
        fileButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                var cardId = Number(button.getAttribute('data-id'));
                addPageView_1(cardId);
            });
        });
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        filters_1 === null || filters_1 === void 0 ? void 0 : filters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        filters_1.classList.remove('disabled');
    };
    if (checkboxFiltersViews.length > 0) {
        checkboxFiltersViews.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                if (views_1.includes(checkbox.value)) {
                    views_1 = views_1.filter(function (cat) { return cat !== checkbox.value; });
                }
                else {
                    views_1.push(checkbox.value);
                }
                fetchPublications_1();
            });
        });
    }
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchPublications_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchPublications_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchPublications_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchPublications_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchPublications_1();
    });
    var timeout_1 = null;
    listSearchInput_1 === null || listSearchInput_1 === void 0 ? void 0 : listSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = listSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchPublications_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = list.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchPublications_1();
        });
    });
    filterButton === null || filterButton === void 0 ? void 0 : filterButton.addEventListener('click', function () {
        var filterColumn = list.querySelector('.science-pubs__accordions');
        if (filterColumn === null || filterColumn === void 0 ? void 0 : filterColumn.classList.contains('hidden')) {
            filterColumn === null || filterColumn === void 0 ? void 0 : filterColumn.classList.remove('hidden');
        }
        else {
            filterColumn === null || filterColumn === void 0 ? void 0 : filterColumn.classList.add('hidden');
        }
    });
    var initializeList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchAllPublications_1()];
                case 1:
                    _a.sent();
                    return [4, fetchPublicationsFilters_1()];
                case 2:
                    _a.sent();
                    return [4, fetchPublications_1()];
                case 3:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeList();
    var updateNumberCards_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var filterDivs;
        return __generator(this, function (_a) {
            filterDivs = document.querySelectorAll('.views-card');
            filterDivs.forEach(function (filterDiv) {
                var minViews = parseInt(filterDiv.getAttribute('data-min'), 10);
                var maxViews = parseInt(filterDiv.getAttribute('data-max'), 10);
                var count = scienceCardsAll_1.filter(function (article) { return article.views >= minViews && article.views <= maxViews; }).length;
                var countSpan = filterDiv.querySelector('.science-pubs__sub-filters-text-number');
                countSpan.textContent = count.toString();
            });
            return [2];
        });
    }); };
    updateNumberCards_1();
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var addCardListeners_1 = function () {
        var listCards = list.querySelectorAll('.science-card');
        if (listCards.length > 0) {
            var cardButtons = list.querySelectorAll('.science-card__button');
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"../starRatings/starRatings":101,"axios":116}],83:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],84:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var searchList = document.querySelector('.search-results');
var getParameterByName = function (name, url) {
    if (url === void 0) { url = window.location.href; }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
if (searchList) {
    var Grid_1 = searchList.querySelector('.search-results__grid');
    var searchFilters_1 = searchList.querySelector('.search-results__filters');
    var searchListingSearchInput_1 = searchList.querySelector('.search-results__search-input');
    var radios = searchList.querySelectorAll('.sort-filter__input');
    var checkboxes = searchList.querySelectorAll('.search-results__category-input');
    var nextPageButton = searchList.querySelector('.pagination__page-next');
    var prevPageButton = searchList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = searchList.querySelector('.pagination__dropdown');
    var paginationLast = searchList.querySelector('.pagination__page-last');
    var paginationFirst = searchList.querySelector('.pagination__page-first');
    var pagination_2 = searchList.querySelector('.pagination');
    var totalSearchResults_1 = searchList.querySelector('.search-results__number');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var queryParam = getParameterByName('q');
    var searchCards_1 = [];
    var keyword_1 = queryParam;
    searchListingSearchInput_1.value = queryParam;
    var types_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchSearchResults_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            types: types_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/search', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post("/api/search", payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        searchCards_1 = response.data.items;
                        if (searchCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalCount_1 = response.data.totalCount;
                        totalPages_1 = response.data.totalPages;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        totalSearchResults_1.innerHTML = totalCount_1.toString();
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, searchCards_1, fetchSearchResults_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        Grid_1.innerHTML = '';
        searchCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.className = 'search-results__card';
            cardElement.innerHTML = "\n            " + (card.tag !== null ? " <p class='search-results__card-tag'>" + card.tag + "</p>" : '') + "\n            <h3 class='search-results__card-title'>" + card.title + "</h3>\n            <div class='search-results__card-image-container'>\n            " + (card.image !== null && card.image !== ''
                ? "<img src='" + card.image + "' alt='image' class='search-results__card-image' />"
                : '') + "\n            </div>\n            <p class='search-results__card-text'>\n                " + (card.description !== null ? card.description : '') + "\n            </p>\n            <div class='search-results__card-bottom flex flex--justify-between flex--align-center'>\n                <div class=\"search-results__link flex flex--align-center flex--justify-center\">\n                    " + card.linkTitle + "\n                    <img src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"arrow icon\"\n                        class=\"search-results__link-icon\">\n                </div>\n                <div class='search-results__card-buttons flex flex--align-center'>\n                    <button\n                        class=\"button button--round-small search-results__button-share search-results__button flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                </div>\n            </div>\n            ";
            Grid_1.appendChild(cardElement);
        });
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        searchFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        searchFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchSearchResults_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchSearchResults_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchSearchResults_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchSearchResults_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchSearchResults_1();
    });
    var timeout_1 = null;
    searchListingSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = searchListingSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchSearchResults_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = searchList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchSearchResults_1();
        });
    });
    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            if (checkbox.checked) {
                types_1.push(checkbox.value);
            }
            else {
                var index = types_1.indexOf(checkbox.value);
                if (index > -1) {
                    types_1.splice(index, 1);
                }
            }
            pageNumber_1 = 1;
            fetchSearchResults_1();
        });
    });
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    fetchSearchResults_1();
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"axios":116}],85:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],86:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var infoComponent = document.querySelector('.details-survey');
if (infoComponent) {
    var pageId_1 = parseInt(infoComponent.getAttribute('data-pageid'));
    var hasRating = parseInt(infoComponent.getAttribute('data-hasrating'));
    var positiveButton_1 = infoComponent.querySelector('.positive');
    var negativeButton_1 = infoComponent.querySelector('.negative');
    var ratingSpan_1 = infoComponent.querySelector('.rating');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var SubmitPositiveAPICall_1 = function () {
        CreateRatingCommand_1(pageId_1, true);
        positiveButton_1.classList.remove('button--secondary');
        positiveButton_1.classList.add('button--primary');
        var img = positiveButton_1.querySelector('.button__image');
        img.src = '/assets/img/img/emoji-happy.svg';
        removeEventListeners_1();
    };
    var SubmitNegativeAPICall_1 = function () {
        CreateRatingCommand_1(pageId_1, false);
        negativeButton_1.classList.remove('button--secondary');
        negativeButton_1.classList.add('button--primary');
        var img = negativeButton_1.querySelector('.button__image');
        img.src = '/assets/img/img/emoji-sad.svg';
        removeEventListeners_1();
    };
    var disableButtons_1 = function () {
        positiveButton_1.classList.add('button--disabled');
        negativeButton_1.classList.add('button--disabled');
    };
    if (hasRating !== 1) {
        positiveButton_1.addEventListener('click', SubmitPositiveAPICall_1);
        negativeButton_1.addEventListener('click', SubmitNegativeAPICall_1);
    }
    else {
        disableButtons_1();
    }
    var CreateRatingCommand_1 = function (pageId, rating) { return __awaiter(void 0, void 0, void 0, function () {
        var response, string, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post("/api/info?pageid=" + pageId + "&rating=" + rating)];
                case 1:
                    response = _a.sent();
                    string = response.data.positiveRatingsCount.toString() +
                        ' ' +
                        (currentCulture_1 == 'ar' ? 'من أصل' : 'out of') +
                        ' ' +
                        response.data.totalRatingsCount.toString();
                    console.log(string);
                    ratingSpan_1.innerHTML = string;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var removeEventListeners_1 = function () {
        positiveButton_1.removeEventListener('click', SubmitPositiveAPICall_1);
        negativeButton_1.removeEventListener('click', SubmitNegativeAPICall_1);
        disableButtons_1();
    };
}
},{"axios":116}],87:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],88:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var favButtons = document.querySelectorAll('.favouriteButton');
var serviceDetails = document.querySelector('.service-details');
if (serviceDetails) {
    var tabs_1 = serviceDetails.querySelectorAll('.service-details__tab');
    var tabContents_1 = serviceDetails.querySelectorAll('.service-details__tab-content');
    var feesButton_1 = serviceDetails.querySelector('.service-details__tooltip');
    var feeWaiverButton_1 = serviceDetails.querySelector('.service-details__waiver-tooltip');
    var activeTabIndex_1 = 0;
    tabContents_1[activeTabIndex_1].classList.remove('hidden');
    tabs_1[activeTabIndex_1].classList.add('service-details__tab--active');
    var resetTabs_1 = function () {
        tabs_1.forEach(function (tab) { return tab.classList.remove('service-details__tab--active'); });
        tabContents_1.forEach(function (item) { return item.classList.add('hidden'); });
    };
    tabs_1.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            resetTabs_1();
            tab.classList.add('service-details__tab--active');
            activeTabIndex_1 = index;
            tabContents_1[activeTabIndex_1].classList.remove('hidden');
        });
    });
    if (favButtons && favButtons.length > 0) {
        favButtons.forEach(function (button) {
            var dataIdAttr = button.getAttribute('data-id');
            var type = button.getAttribute('data-type');
            var favouritedIds = JSON.parse(button.getAttribute('data-ids'));
            if (dataIdAttr !== null && favouritedIds != null) {
                var dataId_1 = parseInt(dataIdAttr);
                if (isFavourite_1.IsFavourited(dataId_1, favouritedIds)) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
                button.addEventListener('click', function (e) {
                    console.log('small button clicked - service details');
                    favourites_1.default(type, dataId_1, button);
                });
            }
        });
    }
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var openFeesTooltip_1 = function () {
        feesButton_1.nextElementSibling.classList.add('service-details__tooltip-inner--active');
    };
    var closeFeesTooltip_1 = function () {
        feesButton_1.nextElementSibling.classList.remove('service-details__tooltip-inner--active');
    };
    var openWaiverTooltip_1 = function () {
        var tooltipInnerDiv = feeWaiverButton_1.nextElementSibling;
        tooltipInnerDiv.classList.add('service-details__waiver-tooltip-inner--active');
        var buttonRect = feeWaiverButton_1.getBoundingClientRect();
        var windowScrollY = window.scrollY === 0 ? -80 : window.scrollY;
        var buttonRectHeight = window.innerWidth < 1200 ? 0 : buttonRect.height;
        var buttonRectTopOrBottom = window.innerWidth < 1200 ? buttonRect.top : buttonRect.bottom;
        var top = buttonRectTopOrBottom + buttonRectHeight + windowScrollY - tooltipInnerDiv.offsetHeight / 2 + 10;
        tooltipInnerDiv.style.top = top + "px";
    };
    var closeWaiverTooltip_1 = function () {
        feeWaiverButton_1.nextElementSibling.classList.remove('service-details__waiver-tooltip-inner--active');
    };
    window.addEventListener('click', function (event) {
        var clickedElement = event.target;
        var feesTargetElement = serviceDetails.querySelector('.service-details__tooltip-inner');
        if (clickedElement.classList.contains('service-details__tooltip')) {
            if (clickedElement.nextElementSibling.classList.contains('service-details__tooltip-inner--active')) {
                closeFeesTooltip_1();
            }
            else {
                openFeesTooltip_1();
            }
            return;
        }
        if (feesTargetElement) {
            while (clickedElement) {
                if (clickedElement === feesTargetElement) {
                    feesButton_1.nextElementSibling.classList.add('service-details__tooltip-inner--active');
                    return;
                }
                clickedElement = clickedElement.parentElement;
            }
            feesButton_1.nextElementSibling.classList.remove('service-details__tooltip-inner--active');
        }
        return;
    });
    window.addEventListener('click', function (event) {
        var clickedElement = event.target;
        var waiverTargetElement = serviceDetails.querySelector('.service-details__waiver-tooltip-inner');
        if (clickedElement.classList.contains('service-details__waiver-tooltip')) {
            if (clickedElement.nextElementSibling.classList.contains('service-details__waiver-tooltip-inner--active')) {
                closeWaiverTooltip_1();
            }
            else {
                openWaiverTooltip_1();
            }
            return;
        }
        if (waiverTargetElement) {
            while (clickedElement) {
                if (clickedElement === waiverTargetElement) {
                    feeWaiverButton_1.nextElementSibling.classList.add('service-details__waiver-tooltip-inner--active');
                    return;
                }
                clickedElement = clickedElement.parentElement;
            }
            feeWaiverButton_1.nextElementSibling.classList.remove('service-details__waiver-tooltip-inner--active');
        }
        return;
    });
    window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeFeesTooltip_1();
            closeWaiverTooltip_1();
        }
    });
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9}],89:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var favourites_1 = __importDefault(require("../../../helpers/favourites"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var isFavourite_1 = require("../../../helpers/isFavourite");
var isUserLoggedIn_1 = __importDefault(require("../../../helpers/isUserLoggedIn"));
var addGoogleAnalyticsEventLog_1 = __importDefault(require("../../../helpers/addGoogleAnalyticsEventLog"));
var servicesListing = document.querySelector('.service-list') || null;
if (servicesListing) {
    var grid_1 = servicesListing.querySelector('.service-list__grid');
    var filterMobile = servicesListing.querySelector('.service-list__filter-mobile');
    var nextPageButton = servicesListing.querySelector('.pagination__page-next');
    var prevPageButton = servicesListing.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = servicesListing.querySelector('.pagination__dropdown');
    var paginationLast = servicesListing.querySelector('.pagination__page-last');
    var paginationFirst = servicesListing.querySelector('.pagination__page-first');
    var pagination_2 = servicesListing.querySelector('.pagination');
    var radios_1 = servicesListing.querySelectorAll('.sort-filter__input');
    var servicesListingSearchInput_1 = servicesListing.querySelector('.service-list__search-input');
    var servicesFilters_1 = servicesListing.querySelector('.service-list__filters');
    var dropdownFilters = servicesListing.querySelectorAll('.dropdown-filter');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var favouritedIds_1 = JSON.parse(grid_1.getAttribute('data-ids'));
    var servicesCards_1 = [];
    var keyword_1 = '';
    var educationalLevels_1 = [];
    var serviceTypes_1 = [];
    var beneficiaries_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var keywordChanged_1 = false;
    var restoreDropdownSelections = function (dropdown, selectedValues) {
        var select = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.multi-select');
        var buttonContainer = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.dropdown-filter__button-container');
        if (!select)
            return;
        selectedValues.forEach(function (value) {
            var option = Array.from(select.options).find(function (item) { return item.value === value; });
            if (!option)
                return;
            option.selected = true;
            option.setAttribute('selected', '');
            if (!buttonContainer)
                return;
            var alreadyRendered = Array.from(buttonContainer.querySelectorAll('.selected-label')).some(function (label) { return label.textContent === value; });
            if (alreadyRendered)
                return;
            var token = document.createElement('div');
            token.classList.add('dropdown-filter__selected-wrapper');
            var label = document.createElement('span');
            label.classList.add('selected-label');
            label.textContent = value;
            var close = document.createElement('a');
            close.classList.add('selected-close');
            close.setAttribute('tabindex', '-1');
            close.setAttribute('data-option', value);
            close.setAttribute('data-hits', '0');
            close.addEventListener('click', function (event) {
                option.selected = false;
                option.removeAttribute('selected');
                token.remove();
                event.stopPropagation();
            });
            token.appendChild(label);
            token.appendChild(close);
            buttonContainer.appendChild(token);
        });
    };
    var initialUrl = new URL(window.location.href);
    restoreDropdownSelections(dropdownFilters[0], initialUrl.searchParams.getAll('beneficiaries'));
    restoreDropdownSelections(dropdownFilters[1], initialUrl.searchParams.getAll('serviceTypes'));
    restoreDropdownSelections(dropdownFilters[2], initialUrl.searchParams.getAll('educationalLevels'));
    var serviceCardSettings_1 = {
        cardButtonText: '',
        availableText: '',
        endText: '',
    };
    var fetchServiceCardSettings_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/services/cardsettings?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    serviceCardSettings_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchServices_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var url, payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        url = new URL(window.location.href);
                        pageNumber_1 = keywordChanged_1 ? 1 : Number(url.searchParams.get('pageNumber') || 1);
                        pageSize_1 = Number(url.searchParams.get('pageSize') || pageSize_1);
                        keyword_1 = keywordChanged_1 ? keyword_1 : url.searchParams.get('keyword') || '';
                        educationalLevels_1 =
                            educationalLevels_1.length === 0 ? url.searchParams.getAll('educationalLevels') : educationalLevels_1;
                        serviceTypes_1 = serviceTypes_1.length === 0 ? url.searchParams.getAll('serviceTypes') : serviceTypes_1;
                        beneficiaries_1 = beneficiaries_1.length === 0 ? url.searchParams.getAll('beneficiaries') : beneficiaries_1;
                        sortBy_1 = Number(url.searchParams.get('sortBy') || sortBy_1);
                        paginationDropdown_1.value = pageSize_1.toString();
                        servicesListingSearchInput_1.value = keyword_1;
                        radios_1.forEach(function (radio) {
                            radio.checked = sortBy_1 === +radio.value;
                        });
                        payload = {
                            keyword: keyword_1,
                            educationalLevels: educationalLevels_1,
                            serviceTypes: serviceTypes_1,
                            beneficiaries: beneficiaries_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, axios_1.default.post('/api/services', payload)];
                    case 2:
                        response = _a.sent();
                        servicesCards_1 = response.data.items;
                        if (servicesCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalCount_1 = response.data.totalCount;
                        totalPages_1 = response.data.totalPages;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 5];
                    case 3:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 5];
                    case 4:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, servicesCards_1, renderPage_1, true);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        servicesFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        servicesFilters_1.classList.remove('disabled');
    };
    var updateCards_1 = function () {
        grid_1.innerHTML = '';
        servicesCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.className = 'service-list__card fade-in';
            cardElement.setAttribute('href', card.link);
            cardElement.addEventListener('click', function (e) {
                addGoogleAnalyticsEventLog_1.default('content_page_view', { page_title: 'Services', content_type: 'Service', language: currentCulture_1 });
            });
            var _class = '';
            if (isFavourite_1.IsFavourited(card.id, favouritedIds_1)) {
                _class = 'active';
            }
            cardElement.innerHTML = "\n                " + (card.isAvailable ? "<p class='service-list__card-tag'>" + serviceCardSettings_1.availableText + "</p>" : "<p class='service-list__card-tag e-services__card-closed'>" + serviceCardSettings_1.endText + "</p>") + "\n\t\t\t\t<h3 class='service-list__card-title'>" + card.title + "</h3>\n\t\t\t\t<p class='service-list__card-text'>\n\t\t\t\t\t\t" + card.description + "\n\t\t\t\t</p>\n\t\t\t\t<div class='service-list__card-bottom flex flex--justify-between flex--align-center'>\n                        <div class=\"service-list__link flex flex--align-center flex--justify-center\">\n                            " + serviceCardSettings_1.cardButtonText + "\n                            <img src=\"/assets/img/img/arrow-top-left-dark.svg\" alt=\"arrow icon\"\n                                class=\"service-list__link-icon\">\n                        </div>\n\t\t\t\t\t<div class='service-list__card-buttons flex flex--align-center'>\n                        " + (isUserLoggedIn_1.default()
                ? "<button class=\"button button--favourite-small favouriteButton service-list__button flex flex--justify-center flex--align-center " + _class + "\" data-type=\"service\" data-id=\"" + card.id + "\">\n                                </button>"
                : '') + "\n\t\t\t\t\t\t<button class=\"button  button--round-small shareButton service-list__button-share service-list__button  flex flex--justify-center flex--align-center\">\n\t\t\t\t\t\t\t\t<img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t";
            grid_1.appendChild(cardElement);
        });
        addCardListeners_1();
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        renderPage_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        renderPage_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        renderPage_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        renderPage_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        renderPage_1();
    });
    var timeout_1 = null;
    servicesListingSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = servicesListingSearchInput_1.value.trim();
            keywordChanged_1 = true;
            pageNumber_1 = 1;
            fetchServices_1();
        }, 1000);
    });
    radios_1.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = servicesListing.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            renderPage_1();
        });
    });
    dropdownFilters.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var beneficiariesOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    beneficiariesOptions_1.push(element.textContent);
                                });
                                beneficiaries_1 = beneficiariesOptions_1;
                                break;
                            case 1:
                                var serviceTypeOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    serviceTypeOptions_1.push(element.textContent);
                                });
                                serviceTypes_1 = serviceTypeOptions_1;
                                break;
                            case 2:
                                var educationalLevelOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    educationalLevelOptions_1.push(element.textContent);
                                });
                                educationalLevels_1 = educationalLevelOptions_1;
                                break;
                            default:
                                break;
                        }
                        pageNumber_1 = 1;
                        renderPage_1();
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
    filterMobile.addEventListener('click', function () {
        var dropdowns = servicesListing.querySelector('.service-list__dropdowns');
        dropdowns.classList.toggle('service-list__dropdowns--active');
    });
    var initializeEventsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchServiceCardSettings_1()];
                case 1:
                    _a.sent();
                    return [4, fetchServices_1()];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    initializeEventsList();
    var addCardListeners_1 = function () {
        var serviceListCards = servicesListing.querySelectorAll('.service-list__card');
        if (serviceListCards.length > 0) {
            var cardButtons = document.querySelectorAll('.service-list__button');
            serviceListCards.forEach(function (card) {
                card.addEventListener('click', function (e) {
                    var target = e.target;
                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });
            cardButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    if (button.classList.contains('favouriteButton')) {
                        var t = button.getAttribute('data-type');
                        var id = Number(button.getAttribute('data-id'));
                        favourites_1.default(t, id, button);
                    }
                    else if (button.classList.contains('shareButton')) {
                        copyToClipboard_1.default(button);
                    }
                });
            });
        }
    };
    var renderPage_1 = function (page) {
        if (page === void 0) { page = null; }
        if (page) {
            pageNumber_1 = page;
        }
        var url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber_1.toString());
        url.searchParams.set('pageSize', pageSize_1.toString());
        if (keyword_1)
            url.searchParams.set('keyword', keyword_1);
        educationalLevels_1.forEach(function (educationalLevel) {
            return url.searchParams.append('educationalLevels', educationalLevel);
        });
        serviceTypes_1.forEach(function (serviceType) { return url.searchParams.append('serviceTypes', serviceType); });
        beneficiaries_1.forEach(function (beneficiary) { return url.searchParams.append('beneficiaries', beneficiary); });
        url.searchParams.set('sortBy', sortBy_1.toString());
        if (page == null) {
            window.location.href = url.toString();
        }
        return url.toString();
    };
}
},{"../../../helpers/addGoogleAnalyticsEventLog":2,"../../../helpers/copyToClipboard":5,"../../../helpers/favourites":6,"../../../helpers/isFavourite":9,"../../../helpers/isUserLoggedIn":10,"../pagination/pagination":71,"axios":116}],90:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],91:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var pagination_1 = require("../pagination/pagination");
var serviceResults = document.querySelector('.service-results');
if (serviceResults) {
    var eventTabs_1 = serviceResults.querySelectorAll('.service-results__tab');
    var sections_1 = serviceResults.querySelectorAll('.service-results__section');
    var eventTabsContainer = serviceResults.querySelector('.service-results__tabs');
    var tableImagesContainer = serviceResults.querySelectorAll('.service-results__table-images');
    var activeTab_1 = 0;
    if (eventTabs_1.length > 1) {
        var resetTabs_1 = function () {
            eventTabs_1.forEach(function (tab) { return tab.classList.remove('service-results__tab--active'); });
            sections_1.forEach(function (tab) { return tab.classList.remove('service-results__section--active'); });
        };
        eventTabs_1.forEach(function (tab, index) {
            tab.addEventListener('click', function () {
                activeTab_1 = index;
                resetTabs_1();
                eventTabs_1[activeTab_1].classList.add('service-results__tab--active');
                sections_1[activeTab_1].classList.add('service-results__section--active');
            });
        });
    }
    else {
        eventTabsContainer.classList.add('hidden');
    }
    tableImagesContainer.forEach(function (item) {
        if (item.children.length > 1) {
            item.nextElementSibling.classList.add('service-results__table-content-title-alt');
        }
    });
    var studentsTableBody_1 = serviceResults.querySelector('.service-results__table-body');
    if (studentsTableBody_1) {
        var studentsMobileTableBody_1 = serviceResults.querySelector('.service-results__table-mobile-body');
        var nextPageButton = serviceResults.querySelector('.pagination__page-next');
        var prevPageButton = serviceResults.querySelector('.pagination__page-prev');
        var paginationDropdown_1 = serviceResults.querySelector('.pagination__dropdown');
        var paginationLast = serviceResults.querySelector('.pagination__page-last');
        var paginationFirst = serviceResults.querySelector('.pagination__page-first');
        var pagination_2 = serviceResults.querySelector('.pagination');
        var radios = serviceResults.querySelectorAll('.sort-filter__input');
        var serviceResultsFilters_1 = serviceResults.querySelector('.service-results__filters');
        var serviceResultsSearchInput_1 = serviceResults.querySelector('.service-results__search-input');
        var dropdownFilters = serviceResults.querySelectorAll('.dropdown-filter');
        var currentCulture_1 = document.documentElement.getAttribute('culture');
        var parentNodeId_1 = serviceResults.getAttribute('data-id');
        var serviceResultsStudentsItems_1 = [];
        var keyword_1 = '';
        var educationDepartments_1 = [];
        var positions_1 = [];
        var years_1 = [];
        var sortBy_1 = 1;
        var pageNumber_1 = 1;
        var pageSize_1 = +paginationDropdown_1.value;
        var totalPages_1 = 0;
        var totalCount_1 = 0;
        var hasNextPage_1 = false;
        var hasPreviousPage_1 = false;
        var buttonsToShow_1 = 3;
        var isLoading_1 = false;
        var clickedNumber_1 = null;
        var serviceResultsStudentsTableColumnsNames_1 = [];
        var fetchServiceResultsStudentsTableColumnsNames_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.get("/api/services/results/columnsNames/" + parentNodeId_1 + "?currentCulture=" + currentCulture_1)];
                    case 1:
                        response = _a.sent();
                        serviceResultsStudentsTableColumnsNames_1 = response.data;
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var fetchServiceResultsStudentsList_1 = function (page) {
            if (page === void 0) { page = null; }
            return __awaiter(void 0, void 0, void 0, function () {
                var payload, response, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            clickedNumber_1 = page;
                            pagination_2.classList.add('hidden');
                            if (clickedNumber_1) {
                                pageNumber_1 = page;
                            }
                            payload = {
                                parentNodeId: parentNodeId_1,
                                keyword: keyword_1,
                                educationDepartments: educationDepartments_1,
                                positions: positions_1,
                                years: years_1,
                                sortBy: sortBy_1,
                                pageNumber: pageNumber_1,
                                pageSize: pageSize_1,
                                currentCulture: currentCulture_1,
                            };
                            isLoading_1 = true;
                            disableInputs_1();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            response = void 0;
                            if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                                window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                            return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/services/results', payload)];
                        case 2:
                            response = _a.sent();
                            return [3, 5];
                        case 3: return [4, axios_1.default.post('/api/services/results', payload)];
                        case 4:
                            response = _a.sent();
                            _a.label = 5;
                        case 5:
                            serviceResultsStudentsItems_1 = response.data.items;
                            if (serviceResultsStudentsItems_1.length > 0) {
                                pagination_2.classList.remove('hidden');
                            }
                            totalPages_1 = response.data.totalPages;
                            totalCount_1 = response.data.totalCount;
                            hasNextPage_1 = response.data.hasNextPage;
                            hasPreviousPage_1 = response.data.hasPreviousPage;
                            return [3, 8];
                        case 6:
                            error_2 = _a.sent();
                            console.error(error_2);
                            enableInputs_1();
                            return [3, 8];
                        case 7:
                            pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, serviceResultsStudentsItems_1, fetchServiceResultsStudentsList_1);
                            isLoading_1 = false;
                            updateItems_1();
                            enableInputs_1();
                            return [7];
                        case 8: return [2];
                    }
                });
            });
        };
        var disableInputs_1 = function () {
            pagination_2.classList.add('disabled');
            serviceResultsFilters_1.classList.add('disabled');
        };
        var enableInputs_1 = function () {
            pagination_2.classList.remove('disabled');
            serviceResultsFilters_1.classList.remove('disabled');
        };
        var updateItems_1 = function () {
            studentsTableBody_1.innerHTML = '';
            studentsMobileTableBody_1.innerHTML = '';
            serviceResultsStudentsItems_1.forEach(function (item) {
                var rowElement = document.createElement('tr');
                rowElement.className = 'gifted-sublist__table-row';
                rowElement.innerHTML = "\n                    " + (serviceResultsStudentsTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'student/team name'; })
                    ? "<td class=\"service-results__table-data\">\n                                    <div class=\"service-results__table-content flex flex--align-center\">\n                                        <div class=\"service-results__table-images\"> </div>\n                                        <span class=\"service-results__table-content-title\">" + item.students[0].name + "</span>\n                                    </div>\n                                </td>"
                    : '') + "\n    \n                    " + (serviceResultsStudentsTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'project title'; })
                    ? "<td class=\"service-results__table-data\">\n                                    <div\n                                        class=\"service-results__table-content flex flex--align-center\">\n                                        <span class=\"service-results__table-content-title\">" + item.projectTitle + "</span>\n                                    </div>\n                                </td>"
                    : '') + "\n    \n                    " + (serviceResultsStudentsTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'education department'; })
                    ? "<td class=\"service-results__table-data\">\n                                    <div\n                                        class=\"service-results__table-content flex flex--align-center\">\n                                        <span class=\"service-results__table-content-title\">" + item.educationDepartment + "</span>\n                                    </div>\n                                </td>"
                    : '') + "\n    \n                    " + (serviceResultsStudentsTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'school'; })
                    ? "<td class=\"service-results__table-data\">\n                                    <div\n                                        class=\"service-results__table-content flex flex--align-center\">\n                                        <span class=\"service-results__table-content-title\">" + item.school + "</span>\n                                    </div>\n                                </td>"
                    : '') + "\n                    " + (serviceResultsStudentsTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'search entity'; })
                    ? "<td class=\"service-results__table-data\">\n                                    <div\n                                        class=\"service-results__table-content flex flex--align-center\">\n                                        <span class=\"service-results__table-content-title\">" + (item.searchEntity !== null ? item.searchEntity : '-') + "</span>\n                                    </div>\n                                </td>"
                    : '') + "\n                    \n                    " + (serviceResultsStudentsTableColumnsNames_1.some(function (item) { return item.key.toLowerCase() === 'prize'; })
                    ? "<td class=\"service-results__table-data\">\n                                    <div\n                                        class=\"service-results__table-content flex flex--align-center service-results__table-content-icon\">\n                                        <img src=\"/assets/img/img/icons/medal-star.svg\" alt=\"icon\" class=\"gifted-sublist__table-icon\">\n                                        <span class=\"service-results__table-content-title\">" + item.position + "</span>\n                                    </div>\n                                </td>"
                    : '');
                var images = rowElement.querySelector('.service-results__table-images');
                if (images) {
                    item.students
                        .filter(function (std) { return std.image !== null && std.image !== undefined && std.image !== ''; })
                        .forEach(function (student) {
                        var imageItem = document.createElement('img');
                        imageItem.alt = 'student image';
                        imageItem.src = student.image;
                        imageItem.classList.add('service-results__table-image');
                        images.appendChild(imageItem);
                    });
                }
                addMobileRow_1(item);
                studentsTableBody_1.appendChild(rowElement);
            });
        };
        var addMobileRow_1 = function (item) {
            var studentName = serviceResultsStudentsTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'student/team name'; });
            var projectTitle = serviceResultsStudentsTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'project title'; });
            var educationDepartment = serviceResultsStudentsTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'education department'; });
            var school = serviceResultsStudentsTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'school'; });
            var searchEntity = serviceResultsStudentsTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'search entity'; });
            var prize = serviceResultsStudentsTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'prize'; });
            studentsMobileTableBody_1.insertAdjacentHTML('beforeend', "\n            " + (studentName !== undefined
                ? "<tr class=\"gifted-sublist__table-row\">\n                            <th class=\"gifted-sublist__table-header\">" + studentName.value + "</th>\n                            <td class=\"service-results__table-data\">\n                                <div class=\"service-results__table-content flex flex--align-center\">\n                                    <div class=\"service-results__table-images\"> </div>\n                                    <span class=\"service-results__table-content-title\">" + item.students[0].name + "</span>\n                                </div>\n                            </td>\n                        </tr>"
                : '') + "\n    \n            " + (projectTitle !== undefined
                ? "<tr class=\"gifted-sublist__table-row\">\n                            <th class=\"gifted-sublist__table-header\">" + projectTitle.value + "</th>\n                            <td class=\"service-results__table-data\">\n                                <div class=\"service-results__table-content flex flex--align-center\">\n                                    <span class=\"service-results__table-content-title\">" + item.projectTitle + "</span>\n                                </div>\n                            </td>\n                        </tr>"
                : '') + "\n    \n            " + (educationDepartment !== undefined
                ? "<tr class=\"gifted-sublist__table-row\">\n                            <th class=\"gifted-sublist__table-header\">" + educationDepartment.value + "</th>\n                            <td class=\"service-results__table-data\">\n                                <div class=\"service-results__table-content flex flex--align-center\">\n                                    <span class=\"service-results__table-content-title\">" + item.educationDepartment + "</span>\n                                </div>\n                            </td>\n                        </tr>"
                : '') + "\n    \n            " + (prize !== undefined
                ? "<tr class=\"gifted-sublist__table-row\">\n                            <th class=\"gifted-sublist__table-header\">" + prize.value + "</th>\n                            <td class=\"service-results__table-data\">\n                                <div class=\"service-results__table-content flex flex--align-center service-results__table-content-icon\">\n                                    <img src=\"/assets/img/img/icons/medal-star.svg\" alt=\"alt\" class=\"gifted-sublist__table-icon\" />\n                                    <span class=\"service-results__table-content-title\">" + item.position + "</span>\n                                </div>\n                            </td>\n                        </tr>"
                : '') + "\n    \n            " + (school !== undefined
                ? "<tr class=\"gifted-sublist__table-row\">\n                            <th class=\"gifted-sublist__table-header\">" + school.value + "</th>\n                            <td class=\"service-results__table-data\">\n                                <div class=\"service-results__table-content flex flex--align-center\">\n                                    <span class=\"service-results__table-content-title\">" + item.school + "</span>\n                                </div>\n                            </td>\n                        </tr>"
                : '') + "\n    \n            " + (searchEntity !== undefined
                ? "<tr class=\"gifted-sublist__table-row\">\n                            <th class=\"gifted-sublist__table-header\">" + searchEntity.value + "</th>\n                            <td class=\"service-results__table-data\">\n                                <div class=\"service-results__table-content flex flex--align-center\">\n                                    <span class=\"service-results__table-content-title\">" + (item.searchEntity !== null ? item.searchEntity : '-') + "</span>\n                                </div>\n                            </td>\n                        </tr>"
                : ''));
        };
        paginationDropdown_1.addEventListener('change', function () {
            pageSize_1 = +paginationDropdown_1.value;
            pageNumber_1 = 1;
            fetchServiceResultsStudentsList_1();
        });
        nextPageButton.addEventListener('click', function () {
            pageNumber_1++;
            fetchServiceResultsStudentsList_1();
        });
        prevPageButton.addEventListener('click', function () {
            pageNumber_1--;
            fetchServiceResultsStudentsList_1();
        });
        paginationFirst.addEventListener('click', function () {
            pageNumber_1 = 1;
            fetchServiceResultsStudentsList_1();
        });
        paginationLast.addEventListener('click', function () {
            pageNumber_1 = totalPages_1;
            fetchServiceResultsStudentsList_1();
        });
        var timeout_1 = null;
        serviceResultsSearchInput_1.addEventListener('input', function (e) {
            clearTimeout(timeout_1);
            timeout_1 = setTimeout(function () {
                keyword_1 = serviceResultsSearchInput_1.value.trim();
                pageNumber_1 = 1;
                fetchServiceResultsStudentsList_1();
            }, 1000);
        });
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                var checkedRadio = serviceResults.querySelector('input[name="sort-filter"]:checked');
                var checkedRadioValue = checkedRadio.value;
                sortBy_1 = +checkedRadioValue;
                fetchServiceResultsStudentsList_1();
            });
        });
        dropdownFilters.forEach(function (dropdown, index) {
            var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
            if (optionsContainer) {
                var config = { childList: true };
                var callback = function (mutationsList, observer) {
                    var _loop_1 = function (mutation) {
                        if (mutation.type === 'childList') {
                            switch (index) {
                                case 0:
                                    var educationDepartmentsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        educationDepartmentsOptions_1.push(element.textContent);
                                    });
                                    educationDepartments_1 = educationDepartmentsOptions_1;
                                    break;
                                case 1:
                                    var positionsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        positionsOptions_1.push(element.textContent);
                                    });
                                    positions_1 = positionsOptions_1;
                                    break;
                                case 2:
                                    var yearsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        yearsOptions_1.push(element.textContent);
                                    });
                                    years_1 = yearsOptions_1;
                                    break;
                                default:
                                    break;
                            }
                            pageNumber_1 = 1;
                            fetchServiceResultsStudentsList_1();
                        }
                    };
                    for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                        var mutation = mutationsList_1[_i];
                        _loop_1(mutation);
                    }
                };
                var observer = new MutationObserver(callback);
                observer.observe(optionsContainer, config);
            }
        });
        var initializeList = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetchServiceResultsStudentsTableColumnsNames_1()];
                    case 1:
                        _a.sent();
                        return [4, fetchServiceResultsStudentsList_1()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        initializeList();
    }
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"axios":116}],92:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],93:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var serviceTimelineThree = document.querySelector('.service-timeline-three');
if (serviceTimelineThree) {
    var timelineTableBody_1 = serviceTimelineThree.querySelector('.service-timeline-three__table-body');
    var dropdownFilters = serviceTimelineThree.querySelectorAll('.dropdown-filter');
    var parentNodeId_1 = serviceTimelineThree.getAttribute('data-id');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var times = serviceTimelineThree.querySelectorAll('.service-timeline-three__table-content-time');
    var serviceTimeline2Filters_1 = serviceTimelineThree.querySelector('.service-timeline-three__filters');
    if (timelineTableBody_1) {
        var timelineMobileTableBody_1 = serviceTimelineThree.querySelector('.service-timeline-three__table-mobile-body');
        var serviceTimeline2ItemsResults_1 = [];
        var paths_1 = [];
        var sections_1 = [];
        var classes_1 = [];
        var branches_1 = [];
        var isLoading_1 = false;
        var version_1 = 2;
        var serviceTimelineTableColumnsNames_1 = [];
        var fetchServiceTimelineTableColumnsNames = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.get("/api/services/timeline/columnsNames/" + version_1 + "?currentCulture=" + currentCulture_1)];
                    case 1:
                        response = _a.sent();
                        serviceTimelineTableColumnsNames_1 = response.data;
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var fetchServiceTimeline2TableData_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            parentNodeId: parentNodeId_1,
                            paths: paths_1,
                            sections: sections_1,
                            classes: classes_1,
                            branches: branches_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/services/timeline2', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/services/timeline2', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        serviceTimeline2ItemsResults_1 = response.data;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        isLoading_1 = false;
                        updateItems_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        }); };
        var updateItems_1 = function () {
            timelineTableBody_1.innerHTML = '';
            timelineMobileTableBody_1.innerHTML = '';
            serviceTimeline2ItemsResults_1.forEach(function (row) {
                var rowElement = document.createElement('tr');
                rowElement.className = 'service-timeline-three__table-row';
                rowElement.innerHTML = "\n                <td class=\"service-timeline-three__table-data\">\n                    <div class=\"service-timeline-three__table-content flex flex--align-center\">\n                        <span class=\"service-timeline-three__table-content-title\">" + row.path + "</span>\n                    </div>\n                </td>\n                <td class=\"service-timeline-three__table-data\">\n                    <div class=\"service-timeline-three__table-content flex flex--align-center\">\n                        <span class=\"service-timeline-three__table-content-title\">" + row.section + "</span>\n                    </div>\n                </td>\n                <td class=\"service-timeline-three__table-data\">\n                    <div class=\"service-timeline-three__table-content flex flex--align-center\">\n                        <span class=\"service-timeline-three__table-content-title\">" + row.class + "</span>\n                    </div>\n                </td>\n                <td class=\"service-timeline-three__table-data\">\n                    <div class=\"service-timeline-three__table-content flex flex--align-center\">\n                        <span class=\"service-timeline-three__table-content-title\">" + row.branch + "</span>\n                    </div>\n                </td>";
                if (row.timePeriods !== null && row.timePeriods.length !== 0) {
                    row.timePeriods.forEach(function (timePeriod) {
                        var timePeriodElement = document.createElement('td');
                        timePeriodElement.className = 'service-timeline-three__table-data';
                        timePeriodElement.innerHTML = "\n                        <div class=\"service-timeline-three__table-content flex flex--align-center\">\n                              <img src=\"/assets/img/img/icons/clock-grey.svg\" alt=\"clock icon\"\n                                  class=\"service-timeline-three__table-icon\" />\n                              <div class=\"service-timeline-three__table-times flex flex--align-center\">\n                                  <span class=\"service-timeline-three__table-content-time\">" + timePeriod.startTime + "</span>\n                                  <span class=\"service-timeline-three__table-content-title\">-</span>\n                                  <span class=\"service-timeline-three__table-content-time\">" + timePeriod.endTime + "</span>\n                              </div>\n                              <span class=\"service-timeline-three__table-content-title\">" + timePeriod.title + "</span>\n                          </div>";
                        rowElement.appendChild(timePeriodElement);
                    });
                }
                addMobileRow_1(row);
                timelineTableBody_1.appendChild(rowElement);
            });
        };
        var addMobileRow_1 = function (row) {
            var path = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'path'; });
            var section = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'section'; });
            var educationClass = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'class'; });
            var branch = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'branch'; });
            var timePeriodName = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'time period'; });
            timelineMobileTableBody_1.insertAdjacentHTML('beforeend', "\n                " + (path !== undefined
                ? "<tr class=\"service-timeline-three__table-row\">\n                                <th class=\"service-timeline-three__table-header\">" + path.value + "</th>\n                                <td class=\"service-timeline-three__table-data\">\n                                    <div class=\"service-timeline-three__table-content flex flex--column\">\n                                        <span class=\"service-timeline-three__table-content-title\">" + row.path + "</span>\n                                    </div>\n                                </td>\n                            </tr>"
                : '') + "\n        \n                " + (section !== undefined
                ? "<tr class=\"service-timeline-three__table-row\">\n                                <th class=\"service-timeline-three__table-header\">" + section.value + "</th>\n                                <td class=\"service-timeline-three__table-data\">\n                                    <div class=\"service-timeline-three__table-content flex flex--column\">\n                                        <span class=\"service-timeline-three__table-content-title\">" + row.section + "</span>\n                                    </div>\n                                </td>\n                            </tr>"
                : '') + "\n        \n                " + (educationClass !== undefined
                ? "<tr class=\"service-timeline-three__table-row\">\n                                <th class=\"service-timeline-three__table-header\">" + educationClass.value + "</th>\n                                <td class=\"service-timeline-three__table-data\">\n                                    <div class=\"service-timeline-three__table-content flex flex--column\">\n                                        <span class=\"service-timeline-three__table-content-title\">" + row.class + "</span>\n                                    </div>\n                                </td>\n                            </tr>"
                : '') + "\n        \n                " + (branch !== undefined
                ? "<tr class=\"service-timeline-three__table-row\">\n                                <th class=\"service-timeline-three__table-header\">" + branch.value + "</th>\n                                <td class=\"service-timeline-three__table-data\">\n                                    <div class=\"service-timeline-three__table-content flex flex--column\">\n                                        <span class=\"service-timeline-three__table-content-title\">" + row.branch + "</span>\n                                    </div>\n                                </td>\n                            </tr>"
                : ''));
            if (timePeriodName !== undefined) {
                row.timePeriods.forEach(function (timePeriod, index) {
                    timelineMobileTableBody_1.insertAdjacentHTML('beforeend', "<tr class=\"service-timeline-three__table-row\">\n                            <th class=\"service-timeline-three__table-header\">" + (index == 0 ? timePeriodName.value : '') + "</th>\n                            <td class=\"service-timeline-three__table-data\">\n                                <div class=\"service-timeline-three__table-content flex flex--align-center service-timeline-three__table-content-icon flex--wrap\">\n                                    <img src=\"/assets/img/img/icons/clock-grey.svg\" alt=\"clock icon\" class=\"service-timeline-three__table-icon\" />\n                                    <div class=\"service-timeline-three__table-times flex flex--align-center\">\n                                        <span class=\"service-timeline-three__table-content-time\">" + timePeriod.startTime + "</span>\n                                        <span class=\"service-timeline-three__table-content-dash\">-</span>\n                                        <span class=\"service-timeline-three__table-content-time\">" + timePeriod.endTime + "</span>\n                                    </div>\n                                    <span class=\"service-timeline-three__table-content-title\">" + timePeriod.title + "</span>\n                                </div>\n                            </td>\n                        </tr>");
                });
            }
        };
        var disableInputs_1 = function () {
            serviceTimeline2Filters_1.classList.add('disabled');
        };
        var enableInputs_1 = function () {
            serviceTimeline2Filters_1.classList.remove('disabled');
        };
        var getFormattedTime_1 = function (dateStr) {
            if (!dateStr)
                return;
            var date = new Date(dateStr);
            var hour = String(date.getHours()).padStart(2, '0');
            var minutes = String(date.getMinutes()).padStart(2, '0');
            return hour + ":" + minutes;
        };
        dropdownFilters.forEach(function (dropdown, index) {
            var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
            if (optionsContainer) {
                var config = { childList: true };
                var callback = function (mutationsList, observer) {
                    var _loop_1 = function (mutation) {
                        if (mutation.type === 'childList') {
                            switch (index) {
                                case 0:
                                    var pathsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        pathsOptions_1.push(element.textContent);
                                    });
                                    paths_1 = pathsOptions_1;
                                    break;
                                case 1:
                                    var sectionsOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        sectionsOptions_1.push(element.textContent);
                                    });
                                    sections_1 = sectionsOptions_1;
                                    break;
                                case 2:
                                    var classesOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        classesOptions_1.push(element.textContent);
                                    });
                                    classes_1 = classesOptions_1;
                                    break;
                                case 3:
                                    var branchesOptions_1 = [];
                                    Array.from(optionsContainer.children).forEach(function (element) {
                                        branchesOptions_1.push(element.textContent);
                                    });
                                    branches_1 = branchesOptions_1;
                                    break;
                                default:
                                    break;
                            }
                            fetchServiceTimeline2TableData_1();
                        }
                    };
                    for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                        var mutation = mutationsList_1[_i];
                        _loop_1(mutation);
                    }
                };
                var observer = new MutationObserver(callback);
                observer.observe(optionsContainer, config);
            }
        });
        times.forEach(function (time) {
            time.textContent = getFormattedTime_1(time.textContent);
        });
        fetchServiceTimelineTableColumnsNames();
        fetchServiceTimeline2TableData_1();
    }
}
},{"axios":116}],94:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],95:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var formatTime_1 = __importDefault(require("../../../helpers/formatTime"));
var serviceTimelineTwo = document.querySelector(".service-timeline-two");
var html = document.querySelector("html");
var dir = html.getAttribute("dir");
if (serviceTimelineTwo) {
    var dates = serviceTimelineTwo.querySelectorAll(".service-timeline-two__table-content-date");
    var times = serviceTimelineTwo.querySelectorAll(".service-timeline-two__table-content-time");
    var tableRows = serviceTimelineTwo.querySelectorAll(".service-timeline-two__table-row");
    var datesTriggers = serviceTimelineTwo.querySelectorAll(".service-timeline-two__table-content-dates-multi");
    var innerTables_1 = serviceTimelineTwo.querySelectorAll(".service-timeline-two__table-inner");
    dates.forEach(function (date) {
        date.textContent = formatDate_1.default(date.textContent);
    });
    times.forEach(function (time) {
        time.textContent = formatTime_1.default(time.textContent, dir);
    });
    tableRows.forEach(function (row) {
        var height = row.clientHeight;
        row.setAttribute("data-height", height.toString());
    });
    datesTriggers.forEach(function (trigger, index) {
        trigger.addEventListener("click", function (e) {
            var innerTable = innerTables_1[index];
            var icon = trigger.querySelector(".service-timeline-two__table-content-chevron");
            if (innerTable.classList.contains("service-timeline-two__table-inner--active")) {
                innerTable.classList.remove("service-timeline-two__table-inner--active");
                icon.classList.remove("service-timeline-two__table-content-chevron--rotate");
                var activeRow = trigger.parentElement.parentElement.parentElement;
                var activeRowHeight = activeRow.getAttribute("data-height");
                activeRow.style.height = activeRowHeight + "px";
                innerTable.style.top = "0";
            }
            else {
                innerTable.classList.add("service-timeline-two__table-inner--active");
                icon.classList.add("service-timeline-two__table-content-chevron--rotate");
                var activeRow = trigger.parentElement.parentElement.parentElement;
                var activeRowHeight = activeRow.clientHeight;
                var innerTableHeight = innerTable.clientHeight;
                var margin = 16;
                activeRow.style.height = innerTableHeight + activeRowHeight + margin + "px";
                innerTable.style.top = activeRowHeight + "px";
            }
        });
    });
}
},{"../../../helpers/formatDate":7,"../../../helpers/formatTime":8}],96:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var formatTime_1 = __importDefault(require("../../../helpers/formatTime"));
var axios_1 = __importDefault(require("axios"));
var serviceTimeline = document.querySelector('.service-timeline');
var direction = document.querySelector('html').getAttribute('dir');
var currentCulture = document.documentElement.getAttribute('culture');
if (serviceTimeline) {
    var serviceTimelineGrid_1 = serviceTimeline.querySelector('.service-timeline__inner');
    var parentNodeId_1 = serviceTimeline.getAttribute('data-id');
    var serviceTimelineTable_1 = serviceTimeline.querySelector('.service-timeline-tables');
    var timelineItems_1 = [];
    if (serviceTimelineGrid_1) {
        var fetchServiceTimeline = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 2];
                        return [4, axios_1.default.get("https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/services/timeline?nodeId=" + parentNodeId_1 + "&currentCulture=" + currentCulture)];
                    case 1:
                        response = _a.sent();
                        return [3, 4];
                    case 2: return [4, axios_1.default.get("/api/services/timeline?nodeId=" + parentNodeId_1 + "&currentCulture=" + currentCulture)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4:
                        timelineItems_1 = response.data;
                        return [3, 7];
                    case 5:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3, 7];
                    case 6:
                        updateItems_1();
                        initializeDates_1();
                        return [7];
                    case 7: return [2];
                }
            });
        }); };
        var updateItems_1 = function () {
            serviceTimelineGrid_1.innerHTML = '';
            timelineItems_1.forEach(function (item) {
                var itemElement = document.createElement('div');
                itemElement.className = 'service-timeline__item';
                itemElement.innerHTML = "\n                <div class=\"service-timeline__content flex\">\n                  <div class=\"service-timeline__dates flex flex--align-center\">\n                    <div\n                      class=\"service-timeline__date service-timeline__date-from flex flex--column flex--justify-center flex--align-center\"\n                      data-dateFrom=\"" + item.startDate + "\">\n                      <span class=\"service-timeline__date-month service-timeline__date-month-from\"></span>\n                      <span class=\"service-timeline__date-day service-timeline__date-day-from\"></span>\n                      <span class=\"service-timeline__date-year service-timeline__date-year-from\"></span>\n                    </div>\n                    " + (item.endDate !== null
                    ? "<div\n                                class=\"service-timeline__date service-timeline__date-to flex flex--column flex--justify-center flex--align-center\"\n                                data-dateTo=\"" + item.endDate + "\">\n                                <span class=\"service-timeline__date-month service-timeline__date-month-to\"></span>\n                                <span class=\"service-timeline__date-day service-timeline__date-day-to\"></span>\n                                <span class=\"service-timeline__date-year service-timeline__date-year-to\"></span>\n                              </div>"
                    : '') + "\n                  </div>\n                  <div class=\"service-timeline__info flex flex--column\">\n                    <div class=\"service-timeline__item-title flex flex--align-start flex--justify-between\">\n                      " + item.title + "\n                      " + (item.tooltips !== null && item.tooltips.length !== 0
                    ? "<button class=\"service-timeline__item-button\">\n                                  <img src=\"/assets/img/img/icons/info-circle.svg\" alt=\"info circle icon\"\n                                    class=\"service-timeline__item-icon\">\n                                  <ul class=\"service-timeline__item-tooltip \">\n                                    <div class=\"service-timeline__item-tooltip-inner flex flex--column\">\n                                      \n                                    </div>\n                                  </ul>\n                                </button>"
                    : '') + "\n                    </div>\n                    <div class=\"service-timeline__item-text\">\n                      " + item.description + "\n                    </div>\n                  </div>\n                </div>";
                if (item.tooltips !== null && item.tooltips.length !== 0) {
                    var tooltipList_1 = itemElement.querySelector('.service-timeline__item-tooltip-inner');
                    item.tooltips.forEach(function (tootlip) {
                        var tooltipElement = document.createElement('li');
                        tooltipElement.className = 'service-timeline__item-tooltip-row flex flex--align-center';
                        tooltipElement.innerHTML = "\n                          <div class=\"service-timeline__item-tooltip-text\">" + tootlip.educationLevel + "</div>\n                          <div class=\"service-timeline__item-tooltip-date flex flex--align-center\"\n                            data-tooltipDate=\"" + tootlip.date + "\">\n                            <img src=\"/assets/img/img/icons/calendar-thick.svg\" alt=\"calendar icon\"\n                              class=\"service-timeline__item-tooltip-icon\">\n                            <span class=\"service-timeline__item-tooltip-content\">\n                            </span>\n                          </div>\n                          <div class=\"service-timeline__item-tooltip-time flex flex--align-center\"\n                            data-tooltipTime=\"" + tootlip.date + "\">\n                            <img src=\"/assets/img/img/icons/clock-thick.svg\" alt=\"clock icon\"\n                              class=\"service-timeline__item-tooltip-icon\">\n                            <span class=\"service-timeline__item-tooltip-timing\">\n                            </span>\n                          </div>";
                        tooltipList_1.appendChild(tooltipElement);
                    });
                }
                serviceTimelineGrid_1.appendChild(itemElement);
            });
        };
        var initializeDates_1 = function () {
            var serviceTimelineItems = serviceTimeline.querySelectorAll('.service-timeline__item');
            if (serviceTimelineItems.length === 1) {
                serviceTimelineItems[0].classList.add('service-timeline__item--single');
            }
            var setDates = function (month, day, year, arr) {
                month.textContent = arr[1];
                day.textContent = arr[0];
                year.textContent = arr[2];
            };
            serviceTimelineItems.forEach(function (item) {
                var _a;
                var dateFrom = item
                    .querySelector('.service-timeline__date-from')
                    .getAttribute('data-dateFrom');
                var dateTo = (_a = item.querySelector('.service-timeline__date-to')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-dateTo');
                var monthFromElement = item.querySelector('.service-timeline__date-month-from');
                var dayFromElement = item.querySelector('.service-timeline__date-day-from');
                var yearFromElement = item.querySelector('.service-timeline__date-year-from');
                var dateFromArray = formatDate_1.default(dateFrom).split(' ');
                setDates(monthFromElement, dayFromElement, yearFromElement, dateFromArray);
                if (dateTo) {
                    var monthToElement = item.querySelector('.service-timeline__date-month-to');
                    var dayToElement = item.querySelector('.service-timeline__date-day-to');
                    var yearToElement = item.querySelector('.service-timeline__date-year-to');
                    var dateToArray = formatDate_1.default(dateTo).split(' ');
                    setDates(monthToElement, dayToElement, yearToElement, dateToArray);
                }
                var tooltipDateElements = item.querySelectorAll('.service-timeline__item-tooltip-date');
                var tooltipTimeElements = item.querySelectorAll('.service-timeline__item-tooltip-time');
                if (tooltipDateElements.length > 0) {
                    tooltipDateElements.forEach(function (tool) {
                        var content = tool.querySelector('.service-timeline__item-tooltip-content');
                        content.textContent = formatDate_1.default(tool.getAttribute('data-tooltipDate'));
                    });
                }
                if (tooltipTimeElements.length > 0) {
                    tooltipTimeElements.forEach(function (tool, index) {
                        var timing = tool.querySelector('.service-timeline__item-tooltip-timing');
                        if (timing) {
                            timing.textContent = formatTime_1.default(tool.getAttribute('data-tooltipTime'), direction);
                        }
                    });
                }
            });
        };
        fetchServiceTimeline();
    }
    else if (serviceTimelineTable_1) {
        var timelineTableBody_1 = serviceTimelineTable_1.querySelector('.service-timeline-tables__table-body');
        if (timelineTableBody_1) {
            var timelineMobileTableBody_1 = serviceTimelineTable_1.querySelector('.service-timeline-tables__table-mobile-body');
            var version_1 = 1;
            var serviceTimelineTableColumnsNames_1 = [];
            var fetchServiceTimelineTableColumnsNames = function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, axios_1.default.get("/api/services/timeline/columnsNames/" + version_1 + "?currentCulture=" + currentCulture)];
                        case 1:
                            response = _a.sent();
                            serviceTimelineTableColumnsNames_1 = response.data;
                            return [3, 3];
                        case 2:
                            error_2 = _a.sent();
                            console.error(error_2);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            }); };
            var fetchServiceTimelineTableData = function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, 6, 7]);
                            response = void 0;
                            if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                                window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 2];
                            return [4, axios_1.default.get("https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/services/timeline?nodeId=" + parentNodeId_1 + "&currentCulture=" + currentCulture)];
                        case 1:
                            response = _a.sent();
                            return [3, 4];
                        case 2: return [4, axios_1.default.get("/api/services/timeline?nodeId=" + parentNodeId_1 + "&currentCulture=" + currentCulture)];
                        case 3:
                            response = _a.sent();
                            _a.label = 4;
                        case 4:
                            timelineItems_1 = response.data;
                            return [3, 7];
                        case 5:
                            error_3 = _a.sent();
                            console.error(error_3);
                            return [3, 7];
                        case 6:
                            updateTableRows_1();
                            initializeTable_1();
                            return [7];
                        case 7: return [2];
                    }
                });
            }); };
            var updateTableRows_1 = function () {
                timelineTableBody_1.innerHTML = '';
                timelineMobileTableBody_1.innerHTML = '';
                timelineItems_1.forEach(function (row, index) {
                    var itemElement = document.createElement('tr');
                    itemElement.className = 'service-timeline-tables__table-row';
                    itemElement.innerHTML = "\n                    <td class=\"service-timeline-tables__table-data\">\n                        <div class=\"service-timeline-tables__table-content flex flex--column flex--align-start\">\n                            <span class=\"service-timeline-tables__table-content-title\">" + (index + 1) + "</span>\n                        </div>\n                    </td>\n                    <td class=\"service-timeline-tables__table-data\">\n                        <div class=\"service-timeline-tables__table-content flex flex--column flex--align-start\">\n                            <span class=\"service-timeline-tables__table-content-title\">" + row.title + "</span>\n                            <span class=\"service-timeline-tables__table-content-text\">" + row.description + "</span>\n                        </div>\n                    </td>\n                    <td class=\"service-timeline-tables__table-data\">\n                        <div class=\"service-timeline-tables__table-content flex flex--column flex--align-start service-timeline-tables__table-content-icon\">\n                            <div class=\"service-timeline-tables__table-content-dates flex flex--align-center\n                            " + (row.tooltips !== null && row.tooltips.length > 0
                        ? "service-timeline-tables__table-content-dates-multi"
                        : '') + "\">\n                            <div class=\"flex flex--align-center\">\n                                <img src=\"/assets/img/img/icons/calendar-grey.svg\" alt=\"calendar icon\"\n                                    class=\"service-timeline-tables__table-icon\" />\n                                <span class=\"service-timeline-tables__table-content-date\">" + row.startDate + "</span>\n                            </div>\n                            " + (row.endDate !== null
                        ? "<span class=\"service-timeline-tables__table-content-note\">-</span>\n                                        <div class=\"flex flex--align-center\">\n                                            <span class=\"service-timeline-tables__table-content-date\">" + row.endDate + "</span>\n                                        </div>\n                                        "
                        : '') + "\n    \n                            " + (row.tooltips !== null && row.tooltips.length > 0
                        ? "<img src=\"/assets/img/img/chevron-down.svg\" alt=\"chevron icon\" \n                                            class=\"service-timeline-tables__table-content-chevron\" />"
                        : '') + "\n                            </div>\n    \n                            " + (row.tooltips !== null && row.tooltips.length > 0
                        ? "<table class=\"service-timeline-tables__table-inner\">\n                                        <thead>\n                                            <tr class=\"service-timeline-tables__table-row\">\n                                                <th class=\"service-timeline-tables__table-header\">\n                                                </th>\n                                                <th class=\"service-timeline-tables__table-header\">\n                                                </th>\n                                            </tr>\n                                        </thead>\n                                        <tbody>\n                                        </tbody>\n                                    </table>"
                        : '') + "\n                        </div>\n                    </td>\n                    <td class=\"service-timeline-tables__table-data\">\n                        <div class=\"flex flex--align-center\">\n                            <img src=\"/assets/img/img/icons/clock-grey.svg\" alt=\"clock icon\"\n                                class=\"service-timeline-tables__table-icon\" />\n                            <span class=\"service-timeline-tables__table-content-time\">" + row.startDate + "</span>\n                        </div>\n                    </td>\n                    ";
                    if (row.tooltips !== null && row.tooltips.length !== 0) {
                        var innerTableTbody_1 = itemElement.querySelector('.service-timeline-tables__table-inner tbody');
                        row.tooltips.forEach(function (tooltip) {
                            var tooltipElement = document.createElement('tr');
                            tooltipElement.className = 'service-timeline-tables__table-row';
                            tooltipElement.innerHTML = "\n                            <td class=\"service-timeline-tables__table-data\">\n                                <span class=\"service-timeline-tables__table-content-title\">" + tooltip.educationLevel + "</span>\n                            </td>\n                            <td class=\"service-timeline-tables__table-data\">\n                                <div class=\"service-timeline-tables__table-dates flex flex--align-center\">\n                                    <div class=\"service-timeline-tables__table-date flex flex--align-center\">\n                                        <img src=\"/assets/img/img/icons/calendar-grey.svg\" alt=\"calendar icon\"\n                                            class=\"service-timeline-tables__table-date-icon\" />\n                                        <span class=\"service-timeline-tables__table-content-date\">" + tooltip.date + "</span>\n                                    </div>\n                                    <div class=\"service-timeline-tables__table-date flex flex--align-center\">\n                                        <img src=\"/assets/img/img/icons/clock-grey.svg\" alt=\"clock icon\"\n                                            class=\"service-timeline-tables__table-date-icon\" />\n                                        <span class=\"service-timeline-tables__table-content-time\">" + tooltip.date + "</span>\n                                    </div>\n                                </div>\n                            </td>";
                            innerTableTbody_1.appendChild(tooltipElement);
                        });
                    }
                    addMobileRow_1(row, index);
                    timelineTableBody_1.appendChild(itemElement);
                });
            };
            var addMobileRow_1 = function (row, index) {
                var step = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'step'; });
                var mission = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'mission'; });
                var timePeriodName = serviceTimelineTableColumnsNames_1.find(function (item) { return item.key.toLowerCase() === 'time period'; });
                timelineMobileTableBody_1.insertAdjacentHTML('beforeend', "\n                    " + (step !== undefined
                    ? "<tr class=\"service-timeline-tables__table-row\">\n                                    <th class=\"service-timeline-tables__table-header\">" + step.value + "</th>\n                                    <td class=\"service-timeline-tables__table-data\">\n                                        <div class=\"service-timeline-tables__table-content flex flex--column\">\n                                            <span class=\"service-timeline-tables__table-content-title\">\n                                                " + (index + 1) + "\n                                            </span>\n                                        </div>\n                                    </td>\n                                </tr>"
                    : '') + "\n            \n                    " + (mission !== undefined
                    ? "<tr class=\"service-timeline-tables__table-row\">\n                                    <th class=\"service-timeline-tables__table-header\">" + mission.value + "</th>\n                                    <td class=\"service-timeline-tables__table-data\">\n                                        <div class=\"service-timeline-tables__table-content flex flex--column\">\n                                            <span class=\"service-timeline-tables__table-content-title\">" + row.title + "</span>\n                                            <span class=\"service-timeline-tables__table-content-text\">" + row.description + "</span>\n                                        </div>\n                                    </td>\n                                </tr>"
                    : '') + "\n                    \n                    " + (timePeriodName !== undefined
                    ? "<tr class=\"service-timeline-tables__table-row\">\n                                <th class=\"service-timeline-tables__table-header\">" + timePeriodName.value + "</th>\n                                <td class=\"service-timeline-tables__table-data\">\n                                    <div class=\"service-timeline-tables__table-content flex flex--column\">\n                                        <div class=\"service-timeline-tables__table-content-top flex flex--align-center\">\n                                            <img src=\"/assets/img/img/icons/calendar-grey.svg\" alt=\"alt\" class=\"service-timeline-tables__table-icon\" />\n                                            <span class=\"service-timeline-tables__table-content-title\">\n                                                " + formatDate_1.default(row.startDate) + "\n                                                " + (row.endDate !== null ? "- " + formatDate_1.default(row.endDate) : '') + "\n                                            </span>\n                                            <div class=\"service-timeline-tables__table-content flex flex--align-center service-timeline-tables__table-content-icon\" style=\"margin-inline-start: auto;\">\n                                                <img src=\"/assets/img/img/icons/clock-grey.svg\" alt=\"alt\" class=\"service-timeline-tables__table-icon\" />\n                                                <span class=\"service-timeline-tables__table-content-time\">" + row.startDate + "</span>\n                                            </div>\n                                        </div>\n\n                                        " + (row.tooltips !== null && row.tooltips.length !== 0
                        ? " <div class=\"service-timeline-tables__table-content-bottom flex flex--column\">\n                                                    " + row.tooltips.map(function (tooltip) {
                            return "<div class=\"service-timeline-tables__table-content-row flex flex--wrap flex--align-center flex--justify-between\">\n                                                                <div class=\"service-timeline-tables__table-content-left\">" + tooltip.educationLevel + "</div>\n                                                                <div class=\"service-timeline-tables__table-content-right flex flex--wrap flex--align-center\">\n                                                                    <div class=\"service-timeline-tables__table-date flex flex--align-center\">\n                                                                    <img src=\"/assets/img/img/icons/calendar-grey.svg\" alt=\"calendar icon\"\n                                                                        class=\"service-timeline-tables__table-date-icon\" />\n                                                                    <span class=\"service-timeline-tables__table-content-date\">" + tooltip.date + "</span>\n                                                                    </div>\n                                                                    <div class=\"service-timeline-tables__table-date flex flex--align-center\">\n                                                                    <img src=\"/assets/img/img/icons/clock-grey.svg\" alt=\"clock icon\"\n                                                                        class=\"service-timeline-tables__table-date-icon\" />\n                                                                    <span class=\"service-timeline-tables__table-content-time\">" + tooltip.date + "</span>\n                                                                    </div>\n                                                                </div>\n                                                            </div>";
                        }) + "\n                                                </div>"
                        : '') + "\n                                    </div>\n                                </td>\n                            </tr>\n                            "
                    : ''));
            };
            var initializeTable_1 = function () {
                var dates = serviceTimelineTable_1.querySelectorAll('.service-timeline-tables__table-content-date');
                var times = serviceTimelineTable_1.querySelectorAll('.service-timeline-tables__table-content-time');
                var tableRows = serviceTimelineTable_1.querySelectorAll('.service-timeline-tables__table-row');
                var datesTriggers = serviceTimelineTable_1.querySelectorAll('.service-timeline-tables__table-content-dates-multi');
                var innerTables = serviceTimelineTable_1.querySelectorAll('.service-timeline-tables__table-inner');
                dates.forEach(function (date) {
                    date.textContent = formatDate_1.default(date.textContent);
                });
                times.forEach(function (time) {
                    time.textContent = formatTime_1.default(time.textContent, direction);
                });
                tableRows.forEach(function (row) {
                    var height = row.clientHeight;
                    row.setAttribute('data-height', height.toString());
                });
                datesTriggers.forEach(function (trigger, index) {
                    trigger.addEventListener('click', function (e) {
                        var innerTable = innerTables[index];
                        var icon = trigger.querySelector('.service-timeline-tables__table-content-chevron');
                        if (innerTable.classList.contains('service-timeline-tables__table-inner--active')) {
                            innerTable.classList.remove('service-timeline-tables__table-inner--active');
                            icon.classList.remove('service-timeline-tables__table-content-chevron--rotate');
                            var activeRow = trigger.parentElement.parentElement.parentElement;
                            var activeRowHeight = activeRow.getAttribute('data-height');
                            activeRow.style.height = activeRowHeight + "px";
                            innerTable.style.top = '0';
                        }
                        else {
                            innerTable.classList.add('service-timeline-tables__table-inner--active');
                            icon.classList.add('service-timeline-tables__table-content-chevron--rotate');
                            var activeRow = trigger.parentElement.parentElement.parentElement;
                            var activeRowHeight = activeRow.clientHeight;
                            var innerTableHeight = innerTable.clientHeight;
                            var margin = 16;
                            activeRow.style.height = innerTableHeight + activeRowHeight + margin + "px";
                            innerTable.style.top = activeRowHeight + "px";
                        }
                    });
                });
            };
            fetchServiceTimelineTableColumnsNames();
            fetchServiceTimelineTableData();
        }
    }
}
},{"../../../helpers/formatDate":7,"../../../helpers/formatTime":8,"axios":116}],97:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],98:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var addGoogleAnalyticsEventLog_1 = __importDefault(require("../../../helpers/addGoogleAnalyticsEventLog"));
var servicesSliders = document.querySelectorAll('.services-slider');
if (servicesSliders.length > 0) {
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    servicesSliders.forEach(function (slider) {
        var pageTitle = slider.getAttribute('data-page-title');
        slider.querySelectorAll('.services-slider__link').forEach(function (link) {
            link.addEventListener('click', function () {
                addGoogleAnalyticsEventLog_1.default('content_page_view', {
                    page_title: pageTitle,
                    content_type: 'Service',
                    language: currentCulture_1,
                });
            });
        });
        slider.querySelectorAll('.shareButton').forEach(function (button) {
            button.addEventListener('click', function () {
                var link = button.getAttribute('data-link');
                copyToClipboard_1.default(button, link ? new URL(link, window.location.origin).href : window.location.href);
            });
        });
    });
}
},{"../../../helpers/addGoogleAnalyticsEventLog":2,"../../../helpers/copyToClipboard":5}],99:[function(require,module,exports){
var filters = document.querySelectorAll('.single-dropdown-filter');
var direction = document.querySelector('html').getAttribute('dir');
filters.forEach(function (item) {
    var selects = item.querySelectorAll('.single-select');
    selects.forEach(function (select) {
        init(select);
    });
    document.addEventListener('click', function (e) {
        var selects = document.querySelectorAll('.single-select');
        var triggers = document.querySelectorAll('.single-dropdown-filter__trigger');
        for (var i = 0; i < selects.length; i++) {
            if (e) {
                var isClickInside = selects[i].parentElement.parentElement.contains(e.target);
                if (!isClickInside) {
                    var wrapper = selects[i].parentElement.parentElement;
                    var dropdown = wrapper.querySelector('.single-dropdown-filter__dropdown-icon');
                    var autocomplete_list = wrapper.querySelector('.single-dropdown-filter__autocomplete-list');
                    dropdown.classList.remove('active');
                    var multiSelects = document.querySelectorAll('.single-dropdown-filter__multi-select-container');
                    multiSelects[i].classList.remove('single-dropdown-filter__multi-select-container--active');
                    triggers[i].classList.remove('single-dropdown-filter__trigger--active');
                    autocomplete_list.innerHTML = '';
                    addPlaceholder(wrapper);
                }
            }
        }
    });
    var trigger = item.querySelector('.single-dropdown-filter__trigger');
    trigger.addEventListener('click', handleTrigger);
    trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            handleTrigger(e);
        }
    });
    function handleTrigger(e) {
        var wrapper = item.querySelector('.single-dropdown-filter__multi-select-container');
        if (wrapper.classList.contains('single-dropdown-filter__multi-select-container--active')) {
            wrapper.classList.remove('single-dropdown-filter__multi-select-container--active');
            trigger.classList.remove('single-dropdown-filter__trigger--active');
        }
        else {
            wrapper.classList.add('single-dropdown-filter__multi-select-container--active');
            trigger.classList.add('single-dropdown-filter__trigger--active');
        }
        var dropdown = wrapper.querySelector('.single-dropdown-filter__dropdown-icon');
        var event = new Event('click');
        dropdown.dispatchEvent(event);
    }
    function init(element) {
        var filter = item;
        var wrapper = document.createElement('div');
        wrapper.addEventListener('click', clickOnWrapper);
        wrapper.classList.add('single-dropdown-filter__multi-select-container');
        var search_div = document.createElement('div');
        search_div.classList.add('single-dropdown-filter__search-container');
        var input = document.createElement('input');
        input.classList.add('selected-input');
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('tabindex', '0');
        input.addEventListener('keyup', inputChange);
        input.addEventListener('click', openOptions);
        var dropdown_icon = document.createElement('a');
        dropdown_icon.classList.add('single-dropdown-filter__dropdown-icon');
        dropdown_icon.addEventListener('click', clickDropdown);
        var autocomplete_list = document.createElement('ul');
        autocomplete_list.classList.add('single-dropdown-filter__autocomplete-list');
        search_div.appendChild(input);
        search_div.appendChild(autocomplete_list);
        search_div.appendChild(dropdown_icon);
        element.parentNode.replaceChild(wrapper, element);
        wrapper.appendChild(element);
        wrapper.appendChild(search_div);
        addPlaceholder(wrapper);
    }
    function removePlaceholder(wrapper) {
        var input_search = wrapper.querySelector('.selected-input');
        input_search.removeAttribute('placeholder');
    }
    function addPlaceholder(wrapper) {
        var input_search = wrapper.querySelector('.selected-input');
        var tokens = wrapper.querySelectorAll('.single-dropdown-filter__selected-wrapper');
        if (!tokens.length && !(document.activeElement === input_search))
            input_search.setAttribute('placeholder', '---------');
    }
    function inputChange(e) {
        var wrapper = e.target.parentNode.parentNode;
        var select = wrapper.querySelector('select');
        var dropdown = wrapper.querySelector('.single-dropdown-filter__dropdown-icon');
        var input_val = e.target.value;
        if (input_val) {
            dropdown.classList.add('active');
            populateAutocompleteList(select, input_val.trim());
        }
        else {
            dropdown.classList.remove('active');
            var event_1 = new Event('click');
            dropdown.dispatchEvent(event_1);
        }
    }
    function clickOnWrapper(e) {
        var wrapper = e.target;
        if (wrapper.tagName == 'DIV') {
            var input_search = wrapper.querySelector('.selected-input');
            var dropdown = wrapper.querySelector('.single-dropdown-filter__dropdown-icon');
            if (!dropdown.classList.contains('active')) {
                var event_2 = new Event('click');
                dropdown.dispatchEvent(event_2);
            }
            input_search.focus();
            removePlaceholder(wrapper);
        }
    }
    function openOptions(e) {
        var input_search = e.target;
        var wrapper = input_search.parentElement.parentElement;
        var dropdown = wrapper.querySelector('.single-dropdown-filter__dropdown-icon');
        if (!dropdown.classList.contains('active')) {
            var event_3 = new Event('click');
            dropdown.dispatchEvent(event_3);
        }
        e.stopPropagation();
    }
    function clickDropdown(e) {
        var dropdown = e.target;
        var wrapper = dropdown.parentNode.parentNode;
        var input_search = wrapper.querySelector('.selected-input');
        var select = wrapper.querySelector('select');
        dropdown.classList.toggle('active');
        if (dropdown.classList.contains('active')) {
            removePlaceholder(wrapper);
            input_search.focus();
            if (!input_search.value) {
                populateAutocompleteList(select, '', true);
            }
            else {
                populateAutocompleteList(select, input_search.value);
            }
        }
        else {
            clearAutocompleteList(select);
            addPlaceholder(wrapper);
        }
    }
    function clearAutocompleteList(select) {
        var wrapper = select.parentNode;
        var autocomplete_list = wrapper.querySelector('.single-dropdown-filter__autocomplete-list');
        autocomplete_list.innerHTML = '';
    }
    function populateAutocompleteList(select, query, dropdown) {
        if (dropdown === void 0) { dropdown = false; }
        var _a = getOptions(select), autocomplete_options = _a.autocomplete_options, all_options = _a.all_options, option_selected = _a.option_selected;
        var options_to_show;
        if (dropdown)
            options_to_show = autocomplete_options;
        else
            options_to_show = autocomplete(query, autocomplete_options);
        var wrapper = select.parentNode;
        var autocomplete_list = wrapper.querySelector('.single-dropdown-filter__autocomplete-list');
        autocomplete_list.innerHTML = '';
        var result_size = options_to_show.length;
        if (result_size > 0) {
            for (var i = 0; i < result_size; i++) {
                if (options_to_show[i] === '') {
                    var emptyli = document.createElement('li');
                    emptyli.innerText = '';
                    emptyli.classList.add('hidden');
                    if (result_size == 1) {
                        var li = document.createElement('li');
                        li.classList.add('not-cursor');
                        if (direction === 'rtl') {
                            li.innerText = 'لم يتم العثور على خيارات';
                        }
                        else {
                            li.innerText = 'No options found';
                        }
                        autocomplete_list.appendChild(li);
                    }
                }
                else {
                    var li = document.createElement('li');
                    li.innerText = options_to_show[i];
                    li.setAttribute('data-value', options_to_show[i]);
                    li.addEventListener('click', selectOption);
                    autocomplete_list.appendChild(li);
                }
            }
        }
        else {
            var li = document.createElement('li');
            li.classList.add('not-cursor');
            if (direction === 'rtl') {
                li.innerText = 'لم يتم العثور على خيارات';
            }
            else {
                li.innerText = 'No options found';
            }
            autocomplete_list.appendChild(li);
        }
        handleListItems(option_selected);
    }
    function selectOption(e) {
        var filterComponent = item;
        var select = filterComponent.querySelector('.single-select');
        var option_selected = select.querySelector('option:checked');
        option_selected.removeAttribute('selected');
        var wrapper = e.target.parentNode.parentNode.parentNode;
        var input_search = wrapper.querySelector('.selected-input');
        var option = wrapper.querySelector("select option[value=\"" + e.target.dataset.value + "\"]");
        option.setAttribute('selected', '');
        select.dispatchEvent(new Event('change'));
        trigger.innerHTML = e.target.dataset.value;
        if (input_search.value) {
            input_search.value = '';
        }
        input_search.focus();
        var autocomplete_list = wrapper.querySelector('.single-dropdown-filter__autocomplete-list');
        if (!autocomplete_list.children.length) {
            var li = document.createElement('li');
            li.classList.add('not-cursor');
            li.innerText = 'No options found';
            autocomplete_list.appendChild(li);
        }
        var event = new Event('keyup');
        input_search.dispatchEvent(event);
        e.stopPropagation();
    }
    function autocomplete(query, options) {
        if (!query) {
            return options;
        }
        var options_return = [];
        for (var i = 0; i < options.length; i++) {
            if (options[i].toLowerCase().includes(query.toLowerCase())) {
                options_return.push(options[i]);
            }
        }
        return options_return;
    }
    function getOptions(select) {
        var all_options = Array.from(select.querySelectorAll('option')).map(function (el) { return el.value; });
        var option_selected = select.querySelector('option:checked');
        var autocomplete_options = [];
        all_options.forEach(function (option) {
            if (option_selected.value !== option) {
                autocomplete_options.push(option);
            }
        });
        autocomplete_options.sort();
        autocomplete_options = all_options;
        return {
            autocomplete_options: autocomplete_options,
            all_options: all_options,
            option_selected: option_selected.value,
        };
    }
    var handleListItems = function (option) {
        var list = item.querySelectorAll('.single-dropdown-filter__autocomplete-list li');
        list.forEach(function (item) {
            if (option === item.textContent) {
                item.classList.add('item--active');
            }
            else {
                item.classList.remove('item--active');
            }
        });
    };
});
},{}],100:[function(require,module,exports){
var sortFilter = document.querySelector(".sort-filter");
if (sortFilter) {
    var dateRangeFilterTrigger = sortFilter.querySelector(".sort-filter__icon-container");
    var dateRangeInner_1 = sortFilter.querySelector(".sort-filter__inner");
    var dateRangeIcon_1 = sortFilter.querySelector(".sort-filter__icon-container");
    var radioInputLabels = sortFilter.querySelectorAll(".sort-filter__input-container");
    var radioInputs_1 = sortFilter.querySelectorAll(".sort-filter__input");
    var handleTrigger_1 = function () {
        dateRangeInner_1.classList.toggle("sort-filter__inner--active");
        dateRangeIcon_1.classList.toggle("sort-filter__icon-container--active");
    };
    var closeSortFilter_1 = function () {
        dateRangeInner_1.classList.remove("sort-filter__inner--active");
        dateRangeIcon_1.classList.remove("sort-filter__icon-container--active");
    };
    radioInputLabels.forEach(function (label, index) {
        label.addEventListener('click', function (e) {
            radioInputs_1.forEach(function (input) { return input.setAttribute("data-checked", "false"); });
            radioInputs_1[index].setAttribute("data-checked", "true");
        });
        label.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                radioInputs_1.forEach(function (input) { return input.setAttribute("data-checked", "false"); });
                radioInputs_1[index].setAttribute("data-checked", "true");
            }
        });
    });
    dateRangeFilterTrigger.addEventListener("click", function () {
        handleTrigger_1();
    });
    dateRangeFilterTrigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            handleTrigger_1();
        }
    });
    document.addEventListener('click', function (event) {
        if (event.target instanceof Element) {
            if (sortFilter && !sortFilter.contains(event.target)) {
                closeSortFilter_1();
            }
        }
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeSortFilter_1();
        }
    });
}
},{}],101:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initStarRatings = void 0;
var axios_1 = __importDefault(require("axios"));
exports.initStarRatings = function () {
    var starRatingComponents = document.querySelectorAll('.reviews');
    if (starRatingComponents.length > 0) {
        starRatingComponents.forEach(function (item) {
            var starRating = item.querySelector('.star-rating');
            var pageId = parseInt(starRating.getAttribute('data-pageid'));
            var isUserRated = parseInt(starRating.getAttribute('data-user-rated'));
            var avgRating = parseInt(starRating.getAttribute('data-avg-rating'));
            var ratingValue = item.querySelector('.rating-value');
            var totalReviews = item.parentNode.querySelector('.service-details__row-title-bold');
            var stars = item.querySelectorAll('.star');
            var SubmitAPICall = function (rating) {
                CreateRatingCommand(pageId, rating);
                disableStars();
            };
            var handleMouseOver = function (event) {
                var value = event.target.getAttribute('data-value');
                highlightStars(value);
            };
            var handleMouseOut = function () {
                unhighlightStars();
            };
            var handleClick = function (event) {
                var rating = Number(event.target.getAttribute('data-value'));
                SubmitAPICall(rating);
            };
            var highlightStars = function (value) {
                stars.forEach(function (star) {
                    star.classList.toggle('hovered', star.getAttribute('data-value') <= value);
                });
            };
            var unhighlightStars = function () {
                stars.forEach(function (star) {
                    star.classList.remove('hovered');
                });
            };
            var selectStars = function (value) {
                stars.forEach(function (star) {
                    star.classList.toggle('selected', star.getAttribute('data-value') <= value);
                    star.classList.remove('hovered');
                });
            };
            var updateScienceStar = function (rating) {
                var trigger = item.previousElementSibling;
                var unhoveredRatingValue = trigger.querySelector('.star-rating-text');
                if (trigger && trigger.classList.contains('star-rating-trigger')) {
                    if (unhoveredRatingValue) {
                        unhoveredRatingValue.innerHTML = rating.toString();
                    }
                    trigger.parentElement.blur();
                    trigger.firstElementChild.remove();
                    trigger.insertAdjacentHTML('afterbegin', "\n                        <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"#7a5df5\" xmlns=\"http://www.w3.org/2000/svg\">\n                            <path d=\"M13.2703 3.79429L14.9713 7.19642C15.2033 7.67001 15.8218 8.12427 16.3438 8.21126L19.4269 8.72351C21.3986 9.05212 21.8626 10.4826 20.4418 11.8937L18.0448 14.2906C17.6389 14.6966 17.4166 15.4794 17.5422 16.04L18.2285 19.0072C18.7697 21.3558 17.5229 22.2644 15.4449 21.0369L12.555 19.3262C12.0331 19.0169 11.1729 19.0169 10.6413 19.3262L7.75146 21.0369C5.68312 22.2644 4.42665 21.3462 4.9679 19.0072L5.65413 16.04C5.77977 15.4794 5.55747 14.6966 5.15154 14.2906L2.75459 11.8937C1.34348 10.4826 1.79774 9.05212 3.76943 8.72351L6.8526 8.21126C7.36485 8.12427 7.98342 7.67001 8.21539 7.19642L9.91645 3.79429C10.8443 1.94825 12.3521 1.94825 13.2703 3.79429Z\" />\n                        </svg>\n                        ");
                }
            };
            var CreateRatingCommand = function (pageId, rating) { return __awaiter(void 0, void 0, void 0, function () {
                var response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, axios_1.default.post("/api/rating?pageid=" + pageId + "&rating=" + rating)];
                        case 1:
                            response = _a.sent();
                            selectStars(response.data.rating);
                            ratingValue.innerHTML = response.data.rating.toString();
                            if (totalReviews) {
                                totalReviews.innerHTML = response.data.totalRatings.toString();
                            }
                            updateScienceStar(response.data.rating);
                            return [3, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error(error_1);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            }); };
            var disableStars = function () {
                starRating.classList.add('button--disabled');
            };
            if (isUserRated === 0) {
                stars.forEach(function (star) {
                    star.addEventListener('mouseover', handleMouseOver);
                    star.addEventListener('mouseout', handleMouseOut);
                    star.addEventListener('click', handleClick);
                });
            }
            else {
                selectStars(avgRating);
                ratingValue.innerHTML = avgRating.toString();
                disableStars();
            }
        });
    }
};
exports.initStarRatings();
},{"axios":116}],102:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],103:[function(require,module,exports){
google.charts.load('current', { packages: ['corechart'] });
var chartDiv = document.getElementById('bar_chart');
if (chartDiv) {
    var chartwidth_1 = chartDiv.parentElement.clientWidth;
    google.charts.setOnLoadCallback(function () {
        var chartDiv = document.getElementById('bar_chart');
        drawChart(chartDiv);
    });
    var changeChartStyles_1 = function () {
        var chartColumns = chartDiv.getElementsByTagName('rect');
        var chartText = chartDiv.getElementsByTagName('text');
        Array.prototype.forEach.call(chartColumns, function (rect) {
            if (parseFloat(rect.getAttribute('x')) > 0) {
                rect.setAttribute('rx', 5);
                rect.setAttribute('ry', 5);
                rect.style.setProperty('font-size', '10px');
            }
        });
        Array.prototype.forEach.call(chartText, function (text) {
            text.style.setProperty('font-size', '10px');
        });
    };
    function drawChart(element) {
        var chartData = element.getAttribute('data-chartdata');
        if (!chartData) {
            console.error('No data found in data-chartdata attribute');
            return;
        }
        var dataArray = JSON.parse(chartData);
        var data = google.visualization.arrayToDataTable(dataArray);
        var options = {
            width: chartwidth_1,
            height: 300,
            theme: 'material',
            legend: { position: 'bottom' },
            chartArea: {
                backgroundColor: '#F4F4F5',
            },
            vAxis: {
                gridlines: { color: 'transparent' },
                textPosition: 'out',
                baselineColor: 'grey',
                format: 'short',
            },
            hAxis: {
                gridlines: { color: 'transparent' },
                textPosition: 'out',
                baselineColor: 'transparent',
            },
            bar: { groupWidth: '25%' },
            backgroundColor: '#F4F4F5',
            colors: ['#7a5df5', '#2B254B'],
        };
        var chart = new google.visualization.ColumnChart(element);
        var observer = new MutationObserver(changeChartStyles_1);
        google.visualization.events.addListener(chart, 'ready', function () {
            changeChartStyles_1();
            observer.observe(chartDiv, {
                childList: true,
                subtree: true,
            });
        });
        chart.draw(data, options);
    }
}
},{}],104:[function(require,module,exports){
var strategicGoals = document.querySelectorAll('.strategic-goals');
strategicGoals.forEach(function (strategicGoal) {
    if (strategicGoal) {
        var tabs_1 = strategicGoal.querySelectorAll('.strategic-goals__tab');
        var grids_1 = strategicGoal.querySelectorAll('.strategic-goals__grid');
        var images_1 = strategicGoal.querySelectorAll('.strategic-goals__image');
        var activeTab_1 = 0;
        var resetAll_1 = function () {
            tabs_1.forEach(function (tab) { return tab.classList.remove('strategic-goals__tab--active'); });
            grids_1.forEach(function (grid) { return grid.classList.add('hidden'); });
            images_1.forEach(function (image) { return image.classList.add('hidden'); });
        };
        tabs_1.forEach(function (tab, index) {
            tab.addEventListener('click', function () {
                activeTab_1 = index;
                resetAll_1();
                tabs_1[activeTab_1].classList.add('strategic-goals__tab--active');
                grids_1[activeTab_1].classList.remove('hidden');
                images_1[activeTab_1].classList.remove('hidden');
            });
        });
    }
});
},{}],105:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var shareButtons = document.querySelectorAll(".shareButton");
if (shareButtons && shareButtons.length > 0) {
    shareButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            copyToClipboard_1.default(button);
        });
    });
}
},{"../../../helpers/copyToClipboard":5}],106:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var successStoriesList = document.querySelector('.stories-list');
if (successStoriesList) {
    var storiesGrid_1 = successStoriesList.querySelector('.stories-list__grid');
    var storiesFilters_1 = successStoriesList.querySelector('.stories-list__search');
    var storiesListSearchInput_1 = successStoriesList.querySelector('.stories-list__search-input');
    var dropdownFilters = successStoriesList.querySelectorAll('.dropdown-filter');
    var nextPageButton = successStoriesList.querySelector('.pagination__page-next');
    var prevPageButton = successStoriesList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = successStoriesList.querySelector('.pagination__dropdown');
    var paginationLast = successStoriesList.querySelector('.pagination__page-last');
    var paginationFirst = successStoriesList.querySelector('.pagination__page-first');
    var pagination_2 = successStoriesList.querySelector('.pagination');
    var radios = successStoriesList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var successStoriesCarousel_1 = document.querySelector('.stories-list__carousel-inner');
    var direction_1 = document.querySelector('html').getAttribute('dir');
    if (successStoriesCarousel_1) {
        var generateBullets = function (carousel) {
            var cards = carousel.querySelectorAll('.stories-list__carousel-card');
            var bulletWrapper = carousel.querySelectorAll('.glide__bullets');
            var imageBulletWrapper = carousel.querySelectorAll('.glide__bullets--images');
            if (cards.length > 1) {
                bulletWrapper.forEach(function (wrapper) {
                    cards.forEach(function () {
                        var button = document.createElement('button');
                        button.className = 'glide__bullet';
                        wrapper.appendChild(button);
                    });
                });
            }
            else {
                var controls = successStoriesCarousel_1.querySelector('.stories-list__controls');
                controls.classList.add('hidden');
            }
            imageBulletWrapper.forEach(function (wrapper) {
                cards.forEach(function (card, index) {
                    var button = document.createElement('button');
                    button.className = 'glide__bullet glide__bullet--image';
                    var backgroundImage = card.style.backgroundImage;
                    var img = document.createElement('img');
                    img.src = backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];
                    button.appendChild(img);
                    button.addEventListener('click', function () {
                        glide_2.go("=" + index);
                    });
                    wrapper.appendChild(button);
                });
            });
        };
        var glideSettings = {
            type: 'slider',
            perView: 1,
            rewind: true,
            bound: true,
            direction: direction_1 || 'ltr',
        };
        var glide_2 = new glide_1.default(successStoriesCarousel_1, glideSettings);
        glide_2.mount();
        generateBullets(successStoriesCarousel_1);
        glide_2.on('move.after', function () {
            var carouselCards = successStoriesCarousel_1.querySelectorAll('.stories-list__carousel-card');
            carouselCards.forEach(function (card) {
                var bullets = card.querySelectorAll('.glide__bullet');
                var imageBullets = card.querySelectorAll('.glide__bullet--image');
                var currentIndex = glide_2.index;
                var imageContainer = card.querySelector('.glide__bullets--images');
                if (direction_1 === 'rtl') {
                    imageContainer.scrollLeft = imageContainer.scrollWidth;
                    imageContainer.scrollLeft -= 103 * currentIndex;
                }
                else {
                    imageContainer.scrollLeft = 0;
                    imageContainer.scrollLeft += 103 * currentIndex;
                }
                bullets.forEach(function (bullet, index) {
                    bullet.classList.toggle('glide__bullet--active', index === currentIndex);
                });
                imageBullets.forEach(function (bullet, index) {
                    bullet.classList.toggle('glide__bullet--image--active', index === currentIndex);
                });
            });
        });
    }
    var storiesCards_1 = [];
    var keyword_1 = '';
    var fields_1 = [];
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchStories_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            fields: fields_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/successStories', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/successStories', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        storiesCards_1 = response.data.items;
                        if (storiesCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, storiesCards_1, fetchStories_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        storiesGrid_1.innerHTML = '';
        storiesCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.className = 'fade-in';
            cardElement.innerHTML = "\n            <div class='stories-list__card flex'>\n                <img src='" + card.media + "' alt='image' class='stories-list__card-image' />\n                <div class='stories-list__card-right flex flex--column'>\n                    <div class='stories-list__card-title'>" + card.title + "</div>\n                    <div class='stories-list__card-details'>" + card.content + "</div>\n                    <div class='stories-list__card-views-container flex flex--align-center flex--justify-end'>\n                        <div class='stories-list__card-views'>" + card.viewsCount + "</div>\n                        <img src='/assets/img/img/icons/eye.svg' alt='views-icon' class='stories-list__card-eye' />\n                    </div>\n                </div>\n            </div>\n        ";
            storiesGrid_1.appendChild(cardElement);
        });
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        storiesFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        storiesFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchStories_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchStories_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchStories_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchStories_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchStories_1();
    });
    var timeout_1 = null;
    storiesListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = storiesListSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchStories_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = successStoriesList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchStories_1();
        });
    });
    dropdownFilters.forEach(function (dropdown, index) {
        var optionsContainer = dropdown.querySelector('.dropdown-filter__button-container');
        if (optionsContainer) {
            var config = { childList: true };
            var callback = function (mutationsList, observer) {
                var _loop_1 = function (mutation) {
                    if (mutation.type === 'childList') {
                        switch (index) {
                            case 0:
                                var fieldsOptions_1 = [];
                                Array.from(optionsContainer.children).forEach(function (element) {
                                    fieldsOptions_1.push(element.textContent);
                                });
                                fields_1 = fieldsOptions_1;
                                break;
                            default:
                                break;
                        }
                        pageNumber_1 = 1;
                        fetchStories_1();
                    }
                };
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    _loop_1(mutation);
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(optionsContainer, config);
        }
    });
    fetchStories_1();
    var shareButtons = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
    var showToastModal_1 = function (button) {
        var toast = document.createElement('div');
        toast.className = 'toast';
        toast.textContent = currentCulture_1 === 'ar' ? 'تم نسخ الرابط!' : 'Link copied to clipboard!';
        var parentDiv = button.closest('div').parentElement.parentElement;
        parentDiv.appendChild(toast);
        var toastWidth = 150;
        var right = window.scrollX - toastWidth / 2;
        toast.style.top = '-5px';
        if (currentCulture_1 === 'ar') {
            toast.style.left = right + "px";
        }
        else {
            toast.style.right = right + "px";
        }
        setTimeout(function () {
            toast.classList.add('show');
        }, 100);
        setTimeout(function () {
            toast.classList.remove('show');
            setTimeout(function () {
                button.closest('div').parentElement.parentElement.removeChild(toast);
            }, 500);
        }, 3000);
    };
    document.addEventListener('DOMContentLoaded', function () {
        var openButtons = document.querySelectorAll('.stories-list__modal-open');
        var closeButtons = document.querySelectorAll('.stories-list__modal-close');
        var modal = document.querySelector('.stories-list__modal');
        var modalCount = document.querySelector('.stories-list__modal-count');
        var modalTitle = document.querySelector('.stories-list__modal-title');
        var modalVideo = document.querySelector('.stories-list__modal-video');
        openButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                var _a, _b, _c;
                var cardId = button.getAttribute('data-card-id');
                var card = document.querySelector(".stories-list__carousel-card[data-card-id='" + cardId + "']");
                if (!card)
                    return;
                var cardTitle = ((_a = card.querySelector('.stories-list__carousel-card-title')) === null || _a === void 0 ? void 0 : _a.textContent) || '';
                var embeddedVideo = ((_b = card.querySelector('.stories-list__carousel-card-video')) === null || _b === void 0 ? void 0 : _b.textContent) || '';
                var embeddedVideoCount = ((_c = card.querySelector('.stories-list__carousel-card-count')) === null || _c === void 0 ? void 0 : _c.textContent) || '';
                modalCount.textContent = embeddedVideoCount;
                modalTitle.textContent = cardTitle;
                modalVideo.src = embeddedVideo;
                modal.showModal();
                var shareButtonModal = document.querySelector('.shareButtonModal');
                if (shareButtonModal) {
                    shareButtonModal.addEventListener('click', function (e) {
                        navigator.clipboard.writeText(window.location.href);
                        showToastModal_1(shareButtonModal);
                    });
                }
            });
        });
        closeButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                modal.close();
                modalVideo.src = '';
            });
        });
        if (modal) {
            modal.addEventListener('click', function (event) {
                if (event.target === modal) {
                    modal.close();
                    modalVideo.src = '';
                }
            });
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    modal.close();
                    modalVideo.src = '';
                }
            });
        }
    });
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"@glidejs/glide":115,"axios":116}],107:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],108:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("../../../helpers/formatDate"));
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var pagination_1 = require("../pagination/pagination");
var axios_1 = __importDefault(require("axios"));
var tenderList = document.querySelector('.tender-list');
if (tenderList) {
    var tendersItems_1 = tenderList.querySelector('.tender-list__items');
    var tendersFilters_1 = tenderList.querySelector('.tender-list__filters');
    var tenderListSearchInput_1 = tenderList.querySelector('.tender-list__search-input');
    var nextPageButton = tenderList.querySelector('.pagination__page-next');
    var prevPageButton = tenderList.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = tenderList.querySelector('.pagination__dropdown');
    var paginationLast = tenderList.querySelector('.pagination__page-last');
    var paginationFirst = tenderList.querySelector('.pagination__page-first');
    var pagination_2 = tenderList.querySelector('.pagination');
    var radios = tenderList.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var tenderCards_1 = [];
    var keyword_1 = '';
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +paginationDropdown_1.value;
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var tenderCardSettings_1 = {
        availableText: '',
        expiredText: '',
        offeringDateText: '',
        submissionDeadlineText: '',
        lastDateToReceiveQuestionsText: '',
        responseDateText: '',
        downloadButtonText: '',
        noTendersText: '',
    };
    var fetchEventCardSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get("/api/tenders/cardsettings?currentCulture=" + currentCulture_1)];
                case 1:
                    response = _a.sent();
                    tenderCardSettings_1 = response.data;
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchTenders_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/tenders', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/tenders', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        tenderCards_1 = response.data.items;
                        if (tenderCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_2 = _a.sent();
                        console.error(error_2);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, tenderCards_1, fetchTenders_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        tendersItems_1.innerHTML = '';
        if (tenderCards_1.length === 0) {
            tendersItems_1.innerHTML = "<div class=\"flex\" style=\"align-self: center;\">" + tenderCardSettings_1.noTendersText + "</div>";
        }
        else {
            tenderCards_1.forEach(function (card) {
                var cardElement = document.createElement('div');
                cardElement.className = 'tender-list__item flex flex--column flex--align-startn';
                cardElement.innerHTML = "\n            <span\n                class=\"tender-list__item-tag " + (!card.isAvailable ? 'tender-list__item-tag--red' : '') + "\">" + (card.isAvailable ? tenderCardSettings_1.availableText : tenderCardSettings_1.expiredText) + "</span>\n            <div class=\"tender-list__top flex\">\n              <div class=\"tender-list__image-container flex flex--align-center flex--justify-center\">\n                <img src=\"/assets/img/img/pdf-image.svg\" alt=\"pdf image\" class=\"tender-list__image\">\n              </div>\n              <div class=\"tender-list__content flex flex--column\">\n                <p class=\"tender-list__title\">" + card.title + "</p>\n                <p class=\"tender-list__text\">" + card.description + "</p>\n              </div>\n            </div>\n            <div class=\"tender-list__middle\">\n              <div class=\"tender-list__info flex flex--align-center\">\n                <img src=\"/assets/img/img/calendar-icon-yellow.svg\" alt=\"calendar icon yellow\"\n                  class=\"tender-list__info-icon\">\n                <span class=\"tender-list__info-text\">" + tenderCardSettings_1.offeringDateText + "</span>\n                <span class=\"tender-list__info-text\">" + formatDate_1.default(card.offeringDate) + "</span>\n              </div>\n              <div class=\"tender-list__info flex flex--align-center\">\n                <img src=\"/assets/img/img/calendar-icon-red.svg\" alt=\"calendar icon red\" class=\"tender-list__info-icon\">\n                <span class=\"tender-list__info-text\">" + tenderCardSettings_1.submissionDeadlineText + "</span>\n                <span class=\"tender-list__info-text\">" + formatDate_1.default(card.submissionDeadline) + "</span>\n              </div>\n              <div class=\"tender-list__info flex flex--align-center\">\n                <img src=\"/assets/img/img/calendar-icon-grey.svg\" alt=\"calendar icon grey\"\n                  class=\"tender-list__info-icon\">\n                <span class=\"tender-list__info-text\">" + tenderCardSettings_1.lastDateToReceiveQuestionsText + "</span>\n                <span class=\"tender-list__info-text\">" + formatDate_1.default(card.lastDateToReceiveQuestions) + "</span>\n              </div>\n              <div class=\"tender-list__info flex flex--align-center\">\n                <img src=\"/assets/img/img/calendar-icon-grey.svg\" alt=\"calendar icon grey\"\n                  class=\"tender-list__info-icon\">\n                <span class=\"tender-list__info-text\">" + tenderCardSettings_1.responseDateText + "</span>\n                <span class=\"tender-list__info-text\">" + formatDate_1.default(card.responseDate) + "</span>\n              </div>\n            </div>\n            <div class=\"tender-list__bottom flex flex--wrap flex--align-center\" data-file=\"" + card.pdfLink + "\">\n              <button\n                  class=\"button button--secondary-long tender-list__item-button flex flex--justify-center flex--align-center\">\n                  <span class=\"button__label\">" + tenderCardSettings_1.downloadButtonText + "</span>\n                  <img src=\"/assets/img/img/arrow-top-left-dark.svg\" class=\"button__image\">\n              </button>\n              <div class=\"tender-list__buttons flex flex--align-center\">\n                <a href=\"" + card.pdfLink + "\" draggable=\"false\" download class=\"button button--round-tiny tender-list__button tender-list__button-download flex flex--justify-center flex--align-center\">\n                  <img src=\"/assets/img/img/download-icon-dark.svg\" alt=\"download icon\" class=\"button__image\">\n                </a>\n                <button\n                  class=\"button button--round-tiny shareButton tender-list__button tender-list__button-share flex flex--justify-center flex--align-center\">\n                  <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                </button>\n              </div>\n            </div>";
                tendersItems_1.appendChild(cardElement);
            });
        }
        var fileButtons = tenderList.querySelectorAll('.tender-list__item-button');
        fileButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                var fileUrl = button.parentElement.getAttribute('data-file');
                if (fileUrl) {
                    window.open(fileUrl, '_blank');
                }
            });
        });
        var shareButtons = tenderList.querySelectorAll('.shareButton');
        if (shareButtons && shareButtons.length > 0) {
            shareButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    copyToClipboard_1.default(button);
                });
            });
        }
    };
    var disableInputs_1 = function () {
        pagination_2.classList.add('disabled');
        tendersFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2.classList.remove('disabled');
        tendersFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchTenders_1();
    });
    nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchTenders_1();
    });
    prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchTenders_1();
    });
    paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchTenders_1();
    });
    paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchTenders_1();
    });
    var timeout_1 = null;
    tenderListSearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = tenderListSearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchTenders_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = tenderList.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchTenders_1();
        });
    });
    fetchEventCardSettings();
    fetchTenders_1();
}
var shareButtons = document.querySelectorAll('.shareButton');
if (shareButtons && shareButtons.length > 0) {
    shareButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            copyToClipboard_1.default(button);
        });
    });
}
},{"../../../helpers/copyToClipboard":5,"../../../helpers/formatDate":7,"../pagination/pagination":71,"axios":116}],109:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],110:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
document.addEventListener('DOMContentLoaded', function () {
    var videoDetails = document.querySelector('.video-gallery-details');
    var videoPlayer = document.querySelectorAll('.video-gallery-details__video-container');
    if (videoDetails) {
        var youtubeVideoCards = videoDetails.querySelectorAll('.video-inline-card--youtube');
        youtubeVideoCards.forEach(function (card) {
            var playerElement = card.querySelector("#player");
            if (playerElement) {
                var player = new window['YT'].Player(playerElement, {
                    events: {
                        'onReady': function (event) {
                            event.target.mute();
                            card.addEventListener("mouseenter", function () {
                                event.target.playVideo();
                            });
                            card.addEventListener("mouseleave", function () {
                                event.target.pauseVideo();
                                event.target.seekTo(0);
                            });
                        }
                    }
                });
            }
        });
    }
    if (videoPlayer) {
        videoPlayer.forEach(function (card) {
            var video = card.querySelector('.video-gallery-details__video-player');
            var playButton = card.querySelector('.video-gallery-details__video-play');
            card.addEventListener('click', function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!video.paused) return [3, 2];
                            return [4, video.play()];
                        case 1:
                            _a.sent();
                            playButton.style.opacity = '0';
                            video.controls = true;
                            return [3, 3];
                        case 2:
                            video.pause();
                            playButton.style.opacity = '1';
                            video.controls = false;
                            _a.label = 3;
                        case 3: return [2];
                    }
                });
            }); });
        });
    }
    var shareButtons = document.querySelectorAll(".shareButton");
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
});
},{"../../../helpers/copyToClipboard":5}],111:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("../pagination/pagination");
var copyToClipboard_1 = __importDefault(require("../../../helpers/copyToClipboard"));
var axios_1 = __importDefault(require("axios"));
var videosGallery = document.querySelector('.video-gallery');
if (videosGallery) {
    var videosGrid_1 = videosGallery.querySelector('.video-gallery__grid');
    var videosFilters_1 = videosGallery.querySelector('.video-gallery__filters');
    var videosGallerySearchInput_1 = videosGallery.querySelector('.input--search');
    var nextPageButton = videosGallery.querySelector('.pagination__page-next');
    var prevPageButton = videosGallery.querySelector('.pagination__page-prev');
    var paginationDropdown_1 = videosGallery.querySelector('.pagination__dropdown');
    var paginationLast = videosGallery.querySelector('.pagination__page-last');
    var paginationFirst = videosGallery.querySelector('.pagination__page-first');
    var pagination_2 = videosGallery.querySelector('.pagination');
    var radios = videosGallery.querySelectorAll('.sort-filter__input');
    var currentCulture_1 = document.documentElement.getAttribute('culture');
    var videosCards_1 = [];
    var keyword_1 = '';
    var sortBy_1 = 1;
    var pageNumber_1 = 1;
    var pageSize_1 = +(paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.value);
    var totalPages_1 = 0;
    var totalCount_1 = 0;
    var hasNextPage_1 = false;
    var hasPreviousPage_1 = false;
    var buttonsToShow_1 = 3;
    var isLoading_1 = false;
    var clickedNumber_1 = null;
    var fetchVideosGallery_1 = function (page) {
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clickedNumber_1 = page;
                        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('hidden');
                        if (clickedNumber_1) {
                            pageNumber_1 = page;
                        }
                        payload = {
                            keyword: keyword_1,
                            sortBy: sortBy_1,
                            pageNumber: pageNumber_1,
                            pageSize: pageSize_1,
                            currentCulture: currentCulture_1,
                        };
                        isLoading_1 = true;
                        disableInputs_1();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        response = void 0;
                        if (!((window.location.hostname === 'localhost' && window.location.port === '2000') ||
                            window.location.hostname === 'mawhiba-fractal.netlify.app')) return [3, 3];
                        return [4, axios_1.default.post('https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/videosgallery', payload)];
                    case 2:
                        response = _a.sent();
                        return [3, 5];
                    case 3: return [4, axios_1.default.post('/api/videosgallery', payload)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        videosCards_1 = response.data.items;
                        if (videosCards_1.length > 0) {
                            pagination_2.classList.remove('hidden');
                        }
                        totalPages_1 = response.data.totalPages;
                        totalCount_1 = response.data.totalCount;
                        hasNextPage_1 = response.data.hasNextPage;
                        hasPreviousPage_1 = response.data.hasPreviousPage;
                        return [3, 8];
                    case 6:
                        error_1 = _a.sent();
                        console.error(error_1);
                        enableInputs_1();
                        return [3, 8];
                    case 7:
                        pagination_1.updatePaginationButtons(totalPages_1, hasPreviousPage_1, hasNextPage_1, pageNumber_1, pageSize_1, totalCount_1, buttonsToShow_1, videosCards_1, fetchVideosGallery_1);
                        isLoading_1 = false;
                        updateCards_1();
                        enableInputs_1();
                        CreatePlayEventListeners_1();
                        return [7];
                    case 8: return [2];
                }
            });
        });
    };
    var updateCards_1 = function () {
        videosGrid_1.innerHTML = '';
        videosCards_1.forEach(function (card) {
            var cardElement = document.createElement('a');
            cardElement.setAttribute('href', card.link);
            cardElement.className = 'video-inline-card flex flex--column';
            var formattedYoutubeVideoUrl;
            var videoContainer;
            if (card.youTubeID) {
                formattedYoutubeVideoUrl = "https://www.youtube.com/embed/" + card.youTubeID + "?enablejsapi=1;";
                cardElement.classList.add('video-inline-card--youtube');
                videoContainer = "\n                    <div class='video-inline-card__video-container video-inline-card__video-container-youtube'>\n                        <iframe id=\"player\" width=\"385\" height=\"332\" src=\"" + formattedYoutubeVideoUrl + "\" frameborder=\"0\" allowfullscreen muted sandbox=\"allow-scripts allow-modals allow-same-origin allow-presentation\"></iframe>\n                        <img src=\"/assets/img/img/icons/play-button--white.svg\" alt=\"play button\" class='video-inline-card__play'>\n                        <div class=\"video-inline-card__overlay\"></div>\n                    </div>\n                ";
            }
            else {
                videoContainer = "\n                    <div class='video-inline-card__video-container'>\n                        <video src='" + card.videoURL + "' playsinline disableRemotePlayback class='video-inline-card__video'></video>\n                        <img src=\"/assets/img/img/icons/play-button--white.svg\" alt=\"play button\" class='video-inline-card__play'>\n                        <div class=\"video-inline-card__overlay\"></div>\n                    </div>\n                ";
            }
            cardElement.innerHTML = "\n            <div class='video-inline-card__tooltip'>" + card.title + "</div>\n            <div class='video-inline-card__border flex flex--justify-between'>\n                <a href=\"" + card.videoURL + "\" draggable=\"false\" download class=\"button button--round-small video-inline-card__download flex flex--justify-center flex--align-center\">\n                    <img src=\"/assets/img/img/icons/download--blue-bg.svg\" alt=\"download icon\" class=\"button__image\">\n                </a>\n                <div class='video-inline-card__icons flex flex--align-center flex--justify-center'>\n                    <div class=\"flex\">\n                        <img src='/assets/img/img/icons/eye.svg' alt='views icon' class='video-inline-card__eye' />\n                        <span class='video-inline-card__count'>" + card.views + "</span>\n                    </div>\n                    <button\n                        class=\"button button--round-small video-inline-card__icon flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/heart-icon.svg\" alt=\"heart icon\" class=\"button__image\">\n                    </button>\n                    <button\n                        class=\"button button--round-small video-inline-card__icon flex flex--justify-center flex--align-center\">\n                        <img src=\"/assets/img/img/share-icon.svg\" alt=\"share icon\" class=\"button__image\">\n                    </button>\n                </div>\n            </div>";
            var border = cardElement.querySelector('.video-inline-card__border');
            border.insertAdjacentHTML('beforebegin', videoContainer);
            videosGrid_1.appendChild(cardElement);
        });
    };
    var CreatePlayEventListeners_1 = function () {
        var videoCards = videosGallery.querySelectorAll('.video-inline-card');
        if (videoCards) {
            var mobileBreakpoint_1 = '(max-width: 767px)';
            videoCards.forEach(function (card) {
                var video = card.querySelector('.video-inline-card__video');
                var playButton = card.querySelector('.video-inline-card__play');
                if (card.classList.contains('video-inline-card--youtube')) {
                    var playerElement = card.querySelector("#player");
                    if (playerElement) {
                        var player = new window['YT'].Player(playerElement, {
                            events: {
                                'onReady': function (event) {
                                    event.target.mute();
                                    card.addEventListener("mouseenter", function () {
                                        event.target.playVideo();
                                    });
                                    card.addEventListener("mouseleave", function () {
                                        event.target.pauseVideo();
                                        event.target.seekTo(0);
                                    });
                                }
                            }
                        });
                    }
                }
                else {
                    card.addEventListener('click', function () {
                        if (window.matchMedia(mobileBreakpoint_1).matches) {
                            if (video.paused) {
                                video.play();
                                playButton.style.opacity = '0';
                            }
                            else {
                                video.pause();
                                playButton.style.opacity = '1';
                            }
                        }
                    });
                    card.addEventListener('mouseenter', function () {
                        if (!window.matchMedia(mobileBreakpoint_1).matches) {
                            video.play();
                        }
                    });
                    card.addEventListener('mouseleave', function () {
                        if (!window.matchMedia(mobileBreakpoint_1).matches) {
                            video.pause();
                            video.currentTime = 0;
                        }
                    });
                }
            });
        }
    };
    var disableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.add('disabled');
        videosFilters_1 === null || videosFilters_1 === void 0 ? void 0 : videosFilters_1.classList.add('disabled');
    };
    var enableInputs_1 = function () {
        pagination_2 === null || pagination_2 === void 0 ? void 0 : pagination_2.classList.remove('disabled');
        videosFilters_1.classList.remove('disabled');
    };
    paginationDropdown_1 === null || paginationDropdown_1 === void 0 ? void 0 : paginationDropdown_1.addEventListener('change', function () {
        pageSize_1 = +paginationDropdown_1.value;
        pageNumber_1 = 1;
        fetchVideosGallery_1();
    });
    nextPageButton === null || nextPageButton === void 0 ? void 0 : nextPageButton.addEventListener('click', function () {
        pageNumber_1++;
        fetchVideosGallery_1();
    });
    prevPageButton === null || prevPageButton === void 0 ? void 0 : prevPageButton.addEventListener('click', function () {
        pageNumber_1--;
        fetchVideosGallery_1();
    });
    paginationFirst === null || paginationFirst === void 0 ? void 0 : paginationFirst.addEventListener('click', function () {
        pageNumber_1 = 1;
        fetchVideosGallery_1();
    });
    paginationLast === null || paginationLast === void 0 ? void 0 : paginationLast.addEventListener('click', function () {
        pageNumber_1 = totalPages_1;
        fetchVideosGallery_1();
    });
    var timeout_1 = null;
    videosGallerySearchInput_1 === null || videosGallerySearchInput_1 === void 0 ? void 0 : videosGallerySearchInput_1.addEventListener('input', function (e) {
        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
            keyword_1 = videosGallerySearchInput_1.value.trim();
            pageNumber_1 = 1;
            fetchVideosGallery_1();
        }, 1000);
    });
    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            var checkedRadio = videosGallery.querySelector('input[name="sort-filter"]:checked');
            var checkedRadioValue = checkedRadio.value;
            sortBy_1 = +checkedRadioValue;
            fetchVideosGallery_1();
        });
    });
    fetchVideosGallery_1();
    var shareButtons = document.querySelectorAll(".shareButton");
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                copyToClipboard_1.default(button);
            });
        });
    }
}
},{"../../../helpers/copyToClipboard":5,"../pagination/pagination":71,"axios":116}],112:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],113:[function(require,module,exports){
document.addEventListener('DOMContentLoaded', function () {
    var videoCards = document.querySelectorAll('.video-inline-card');
    if (videoCards) {
        var mobileBreakpoint_1 = '(max-width: 767px)';
        videoCards.forEach(function (card) {
            if (card.classList.contains('video-inline-card--youtube')) {
                return;
            }
            else {
                var video_1 = card.querySelector('.video-inline-card__video');
                var playButton_1 = card.querySelector('.video-inline-card__play');
                card.addEventListener('click', function () {
                    if (window.matchMedia(mobileBreakpoint_1).matches) {
                        if (video_1.paused) {
                            video_1.play();
                            playButton_1.style.opacity = '0';
                        }
                        else {
                            video_1.pause();
                            playButton_1.style.opacity = '1';
                        }
                    }
                });
                card.addEventListener('mouseenter', function () {
                    if (!window.matchMedia(mobileBreakpoint_1).matches) {
                        video_1.play();
                    }
                });
                card.addEventListener('mouseleave', function () {
                    if (!window.matchMedia(mobileBreakpoint_1).matches) {
                        video_1.pause();
                        video_1.currentTime = 0;
                    }
                });
            }
        });
        var videoButtons = document.querySelectorAll('.video-inline-card__download');
        videoButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                var fileUrl = button.parentElement.getAttribute('data-video');
                if (fileUrl) {
                    window.open(fileUrl, '_blank');
                }
            });
        });
    }
});
},{}],114:[function(require,module,exports){
google.charts.load('current', { packages: ['corechart'] });
var chartDiv = document.getElementById('curve_chart1');
google.charts.setOnLoadCallback(function () {
    var chartDiv = document.getElementById('curve_chart1');
    if (chartDiv) {
        if (getComputedStyle(chartDiv).display !== 'none') {
            drawChart(chartDiv);
        }
        else {
            observeVisibility(chartDiv);
        }
    }
    var chartDiv2 = document.getElementById('curve_chart2');
    if (chartDiv2) {
        if (getComputedStyle(chartDiv2).display !== 'none') {
            drawChart(chartDiv2);
        }
        else {
            observeVisibility(chartDiv2);
        }
    }
    var chartDiv3 = document.getElementById('curve_chart3');
    if (chartDiv3) {
        if (getComputedStyle(chartDiv3).display !== 'none') {
            drawChart(chartDiv3);
        }
        else {
            observeVisibility(chartDiv3);
        }
    }
});
function drawChart(element) {
    var chartData = element.getAttribute('data-chartdata');
    if (!chartData) {
        console.error('No data found in data-chartdata attribute');
        return;
    }
    var dataArray = JSON.parse(chartData);
    var data = google.visualization.arrayToDataTable(dataArray);
    var options = {
        hAxis: {
            gridlines: { color: 'transparent' },
            textPosition: 'none',
            baselineColor: 'transparent',
        },
        vAxis: {
            gridlines: { color: 'transparent' },
            textPosition: 'none',
            baselineColor: 'transparent',
        },
        curveType: 'function',
        legend: { position: 'none' },
        chartArea: { width: '100%', height: '100%' },
        series: {
            0: { color: '#6f6f91' }
        },
        lineWidth: 3,
        tooltip: { trigger: 'none' }
    };
    var chart1 = new google.visualization.LineChart(element);
    google.visualization.events.addListener(chart1, 'ready', function () { return addShadowEffect1(); });
    chart1.draw(data, options);
}
function addShadowEffect1() {
    var svg = document.querySelector('#curve_chart1 svg');
    var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    var filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
    filter.setAttribute('id', 'shadow');
    filter.innerHTML = "\n      <feDropShadow dx=\"0\" dy=\"3\" stdDeviation=\"3\" flood-color=\"rgba(0, 0, 0, 0.3)\" />\n    ";
    defs.appendChild(filter);
    svg.appendChild(defs);
    var path = svg.querySelector('path');
    path.setAttribute('filter', 'url(#shadow)');
}
function addShadowEffect2() {
    var svg = document.querySelector('#curve_chart2 svg');
    var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    var filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
    filter.setAttribute('id', 'shadow');
    filter.innerHTML = "\n      <feDropShadow dx=\"0\" dy=\"3\" stdDeviation=\"3\" flood-color=\"rgba(0, 0, 0, 0.3)\" />\n    ";
    defs.appendChild(filter);
    svg.appendChild(defs);
    var path = svg.querySelector('path');
    path.setAttribute('filter', 'url(#shadow)');
}
function addShadowEffect3() {
    var svg = document.querySelector('#curve_chart3 svg');
    var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    var filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
    filter.setAttribute('id', 'shadow');
    filter.innerHTML = "\n      <feDropShadow dx=\"0\" dy=\"3\" stdDeviation=\"3\" flood-color=\"rgba(0, 0, 0, 0.3)\" />\n    ";
    defs.appendChild(filter);
    svg.appendChild(defs);
    var path = svg.querySelector('path');
    path.setAttribute('filter', 'url(#shadow)');
}
function observeVisibility(element) {
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'style' && getComputedStyle(element).display !== 'none') {
                drawChart(element);
            }
        });
    });
    observer.observe(element, { attributes: true });
}
var initializeWebStatsComponent = function (webStatsComponent) {
    var webStatsTabs = webStatsComponent.querySelectorAll('.web-stats__tab');
    var webStatsContents = webStatsComponent.querySelectorAll('.web-stats__stat');
    var activeTab = 0;
    if (webStatsTabs.length > 0) {
        var showSelectedItems_1 = function (activeTab) {
            webStatsTabs.forEach(function (tab, index) {
                tab.classList.remove('web-stats__tab--active');
                webStatsContents[index].style.display = 'none';
            });
            webStatsTabs[activeTab].classList.add('web-stats__tab--active');
            webStatsContents[activeTab].style.display = 'block';
        };
        var handleTabClick_1 = function (index) {
            activeTab = index;
            showSelectedItems_1(activeTab);
        };
        webStatsTabs.forEach(function (tab, index) {
            tab.addEventListener('click', function () { return handleTabClick_1(index); });
        });
        showSelectedItems_1(activeTab);
    }
};
document.querySelectorAll('.web-stats').forEach(function (webStatsComponent) {
    initializeWebStatsComponent(webStatsComponent);
});
},{}],115:[function(require,module,exports){
/*!
 * Glide.js v3.6.0
 * (c) 2013-2022 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Glide = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      };
    }

    return _get.apply(this, arguments);
  }

  var defaults = {
    /**
     * Type of the movement.
     *
     * Available types:
     * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
     * `carousel` - Changes slides without starting over when it reaches the first or last slide.
     *
     * @type {String}
     */
    type: 'slider',

    /**
     * Start at specific slide number defined with zero-based index.
     *
     * @type {Number}
     */
    startAt: 0,

    /**
     * A number of slides visible on the single viewport.
     *
     * @type {Number}
     */
    perView: 1,

    /**
     * Focus currently active slide at a specified position in the track.
     *
     * Available inputs:
     * `center` - Current slide will be always focused at the center of a track.
     * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
     *
     * @type {String|Number}
     */
    focusAt: 0,

    /**
     * A size of the gap added between slides.
     *
     * @type {Number}
     */
    gap: 10,

    /**
     * Change slides after a specified interval. Use `false` for turning off autoplay.
     *
     * @type {Number|Boolean}
     */
    autoplay: false,

    /**
     * Stop autoplay on mouseover event.
     *
     * @type {Boolean}
     */
    hoverpause: true,

    /**
     * Allow for changing slides with left and right keyboard arrows.
     *
     * @type {Boolean}
     */
    keyboard: true,

    /**
     * Stop running `perView` number of slides from the end. Use this
     * option if you don't want to have an empty space after
     * a slider. Works only with `slider` type and a
     * non-centered `focusAt` setting.
     *
     * @type {Boolean}
     */
    bound: false,

    /**
     * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
     *
     * @type {Number|Boolean}
     */
    swipeThreshold: 80,

    /**
     * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
     *
     * @type {Number|Boolean}
     */
    dragThreshold: 120,

    /**
     * A number of slides moved on single swipe.
     *
     * Available types:
     * `` - Moves slider by one slide per swipe
     * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
     *
     * @type {String}
     */
    perSwipe: '',

    /**
     * Moving distance ratio of the slides on a swiping and dragging.
     *
     * @type {Number}
     */
    touchRatio: 0.5,

    /**
     * Angle required to activate slides moving on swiping or dragging.
     *
     * @type {Number}
     */
    touchAngle: 45,

    /**
     * Duration of the animation in milliseconds.
     *
     * @type {Number}
     */
    animationDuration: 400,

    /**
     * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
     *
     * @type {Boolean}
     */
    rewind: true,

    /**
     * Duration of the rewinding animation of the `slider` type in milliseconds.
     *
     * @type {Number}
     */
    rewindDuration: 800,

    /**
     * Easing function for the animation.
     *
     * @type {String}
     */
    animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

    /**
     * Wait for the animation to finish until the next user input can be processed
     *
     * @type {boolean}
     */
    waitForTransition: true,

    /**
     * Throttle costly events at most once per every wait milliseconds.
     *
     * @type {Number}
     */
    throttle: 10,

    /**
     * Moving direction mode.
     *
     * Available inputs:
     * - 'ltr' - left to right movement,
     * - 'rtl' - right to left movement.
     *
     * @type {String}
     */
    direction: 'ltr',

    /**
     * The distance value of the next and previous viewports which
     * have to peek in the current view. Accepts number and
     * pixels as a string. Left and right peeking can be
     * set up separately with a directions object.
     *
     * For example:
     * `100` - Peek 100px on the both sides.
     * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
     *
     * @type {Number|String|Object}
     */
    peek: 0,

    /**
     * Defines how many clones of current viewport will be generated.
     *
     * @type {Number}
     */
    cloningRatio: 1,

    /**
     * Collection of options applied at specified media breakpoints.
     * For example: display two slides per view under 800px.
     * `{
     *   '800px': {
     *     perView: 2
     *   }
     * }`
     */
    breakpoints: {},

    /**
     * Collection of internally used HTML classes.
     *
     * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
     * @type {Object}
     */
    classes: {
      swipeable: 'glide--swipeable',
      dragging: 'glide--dragging',
      direction: {
        ltr: 'glide--ltr',
        rtl: 'glide--rtl'
      },
      type: {
        slider: 'glide--slider',
        carousel: 'glide--carousel'
      },
      slide: {
        clone: 'glide__slide--clone',
        active: 'glide__slide--active'
      },
      arrow: {
        disabled: 'glide__arrow--disabled'
      },
      nav: {
        active: 'glide__bullet--active'
      }
    }
  };

  /**
   * Outputs warning message to the bowser console.
   *
   * @param  {String} msg
   * @return {Void}
   */
  function warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
  }

  /**
   * Converts value entered as number
   * or string to integer value.
   *
   * @param {String} value
   * @returns {Number}
   */
  function toInt(value) {
    return parseInt(value);
  }
  /**
   * Converts value entered as number
   * or string to flat value.
   *
   * @param {String} value
   * @returns {Number}
   */

  function toFloat(value) {
    return parseFloat(value);
  }
  /**
   * Indicates whether the specified value is a string.
   *
   * @param  {*}   value
   * @return {Boolean}
   */

  function isString(value) {
    return typeof value === 'string';
  }
  /**
   * Indicates whether the specified value is an object.
   *
   * @param  {*} value
   * @return {Boolean}
   *
   * @see https://github.com/jashkenas/underscore
   */

  function isObject(value) {
    var type = _typeof(value);

    return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
  }
  /**
   * Indicates whether the specified value is a function.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  /**
   * Indicates whether the specified value is undefined.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Indicates whether the specified value is an array.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isArray(value) {
    return value.constructor === Array;
  }

  /**
   * Creates and initializes specified collection of extensions.
   * Each extension receives access to instance of glide and rest of components.
   *
   * @param {Object} glide
   * @param {Object} extensions
   *
   * @returns {Object}
   */

  function mount(glide, extensions, events) {
    var components = {};

    for (var name in extensions) {
      if (isFunction(extensions[name])) {
        components[name] = extensions[name](glide, components, events);
      } else {
        warn('Extension must be a function');
      }
    }

    for (var _name in components) {
      if (isFunction(components[_name].mount)) {
        components[_name].mount();
      }
    }

    return components;
  }

  /**
   * Defines getter and setter property on the specified object.
   *
   * @param  {Object} obj         Object where property has to be defined.
   * @param  {String} prop        Name of the defined property.
   * @param  {Object} definition  Get and set definitions for the property.
   * @return {Void}
   */
  function define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
  }
  /**
   * Sorts aphabetically object keys.
   *
   * @param  {Object} obj
   * @return {Object}
   */

  function sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function (r, k) {
      r[k] = obj[k];
      return r[k], r;
    }, {});
  }
  /**
   * Merges passed settings object with default options.
   *
   * @param  {Object} defaults
   * @param  {Object} settings
   * @return {Object}
   */

  function mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.

    if (settings.hasOwnProperty('classes')) {
      options.classes = Object.assign({}, defaults.classes, settings.classes);

      if (settings.classes.hasOwnProperty('direction')) {
        options.classes.direction = Object.assign({}, defaults.classes.direction, settings.classes.direction);
      }

      if (settings.classes.hasOwnProperty('type')) {
        options.classes.type = Object.assign({}, defaults.classes.type, settings.classes.type);
      }

      if (settings.classes.hasOwnProperty('slide')) {
        options.classes.slide = Object.assign({}, defaults.classes.slide, settings.classes.slide);
      }

      if (settings.classes.hasOwnProperty('arrow')) {
        options.classes.arrow = Object.assign({}, defaults.classes.arrow, settings.classes.arrow);
      }

      if (settings.classes.hasOwnProperty('nav')) {
        options.classes.nav = Object.assign({}, defaults.classes.nav, settings.classes.nav);
      }
    }

    if (settings.hasOwnProperty('breakpoints')) {
      options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    }

    return options;
  }

  var EventsBus = /*#__PURE__*/function () {
    /**
     * Construct a EventBus instance.
     *
     * @param {Object} events
     */
    function EventsBus() {
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, EventsBus);

      this.events = events;
      this.hop = events.hasOwnProperty;
    }
    /**
     * Adds listener to the specifed event.
     *
     * @param {String|Array} event
     * @param {Function} handler
     */


    _createClass(EventsBus, [{
      key: "on",
      value: function on(event, handler) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.on(event[i], handler);
          }

          return;
        } // Create the event's object if not yet created


        if (!this.hop.call(this.events, event)) {
          this.events[event] = [];
        } // Add the handler to queue


        var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event

        return {
          remove: function remove() {
            delete this.events[event][index];
          }
        };
      }
      /**
       * Runs registered handlers for specified event.
       *
       * @param {String|Array} event
       * @param {Object=} context
       */

    }, {
      key: "emit",
      value: function emit(event, context) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.emit(event[i], context);
          }

          return;
        } // If the event doesn't exist, or there's no handlers in queue, just leave


        if (!this.hop.call(this.events, event)) {
          return;
        } // Cycle through events queue, fire!


        this.events[event].forEach(function (item) {
          item(context || {});
        });
      }
    }]);

    return EventsBus;
  }();

  var Glide$1 = /*#__PURE__*/function () {
    /**
     * Construct glide.
     *
     * @param  {String} selector
     * @param  {Object} options
     */
    function Glide(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Glide);

      this._c = {};
      this._t = [];
      this._e = new EventsBus();
      this.disabled = false;
      this.selector = selector;
      this.settings = mergeOptions(defaults, options);
      this.index = this.settings.startAt;
    }
    /**
     * Initializes glide.
     *
     * @param {Object} extensions Collection of extensions to initialize.
     * @return {Glide}
     */


    _createClass(Glide, [{
      key: "mount",
      value: function mount$1() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._e.emit('mount.before');

        if (isObject(extensions)) {
          this._c = mount(this, extensions, this._e);
        } else {
          warn('You need to provide a object on `mount()`');
        }

        this._e.emit('mount.after');

        return this;
      }
      /**
       * Collects an instance `translate` transformers.
       *
       * @param  {Array} transformers Collection of transformers.
       * @return {Void}
       */

    }, {
      key: "mutate",
      value: function mutate() {
        var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (isArray(transformers)) {
          this._t = transformers;
        } else {
          warn('You need to provide a array on `mutate()`');
        }

        return this;
      }
      /**
       * Updates glide with specified settings.
       *
       * @param {Object} settings
       * @return {Glide}
       */

    }, {
      key: "update",
      value: function update() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.settings = mergeOptions(this.settings, settings);

        if (settings.hasOwnProperty('startAt')) {
          this.index = settings.startAt;
        }

        this._e.emit('update');

        return this;
      }
      /**
       * Change slide with specified pattern. A pattern must be in the special format:
       * `>` - Move one forward
       * `<` - Move one backward
       * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
       * `>>` - Rewinds to end (last slide)
       * `<<` - Rewinds to start (first slide)
       * `|>` - Move one viewport forward
       * `|<` - Move one viewport backward
       *
       * @param {String} pattern
       * @return {Glide}
       */

    }, {
      key: "go",
      value: function go(pattern) {
        this._c.Run.make(pattern);

        return this;
      }
      /**
       * Move track by specified distance.
       *
       * @param {String} distance
       * @return {Glide}
       */

    }, {
      key: "move",
      value: function move(distance) {
        this._c.Transition.disable();

        this._c.Move.make(distance);

        return this;
      }
      /**
       * Destroy instance and revert all changes done by this._c.
       *
       * @return {Glide}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        this._e.emit('destroy');

        return this;
      }
      /**
       * Start instance autoplaying.
       *
       * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Glide}
       */

    }, {
      key: "play",
      value: function play() {
        var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (interval) {
          this.settings.autoplay = interval;
        }

        this._e.emit('play');

        return this;
      }
      /**
       * Stop instance autoplaying.
       *
       * @return {Glide}
       */

    }, {
      key: "pause",
      value: function pause() {
        this._e.emit('pause');

        return this;
      }
      /**
       * Sets glide into a idle status.
       *
       * @return {Glide}
       */

    }, {
      key: "disable",
      value: function disable() {
        this.disabled = true;
        return this;
      }
      /**
       * Sets glide into a active status.
       *
       * @return {Glide}
       */

    }, {
      key: "enable",
      value: function enable() {
        this.disabled = false;
        return this;
      }
      /**
       * Adds cuutom event listener with handler.
       *
       * @param  {String|Array} event
       * @param  {Function} handler
       * @return {Glide}
       */

    }, {
      key: "on",
      value: function on(event, handler) {
        this._e.on(event, handler);

        return this;
      }
      /**
       * Checks if glide is a precised type.
       *
       * @param  {String} name
       * @return {Boolean}
       */

    }, {
      key: "isType",
      value: function isType(name) {
        return this.settings.type === name;
      }
      /**
       * Gets value of the core options.
       *
       * @return {Object}
       */

    }, {
      key: "settings",
      get: function get() {
        return this._o;
      }
      /**
       * Sets value of the core options.
       *
       * @param  {Object} o
       * @return {Void}
       */
      ,
      set: function set(o) {
        if (isObject(o)) {
          this._o = o;
        } else {
          warn('Options must be an `object` instance.');
        }
      }
      /**
       * Gets current index of the slider.
       *
       * @return {Object}
       */

    }, {
      key: "index",
      get: function get() {
        return this._i;
      }
      /**
       * Sets current index a slider.
       *
       * @return {Object}
       */
      ,
      set: function set(i) {
        this._i = toInt(i);
      }
      /**
       * Gets type name of the slider.
       *
       * @return {String}
       */

    }, {
      key: "type",
      get: function get() {
        return this.settings.type;
      }
      /**
       * Gets value of the idle status.
       *
       * @return {Boolean}
       */

    }, {
      key: "disabled",
      get: function get() {
        return this._d;
      }
      /**
       * Sets value of the idle status.
       *
       * @return {Boolean}
       */
      ,
      set: function set(status) {
        this._d = !!status;
      }
    }]);

    return Glide;
  }();

  function Run (Glide, Components, Events) {
    var Run = {
      /**
       * Initializes autorunning of the glide.
       *
       * @return {Void}
       */
      mount: function mount() {
        this._o = false;
      },

      /**
       * Makes glides running based on the passed moving schema.
       *
       * @param {String} move
       */
      make: function make(move) {
        var _this = this;

        if (!Glide.disabled) {
          !Glide.settings.waitForTransition || Glide.disable();
          this.move = move;
          Events.emit('run.before', this.move);
          this.calculate();
          Events.emit('run', this.move);
          Components.Transition.after(function () {
            if (_this.isStart()) {
              Events.emit('run.start', _this.move);
            }

            if (_this.isEnd()) {
              Events.emit('run.end', _this.move);
            }

            if (_this.isOffset()) {
              _this._o = false;
              Events.emit('run.offset', _this.move);
            }

            Events.emit('run.after', _this.move);
            Glide.enable();
          });
        }
      },

      /**
       * Calculates current index based on defined move.
       *
       * @return {Number|Undefined}
       */
      calculate: function calculate() {
        var move = this.move,
            length = this.length;
        var steps = move.steps,
            direction = move.direction; // By default assume that size of view is equal to one slide

        var viewSize = 1; // While direction is `=` we want jump to
        // a specified index described in steps.

        if (direction === '=') {
          // Check if bound is true, 
          // as we want to avoid whitespaces.
          if (Glide.settings.bound && toInt(steps) > length) {
            Glide.index = length;
            return;
          }

          Glide.index = steps;
          return;
        } // When pattern is equal to `>>` we want
        // fast forward to the last slide.


        if (direction === '>' && steps === '>') {
          Glide.index = length;
          return;
        } // When pattern is equal to `<<` we want
        // fast forward to the first slide.


        if (direction === '<' && steps === '<') {
          Glide.index = 0;
          return;
        } // pagination movement


        if (direction === '|') {
          viewSize = Glide.settings.perView || 1;
        } // we are moving forward


        if (direction === '>' || direction === '|' && steps === '>') {
          var index = calculateForwardIndex(viewSize);

          if (index > length) {
            this._o = true;
          }

          Glide.index = normalizeForwardIndex(index, viewSize);
          return;
        } // we are moving backward


        if (direction === '<' || direction === '|' && steps === '<') {
          var _index = calculateBackwardIndex(viewSize);

          if (_index < 0) {
            this._o = true;
          }

          Glide.index = normalizeBackwardIndex(_index, viewSize);
          return;
        }

        warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
      },

      /**
       * Checks if we are on the first slide.
       *
       * @return {Boolean}
       */
      isStart: function isStart() {
        return Glide.index <= 0;
      },

      /**
       * Checks if we are on the last slide.
       *
       * @return {Boolean}
       */
      isEnd: function isEnd() {
        return Glide.index >= this.length;
      },

      /**
       * Checks if we are making a offset run.
       *
       * @param {String} direction
       * @return {Boolean}
       */
      isOffset: function isOffset() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        if (!direction) {
          return this._o;
        }

        if (!this._o) {
          return false;
        } // did we view to the right?


        if (direction === '|>') {
          return this.move.direction === '|' && this.move.steps === '>';
        } // did we view to the left?


        if (direction === '|<') {
          return this.move.direction === '|' && this.move.steps === '<';
        }

        return this.move.direction === direction;
      },

      /**
       * Checks if bound mode is active
       *
       * @return {Boolean}
       */
      isBound: function isBound() {
        return Glide.isType('slider') && Glide.settings.focusAt !== 'center' && Glide.settings.bound;
      }
    };
    /**
     * Returns index value to move forward/to the right
     *
     * @param viewSize
     * @returns {Number}
     */

    function calculateForwardIndex(viewSize) {
      var index = Glide.index;

      if (Glide.isType('carousel')) {
        return index + viewSize;
      }

      return index + (viewSize - index % viewSize);
    }
    /**
     * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
     *
     * @param index
     * @param length
     * @param viewSize
     * @returns {Number}
     */


    function normalizeForwardIndex(index, viewSize) {
      var length = Run.length;

      if (index <= length) {
        return index;
      }

      if (Glide.isType('carousel')) {
        return index - (length + 1);
      }

      if (Glide.settings.rewind) {
        // bound does funny things with the length, therefor we have to be certain
        // that we are on the last possible index value given by bound
        if (Run.isBound() && !Run.isEnd()) {
          return length;
        }

        return 0;
      }

      if (Run.isBound()) {
        return length;
      }

      return Math.floor(length / viewSize) * viewSize;
    }
    /**
     * Calculates index value to move backward/to the left
     *
     * @param viewSize
     * @returns {Number}
     */


    function calculateBackwardIndex(viewSize) {
      var index = Glide.index;

      if (Glide.isType('carousel')) {
        return index - viewSize;
      } // ensure our back navigation results in the same index as a forward navigation
      // to experience a homogeneous paging


      var view = Math.ceil(index / viewSize);
      return (view - 1) * viewSize;
    }
    /**
     * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
     *
     * @param index
     * @param length
     * @param viewSize
     * @returns {*}
     */


    function normalizeBackwardIndex(index, viewSize) {
      var length = Run.length;

      if (index >= 0) {
        return index;
      }

      if (Glide.isType('carousel')) {
        return index + (length + 1);
      }

      if (Glide.settings.rewind) {
        // bound does funny things with the length, therefor we have to be certain
        // that we are on first possible index value before we to rewind to the length given by bound
        if (Run.isBound() && Run.isStart()) {
          return length;
        }

        return Math.floor(length / viewSize) * viewSize;
      }

      return 0;
    }

    define(Run, 'move', {
      /**
       * Gets value of the move schema.
       *
       * @returns {Object}
       */
      get: function get() {
        return this._m;
      },

      /**
       * Sets value of the move schema.
       *
       * @returns {Object}
       */
      set: function set(value) {
        var step = value.substr(1);
        this._m = {
          direction: value.substr(0, 1),
          steps: step ? toInt(step) ? toInt(step) : step : 0
        };
      }
    });
    define(Run, 'length', {
      /**
       * Gets value of the running distance based
       * on zero-indexing number of slides.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;
        var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
        // reduced by `perView` and `focusAt` settings. Running distance
        // should end before creating an empty space after instance.

        if (this.isBound()) {
          return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
        }

        return length - 1;
      }
    });
    define(Run, 'offset', {
      /**
       * Gets status of the offsetting flag.
       *
       * @return {Boolean}
       */
      get: function get() {
        return this._o;
      }
    });
    return Run;
  }

  /**
   * Returns a current time.
   *
   * @return {Number}
   */
  function now() {
    return new Date().getTime();
  }

  /**
   * Returns a function, that, when invoked, will only be triggered
   * at most once during a given window of time.
   *
   * @param {Function} func
   * @param {Number} wait
   * @param {Object=} options
   * @return {Function}
   *
   * @see https://github.com/jashkenas/underscore
   */

  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function later() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function throttled() {
      var at = now();
      if (!previous && options.leading === false) previous = at;
      var remaining = wait - (at - previous);
      context = this;
      args = arguments;

      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }

        previous = at;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };

    throttled.cancel = function () {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  var MARGIN_TYPE = {
    ltr: ['marginLeft', 'marginRight'],
    rtl: ['marginRight', 'marginLeft']
  };
  function Gaps (Glide, Components, Events) {
    var Gaps = {
      /**
       * Applies gaps between slides. First and last
       * slides do not receive it's edge margins.
       *
       * @param {HTMLCollection} slides
       * @return {Void}
       */
      apply: function apply(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          var direction = Components.Direction.value;

          if (i !== 0) {
            style[MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
          } else {
            style[MARGIN_TYPE[direction][0]] = '';
          }

          if (i !== slides.length - 1) {
            style[MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
          } else {
            style[MARGIN_TYPE[direction][1]] = '';
          }
        }
      },

      /**
       * Removes gaps from the slides.
       *
       * @param {HTMLCollection} slides
       * @returns {Void}
      */
      remove: function remove(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          style.marginLeft = '';
          style.marginRight = '';
        }
      }
    };
    define(Gaps, 'value', {
      /**
       * Gets value of the gap.
       *
       * @returns {Number}
       */
      get: function get() {
        return toInt(Glide.settings.gap);
      }
    });
    define(Gaps, 'grow', {
      /**
       * Gets additional dimensions value caused by gaps.
       * Used to increase width of the slides wrapper.
       *
       * @returns {Number}
       */
      get: function get() {
        return Gaps.value * Components.Sizes.length;
      }
    });
    define(Gaps, 'reductor', {
      /**
       * Gets reduction value caused by gaps.
       * Used to subtract width of the slides.
       *
       * @returns {Number}
       */
      get: function get() {
        var perView = Glide.settings.perView;
        return Gaps.value * (perView - 1) / perView;
      }
    });
    /**
     * Apply calculated gaps:
     * - after building, so slides (including clones) will receive proper margins
     * - on updating via API, to recalculate gaps with new options
     */

    Events.on(['build.after', 'update'], throttle(function () {
      Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
     * Remove gaps:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
  }

  /**
   * Finds siblings nodes of the passed node.
   *
   * @param  {Element} node
   * @return {Array}
   */
  function siblings(node) {
    if (node && node.parentNode) {
      var n = node.parentNode.firstChild;
      var matched = [];

      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== node) {
          matched.push(n);
        }
      }

      return matched;
    }

    return [];
  }
  /**
   * Checks if passed node exist and is a valid element.
   *
   * @param  {Element} node
   * @return {Boolean}
   */

  function exist(node) {
    if (node && node instanceof window.HTMLElement) {
      return true;
    }

    return false;
  }
  /**
   * Coerces a NodeList to an Array.
   *
   * @param  {NodeList} nodeList
   * @return {Array}
   */

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  var TRACK_SELECTOR = '[data-glide-el="track"]';
  function Html (Glide, Components, Events) {
    var Html = {
      /**
       * Setup slider HTML nodes.
       *
       * @param {Glide} glide
       */
      mount: function mount() {
        this.root = Glide.selector;
        this.track = this.root.querySelector(TRACK_SELECTOR);
        this.collectSlides();
      },

      /**
       * Collect slides
       */
      collectSlides: function collectSlides() {
        this.slides = toArray(this.wrapper.children).filter(function (slide) {
          return !slide.classList.contains(Glide.settings.classes.slide.clone);
        });
      }
    };
    define(Html, 'root', {
      /**
       * Gets node of the glide main element.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._r;
      },

      /**
       * Sets node of the glide main element.
       *
       * @return {Object}
       */
      set: function set(r) {
        if (isString(r)) {
          r = document.querySelector(r);
        }

        if (exist(r)) {
          Html._r = r;
        } else {
          warn('Root element must be a existing Html node');
        }
      }
    });
    define(Html, 'track', {
      /**
       * Gets node of the glide track with slides.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._t;
      },

      /**
       * Sets node of the glide track with slides.
       *
       * @return {Object}
       */
      set: function set(t) {
        if (exist(t)) {
          Html._t = t;
        } else {
          warn("Could not find track element. Please use ".concat(TRACK_SELECTOR, " attribute."));
        }
      }
    });
    define(Html, 'wrapper', {
      /**
       * Gets node of the slides wrapper.
       *
       * @return {Object}
       */
      get: function get() {
        return Html.track.children[0];
      }
    });
    /**
     * Add/remove/reorder dynamic slides
     */

    Events.on('update', function () {
      Html.collectSlides();
    });
    return Html;
  }

  function Peek (Glide, Components, Events) {
    var Peek = {
      /**
       * Setups how much to peek based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.peek;
      }
    };
    define(Peek, 'value', {
      /**
       * Gets value of the peek.
       *
       * @returns {Number|Object}
       */
      get: function get() {
        return Peek._v;
      },

      /**
       * Sets value of the peek.
       *
       * @param {Number|Object} value
       * @return {Void}
       */
      set: function set(value) {
        if (isObject(value)) {
          value.before = toInt(value.before);
          value.after = toInt(value.after);
        } else {
          value = toInt(value);
        }

        Peek._v = value;
      }
    });
    define(Peek, 'reductor', {
      /**
       * Gets reduction value caused by peek.
       *
       * @returns {Number}
       */
      get: function get() {
        var value = Peek.value;
        var perView = Glide.settings.perView;

        if (isObject(value)) {
          return value.before / perView + value.after / perView;
        }

        return value * 2 / perView;
      }
    });
    /**
     * Recalculate peeking sizes on:
     * - when resizing window to update to proper percents
     */

    Events.on(['resize', 'update'], function () {
      Peek.mount();
    });
    return Peek;
  }

  function Move (Glide, Components, Events) {
    var Move = {
      /**
       * Constructs move component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        this._o = 0;
      },

      /**
       * Calculates a movement value based on passed offset and currently active index.
       *
       * @param  {Number} offset
       * @return {Void}
       */
      make: function make() {
        var _this = this;

        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this.offset = offset;
        Events.emit('move', {
          movement: this.value
        });
        Components.Transition.after(function () {
          Events.emit('move.after', {
            movement: _this.value
          });
        });
      }
    };
    define(Move, 'offset', {
      /**
       * Gets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      get: function get() {
        return Move._o;
      },

      /**
       * Sets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      set: function set(value) {
        Move._o = !isUndefined(value) ? toInt(value) : 0;
      }
    });
    define(Move, 'translate', {
      /**
       * Gets a raw movement value.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Sizes.slideWidth * Glide.index;
      }
    });
    define(Move, 'value', {
      /**
       * Gets an actual movement value corrected by offset.
       *
       * @return {Number}
       */
      get: function get() {
        var offset = this.offset;
        var translate = this.translate;

        if (Components.Direction.is('rtl')) {
          return translate + offset;
        }

        return translate - offset;
      }
    });
    /**
     * Make movement to proper slide on:
     * - before build, so glide will start at `startAt` index
     * - on each standard run to move to newly calculated index
     */

    Events.on(['build.before', 'run'], function () {
      Move.make();
    });
    return Move;
  }

  function Sizes (Glide, Components, Events) {
    var Sizes = {
      /**
       * Setups dimensions of slides.
       *
       * @return {Void}
       */
      setupSlides: function setupSlides() {
        var width = "".concat(this.slideWidth, "px");
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = width;
        }
      },

      /**
       * Setups dimensions of slides wrapper.
       *
       * @return {Void}
       */
      setupWrapper: function setupWrapper() {
        Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
      },

      /**
       * Removes applied styles from HTML elements.
       *
       * @returns {Void}
       */
      remove: function remove() {
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '';
        }

        Components.Html.wrapper.style.width = '';
      }
    };
    define(Sizes, 'length', {
      /**
       * Gets count number of the slides.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.slides.length;
      }
    });
    define(Sizes, 'width', {
      /**
       * Gets width value of the slider (visible area).
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.track.offsetWidth;
      }
    });
    define(Sizes, 'wrapperSize', {
      /**
       * Gets size of the slides wrapper.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
      }
    });
    define(Sizes, 'slideWidth', {
      /**
       * Gets width value of a single slide.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
      }
    });
    /**
     * Apply calculated glide's dimensions:
     * - before building, so other dimensions (e.g. translate) will be calculated propertly
     * - when resizing window to recalculate sildes dimensions
     * - on updating via API, to calculate dimensions based on new options
     */

    Events.on(['build.before', 'resize', 'update'], function () {
      Sizes.setupSlides();
      Sizes.setupWrapper();
    });
    /**
     * Remove calculated glide's dimensions:
     * - on destoting to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Sizes.remove();
    });
    return Sizes;
  }

  function Build (Glide, Components, Events) {
    var Build = {
      /**
       * Init glide building. Adds classes, sets
       * dimensions and setups initial state.
       *
       * @return {Void}
       */
      mount: function mount() {
        Events.emit('build.before');
        this.typeClass();
        this.activeClass();
        Events.emit('build.after');
      },

      /**
       * Adds `type` class to the glide element.
       *
       * @return {Void}
       */
      typeClass: function typeClass() {
        Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
      },

      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      activeClass: function activeClass() {
        var classes = Glide.settings.classes;
        var slide = Components.Html.slides[Glide.index];

        if (slide) {
          slide.classList.add(classes.slide.active);
          siblings(slide).forEach(function (sibling) {
            sibling.classList.remove(classes.slide.active);
          });
        }
      },

      /**
       * Removes HTML classes applied at building.
       *
       * @return {Void}
       */
      removeClasses: function removeClasses() {
        var _Glide$settings$class = Glide.settings.classes,
            type = _Glide$settings$class.type,
            slide = _Glide$settings$class.slide;
        Components.Html.root.classList.remove(type[Glide.settings.type]);
        Components.Html.slides.forEach(function (sibling) {
          sibling.classList.remove(slide.active);
        });
      }
    };
    /**
     * Clear building classes:
     * - on destroying to bring HTML to its initial state
     * - on updating to remove classes before remounting component
     */

    Events.on(['destroy', 'update'], function () {
      Build.removeClasses();
    });
    /**
     * Remount component:
     * - on resizing of the window to calculate new dimensions
     * - on updating settings via API
     */

    Events.on(['resize', 'update'], function () {
      Build.mount();
    });
    /**
     * Swap active class of current slide:
     * - after each move to the new index
     */

    Events.on('move.after', function () {
      Build.activeClass();
    });
    return Build;
  }

  function Clones (Glide, Components, Events) {
    var Clones = {
      /**
       * Create pattern map and collect slides to be cloned.
       */
      mount: function mount() {
        this.items = [];

        if (Glide.isType('carousel')) {
          this.items = this.collect();
        }
      },

      /**
       * Collect clones with pattern.
       *
       * @return {[]}
       */
      collect: function collect() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var slides = Components.Html.slides;
        var _Glide$settings = Glide.settings,
            perView = _Glide$settings.perView,
            classes = _Glide$settings.classes,
            cloningRatio = _Glide$settings.cloningRatio;

        if (slides.length !== 0) {
          var peekIncrementer = +!!Glide.settings.peek;
          var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
          var append = slides.slice(0, cloneCount).reverse();
          var prepend = slides.slice(cloneCount * -1);

          for (var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++) {
            for (var i = 0; i < append.length; i++) {
              var clone = append[i].cloneNode(true);
              clone.classList.add(classes.slide.clone);
              items.push(clone);
            }

            for (var _i = 0; _i < prepend.length; _i++) {
              var _clone = prepend[_i].cloneNode(true);

              _clone.classList.add(classes.slide.clone);

              items.unshift(_clone);
            }
          }
        }

        return items;
      },

      /**
       * Append cloned slides with generated pattern.
       *
       * @return {Void}
       */
      append: function append() {
        var items = this.items;
        var _Components$Html = Components.Html,
            wrapper = _Components$Html.wrapper,
            slides = _Components$Html.slides;
        var half = Math.floor(items.length / 2);
        var prepend = items.slice(0, half).reverse();
        var append = items.slice(half * -1).reverse();
        var width = "".concat(Components.Sizes.slideWidth, "px");

        for (var i = 0; i < append.length; i++) {
          wrapper.appendChild(append[i]);
        }

        for (var _i2 = 0; _i2 < prepend.length; _i2++) {
          wrapper.insertBefore(prepend[_i2], slides[0]);
        }

        for (var _i3 = 0; _i3 < items.length; _i3++) {
          items[_i3].style.width = width;
        }
      },

      /**
       * Remove all cloned slides.
       *
       * @return {Void}
       */
      remove: function remove() {
        var items = this.items;

        for (var i = 0; i < items.length; i++) {
          Components.Html.wrapper.removeChild(items[i]);
        }
      }
    };
    define(Clones, 'grow', {
      /**
       * Gets additional dimensions value caused by clones.
       *
       * @return {Number}
       */
      get: function get() {
        return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
      }
    });
    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */

    Events.on('update', function () {
      Clones.remove();
      Clones.mount();
      Clones.append();
    });
    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */

    Events.on('build.before', function () {
      if (Glide.isType('carousel')) {
        Clones.append();
      }
    });
    /**
     * Remove clones HTMLElements:
     * - on destroying, to bring HTML to its initial state
     */

    Events.on('destroy', function () {
      Clones.remove();
    });
    return Clones;
  }

  var EventsBinder = /*#__PURE__*/function () {
    /**
     * Construct a EventsBinder instance.
     */
    function EventsBinder() {
      var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, EventsBinder);

      this.listeners = listeners;
    }
    /**
     * Adds events listeners to arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Function} closure
     * @param  {Boolean|Object} capture
     * @return {Void}
     */


    _createClass(EventsBinder, [{
      key: "on",
      value: function on(events, el, closure) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          this.listeners[events[i]] = closure;
          el.addEventListener(events[i], this.listeners[events[i]], capture);
        }
      }
      /**
       * Removes event listeners from arrows HTML elements.
       *
       * @param  {String|Array} events
       * @param  {Element|Window|Document} el
       * @param  {Boolean|Object} capture
       * @return {Void}
       */

    }, {
      key: "off",
      value: function off(events, el) {
        var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          el.removeEventListener(events[i], this.listeners[events[i]], capture);
        }
      }
      /**
       * Destroy collected listeners.
       *
       * @returns {Void}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        delete this.listeners;
      }
    }]);

    return EventsBinder;
  }();

  function Resize (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Resize = {
      /**
       * Initializes window bindings.
       */
      mount: function mount() {
        this.bind();
      },

      /**
       * Binds `rezsize` listener to the window.
       * It's a costly event, so we are debouncing it.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('resize', window, throttle(function () {
          Events.emit('resize');
        }, Glide.settings.throttle));
      },

      /**
       * Unbinds listeners from the window.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('resize', window);
      }
    };
    /**
     * Remove bindings from window:
     * - on destroying, to remove added EventListener
     */

    Events.on('destroy', function () {
      Resize.unbind();
      Binder.destroy();
    });
    return Resize;
  }

  var VALID_DIRECTIONS = ['ltr', 'rtl'];
  var FLIPED_MOVEMENTS = {
    '>': '<',
    '<': '>',
    '=': '='
  };
  function Direction (Glide, Components, Events) {
    var Direction = {
      /**
       * Setups gap value based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.direction;
      },

      /**
       * Resolves pattern based on direction value
       *
       * @param {String} pattern
       * @returns {String}
       */
      resolve: function resolve(pattern) {
        var token = pattern.slice(0, 1);

        if (this.is('rtl')) {
          return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
        }

        return pattern;
      },

      /**
       * Checks value of direction mode.
       *
       * @param {String} direction
       * @returns {Boolean}
       */
      is: function is(direction) {
        return this.value === direction;
      },

      /**
       * Applies direction class to the root HTML element.
       *
       * @return {Void}
       */
      addClass: function addClass() {
        Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
      },

      /**
       * Removes direction class from the root HTML element.
       *
       * @return {Void}
       */
      removeClass: function removeClass() {
        Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
      }
    };
    define(Direction, 'value', {
      /**
       * Gets value of the direction.
       *
       * @returns {Number}
       */
      get: function get() {
        return Direction._v;
      },

      /**
       * Sets value of the direction.
       *
       * @param {String} value
       * @return {Void}
       */
      set: function set(value) {
        if (VALID_DIRECTIONS.indexOf(value) > -1) {
          Direction._v = value;
        } else {
          warn('Direction value must be `ltr` or `rtl`');
        }
      }
    });
    /**
     * Clear direction class:
     * - on destroy to bring HTML to its initial state
     * - on update to remove class before reappling bellow
     */

    Events.on(['destroy', 'update'], function () {
      Direction.removeClass();
    });
    /**
     * Remount component:
     * - on update to reflect changes in direction value
     */

    Events.on('update', function () {
      Direction.mount();
    });
    /**
     * Apply direction class:
     * - before building to apply class for the first time
     * - on updating to reapply direction class that may changed
     */

    Events.on(['build.before', 'update'], function () {
      Direction.addClass();
    });
    return Direction;
  }

  /**
   * Reflects value of glide movement.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Rtl (Glide, Components) {
    return {
      /**
       * Negates the passed translate if glide is in RTL option.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Components.Direction.is('rtl')) {
          return -translate;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `gap` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Gap (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with number in the `gap` settings.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
        return translate + Components.Gaps.value * multiplier;
      }
    };
  }

  /**
   * Updates glide movement with width of additional clones width.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Grow (Glide, Components) {
    return {
      /**
       * Adds to the passed translate width of the half of clones.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        return translate + Components.Clones.grow / 2;
      }
    };
  }

  /**
   * Updates glide movement with a `peek` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */

  function Peeking (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with a `peek` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Glide.settings.focusAt >= 0) {
          var peek = Components.Peek.value;

          if (isObject(peek)) {
            return translate - peek.before;
          }

          return translate - peek;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `focusAt` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Focusing (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with index in the `focusAt` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var gap = Components.Gaps.value;
        var width = Components.Sizes.width;
        var focusAt = Glide.settings.focusAt;
        var slideWidth = Components.Sizes.slideWidth;

        if (focusAt === 'center') {
          return translate - (width / 2 - slideWidth / 2);
        }

        return translate - slideWidth * focusAt - gap * focusAt;
      }
    };
  }

  /**
   * Applies diffrent transformers on translate value.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */

  function mutator (Glide, Components, Events) {
    /**
     * Merge instance transformers with collection of default transformers.
     * It's important that the Rtl component be last on the list,
     * so it reflects all previous transformations.
     *
     * @type {Array}
     */
    var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);
    return {
      /**
       * Piplines translate value with registered transformers.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      mutate: function mutate(translate) {
        for (var i = 0; i < TRANSFORMERS.length; i++) {
          var transformer = TRANSFORMERS[i];

          if (isFunction(transformer) && isFunction(transformer().modify)) {
            translate = transformer(Glide, Components, Events).modify(translate);
          } else {
            warn('Transformer should be a function that returns an object with `modify()` method');
          }
        }

        return translate;
      }
    };
  }

  function Translate (Glide, Components, Events) {
    var Translate = {
      /**
       * Sets value of translate on HTML element.
       *
       * @param {Number} value
       * @return {Void}
       */
      set: function set(value) {
        var transform = mutator(Glide, Components).mutate(value);
        var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
        Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15

        Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22

        Components.Html.wrapper.style.transform = translate3d;
      },

      /**
       * Removes value of translate from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transform = '';
      },

      /**
       * @return {number}
       */
      getStartIndex: function getStartIndex() {
        var length = Components.Sizes.length;
        var index = Glide.index;
        var perView = Glide.settings.perView;

        if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
          return length + (index - perView);
        } // "modulo length" converts an index that equals length to zero


        return (index + perView) % length;
      },

      /**
       * @return {number}
       */
      getTravelDistance: function getTravelDistance() {
        var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;

        if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
          // reverse travel distance so that we don't have to change subtract operations
          return travelDistance * -1;
        }

        return travelDistance;
      }
    };
    /**
     * Set new translate value:
     * - on move to reflect index change
     * - on updating via API to reflect possible changes in options
     */

    Events.on('move', function (context) {
      if (!Glide.isType('carousel') || !Components.Run.isOffset()) {
        return Translate.set(context.movement);
      }

      Components.Transition.after(function () {
        Events.emit('translate.jump');
        Translate.set(Components.Sizes.slideWidth * Glide.index);
      });
      var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
      return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
     * Remove translate:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Translate.remove();
    });
    return Translate;
  }

  function Transition (Glide, Components, Events) {
    /**
     * Holds inactivity status of transition.
     * When true transition is not applied.
     *
     * @type {Boolean}
     */
    var disabled = false;
    var Transition = {
      /**
       * Composes string of the CSS transition.
       *
       * @param {String} property
       * @return {String}
       */
      compose: function compose(property) {
        var settings = Glide.settings;

        if (!disabled) {
          return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
        }

        return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
      },

      /**
       * Sets value of transition on HTML element.
       *
       * @param {String=} property
       * @return {Void}
       */
      set: function set() {
        var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
        Components.Html.wrapper.style.transition = this.compose(property);
      },

      /**
       * Removes value of transition from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transition = '';
      },

      /**
       * Runs callback after animation.
       *
       * @param  {Function} callback
       * @return {Void}
       */
      after: function after(callback) {
        setTimeout(function () {
          callback();
        }, this.duration);
      },

      /**
       * Enable transition.
       *
       * @return {Void}
       */
      enable: function enable() {
        disabled = false;
        this.set();
      },

      /**
       * Disable transition.
       *
       * @return {Void}
       */
      disable: function disable() {
        disabled = true;
        this.set();
      }
    };
    define(Transition, 'duration', {
      /**
       * Gets duration of the transition based
       * on currently running animation type.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;

        if (Glide.isType('slider') && Components.Run.offset) {
          return settings.rewindDuration;
        }

        return settings.animationDuration;
      }
    });
    /**
     * Set transition `style` value:
     * - on each moving, because it may be cleared by offset move
     */

    Events.on('move', function () {
      Transition.set();
    });
    /**
     * Disable transition:
     * - before initial build to avoid transitioning from `0` to `startAt` index
     * - while resizing window and recalculating dimensions
     * - on jumping from offset transition at start and end edges in `carousel` type
     */

    Events.on(['build.before', 'resize', 'translate.jump'], function () {
      Transition.disable();
    });
    /**
     * Enable transition:
     * - on each running, because it may be disabled by offset move
     */

    Events.on('run', function () {
      Transition.enable();
    });
    /**
     * Remove transition:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Transition.remove();
    });
    return Transition;
  }

  /**
   * Test via a getter in the options object to see
   * if the passive property is accessed.
   *
   * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
   */
  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {}

  var supportsPassive$1 = supportsPassive;

  var START_EVENTS = ['touchstart', 'mousedown'];
  var MOVE_EVENTS = ['touchmove', 'mousemove'];
  var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
  var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];
  function Swipe (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = supportsPassive$1 ? {
      passive: true
    } : false;
    var Swipe = {
      /**
       * Initializes swipe bindings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bindSwipeStart();
      },

      /**
       * Handler for `swipestart` event. Calculates entry points of the user's tap.
       *
       * @param {Object} event
       * @return {Void}
       */
      start: function start(event) {
        if (!disabled && !Glide.disabled) {
          this.disable();
          var swipe = this.touches(event);
          swipeSin = null;
          swipeStartX = toInt(swipe.pageX);
          swipeStartY = toInt(swipe.pageY);
          this.bindSwipeMove();
          this.bindSwipeEnd();
          Events.emit('swipe.start');
        }
      },

      /**
       * Handler for `swipemove` event. Calculates user's tap angle and distance.
       *
       * @param {Object} event
       */
      move: function move(event) {
        if (!Glide.disabled) {
          var _Glide$settings = Glide.settings,
              touchAngle = _Glide$settings.touchAngle,
              touchRatio = _Glide$settings.touchRatio,
              classes = _Glide$settings.classes;
          var swipe = this.touches(event);
          var subExSx = toInt(swipe.pageX) - swipeStartX;
          var subEySy = toInt(swipe.pageY) - swipeStartY;
          var powEX = Math.abs(subExSx << 2);
          var powEY = Math.abs(subEySy << 2);
          var swipeHypotenuse = Math.sqrt(powEX + powEY);
          var swipeCathetus = Math.sqrt(powEY);
          swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

          if (swipeSin * 180 / Math.PI < touchAngle) {
            event.stopPropagation();
            Components.Move.make(subExSx * toFloat(touchRatio));
            Components.Html.root.classList.add(classes.dragging);
            Events.emit('swipe.move');
          } else {
            return false;
          }
        }
      },

      /**
       * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
       *
       * @param {Object} event
       * @return {Void}
       */
      end: function end(event) {
        if (!Glide.disabled) {
          var _Glide$settings2 = Glide.settings,
              perSwipe = _Glide$settings2.perSwipe,
              touchAngle = _Glide$settings2.touchAngle,
              classes = _Glide$settings2.classes;
          var swipe = this.touches(event);
          var threshold = this.threshold(event);
          var swipeDistance = swipe.pageX - swipeStartX;
          var swipeDeg = swipeSin * 180 / Math.PI;
          this.enable();

          if (swipeDistance > threshold && swipeDeg < touchAngle) {
            Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
          } else if (swipeDistance < -threshold && swipeDeg < touchAngle) {
            Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
          } else {
            // While swipe don't reach distance apply previous transform.
            Components.Move.make();
          }

          Components.Html.root.classList.remove(classes.dragging);
          this.unbindSwipeMove();
          this.unbindSwipeEnd();
          Events.emit('swipe.end');
        }
      },

      /**
       * Binds swipe's starting event.
       *
       * @return {Void}
       */
      bindSwipeStart: function bindSwipeStart() {
        var _this = this;

        var _Glide$settings3 = Glide.settings,
            swipeThreshold = _Glide$settings3.swipeThreshold,
            dragThreshold = _Glide$settings3.dragThreshold;

        if (swipeThreshold) {
          Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }

        if (dragThreshold) {
          Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }
      },

      /**
       * Unbinds swipe's starting event.
       *
       * @return {Void}
       */
      unbindSwipeStart: function unbindSwipeStart() {
        Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
        Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
      },

      /**
       * Binds swipe's moving event.
       *
       * @return {Void}
       */
      bindSwipeMove: function bindSwipeMove() {
        var _this2 = this;

        Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
          _this2.move(event);
        }, Glide.settings.throttle), capture);
      },

      /**
       * Unbinds swipe's moving event.
       *
       * @return {Void}
       */
      unbindSwipeMove: function unbindSwipeMove() {
        Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
      },

      /**
       * Binds swipe's ending event.
       *
       * @return {Void}
       */
      bindSwipeEnd: function bindSwipeEnd() {
        var _this3 = this;

        Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
          _this3.end(event);
        });
      },

      /**
       * Unbinds swipe's ending event.
       *
       * @return {Void}
       */
      unbindSwipeEnd: function unbindSwipeEnd() {
        Binder.off(END_EVENTS, Components.Html.wrapper);
      },

      /**
       * Normalizes event touches points accorting to different types.
       *
       * @param {Object} event
       */
      touches: function touches(event) {
        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return event;
        }

        return event.touches[0] || event.changedTouches[0];
      },

      /**
       * Gets value of minimum swipe distance settings based on event type.
       *
       * @return {Number}
       */
      threshold: function threshold(event) {
        var settings = Glide.settings;

        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return settings.dragThreshold;
        }

        return settings.swipeThreshold;
      },

      /**
       * Enables swipe event.
       *
       * @return {self}
       */
      enable: function enable() {
        disabled = false;
        Components.Transition.enable();
        return this;
      },

      /**
       * Disables swipe event.
       *
       * @return {self}
       */
      disable: function disable() {
        disabled = true;
        Components.Transition.disable();
        return this;
      }
    };
    /**
     * Add component class:
     * - after initial building
     */

    Events.on('build.after', function () {
      Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
     * Remove swiping bindings:
     * - on destroying, to remove added EventListeners
     */

    Events.on('destroy', function () {
      Swipe.unbindSwipeStart();
      Swipe.unbindSwipeMove();
      Swipe.unbindSwipeEnd();
      Binder.destroy();
    });
    return Swipe;
  }

  function Images (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Images = {
      /**
       * Binds listener to glide wrapper.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bind();
      },

      /**
       * Binds `dragstart` event on wrapper to prevent dragging images.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
      },

      /**
       * Unbinds `dragstart` event on wrapper.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('dragstart', Components.Html.wrapper);
      },

      /**
       * Event handler. Prevents dragging.
       *
       * @return {Void}
       */
      dragstart: function dragstart(event) {
        event.preventDefault();
      }
    };
    /**
     * Remove bindings from images:
     * - on destroying, to remove added EventListeners
     */

    Events.on('destroy', function () {
      Images.unbind();
      Binder.destroy();
    });
    return Images;
  }

  function Anchors (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    /**
     * Holds detaching status of anchors.
     * Prevents detaching of already detached anchors.
     *
     * @private
     * @type {Boolean}
     */

    var detached = false;
    /**
     * Holds preventing status of anchors.
     * If `true` redirection after click will be disabled.
     *
     * @private
     * @type {Boolean}
     */

    var prevented = false;
    var Anchors = {
      /**
       * Setups a initial state of anchors component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        /**
         * Holds collection of anchors elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._a = Components.Html.wrapper.querySelectorAll('a');
        this.bind();
      },

      /**
       * Binds events to anchors inside a track.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('click', Components.Html.wrapper, this.click);
      },

      /**
       * Unbinds events attached to anchors inside a track.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('click', Components.Html.wrapper);
      },

      /**
       * Handler for click event. Prevents clicks when glide is in `prevent` status.
       *
       * @param  {Object} event
       * @return {Void}
       */
      click: function click(event) {
        if (prevented) {
          event.stopPropagation();
          event.preventDefault();
        }
      },

      /**
       * Detaches anchors click event inside glide.
       *
       * @return {self}
       */
      detach: function detach() {
        prevented = true;

        if (!detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = false;
          }

          detached = true;
        }

        return this;
      },

      /**
       * Attaches anchors click events inside glide.
       *
       * @return {self}
       */
      attach: function attach() {
        prevented = false;

        if (detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = true;
          }

          detached = false;
        }

        return this;
      }
    };
    define(Anchors, 'items', {
      /**
       * Gets collection of the arrows HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Anchors._a;
      }
    });
    /**
     * Detach anchors inside slides:
     * - on swiping, so they won't redirect to its `href` attributes
     */

    Events.on('swipe.move', function () {
      Anchors.detach();
    });
    /**
     * Attach anchors inside slides:
     * - after swiping and transitions ends, so they can redirect after click again
     */

    Events.on('swipe.end', function () {
      Components.Transition.after(function () {
        Anchors.attach();
      });
    });
    /**
     * Unbind anchors inside slides:
     * - on destroying, to bring anchors to its initial state
     */

    Events.on('destroy', function () {
      Anchors.attach();
      Anchors.unbind();
      Binder.destroy();
    });
    return Anchors;
  }

  var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
  var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
  var PREVIOUS_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\"<\"]");
  var NEXT_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\">\"]");
  function Controls (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var capture = supportsPassive$1 ? {
      passive: true
    } : false;
    var Controls = {
      /**
       * Inits arrows. Binds events listeners
       * to the arrows HTML elements.
       *
       * @return {Void}
       */
      mount: function mount() {
        /**
         * Collection of navigation HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);
        /**
         * Collection of controls HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */

        this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);
        /**
         * Collection of arrow control HTML elements.
         *
         * @private
         * @type {Object}
         */

        this._arrowControls = {
          previous: Components.Html.root.querySelectorAll(PREVIOUS_CONTROLS_SELECTOR),
          next: Components.Html.root.querySelectorAll(NEXT_CONTROLS_SELECTOR)
        };
        this.addBindings();
      },

      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      setActive: function setActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.addClass(this._n[i].children);
        }
      },

      /**
       * Removes active class to current slide.
       *
       * @return {Void}
       */
      removeActive: function removeActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.removeClass(this._n[i].children);
        }
      },

      /**
       * Toggles active class on items inside navigation.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      addClass: function addClass(controls) {
        var settings = Glide.settings;
        var item = controls[Glide.index];

        if (!item) {
          return;
        }

        if (item) {
          item.classList.add(settings.classes.nav.active);
          siblings(item).forEach(function (sibling) {
            sibling.classList.remove(settings.classes.nav.active);
          });
        }
      },

      /**
       * Removes active class from active control.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      removeClass: function removeClass(controls) {
        var item = controls[Glide.index];

        if (item) {
          item.classList.remove(Glide.settings.classes.nav.active);
        }
      },

      /**
       * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
       */
      setArrowState: function setArrowState() {
        if (Glide.settings.rewind) {
          return;
        }

        var next = Controls._arrowControls.next;
        var previous = Controls._arrowControls.previous;
        this.resetArrowState(next, previous);

        if (Glide.index === 0) {
          this.disableArrow(previous);
        }

        if (Glide.index === Components.Run.length) {
          this.disableArrow(next);
        }
      },

      /**
       * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
       *
       * @param {NodeList[]} lists
       */
      resetArrowState: function resetArrowState() {
        var settings = Glide.settings;

        for (var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++) {
          lists[_key] = arguments[_key];
        }

        lists.forEach(function (list) {
          toArray(list).forEach(function (element) {
            element.classList.remove(settings.classes.arrow.disabled);
          });
        });
      },

      /**
       * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
       *
       * @param {NodeList[]} lists
       */
      disableArrow: function disableArrow() {
        var settings = Glide.settings;

        for (var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          lists[_key2] = arguments[_key2];
        }

        lists.forEach(function (list) {
          toArray(list).forEach(function (element) {
            element.classList.add(settings.classes.arrow.disabled);
          });
        });
      },

      /**
       * Adds handles to the each group of controls.
       *
       * @return {Void}
       */
      addBindings: function addBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.bind(this._c[i].children);
        }
      },

      /**
       * Removes handles from the each group of controls.
       *
       * @return {Void}
       */
      removeBindings: function removeBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.unbind(this._c[i].children);
        }
      },

      /**
       * Binds events to arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      bind: function bind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.on('click', elements[i], this.click);
          Binder.on('touchstart', elements[i], this.click, capture);
        }
      },

      /**
       * Unbinds events binded to the arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      unbind: function unbind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.off(['click', 'touchstart'], elements[i]);
        }
      },

      /**
       * Handles `click` event on the arrows HTML elements.
       * Moves slider in direction given via the
       * `data-glide-dir` attribute.
       *
       * @param {Object} event
       * @return {void}
       */
      click: function click(event) {
        if (!supportsPassive$1 && event.type === 'touchstart') {
          event.preventDefault();
        }

        var direction = event.currentTarget.getAttribute('data-glide-dir');
        Components.Run.make(Components.Direction.resolve(direction));
      }
    };
    define(Controls, 'items', {
      /**
       * Gets collection of the controls HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Controls._c;
      }
    });
    /**
     * Swap active class of current navigation item:
     * - after mounting to set it to initial index
     * - after each move to the new index
     */

    Events.on(['mount.after', 'move.after'], function () {
      Controls.setActive();
    });
    /**
     * Add or remove disabled class of arrow elements
     */

    Events.on(['mount.after', 'run'], function () {
      Controls.setArrowState();
    });
    /**
     * Remove bindings and HTML Classes:
     * - on destroying, to bring markup to its initial state
     */

    Events.on('destroy', function () {
      Controls.removeBindings();
      Controls.removeActive();
      Binder.destroy();
    });
    return Controls;
  }

  function Keyboard (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Keyboard = {
      /**
       * Binds keyboard events on component mount.
       *
       * @return {Void}
       */
      mount: function mount() {
        if (Glide.settings.keyboard) {
          this.bind();
        }
      },

      /**
       * Adds keyboard press events.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('keyup', document, this.press);
      },

      /**
       * Removes keyboard press events.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('keyup', document);
      },

      /**
       * Handles keyboard's arrows press and moving glide foward and backward.
       *
       * @param  {Object} event
       * @return {Void}
       */
      press: function press(event) {
        var perSwipe = Glide.settings.perSwipe;

        if (event.code === 'ArrowRight') {
          Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
        }

        if (event.code === 'ArrowLeft') {
          Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
        }
      }
    };
    /**
     * Remove bindings from keyboard:
     * - on destroying to remove added events
     * - on updating to remove events before remounting
     */

    Events.on(['destroy', 'update'], function () {
      Keyboard.unbind();
    });
    /**
     * Remount component
     * - on updating to reflect potential changes in settings
     */

    Events.on('update', function () {
      Keyboard.mount();
    });
    /**
     * Destroy binder:
     * - on destroying to remove listeners
     */

    Events.on('destroy', function () {
      Binder.destroy();
    });
    return Keyboard;
  }

  function Autoplay (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Autoplay = {
      /**
       * Initializes autoplaying and events.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.enable();
        this.start();

        if (Glide.settings.hoverpause) {
          this.bind();
        }
      },

      /**
       * Enables autoplaying
       *
       * @returns {Void}
       */
      enable: function enable() {
        this._e = true;
      },

      /**
       * Disables autoplaying.
       *
       * @returns {Void}
       */
      disable: function disable() {
        this._e = false;
      },

      /**
       * Starts autoplaying in configured interval.
       *
       * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Void}
       */
      start: function start() {
        var _this = this;

        if (!this._e) {
          return;
        }

        this.enable();

        if (Glide.settings.autoplay) {
          if (isUndefined(this._i)) {
            this._i = setInterval(function () {
              _this.stop();

              Components.Run.make('>');

              _this.start();

              Events.emit('autoplay');
            }, this.time);
          }
        }
      },

      /**
       * Stops autorunning of the glide.
       *
       * @return {Void}
       */
      stop: function stop() {
        this._i = clearInterval(this._i);
      },

      /**
       * Stops autoplaying while mouse is over glide's area.
       *
       * @return {Void}
       */
      bind: function bind() {
        var _this2 = this;

        Binder.on('mouseover', Components.Html.root, function () {
          if (_this2._e) {
            _this2.stop();
          }
        });
        Binder.on('mouseout', Components.Html.root, function () {
          if (_this2._e) {
            _this2.start();
          }
        });
      },

      /**
       * Unbind mouseover events.
       *
       * @returns {Void}
       */
      unbind: function unbind() {
        Binder.off(['mouseover', 'mouseout'], Components.Html.root);
      }
    };
    define(Autoplay, 'time', {
      /**
       * Gets time period value for the autoplay interval. Prioritizes
       * times in `data-glide-autoplay` attrubutes over options.
       *
       * @return {Number}
       */
      get: function get() {
        var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

        if (autoplay) {
          return toInt(autoplay);
        }

        return toInt(Glide.settings.autoplay);
      }
    });
    /**
     * Stop autoplaying and unbind events:
     * - on destroying, to clear defined interval
     * - on updating via API to reset interval that may changed
     */

    Events.on(['destroy', 'update'], function () {
      Autoplay.unbind();
    });
    /**
     * Stop autoplaying:
     * - before each run, to restart autoplaying
     * - on pausing via API
     * - on destroying, to clear defined interval
     * - while starting a swipe
     * - on updating via API to reset interval that may changed
     */

    Events.on(['run.before', 'swipe.start', 'update'], function () {
      Autoplay.stop();
    });
    Events.on(['pause', 'destroy'], function () {
      Autoplay.disable();
      Autoplay.stop();
    });
    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */

    Events.on(['run.after', 'swipe.end'], function () {
      Autoplay.start();
    });
    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */

    Events.on(['play'], function () {
      Autoplay.enable();
      Autoplay.start();
    });
    /**
     * Remount autoplaying:
     * - on updating via API to reset interval that may changed
     */

    Events.on('update', function () {
      Autoplay.mount();
    });
    /**
     * Destroy a binder:
     * - on destroying glide instance to clearup listeners
     */

    Events.on('destroy', function () {
      Binder.destroy();
    });
    return Autoplay;
  }

  /**
   * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
   *
   * @param {Object} points
   * @returns {Object}
   */

  function sortBreakpoints(points) {
    if (isObject(points)) {
      return sortKeys(points);
    } else {
      warn("Breakpoints option must be an object");
    }

    return {};
  }

  function Breakpoints (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    /**
     * Holds reference to settings.
     *
     * @type {Object}
     */

    var settings = Glide.settings;
    /**
     * Holds reference to breakpoints object in settings. Sorts breakpoints
     * from smaller to larger. It is required in order to proper
     * matching currently active breakpoint settings.
     *
     * @type {Object}
     */

    var points = sortBreakpoints(settings.breakpoints);
    /**
     * Cache initial settings before overwritting.
     *
     * @type {Object}
     */

    var defaults = Object.assign({}, settings);
    var Breakpoints = {
      /**
       * Matches settings for currectly matching media breakpoint.
       *
       * @param {Object} points
       * @returns {Object}
       */
      match: function match(points) {
        if (typeof window.matchMedia !== 'undefined') {
          for (var point in points) {
            if (points.hasOwnProperty(point)) {
              if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) {
                return points[point];
              }
            }
          }
        }

        return defaults;
      }
    };
    /**
     * Overwrite instance settings with currently matching breakpoint settings.
     * This happens right after component initialization.
     */

    Object.assign(settings, Breakpoints.match(points));
    /**
     * Update glide with settings of matched brekpoint:
     * - window resize to update slider
     */

    Binder.on('resize', window, throttle(function () {
      Glide.settings = mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
     * Resort and update default settings:
     * - on reinit via API, so breakpoint matching will be performed with options
     */

    Events.on('update', function () {
      points = sortBreakpoints(points);
      defaults = Object.assign({}, settings);
    });
    /**
     * Unbind resize listener:
     * - on destroying, to bring markup to its initial state
     */

    Events.on('destroy', function () {
      Binder.off('resize', window);
    });
    return Breakpoints;
  }

  var COMPONENTS = {
    // Required
    Html: Html,
    Translate: Translate,
    Transition: Transition,
    Direction: Direction,
    Peek: Peek,
    Sizes: Sizes,
    Gaps: Gaps,
    Move: Move,
    Clones: Clones,
    Resize: Resize,
    Build: Build,
    Run: Run,
    // Optional
    Swipe: Swipe,
    Images: Images,
    Anchors: Anchors,
    Controls: Controls,
    Keyboard: Keyboard,
    Autoplay: Autoplay,
    Breakpoints: Breakpoints
  };

  var Glide = /*#__PURE__*/function (_Core) {
    _inherits(Glide, _Core);

    var _super = _createSuper(Glide);

    function Glide() {
      _classCallCheck(this, Glide);

      return _super.apply(this, arguments);
    }

    _createClass(Glide, [{
      key: "mount",
      value: function mount() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _get(_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, COMPONENTS, extensions));
      }
    }]);

    return Glide;
  }(Glide$1);

  return Glide;

}));

},{}],116:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":118}],117:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":124,"../core/createError":125,"./../core/settle":129,"./../helpers/buildURL":133,"./../helpers/cookies":135,"./../helpers/isURLSameOrigin":138,"./../helpers/parseHeaders":140,"./../utils":143}],118:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":119,"./cancel/CancelToken":120,"./cancel/isCancel":121,"./core/Axios":122,"./core/mergeConfig":128,"./defaults":131,"./helpers/bind":132,"./helpers/isAxiosError":137,"./helpers/spread":141,"./utils":143}],119:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],120:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":119}],121:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],122:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":133,"../helpers/validator":142,"./../utils":143,"./InterceptorManager":123,"./dispatchRequest":126,"./mergeConfig":128}],123:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":143}],124:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":134,"../helpers/isAbsoluteURL":136}],125:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":127}],126:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":121,"../defaults":131,"./../utils":143,"./transformData":130}],127:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],128:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

},{"../utils":143}],129:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":125}],130:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":131,"./../utils":143}],131:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))

},{"./adapters/http":117,"./adapters/xhr":117,"./core/enhanceError":127,"./helpers/normalizeHeaderName":139,"./utils":143,"_process":145}],132:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],133:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":143}],134:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],135:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":143}],136:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],137:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],138:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":143}],139:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":143}],140:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":143}],141:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],142:[function(require,module,exports){
'use strict';

var pkg = require('./../../package.json');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};

},{"./../../package.json":144}],143:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":132}],144:[function(require,module,exports){
module.exports={
  "_args": [
    [
      "axios@0.21.4",
      "D:\\Agent\\_work\\1\\s\\src\\Mawhiba.Frontend"
    ]
  ],
  "_from": "axios@0.21.4",
  "_id": "axios@0.21.4",
  "_inBundle": false,
  "_integrity": "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==",
  "_location": "/axios",
  "_phantomChildren": {},
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "axios@0.21.4",
    "name": "axios",
    "escapedName": "axios",
    "rawSpec": "0.21.4",
    "saveSpec": null,
    "fetchSpec": "0.21.4"
  },
  "_requiredBy": [
    "/",
    "/localtunnel",
    "/paged-request"
  ],
  "_resolved": "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz",
  "_spec": "0.21.4",
  "_where": "D:\\Agent\\_work\\1\\s\\src\\Mawhiba.Frontend",
  "author": {
    "name": "Matt Zabriskie"
  },
  "browser": {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  "bugs": {
    "url": "https://github.com/axios/axios/issues"
  },
  "bundlesize": [
    {
      "path": "./dist/axios.min.js",
      "threshold": "5kB"
    }
  ],
  "dependencies": {
    "follow-redirects": "^1.14.0"
  },
  "description": "Promise based HTTP client for the browser and node.js",
  "devDependencies": {
    "coveralls": "^3.0.0",
    "es6-promise": "^4.2.4",
    "grunt": "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    "minimist": "^1.2.0",
    "mocha": "^8.2.1",
    "sinon": "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    "typescript": "^4.0.5",
    "url-search-params": "^0.10.0",
    "webpack": "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  "homepage": "https://axios-http.com",
  "jsdelivr": "dist/axios.min.js",
  "keywords": [
    "xhr",
    "http",
    "ajax",
    "promise",
    "node"
  ],
  "license": "MIT",
  "main": "index.js",
  "name": "axios",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/axios/axios.git"
  },
  "scripts": {
    "build": "NODE_ENV=production grunt build",
    "coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    "examples": "node ./examples/server.js",
    "fix": "eslint --fix lib/**/*.js",
    "postversion": "git push && git push --tags",
    "preversion": "npm test",
    "start": "node ./sandbox/server.js",
    "test": "grunt test",
    "version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
  },
  "typings": "./index.d.ts",
  "unpkg": "dist/axios.min.js",
  "version": "0.21.4"
}

},{}],145:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,36,31,32,33,34,35,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,65,63,64,66,67,68,69,70,11,71,73,72,74,75,76,78,79,77,80,81,82,83,84,85,88,86,87,89,90,91,92,98,96,97,93,94,95,99,100,101,102,103,104,105,106,107,108,109,111,112,110,113,114])(114)
});

